
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c11PZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// This function is used to override the values of an object with the values of another object.
// Unless the value is null or undefined, the value from the source object will be used.
function $78996b68e17eef8d$export$8b58be045bf06082(target, source) {
    const result = {
        ...target
    };
    for(const key in source)if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
    return result;
}



var $gQNge = parcelRequire("gQNge");


var $lYEhB = parcelRequire("lYEhB");

const $e14c00de9dfb3994$export$554c849e7e3a0f1 = {
    mapUserIdToProfileUrl: ()=>null,
    generateSearchUrl: (0, $gQNge.defaultGenerateSearchUrl),
    getFeatureGate: ()=>false,
    getFrontendExperiment: ()=>({
            abTestId: '',
            cohort: '',
            serveExperiment: false
        }),
    queryParams: {},
    onNavigate: (0, $lYEhB.defaultOnNavigate),
    isNav4Enabled: false,
    isAdminHubAIEnabled: false,
    isRovoLLMEnabled: false
};
/**
 * Provides information about the host application that can't be stored in a state store,
 * e.g. a function.
 */ const $e14c00de9dfb3994$var$AppContext = /*#__PURE__*/ (0, $cozmU.createContext)($e14c00de9dfb3994$export$554c849e7e3a0f1);
const $e14c00de9dfb3994$export$fdc397e486fa83e7 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($e14c00de9dfb3994$var$AppContext);
const $e14c00de9dfb3994$export$20d2b7652facc723 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e14c00de9dfb3994$var$AppContext.Provider, {
        value: (0, $78996b68e17eef8d$export$8b58be045bf06082)($e14c00de9dfb3994$export$554c849e7e3a0f1, props)
    }, children);
module.exports["useAppContext"] = $e14c00de9dfb3994$export$fdc397e486fa83e7;
module.exports["AppContextProvider"] = $e14c00de9dfb3994$export$20d2b7652facc723;

});

parcelRegister("gQNge", function(module, exports) {
function $fef788de4a50ec08$export$3c0cdf0037f37eca(queryParams) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
        else searchParams.delete(key);
    });
    url.search = searchParams.toString();
    return url.href;
}
module.exports["defaultGenerateSearchUrl"] = $fef788de4a50ec08$export$3c0cdf0037f37eca;

});

parcelRegister("lYEhB", function(module, exports) {
const $a0f07052a6e35159$export$bd386de500a3324b = {
    callback: (url)=>{
        window.location.href = url;
    },
    options: {
        alwaysUseOnLinkClick: false
    }
};
module.exports["defaultOnNavigate"] = $a0f07052a6e35159$export$bd386de500a3324b;

});

parcelRegister("hdMUr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ej0c1 = parcelRequire("ej0c1");






























const $b229105ea1272257$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("eesba"));
        case 'da':
            return (parcelRequire("bLTm3"));
        case 'de':
            return (parcelRequire("3XVa6"));
        case 'en':
            return (parcelRequire("jaYAM"));
        case 'en_GB':
            return (parcelRequire("7Bkma"));
        case 'en_ZZ':
            return (parcelRequire("iJnNd"));
        case 'es':
            return (parcelRequire("ksjH0"));
        case 'fi':
            return (parcelRequire("kUbIB"));
        case 'fr':
            return (parcelRequire("kaNfw"));
        case 'hr':
            return (parcelRequire("jO13r"));
        case 'hu':
            return (parcelRequire("6mYVW"));
        case 'it':
            return (parcelRequire("8ml2N"));
        case 'ja':
            return (parcelRequire("fpOW4"));
        case 'ko':
            return (parcelRequire("7F4l3"));
        case 'nb':
            return (parcelRequire("gfKOF"));
        case 'nl':
            return (parcelRequire("fOS8M"));
        case 'pl':
            return (parcelRequire("aSAb5"));
        case 'pt_BR':
            return (parcelRequire("6trHz"));
        case 'ru':
            return (parcelRequire("fl3PF"));
        case 'sl':
            return (parcelRequire("dqkwI"));
        case 'sr_RS':
            return (parcelRequire("3oOtg"));
        case 'sr_YR':
            return (parcelRequire("eP8bg"));
        case 'sv':
            return (parcelRequire("cu6Sm"));
        case 'th':
            return (parcelRequire("grzGi"));
        case 'tr':
            return (parcelRequire("9rVUk"));
        case 'uk':
            return (parcelRequire("jmCuW"));
        case 'vi':
            return (parcelRequire("l5SiF"));
        case 'zh':
            return (parcelRequire("5SBU6"));
        case 'zh_TW':
            return (parcelRequire("jfjtW"));
    }
};































const $d59ac6f5f0ea5120$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("a8J3L"));
        case 'da':
            return (parcelRequire("hyjql"));
        case 'de':
            return (parcelRequire("4d7mR"));
        case 'en':
            return (parcelRequire("l414Y"));
        case 'en_GB':
            return (parcelRequire("d1vR7"));
        case 'en_ZZ':
            return (parcelRequire("lbIOK"));
        case 'es':
            return (parcelRequire("erEK7"));
        case 'fi':
            return (parcelRequire("dwQIL"));
        case 'fr':
            return (parcelRequire("9mlgJ"));
        case 'hr':
            return (parcelRequire("g1JlU"));
        case 'hu':
            return (parcelRequire("ZF1G9"));
        case 'it':
            return (parcelRequire("fagXR"));
        case 'ja':
            return (parcelRequire("gJKhA"));
        case 'ko':
            return (parcelRequire("a0jez"));
        case 'nb':
            return (parcelRequire("ea0Re"));
        case 'nl':
            return (parcelRequire("gL0Dx"));
        case 'pl':
            return (parcelRequire("bhJWq"));
        case 'pt_BR':
            return (parcelRequire("hUo4O"));
        case 'ru':
            return (parcelRequire("hDbbU"));
        case 'sl':
            return (parcelRequire("77INV"));
        case 'sr_RS':
            return (parcelRequire("9sz3K"));
        case 'sr_YR':
            return (parcelRequire("ctEz6"));
        case 'sv':
            return (parcelRequire("im1dt"));
        case 'th':
            return (parcelRequire("fRkaa"));
        case 'tr':
            return (parcelRequire("jOXsT"));
        case 'uk':
            return (parcelRequire("5oZ61"));
        case 'vi':
            return (parcelRequire("lXomr"));
        case 'zh':
            return (parcelRequire("6AJxn"));
        case 'zh_TW':
            return (parcelRequire("3yxPO"));
    }
};































const $acf6cbf82438a9be$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("agerH"));
        case 'da':
            return (parcelRequire("1guW5"));
        case 'de':
            return (parcelRequire("fBVAD"));
        case 'en':
            return (parcelRequire("540xp"));
        case 'en_GB':
            return (parcelRequire("dDn4v"));
        case 'en_ZZ':
            return (parcelRequire("fheBd"));
        case 'es':
            return (parcelRequire("h8W7L"));
        case 'fi':
            return (parcelRequire("aUnph"));
        case 'fr':
            return (parcelRequire("d7Xrz"));
        case 'hr':
            return (parcelRequire("1vhaM"));
        case 'hu':
            return (parcelRequire("b1QGl"));
        case 'it':
            return (parcelRequire("8RgFL"));
        case 'ja':
            return (parcelRequire("imD26"));
        case 'ko':
            return (parcelRequire("dKwIN"));
        case 'nb':
            return (parcelRequire("2TMvz"));
        case 'nl':
            return (parcelRequire("edNkB"));
        case 'pl':
            return (parcelRequire("7v0d6"));
        case 'pt_BR':
            return (parcelRequire("i6YAa"));
        case 'ru':
            return (parcelRequire("8hihb"));
        case 'sl':
            return (parcelRequire("2ZCu4"));
        case 'sr_RS':
            return (parcelRequire("byEb5"));
        case 'sr_YR':
            return (parcelRequire("3pj4Z"));
        case 'sv':
            return (parcelRequire("jys7x"));
        case 'th':
            return (parcelRequire("1KJtX"));
        case 'tr':
            return (parcelRequire("jA8mS"));
        case 'uk':
            return (parcelRequire("fjM8E"));
        case 'vi':
            return (parcelRequire("kvVV6"));
        case 'zh':
            return (parcelRequire("cHEVj"));
        case 'zh_TW':
            return (parcelRequire("ehjC2"));
    }
};
































const $6a978b70b7be62de$export$417b577dd0ae3221 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("lXiQY"));
        case 'da':
            return (parcelRequire("ceL5Y"));
        case 'de':
            return (parcelRequire("9PFi4"));
        case 'en':
            return Promise.resolve((parcelRequire("ej0c1")));
        case 'en_GB':
            return (parcelRequire("9XxAb"));
        case 'en_ZZ':
            return (parcelRequire("OStr5"));
        case 'es':
            return (parcelRequire("1J13e"));
        case 'fi':
            return (parcelRequire("gyaDS"));
        case 'fr':
            return (parcelRequire("lSLlQ"));
        case 'hr':
            return (parcelRequire("kMWsF"));
        case 'hu':
            return (parcelRequire("kP2Kb"));
        case 'it':
            return (parcelRequire("cCQAD"));
        case 'ja':
            return (parcelRequire("d7Jf3"));
        case 'ko':
            return (parcelRequire("92nxS"));
        case 'nb':
            return (parcelRequire("deUzL"));
        case 'nl':
            return (parcelRequire("aykdQ"));
        case 'pl':
            return (parcelRequire("8gT6G"));
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("gRJMd"));
        case 'ru':
            return (parcelRequire("egG6R"));
        case 'sl':
            return (parcelRequire("2OF8N"));
        case 'sr_RS':
            return (parcelRequire("lRRyP"));
        case 'sr_YR':
            return (parcelRequire("atzeI"));
        case 'sv':
            return (parcelRequire("ix7N8"));
        case 'th':
            return (parcelRequire("fXCNp"));
        case 'tr':
            return (parcelRequire("bMuJn"));
        case 'uk':
            return (parcelRequire("e0LRB"));
        case 'vi':
            return (parcelRequire("1ougv"));
        case 'zh_TW':
            return (parcelRequire("4S2B8"));
        case 'zh':
            return (parcelRequire("79XJS"));
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$417b577dd0ae3221(fragments[0]);
                else return Promise.resolve((parcelRequire("ej0c1")));
            }
    }
};
const $6a978b70b7be62de$export$bb2dfe5d62b737e9 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$bb2dfe5d62b737e9(fragments[0]);
                else return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $6a978b70b7be62de$export$622f604e3a034452 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$622f604e3a034452(fragments[0]);
                else return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $6a978b70b7be62de$export$97d82de8c43f5d55 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$97d82de8c43f5d55(fragments[0]);
                else return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en');
            }
    }
};
function $6a978b70b7be62de$export$6e4716e192dd76c5(locale) {
    return Promise.allSettled([
        $6a978b70b7be62de$export$417b577dd0ae3221(locale),
        $6a978b70b7be62de$export$bb2dfe5d62b737e9(locale),
        $6a978b70b7be62de$export$622f604e3a034452(locale),
        $6a978b70b7be62de$export$97d82de8c43f5d55(locale)
    ]).then((results)=>{
        const accumulatedMessages = results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                ...acc,
                ...result.value.default
            };
            return acc;
        }, {});
        return accumulatedMessages;
    });
}


const $60e352734959f7f0$var$useI18n = (locale, source)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState((0, $ej0c1.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages((0, $ej0c1.default));
        (0, $6a978b70b7be62de$export$6e4716e192dd76c5)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'i18n_messages_load_error',
                    source: source,
                    attributes: {
                        locale: locale,
                        error: error.message
                    }
                }
            }).fire();
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale,
        source,
        createAnalyticsEvent
    ]);
    return messages;
};
const $60e352734959f7f0$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $60e352734959f7f0$var$useI18n(intl.locale, props.experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $60e352734959f7f0$export$2e2bcd8739ae039 = $60e352734959f7f0$var$MessagesIntlProvider;
module.exports["default"] = $60e352734959f7f0$export$2e2bcd8739ae039;

});

parcelRegister("ej0c1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6e2a0e01d55c9360$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $295b7ff928e6276a$export$2e2bcd8739ae039 = {
    "3p-result-labeling.knowledge_article.label": "Knowledge article",
    "3p-result-labeling.news_article.label": "News article",
    "advanced-search.labels.filter.no.text": "Start typing to search for a label",
    "ai-summary-label": "Summarize",
    "archive.label": "Archive",
    "assets-app-message-banner-available-soon": "<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.",
    "assets-app-message-banner-dismiss-message": "Dismiss",
    "attachment_type": "Attachment",
    "audio.label": "Audio",
    "avatar": "Avatar",
    "blogpost.label": "Blogpost",
    "blogpost_type": "Blogpost",
    "branch.label": "Branch",
    "channel.label": "Channel",
    "code.label": "Code",
    "comment-result.label": "Comment",
    "comment_type": "Comment",
    "commit.label": "Commit",
    "connect_third_party_product_description": "Connect your account to see missing results",
    "connect_third_party_product_title": "Your admin has added {product}!",
    "connect_third_party_product_title_alternate": "{product} is now available!",
    "copied-link-tooltip-label": "Copied!",
    "copy-content-link-label": "Copy link",
    "copy-link-button-label": "Copy Link",
    "copy-link-success-icon-label": "Success icon",
    "copy-link-tooltip-label": "Copy link",
    "createdNewest": "Created (newest)",
    "createdOldest": "Created (oldest)",
    "customer-org.label": "Customer Org",
    "dashboard.label": "Dashboard",
    "database.label": "Database",
    "date.filter.after.label": "after",
    "date.filter.any.time": "Anytime",
    "date.filter.before.label": "before",
    "date.filter.custom": "Custom",
    "date.filter.custom.invalid.after.end": "The From date has to be before the To date",
    "date.filter.custom.invalid.after.today": "The From date can\u2019t be in the future",
    "date.filter.custom.invalid.to.after.today": "The To date can\u2019t be in the future",
    "date.filter.from.label": "Choose start date to filter",
    "date.filter.from.title": "From",
    "date.filter.input.placeholder": "Choose a date",
    "date.filter.last.month": "Past 30 days",
    "date.filter.last.week": "Past 7 days",
    "date.filter.last.year": "Past year",
    "date.filter.title": "Last updated",
    "date.filter.to.label": "Choose end date to filter",
    "date.filter.to.range": "to",
    "date.filter.to.title": "To",
    "date.filter.today": "Today",
    "date.filter.update.button": "Update",
    "date.filter.yesterday": "Yesterday",
    "deal.label": "Deal",
    "design-search-result.label": "Design",
    "design.label": "Design",
    "document-search-result.google-docs-label": "Docs",
    "document-search-result.google-sheets-label": "Sheets",
    "document-search-result.google-slides-label": "Slides",
    "document-search-result.ms-excel-label": "Excel",
    "document-search-result.ms-powerpoint-label": "PowerPoint",
    "document-search-result.ms-word-label": "Word",
    "document.label": "Document",
    "draft_label": "Draft",
    "dropdown_generate_answer": "Generate answer",
    "dropdown_recent_icon_label": "Recent",
    "dropdown_search": "Search",
    "dropdown_search_icon_label": "Search",
    "error-boundary.code": "The code associated with this error: {code}",
    "error-boundary.description": "The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:",
    "error-boundary.description.support-link": "Atlassian Support",
    "error-boundary.reload-page": "Refresh page",
    "error-boundary.support-link-text": "our support team",
    "error-boundary.title": "We've hit a snag",
    "error-boundary.url": "The URL of this page",
    "error_primary": "We're having trouble searching",
    "error_secondary": "It might just be a hiccup. The best thing to do is to <btn>try again</btn>.",
    "externalPeopleLabel": "External people #{channelName}",
    "externalPersonLabel": "External person",
    "file.label": "File",
    "filter": "Filter icon",
    "give_feedback_text": "Give feedback",
    "image.label": "Image",
    "inline-app-selector.1p-3p-app-tooltip": "Open a full page search for this term filtered by {productName} results",
    "inline-app-selector.additional-products": "+ {count}",
    "inline-app-selector.all-apps-tooltip": "Open a full page search for this term searching all apps",
    "inline-product-filters.more-filters.tooltip": "Open a full page search with more filter options for {product}",
    "input_aria_label": "Press enter to navigate to advanced search with your text query",
    "input_clear_icon_label": "Clear search",
    "input_copy_link_icon_label": "Copy link",
    "input_placeholder": "Search",
    "input_placeholder_default": "Search for anything",
    "input_placeholder_ghost_text_kpi_acronym": "Search any acronym, like \"KPI\"",
    "input_placeholder_ghost_text_mention_teammates": "@mention a teammate to see their work",
    "input_placeholder_ghost_text_search_across": "Search across {products}, and more",
    "input_placeholder_ghost_text_search_teammate": "Search the name of a teammate",
    "input_placeholder_ghost_text_submit_expense": "Ask a question like \"How do I submit an expense?\"",
    "input_placeholder_nav3": "Search",
    "input_placeholder_with_atlassian_intelligence": "Search or ask anything",
    "input_placeholder_with_rovo": "Search or ask Rovo",
    "input_search_icon_label": "Search",
    "invoice.label": "Invoice",
    "issue.label": "Issue",
    "issue_type": "Work item",
    "jira_advanced_search": "Search Jira for work items",
    "jira_single_site_boards": "Boards",
    "jira_single_site_filters": "Filters",
    "jira_single_site_label": "Go to all:",
    "jira_single_site_people": "Teams",
    "jira_single_site_plans": "Plans",
    "jira_single_site_projects": "Projects",
    "jira_single_site_spaces": "Spaces",
    "jira_single_site_work_items_jql": "Work items (JQL)",
    "landing_primary": "Seek and you shall find",
    "landing_secondary": "Search for what you're looking for in your Atlassian and connected apps",
    "landing_secondary_rovo": "Search or ask Rovo what you're looking for in your Atlassian and connected apps",
    "landing_secondary_unified_with_sain": "Search or ask anything across your Atlassian apps",
    "landing_secondary_unified_without_sain": "Search for anything across your Atlassian apps",
    "landing_secondary_with_atlassian_intelligence": "Search or ask what you're looking for in your Atlassian and connected apps",
    "leap-query.title.related-search": "Related searches",
    "leap-query.title.teammates-also-ask": "Your teammates also ask",
    "link-attachments.button.label": "{count, plural, one {# link} other {# links}}",
    "live_doc_type": "Live Doc",
    "more-actions-label": "More Actions",
    "more-label": "More",
    "new-product-message-banner-dismiss-message-button": "Dismiss",
    "new-product-message-banner-text": "{product} was only recently added and we're still tweaking the results.",
    "noOptions": "No options",
    "no_results_clear_filters": "Clear filters",
    "no_results_content_cleared_by_space_change": "No results - the selected folder may have been moved or deleted.",
    "no_results_primary": "We couldn't find anything matching your search",
    "no_results_search_all_drives": "Search all Drives",
    "no_results_search_all_sites": "Search all Sites",
    "no_results_secondary_no_filters": "Try again with a different term.",
    "no_results_secondary_some_filters_applied": "Looks like you have some filters applied. You could try clearing them.",
    "oauth-banner.acknowledgement.success-flag-action": "Understood",
    "oauth-banner.authorization-fail": "Failed to connect to {product}.",
    "oauth-banner.authorization-success": "Account connected to {product}.",
    "oauth-banner.reconnect-slack": "Reconnect",
    "oauth-banner.slack-enterprise-grid-auth-upgrade-description": "Your organization's Slack connection was upgraded. Reconnect Slack to see more in Rovo Search and Chat.",
    "oauth-banner.slack-enterprise-grid-auth-upgrade-title": "Reconnect Slack to see messages from multiple workspaces",
    "oauth-banner.soft-banner-description": "You\u2019re seeing public channels. Connect your account to also search DMs and private channels.",
    "oauth-banner.soft-banner-title": "Connect {product} for personalized results",
    "oauth-message-connect": "Connect",
    "oauth-message-dismiss": "Dismiss",
    "other.label": "Other",
    "page.label": "Page",
    "page_type": "Page",
    "pdf.label": "PDF",
    "presentation.label": "Presentation",
    "project.label": "Project",
    "pull-request.label": "Pull Request",
    "pull_request_type": "Pull Request",
    "quick-find-filters.filter-by-icon-label": "Filter by Icon",
    "quick-find.assets.filter.assets-schema.icon.label": "Assets schema filter",
    "quick-find.assets.filter.assets-schema.label.selected": "Selected",
    "quick-find.assets.filter.assets-schema.label.unselected": "Suggested",
    "quick-find.assets.filter.assets-schema.placeholder": "Find schemas",
    "quick-find.assets.filter.assets-type.icon.label": "Object type filter",
    "quick-find.assets.filter.assets-type.label.selected": "Selected",
    "quick-find.assets.filter.assets-type.label.unselected": "Suggested",
    "quick-find.assets.filter.assets-type.placeholder": "Find object types",
    "quick-find.confluence.filter.contributor.placeholder": "Find people",
    "quick-find.confluence.filter.label.selected": "Selected",
    "quick-find.confluence.filter.label.unselected": "Suggested",
    "quick-find.filter.type.label.selected": "Selected",
    "quick-find.filter.type.label.unselected": "Available",
    "quick-find.filter.type.placeholder": "Find type",
    "quick-find.filters.clear-filters-button-label": "Clear filters",
    "quick-find.filters.names.assets-schema": "Schema",
    "quick-find.filters.names.assets-type": "Object type",
    "quick-find.filters.names.assignee": "Assignee",
    "quick-find.filters.names.contributor": "Contributor",
    "quick-find.filters.names.project": "Project",
    "quick-find.filters.names.spaces": "Space",
    "quick-find.filters.names.type": "Type",
    "quick-find.ghost-text.3p-multiple": "Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps",
    "quick-find.ghost-text.3p.github": "Search your GitHub repos, commits and PRs",
    "quick-find.ghost-text.3p.google-drive": "Search your Google Drive Docs, Sheets and Slides",
    "quick-find.ghost-text.3p.onedrive": "Search your OneDrive documents and files",
    "quick-find.ghost-text.3p.sharepoint": "Search your SharePoint documents and files",
    "quick-find.ghost-text.3p.slack": "Search your Slack DMs and messages",
    "quick-find.ghost-text.3p.teams": "Search your Microsoft Teams chats and messages",
    "quick-find.ghost-text.control": "Search",
    "quick-find.ghost-text.default-3p": "Search across all your apps",
    "quick-find.ghost-text.mixed-apps": "Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps",
    "quick-find.ghost-text.sain": "Ask me anything or search...",
    "quick-find.ghost-text.sain.benefits": "Try any question, like \"Where can I see my benefits?\"",
    "quick-find.ghost-text.sain.it-support": "Try any question, like \"How do I contact IT support?\"",
    "quick-find.ghost-text.sain.meeting-room": "Try any question, like \"How do I book a meeting room?\"",
    "quick-find.ghost-text.sain.notifications": "Try any question, like \"How do I change my notification settings?\"",
    "quick-find.ghost-text.sain.reset-password": "Try any question, like \"How do I reset my password?\"",
    "quick-find.ghost-text.sain.time-off": "Try any question, like \"How do I request time off?\"",
    "quick-find.ghost-text.two-apps": "Search {firstPartyApp}, {thirdPartyApp1} and other apps",
    "quick-find.github.code.type": "Code",
    "quick-find.jira.filter.assignee.placeholder": "Find people",
    "quick-find.jira.filter.assignee.selected": "Selected",
    "quick-find.jira.filter.assignee.unselected": "Suggested",
    "quick-find.jira.filter.project.placeholder": "Find projects",
    "quick-find.jira.filter.project.selected": "Selected",
    "quick-find.jira.filter.project.unselected": "Suggested",
    "quick-find.jira.filter.spaces.placeholder": "Find spaces",
    "quick-find.jira.filter.spaces.selected": "Selected",
    "quick-find.jira.filter.spaces.unselected": "Suggested",
    "quick-find.mercury.focus-area-status-update.title": "Update for {focusAreaName}",
    "quick-find.mercury.risk.icon-label": "Risk",
    "quick-find.talent.position.external-position-key": "External key {positionKey}",
    "quick-find.talent.position.title": "{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}",
    "quick_find_connect_apps_button_aria_label": "Open app connections",
    "quick_find_connect_apps_label": "Connect apps",
    "recentWork.eventTypeMessage.absolute.commented": "You commented on {absoluteTime}",
    "recentWork.eventTypeMessage.absolute.created": "You created on {absoluteTime}",
    "recentWork.eventTypeMessage.absolute.edited": "You edited on {absoluteTime}",
    "recentWork.eventTypeMessage.absolute.published": "You published on {absoluteTime}",
    "recentWork.eventTypeMessage.absolute.updated": "You updated on {absoluteTime}",
    "recentWork.eventTypeMessage.absolute.viewed": "You viewed on {absoluteTime}",
    "recentWork.eventTypeMessage.absolute.workedOn": "You worked on {absoluteTime}",
    "recentWork.eventTypeMessage.commented": "You commented",
    "recentWork.eventTypeMessage.created": "You created",
    "recentWork.eventTypeMessage.edited": "You edited",
    "recentWork.eventTypeMessage.multi.absolute.commented": "Commented on {absoluteTime}",
    "recentWork.eventTypeMessage.multi.absolute.created": "Created on {absoluteTime}",
    "recentWork.eventTypeMessage.multi.absolute.edited": "Edited on {absoluteTime}",
    "recentWork.eventTypeMessage.multi.absolute.published": "Published on {absoluteTime}",
    "recentWork.eventTypeMessage.multi.absolute.updated": "Updated on {absoluteTime}",
    "recentWork.eventTypeMessage.multi.absolute.viewed": "Viewed on {absoluteTime}",
    "recentWork.eventTypeMessage.multi.absolute.workedOn": "Worked on {absoluteTime}",
    "recentWork.eventTypeMessage.multi.commented": "Commented",
    "recentWork.eventTypeMessage.multi.created": "Created",
    "recentWork.eventTypeMessage.multi.dateTime.workedOn": "Worked on {relativeTime}",
    "recentWork.eventTypeMessage.multi.edited": "Edited",
    "recentWork.eventTypeMessage.multi.published": "Published",
    "recentWork.eventTypeMessage.multi.relative.commented": "Commented {relativeTime}",
    "recentWork.eventTypeMessage.multi.relative.created": "Created {relativeTime}",
    "recentWork.eventTypeMessage.multi.relative.edited": "Edited {relativeTime}",
    "recentWork.eventTypeMessage.multi.relative.published": "Published {relativeTime}",
    "recentWork.eventTypeMessage.multi.relative.updated": "Updated {relativeTime}",
    "recentWork.eventTypeMessage.multi.relative.viewed": "Viewed {relativeTime}",
    "recentWork.eventTypeMessage.multi.updated": "Updated",
    "recentWork.eventTypeMessage.multi.viewed": "Viewed",
    "recentWork.eventTypeMessage.multi.workedOn": "Worked on",
    "recentWork.eventTypeMessage.published": "You published",
    "recentWork.eventTypeMessage.relative.commented": "You commented {relativeTime}",
    "recentWork.eventTypeMessage.relative.created": "You created {relativeTime}",
    "recentWork.eventTypeMessage.relative.edited": "You edited {relativeTime}",
    "recentWork.eventTypeMessage.relative.published": "You published {relativeTime}",
    "recentWork.eventTypeMessage.relative.updated": "You updated {relativeTime}",
    "recentWork.eventTypeMessage.relative.viewed": "You viewed {relativeTime}",
    "recentWork.eventTypeMessage.relative.workedOn": "You worked on {relativeTime}",
    "recentWork.eventTypeMessage.updated": "You updated",
    "recentWork.eventTypeMessage.viewed": "You viewed",
    "recentWork.eventTypeMessage.workedOn": "You worked on",
    "recents_heading": "Search Results",
    "recommended.eventTypeMessage.icu.absolute.clicked": "{actor, select, you {You clicked on {absoluteTime}} collaborator {Collaborator clicked on {absoluteTime}} other {{username} clicked on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.commented": "{actor, select, you {You commented on {absoluteTime}} collaborator {Collaborator commented on {absoluteTime}} other {{username} commented on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.created": "{actor, select, you {You created on {absoluteTime}} collaborator {Collaborator created on {absoluteTime}} other {{username} created on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.edited": "{actor, select, you {You edited on {absoluteTime}} collaborator {Collaborator edited on {absoluteTime}} other {{username} edited on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.interacted": "{actor, select, you {You interacted on {absoluteTime}} collaborator {Collaborator interacted on {absoluteTime}} other {{username} interacted on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.mentioned": "{actor, select, you {You were mentioned on {absoluteTime}} collaborator {Collaborator was mentioned on {absoluteTime}} other {{username} was mentioned on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.reacted": "{actor, select, you {You reacted on {absoluteTime}} collaborator {Collaborator reacted on {absoluteTime}} other {{username} reacted on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.read": "{actor, select, you {You read on {absoluteTime}} collaborator {Collaborator read on {absoluteTime}} other {{username} read on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.shared": "{actor, select, you {You shared on {absoluteTime}} collaborator {Collaborator shared on {absoluteTime}} other {{username} shared on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.absolute.viewed": "{actor, select, you {You viewed on {absoluteTime}} collaborator {Collaborator viewed on {absoluteTime}} other {{username} viewed on {absoluteTime}}}",
    "recommended.eventTypeMessage.icu.clicked": "{actor, select, you {You clicked} collaborator {Collaborator clicked} other {{username} clicked}}",
    "recommended.eventTypeMessage.icu.commented": "{actor, select, you {You commented} collaborator {Collaborator commented} other {{username} commented}}",
    "recommended.eventTypeMessage.icu.created": "{actor, select, you {You created} collaborator {Collaborator created} other {{username} created}}",
    "recommended.eventTypeMessage.icu.edited": "{actor, select, you {You edited} collaborator {Collaborator edited} other {{username} edited}}",
    "recommended.eventTypeMessage.icu.interacted": "{actor, select, you {You interacted} collaborator {Collaborator interacted} other {{username} interacted}}",
    "recommended.eventTypeMessage.icu.mentioned": "{actor, select, you {You were mentioned} collaborator {Collaborator was mentioned} other {{username} was mentioned}}",
    "recommended.eventTypeMessage.icu.reacted": "{actor, select, you {You reacted} collaborator {Collaborator reacted} other {{username} reacted}}",
    "recommended.eventTypeMessage.icu.read": "{actor, select, you {You read} collaborator {Collaborator read} other {{username} read}}",
    "recommended.eventTypeMessage.icu.relative.clicked": "{actor, select, you {You clicked {relativeTime}} collaborator {Collaborator clicked {relativeTime}} other {{username} clicked {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.commented": "{actor, select, you {You commented {relativeTime}} collaborator {Collaborator commented {relativeTime}} other {{username} commented {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.created": "{actor, select, you {You created {relativeTime}} collaborator {Collaborator created {relativeTime}} other {{username} created {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.edited": "{actor, select, you {You edited {relativeTime}} collaborator {Collaborator edited {relativeTime}} other {{username} edited {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.interacted": "{actor, select, you {You interacted {relativeTime}} collaborator {Collaborator interacted {relativeTime}} other {{username} interacted {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.mentioned": "{actor, select, you {You were mentioned {relativeTime}} collaborator {Collaborator was mentioned {relativeTime}} other {{username} was mentioned {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.reacted": "{actor, select, you {You reacted {relativeTime}} collaborator {Collaborator reacted {relativeTime}} other {{username} reacted {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.read": "{actor, select, you {You read {relativeTime}} collaborator {Collaborator read {relativeTime}} other {{username} read {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.shared": "{actor, select, you {You shared {relativeTime}} collaborator {Collaborator shared {relativeTime}} other {{username} shared {relativeTime}}}",
    "recommended.eventTypeMessage.icu.relative.viewed": "{actor, select, you {You viewed {relativeTime}} collaborator {Collaborator viewed {relativeTime}} other {{username} viewed {relativeTime}}}",
    "recommended.eventTypeMessage.icu.shared": "{actor, select, you {You shared} collaborator {Collaborator shared} other {{username} shared}}",
    "recommended.eventTypeMessage.icu.viewed": "{actor, select, you {You viewed} collaborator {Collaborator viewed} other {{username} viewed}}",
    "relay.jira-dc-work-item.issue-label": "Issue",
    "relay.jira-dc-work-item.work-item.work-item-label": "Work item",
    "relay.jira-dc.comment-result.label": "Comment",
    "relay.jira-dc.issue-result.label": "Work item",
    "relay.jira-dc.project-result.label": "Project",
    "relay.jira-dc.space-result.label": "Space",
    "relay.jira-dc.work-item-assignee.assigned": "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}",
    "relay.jira-dc.work-item-creator.created": "{created, select, internal {{firstName} created} other {External person created}}",
    "relay.jira-dc.work-item-status.for": "{statusLozenge} for {dateLozenge}",
    "relay.search-page.results.product-results.third-party.conversation-search-result.tabs-label": "Tabs",
    "relay.search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label": "{count, plural, one {# attachment} other {# attachments}}",
    "relay.search-page.results.product-results.third-party.message-search-result.member-count": "{count, plural, one {# member} other {# members}}",
    "relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label": "{count, plural, one {# link} other {# links}}",
    "relay.search-result.attachment-label": "Attachment",
    "relay.search-result.attachments.attached-date.label": "Attached {formattedDate}",
    "relay.search-result.attachments.audio-label": "Audio",
    "relay.search-result.attachments.expand.label": "Expand",
    "relay.search-result.attachments.image-label": "Image",
    "relay.search-result.attachments.pdf-label": "PDF",
    "relay.search-result.attachments.video-label": "Video",
    "relay.search-result.message-last-active": "Last active {formattedDate}",
    "relay.search-result.message-type-label": "Message",
    "relay.search-result.multi-workspace-label": "Multi-workspace",
    "relay.search-result.private-channel-label": "Private Channel",
    "relay.search-result.thread-type-label": "Thread",
    "relevance": "Relevance",
    "repository.label": "Repository",
    "results-sort.createdDate.selected": "Sort by created (newest)",
    "results-sort.createdDateASC": "Created (oldest)",
    "results-sort.createdDateASCSelected.selected": "Sort by created (oldest)",
    "results-sort.createdDateDESC": "Created (newest)",
    "results-sort.latestModifiedDateASC": "Updated (oldest)",
    "results-sort.latestModifiedDateASC.selected": "Sort by updated (oldest)",
    "results-sort.latestModifiedDateDESC": "Updated (newest)",
    "results-sort.latestModifiedDateDESC.selected": "Sort by updated (newest)",
    "results-sort.relevanceDESC": "Relevance",
    "results-sort.relevanceDESC.selected": "Sort by relevance",
    "results-sort.sort-options.label": "Change list sorting",
    "rovo-onboarding-got-it": "Got it",
    "rovo-onboarding-step-1-description": "Choose an app to get more relevant results and filters. For example, filter by Space in Confluence.",
    "rovo-onboarding-step-1-heading": "Search across company apps",
    "rovo-search.assets.filter.icon.label": "Assets filter",
    "rovo-search.confluence.filter.icon.label": "Confluence filter",
    "rovo-search.jira.filter.icon.label": "Jira filter",
    "rovo-search.talent.filter.icon.label": "Talent filter",
    "rovo.search.quick-find-3p.connect": "Connect {connectorName}",
    "rovo.search.quick-find-3p.dismiss": "Dismiss",
    "rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body": "Connect to see missing results",
    "rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading-v2": "Your admin added {connectorName}.",
    "rovo.search.quick-find-3p.full-connector.social-proof-high.heading-v2": "{teamConnectAppPercentage}% of your team have connected apps",
    "rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading-v3": "{teamConnectAppPercentage}% of your team have connected apps",
    "rovo.search.quick-find-3p.smart-link-connector.social-proof-low.body": "Connect your account to see missing results",
    "rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading-v2": "{connectorName} is now available!",
    "rovo.search.quick-find-authorization-fail": "Failed to connect to {product}.",
    "rovo.search.quick-find.authorization-success": "Account connected to {product}.",
    "seaech-page.townsquare.api.goal-state.archived": "Archived",
    "seaech-page.townsquare.api.goal-state.at-risk": "At risk",
    "seaech-page.townsquare.api.goal-state.cancelled": "Canceled",
    "seaech-page.townsquare.api.goal-state.completed": "Completed",
    "seaech-page.townsquare.api.goal-state.off-track": "Off track",
    "seaech-page.townsquare.api.goal-state.on-track": "On track",
    "seaech-page.townsquare.api.goal-state.paused": "Paused",
    "seaech-page.townsquare.api.goal-state.pending": "Pending",
    "search-branch-result.label": "Branch",
    "search-commit-result.committed": "Committed {formattedDate}",
    "search-commit-result.label": "Commit",
    "search-federated-result.email.label": "Email",
    "search-federated-result.external-person.label": "External person",
    "search-federated-result.forwarded.label": "{person} forwarded",
    "search-federated-result.inbox.label": "Inbox",
    "search-federated-result.sent.label": "{person} sent",
    "search-federated-result.timestamp.label": "{formattedDate}",
    "search-filters.filter-by-icon": "Filter by icon",
    "search-filters.names.contributor": "Contributor",
    "search-filters.names.type": "Type",
    "search-git-build-status.failed": "{failed} of {total} failed",
    "search-git-build-status.failed-generic": "Build failed",
    "search-git-build-status.icon-label": "Build status",
    "search-git-build-status.passed": "{passed} of {total} passed",
    "search-git-build-status.passed-generic": "Build passed",
    "search-git-build-status.paused": "Build paused",
    "search-git-build-status.pending": "Build pending",
    "search-git-build-status.running": "Build in progress",
    "search-git-build-status.stopped": "Build stopped",
    "search-git-build-status.unknown": "Build status unknown",
    "search-graph-calendar.calendar-label": "Calendar",
    "search-graph-calendar.created.placeholder": "{person} created",
    "search-graph-calendar.external-person": "External person",
    "search-graph-calendar.join-meeting-link": "Join meeting",
    "search-graph-calendar.meeting-link": "Meeting link",
    "search-graph-calendar.meeting-link-icon": "Join meeting",
    "search-graph-calendar.past-events-button": "Past events",
    "search-graph-calendar.recurring-event-icon": "Recurring event",
    "search-graph-calendar.recurring-event-label": "Recurring",
    "search-graph-calendar.upcoming-events-button": "Upcoming events",
    "search-graph-campaign.campaign-label": "Campaign",
    "search-graph-campaign.ended-on": "Ended on {date}",
    "search-graph-campaign.ends-on": "Ends on {date}",
    "search-graph-case.case-label": "Case",
    "search-graph-case.closed-on": "Closed on {date}",
    "search-graph-case.closes-on": "Closes on {date}",
    "search-graph-confluence-dc.document.attachmentLabel": "Attachment",
    "search-graph-confluence-dc.document.blogpostLabel": "Blog Post",
    "search-graph-confluence-dc.document.commentLabel": "Comment",
    "search-graph-confluence-dc.document.pageLabel": "Page",
    "search-graph-confluence-dc.document.spaceLabel": "Space",
    "search-graph-customer-contact.customer-contact-label": "Customer Contact",
    "search-graph-customer-org.customer-org-label": "Customer Organization",
    "search-graph-dashboard.dashboard-label": "Dashboard",
    "search-graph-data-table.data-table-label": "Data table",
    "search-graph-deal.closed-on": "Closed on {date}",
    "search-graph-deal.closes-on": "Closes on {date}",
    "search-graph-deal.deal-label": "Deal",
    "search-graph-default.dashboard.label": "Dashboard",
    "search-graph-default.deal.label": "Deal",
    "search-graph-default.design.label": "Design",
    "search-graph-default.invoice.label": "Invoice",
    "search-graph-default.task.label": "Task",
    "search-graph-jira-dc.comment-result.label": "Comment",
    "search-graph-jira-dc.issue-result.label": "Work item",
    "search-graph-jira-dc.project-result.label": "Project",
    "search-graph-jira-dc.space-result.label": "Space",
    "search-graph-lead.lead-label": "Lead",
    "search-graph-video.dropdown-message": "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}",
    "search-graph-video.duration.hours": "{hours} hour {minutes} min",
    "search-graph-video.duration.seconds": "{seconds} sec",
    "search-graph-video.gong-topics": "{chapterCount, plural, one {# topic in this call} other {# topics in this call}}",
    "search-graph-video.in-meeting-chat": "In-Meeting Chat",
    "search-graph-video.past-meetings": "Past meetings",
    "search-graph-video.past-meetings-updated": "Updated {relativeTime}",
    "search-graph-video.see-all": "See all",
    "search-graph-video.shared-links": "Shared links",
    "search-graph-video.video-icon-label": "video icon",
    "search-graph-video.video-thumbnail-alt-text": "Video thumbnail",
    "search-graph-video.video-type": "Video",
    "search-graph-work-item.approval": "Approval",
    "search-graph-work-item.bug.label": "Bug",
    "search-graph-work-item.catalog_item": "Catalog item",
    "search-graph-work-item.epic.label": "Epic",
    "search-graph-work-item.incident": "Incident",
    "search-graph-work-item.issue": "Issue",
    "search-graph-work-item.label": "Work item",
    "search-graph-work-item.milestone.label": "Milestone",
    "search-graph-work-item.problem": "Problem",
    "search-graph-work-item.question": "Question",
    "search-graph-work-item.requested_item": "Requested item",
    "search-graph-work-item.section": "Section",
    "search-graph-work-item.story.label": "Story",
    "search-graph-work-item.task.label": "Task",
    "search-graph-work-item.ticket": "Ticket",
    "search-page-relay.filters.product-filters.slack-channel.label": "Channel",
    "search-page-relay.filters.product-filters.slack-channel.placeholder": "Filter by channel",
    "search-page-relay.filters.product-filters.slack-channel.selected-label": "Selected",
    "search-page-relay.filters.product-filters.slack-channel.suggested-label": "Channels",
    "search-page-relay.filters.product-filters.workspace-name.label": "Team",
    "search-page-relay.filters.product-filters.workspace-name.placeholder": "Filter by team",
    "search-page-relay.filters.product-filters.workspace-name.selected-label": "Selected",
    "search-page-relay.filters.product-filters.workspace-name.suggested-label": "Teams",
    "search-page-relay.results.product-results.third-party.conversation-search-result.label": "Channel",
    "search-page-relay.results.product-results.third-party.conversation-search-result.member-count": "{count, plural, one {# member} other {# members}}",
    "search-page-relay.results.product-results.third-party.conversation-search-result.multi-workspace-channel-label": "Multi-workspace channel",
    "search-page-relay.results.product-results.third-party.conversation-search-result.private-channel": "Private channel",
    "search-page-relay.results.product-results.third-party.conversation-search-result.time-since-label": "Last active {formattedDate}",
    "search-page-relay.results.product-results.third-party.conversation-search-result.unknown-channel": "unknown-channel",
    "search-page.ai-mode.ai-mode": "AI Mode",
    "search-page.ai-mode.results": "Results",
    "search-page.app-filter-sidebar.all": "All",
    "search-page.app-filter-sidebar.connect-apps-description": "Get better answers and more results across Search and Chat.",
    "search-page.app-filter-sidebar.connect-apps-header": "Connect apps",
    "search-page.app-filter-sidebar.connected-apps-header": "Filter results",
    "search-page.app-filter-sidebar.filter-menu.menu-item.hide": "Hide app",
    "search-page.app-filter-sidebar.filter-menu.trigger": "Show more options",
    "search-page.app-filter-sidebar.group": "Filter search by app",
    "search-page.app-filter-sidebar.improve-search": "Improve search",
    "search-page.app-filter-sidebar.no-matching-results-tooltip": "No matching results in {product}",
    "search-page.app-filter-sidebar.product-timeout-button-text": "See only {product} results",
    "search-page.app-filter-sidebar.product-timeout-primary-text": "{product} results took too long to show",
    "search-page.app-filter-sidebar.product-timeout-secondary-text": "Try again by filtering just for {product}.",
    "search-page.app-filter-sidebar.product-timeout-tooltip": "{product} results were too slow to show",
    "search-page.app-filter-sidebar.show-all-apps.button.label": "Show all apps",
    "search-page.app-filter-sidebar.show-more.button.label": "Show more",
    "search-page.app-filter-sidebar.show-more.filter.placeholder": "Find apps",
    "search-page.assets.filter.assets-schema.icon.label": "Assets schema filter",
    "search-page.assets.filter.assets-schema.label.selected": "Selected",
    "search-page.assets.filter.assets-schema.label.unselected": "Suggested",
    "search-page.assets.filter.assets-schema.placeholder": "Find schemas",
    "search-page.assets.filter.assets-type.icon.label": "Object type filter",
    "search-page.assets.filter.assets-type.label.selected": "Selected",
    "search-page.assets.filter.assets-type.label.unselected": "Suggested",
    "search-page.assets.filter.assets-type.placeholder": "Find object types",
    "search-page.atlas.for": "for",
    "search-page.atlas.goal.for": "for",
    "search-page.auto-correction.did-you-mean": "Did you mean {suggestedQuery}",
    "search-page.auto-correction.search-instead-for": "Search instead for {originalQuery}",
    "search-page.auto-correction.showing-results-for": "Showing results for {replacementQuery}",
    "search-page.browser-extension-banner.close-button-label": "Close browser extension banner",
    "search-page.browser-extension-banner.link-text": "Get the browser extension",
    "search-page.browser-extension-banner.title": "Use Rovo wherever you are",
    "search-page.close-date-filter.date-label": "Select date",
    "search-page.close-date-filter.date-placeholder": "Select a date",
    "search-page.close-date-filter.label": "Close date",
    "search-page.close-date-filter.update-button": "Apply",
    "search-page.comment-icon-label": "Comment",
    "search-page.common.display-name-tooltip.displayNameLabel": "Display name: {displayName}",
    "search-page.common.display-name-tooltip.nameLabel": "Name: {name}",
    "search-page.common.graph-work-item-status.closed": "Closed",
    "search-page.common.graph-work-item-status.open": "Open",
    "search-page.common.quick-find.textfield.filterToggleLabel": "Filters",
    "search-page.common.quick-find.textfield.filterToggleLabelWithCount": "Filters, {count} applied",
    "search-page.common.search-result-type.playlist": "Playlist",
    "search-page.common.status-target-date-display.for": "for",
    "search-page.common.ui.clear-filter-button.label": "Clear filter",
    "search-page.common.ui.quick-find.search-dialog-announcer.availableOptions": "{count} options available",
    "search-page.common.ui.quick-find.search-dialog-announcer.errorAnnouncement": "Something went wrong. We couldn't load your search results. Please try again.",
    "search-page.common.ui.quick-find.search-dialog-announcer.noResultsAnnouncement": "We couldn't find any results with that title",
    "search-page.common.ui.top-reaction.image-reaction-fallback-label": "Like",
    "search-page.common.ui.top-reaction.unicode-reaction-aria-label": "{emojiName} reaction",
    "search-page.confluence.filter.content.placeholder": "Find content",
    "search-page.confluence.filter.content.selected": "Selected",
    "search-page.confluence.filter.content.unselected": "Suggested",
    "search-page.confluence.filter.contributor.label.selected": "Selected",
    "search-page.confluence.filter.contributor.label.unselected": "Suggested",
    "search-page.confluence.filter.contributor.placeholder": "Find people",
    "search-page.confluence.filter.creator.placeholder": "Find people",
    "search-page.confluence.filter.creator.selected": "Selected",
    "search-page.confluence.filter.creator.unselected": "Suggested",
    "search-page.confluence.filter.icon.label": "Confluence filter",
    "search-page.confluence.filter.label.selected": "Selected",
    "search-page.confluence.filter.label.unselected": "Suggested",
    "search-page.confluence.filter.labels.placeholder": "Find labels",
    "search-page.confluence.filter.space.icon": "Space Icon",
    "search-page.confluence.filter.space.placeholder": "Find spaces",
    "search-page.controllers.all-apps-icon.appStackLabel": "Apps not shown",
    "search-page.controllers.store.search.filters.universal-type.async-video": "Async videos",
    "search-page.controllers.store.search.filters.universal-type.meeting-recording": "Meeting recordings",
    "search-page.controllers.store.search.filters.universal-type.playlist": "Playlists",
    "search-page.dropdown.search-suggestions": "Search Suggestions Dropdown",
    "search-page.embedded-comments.comment-header-prefix": "Re: {label}",
    "search-page.filter.app-select.all": "All",
    "search-page.filter.app-select.label.selected": "Selected",
    "search-page.filter.app-select.label.unselected": "Suggested",
    "search-page.filter.app-select.placeholder": "Find app",
    "search-page.filter.app-select.tooltip.redirect": "Open a full page search filtered by {appLabel} results",
    "search-page.filter.close.date.anytime": "Anytime",
    "search-page.filter.close.date.custom": "Specific date",
    "search-page.filter.close.date.last30days": "Last 30 days",
    "search-page.filter.close.date.last365days": "Last 365 days",
    "search-page.filter.close.date.last7days": "Last 7 days",
    "search-page.filter.close.date.last90days": "Last 90 days",
    "search-page.filter.close.date.next30days": "Next 30 days",
    "search-page.filter.close.date.next365days": "Next 365 days",
    "search-page.filter.close.date.next7days": "Next 7 days",
    "search-page.filter.close.date.next90days": "Next 90 days",
    "search-page.filter.close.date.today": "Today",
    "search-page.filter.last.updated.anytime": "Anytime",
    "search-page.filter.last.updated.custom": "Custom",
    "search-page.filter.last.updated.past30Days": "Past 30 days",
    "search-page.filter.last.updated.past7Days": "Past 7 days",
    "search-page.filter.last.updated.pastYear": "Past year",
    "search-page.filter.last.updated.today": "Today",
    "search-page.filter.last.updated.yesterday": "Yesterday",
    "search-page.filter.opportunityStatus.all": "Any",
    "search-page.filter.opportunityStatus.closed": "Closed",
    "search-page.filter.opportunityStatus.open": "Open",
    "search-page.filter.pageStatus.all": "All",
    "search-page.filter.pageStatus.inProgress": "In progress",
    "search-page.filter.pageStatus.readyForReview": "Ready for review",
    "search-page.filter.pageStatus.roughDraft": "Rough draft",
    "search-page.filter.pageStatus.verified": "Verified",
    "search-page.filter.pull-request-status.declined": "Declined",
    "search-page.filter.pull-request-status.draft": "Draft",
    "search-page.filter.pull-request-status.merged": "Merged",
    "search-page.filter.pull-request-status.open": "Open",
    "search-page.filter.pull-request-status.unknown": "Unknown",
    "search-page.filter.reviewer.label.selected": "Selected",
    "search-page.filter.reviewer.label.unselected": "Suggested",
    "search-page.filter.reviewer.placeholder": "Find people",
    "search-page.filter.status.done": "Done",
    "search-page.filter.status.indeterminate": "In Progress (Open)",
    "search-page.filter.status.new": "To Do (Open)",
    "search-page.filter.status.open": "Open",
    "search-page.filter.status.undefined": "Other",
    "search-page.filter.suggested.options.section": "Suggested",
    "search-page.filter.type.Story": "Story",
    "search-page.filter.type.all": "All",
    "search-page.filter.type.answer": "Answers",
    "search-page.filter.type.archive": "Archive",
    "search-page.filter.type.article": "Articles",
    "search-page.filter.type.ask": "Asks",
    "search-page.filter.type.attachment": "Attachments",
    "search-page.filter.type.audio": "Audio",
    "search-page.filter.type.blogpost": "Blog posts",
    "search-page.filter.type.board": "Boards",
    "search-page.filter.type.branch": "Branches",
    "search-page.filter.type.bug": "Bug",
    "search-page.filter.type.calendar": "Calendars",
    "search-page.filter.type.campaign": "Campaigns",
    "search-page.filter.type.card": "Cards",
    "search-page.filter.type.case": "Cases",
    "search-page.filter.type.catalog-item": "Catalog items",
    "search-page.filter.type.code": "Code",
    "search-page.filter.type.comment": "Comments",
    "search-page.filter.type.commit": "Commits",
    "search-page.filter.type.component": "Components",
    "search-page.filter.type.conversation": "Channels",
    "search-page.filter.type.customer-contact": "Customer Contacts",
    "search-page.filter.type.customer-org": "Customer Organizations",
    "search-page.filter.type.dashboard": "Dashboards",
    "search-page.filter.type.data-table": "Data tables",
    "search-page.filter.type.database": "Databases",
    "search-page.filter.type.deal": "Deals",
    "search-page.filter.type.demand": "Demands",
    "search-page.filter.type.design": "Designs",
    "search-page.filter.type.devops-work-item": "Issues",
    "search-page.filter.type.documents": "Documents",
    "search-page.filter.type.embed": "Smart Links",
    "search-page.filter.type.epic": "Epic",
    "search-page.filter.type.filter": "Filters",
    "search-page.filter.type.focus-area": "Focus areas",
    "search-page.filter.type.folder": "Folders",
    "search-page.filter.type.form": "Form",
    "search-page.filter.type.gliffy": "Gliffy Diagrams",
    "search-page.filter.type.goal": "Goals",
    "search-page.filter.type.image": "Images",
    "search-page.filter.type.incident": "Incidents",
    "search-page.filter.type.invoice": "Invoices",
    "search-page.filter.type.jira-work-item": "Work items",
    "search-page.filter.type.knowledge-article": "Knowledge articles",
    "search-page.filter.type.lead": "Leads",
    "search-page.filter.type.message": "Messages",
    "search-page.filter.type.news-article": "News articles",
    "search-page.filter.type.notebook": "Notebook",
    "search-page.filter.type.object": "Objects",
    "search-page.filter.type.organization": "Organizations",
    "search-page.filter.type.other": "Other",
    "search-page.filter.type.page": "Pages",
    "search-page.filter.type.pageAndLiveDoc": "Pages and Live Docs",
    "search-page.filter.type.pdf": "PDF",
    "search-page.filter.type.placeholder": "Find type",
    "search-page.filter.type.plan": "Plans",
    "search-page.filter.type.position": "Positions",
    "search-page.filter.type.post": "Posts",
    "search-page.filter.type.presentation": "Presentations",
    "search-page.filter.type.project": "Projects",
    "search-page.filter.type.pull-request": "Pull requests",
    "search-page.filter.type.question": "Questions",
    "search-page.filter.type.repository": "Repositories",
    "search-page.filter.type.requested-item": "Requested items",
    "search-page.filter.type.risk": "Risks",
    "search-page.filter.type.schema": "Schemas",
    "search-page.filter.type.shortcut": "Shortcut",
    "search-page.filter.type.slide": "Slides",
    "search-page.filter.type.space": "Spaces",
    "search-page.filter.type.space-calendar": "Space calendars",
    "search-page.filter.type.spreadsheet": "Spreadsheets",
    "search-page.filter.type.subtask": "Subtask",
    "search-page.filter.type.tag": "Tags",
    "search-page.filter.type.task": "Task",
    "search-page.filter.type.ticket": "Tickets",
    "search-page.filter.type.type": "Object types",
    "search-page.filter.type.video": "Videos",
    "search-page.filter.type.web-page": "Web pages",
    "search-page.filter.type.whiteboard": "Whiteboards",
    "search-page.filter.type.work-item": "Tasks",
    "search-page.filters.clear-filters-button-label": "Clear filters",
    "search-page.filters.dropdown.button": "More filters",
    "search-page.filters.dropdown.clear-filters": "Clear filters",
    "search-page.filters.names.app-select": "App",
    "search-page.filters.names.archived": "Show archived content",
    "search-page.filters.names.archivedAndPendingComponents": "Show archived/pending components",
    "search-page.filters.names.assets-schema": "Schema",
    "search-page.filters.names.assets-type": "Object type",
    "search-page.filters.names.assignee": "Assignee",
    "search-page.filters.names.closeDate": "Close date",
    "search-page.filters.names.content": "Content under",
    "search-page.filters.names.contributor": "Contributor",
    "search-page.filters.names.createdBy": "Created by",
    "search-page.filters.names.drive": "Drive",
    "search-page.filters.names.focusAreaType": "Focus area type",
    "search-page.filters.names.focusAreaUnder": "Focus area under",
    "search-page.filters.names.has-attachment": "Has attachment",
    "search-page.filters.names.labels": "Label",
    "search-page.filters.names.lastUpdated": "Last updated",
    "search-page.filters.names.lastUpdatedBy": "Last updated by",
    "search-page.filters.names.owner": "Owner",
    "search-page.filters.names.pageStatus": "Status",
    "search-page.filters.names.position-status-filter": "Filled status",
    "search-page.filters.names.positionEmploymentType": "Employment type",
    "search-page.filters.names.positionFocusArea": "Focus area",
    "search-page.filters.names.positionJobFamily": "Job family",
    "search-page.filters.names.positionTeam": "Team",
    "search-page.filters.names.project": "Project",
    "search-page.filters.names.pull-request-status": "PR status",
    "search-page.filters.names.reporter": "Reporter",
    "search-page.filters.names.repository": "Repository",
    "search-page.filters.names.repository.no-options": "No repositories available",
    "search-page.filters.names.reviewer": "Reviewer",
    "search-page.filters.names.site": "Site",
    "search-page.filters.names.space": "Space",
    "search-page.filters.names.spaces": "Space",
    "search-page.filters.names.status": "Status",
    "search-page.filters.names.titleMatchOnly": "Search title only",
    "search-page.filters.names.type": "Type",
    "search-page.filters.names.verified": "Verified",
    "search-page.filters.names.work-commented-on": "Work I've commented on",
    "search-page.filters.names.work-watching": "Work I\u2019m watching",
    "search-page.filters.suggested-filters-section-label": "Suggested",
    "search-page.google-drive.filter.drive.placeholder": "Find drives",
    "search-page.jira-assignee.assignee": "Assignee: {assigneeName}",
    "search-page.jira-assignee.unassigned": "Unassigned",
    "search-page.jira.filter.assignee.placeholder": "Find people",
    "search-page.jira.filter.assignee.selected": "Selected",
    "search-page.jira.filter.assignee.unselected": "Suggested",
    "search-page.jira.filter.project.placeholder": "Find projects",
    "search-page.jira.filter.project.selected": "Selected",
    "search-page.jira.filter.project.unselected": "Suggested",
    "search-page.jira.filter.reporter.placeholder": "Find people",
    "search-page.jira.filter.reporter.selected": "Selected",
    "search-page.jira.filter.reporter.unselected": "Suggested",
    "search-page.jira.filter.spaces.placeholder": "Find spaces",
    "search-page.jira.filter.spaces.selected": "Selected",
    "search-page.jira.filter.spaces.unselected": "Suggested",
    "search-page.linked-pull-requests.expand-label": "{count}{hasMore, select, true {+} other {}} {count, plural, one {Pull request} other {Pull requests}}",
    "search-page.linked-pull-requests.last-updated": "Updated {relativeTime}",
    "search-page.linked-pull-requests.metadata-label": "Pull Request",
    "search-page.linked-pull-requests.pull-request-id": "ID# {prId}",
    "search-page.linked-pull-requests.reviewer-count": "{count, plural, =0 {No reviewers} one {# reviewer} other {# reviewers}}",
    "search-page.linked-pull-requests.status-declined": "Declined",
    "search-page.linked-pull-requests.status-draft": "Draft",
    "search-page.linked-pull-requests.status-merged": "Merged",
    "search-page.linked-pull-requests.status-open": "Open",
    "search-page.linked-pull-requests.status-unknown": "Unknown",
    "search-page.linked-results.comments": "Comments",
    "search-page.linked-results.external-link": "External link",
    "search-page.linked-results.found-in": "Found in",
    "search-page.linked-results.mentioned-in": "Mentioned in",
    "search-page.linked-results.related": "Related links",
    "search-page.linked-results.related-pages": "Related pages",
    "search-page.linked-results.see-all": "See all",
    "search-page.linked-results.show-more": "Show {count} more",
    "search-page.linked-results.similar": "{count} similar",
    "search-page.mercury.filter.content.placeholder": "Find focus areas",
    "search-page.mercury.filter.content.selected": "Selected",
    "search-page.mercury.filter.content.unselected": "Suggested",
    "search-page.mercury.filter.focusAreaType.label.selected": "Selected",
    "search-page.mercury.filter.focusAreaType.label.unselected": "Suggested",
    "search-page.mercury.filter.focusAreaType.placeholder": "Find focus area types",
    "search-page.mercury.focus-area-update.title": "Update for {focusAreaName}",
    "search-page.navigation.search.work-items": "Search work items",
    "search-page.nouns.goal": "Goal",
    "search-page.nouns.goals": "Goals",
    "search-page.nouns.project": "Project",
    "search-page.nouns.projects": "Projects",
    "search-page.nouns.tag": "Tag",
    "search-page.nouns.tags": "Tags",
    "search-page.products.custom-website": "Web page",
    "search-page.products.custom-websites": "Web pages",
    "search-page.profile-avatar.label": "Person Avatar",
    "search-page.quick-find.dialog.banners.github-tip.dismissBannerLabel": "Dismiss GitHub tip",
    "search-page.quick-find.dialog.banners.github-tip.oauthFailFlagTitle": "Could not connect to GitHub",
    "search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagDescription": "You can now find and action on PRs, commits, and repos in Rovo Search and Chat.",
    "search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagTitle": "GitHub connected",
    "search-page.quick-find.dialog.banners.github-tip.tipBanner": "<b>Tip:</b> <connectLink>Connect GitHub</connectLink> to find and action on PRs, issues, and repos in your search results.",
    "search-page.quick-find.dialog.chat-intent-router.chat": "Ask Rovo",
    "search-page.quick-find.dialog.chat-intent-router.results-heading": "Search results",
    "search-page.quick-find.dialog.chat-intent-router.search": "Search all apps",
    "search-page.quick-find.dialog.chat-intent-router.search-for-query": "Search",
    "search-page.quick-find.dialog.filters.inline-product-filters.moreFiltersLabel": "More",
    "search-page.quick-find.dialog.product-entity.loomVideoCount": "{count, plural, one {# video} other {# videos}}",
    "search-page.quick-find.dialog.prompt-of-the-day.askRovo": "Ask Rovo",
    "search-page.quick-find.dialog.prompt-of-the-day.promptOfTheDayIconLabel": "Rovo chat prompt",
    "search-page.quick-find.filters.product-filters.loom-folder.loomFilterFolderIcon": "Folder Icon",
    "search-page.quick-find.filters.product-filters.loom-folder.loomFilterFolderPlaceholder": "Find folders",
    "search-page.quick-find.filters.product-filters.loom-folder.loomFilterLabelSelected": "Selected",
    "search-page.quick-find.filters.product-filters.loom-folder.loomFilterLabelUnselected": "Suggested",
    "search-page.quick-find.filters.product-filters.loom-folder.loomFolder": "Folder",
    "search-page.quick-find.filters.product-filters.loom-space.loomFilterLabelSelected": "Selected",
    "search-page.quick-find.filters.product-filters.loom-space.loomFilterLabelUnselected": "Suggested",
    "search-page.quick-find.filters.product-filters.loom-space.loomFilterSpaceIcon": "Space Icon",
    "search-page.quick-find.filters.product-filters.loom-space.loomFilterSpacePlaceholder": "Find spaces",
    "search-page.quick-find.filters.product-filters.loom-space.loomSpace": "Spaces",
    "search-page.quick-find.filters.product-filters.loom-tag.findTags": "Find tags",
    "search-page.quick-find.filters.product-filters.loom-tag.selected": "Selected",
    "search-page.quick-find.filters.product-filters.loom-tag.suggested": "Suggested",
    "search-page.quick-find.filters.product-filters.loom-tag.tagIcon": "Tag icon",
    "search-page.quick-find.filters.product-filters.loom-tag.tags": "Tags",
    "search-page.relay.compass.owner-name": "Owned by {ownerName}",
    "search-page.relay.compass.tier": "Tier {tier}",
    "search-page.relay.fps-inline-rovo-chat.title": "Dive deeper into this topic with Rovo",
    "search-page.result.mercury.risk.icon.label": "Risk",
    "search-page.result.mercury.risk.status.accepted": "Accepted",
    "search-page.result.mercury.risk.status.canceled": "Canceled",
    "search-page.result.mercury.risk.status.draft": "Draft",
    "search-page.result.mercury.risk.status.resolved": "Resolved",
    "search-page.results.private-result-label": "Private",
    "search-page.results.private-result-tooltip": "Only visible to you",
    "search-page.results.product-results.third-party.channel-member-count": "{memberCount, plural, one {# member} other {# members}}",
    "search-page.results.product-results.third-party.channel-type-label": "Channel",
    "search-page.results.product-results.third-party.external-people-label": "External people",
    "search-page.results.product-results.third-party.external-person-label": "External person",
    "search-page.results.product-results.third-party.last-active": "Last active {relativeDate}",
    "search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip": "Restricted - Only specific people can see this result",
    "search-page.results.product-results.third-party.message-type-label": "Message",
    "search-page.results.product-results.third-party.no-contributors-label": "External people in #{channelName}",
    "search-page.results.product-results.third-party.private-conversation-text": "{users} in a private conversation",
    "search-page.results.product-results.third-party.thread-type-label": "Thread",
    "search-page.results.product-results.third-party.title-and-channel-name": "{title} in #{channelName}",
    "search-page.results.product-results.third-party.title-with-remaining-contributors": "{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}",
    "search-page.results.restricted-result-label": "Restricted",
    "search-page.results.restricted-result-tooltip": "Only visible to specific people",
    "search-page.salesforce.filter.calendarType": "Calendar Type",
    "search-page.salesforce.filter.calendarType.no-options": "No calendar types available",
    "search-page.salesforce.filter.campaignStatus": "Campaign status",
    "search-page.salesforce.filter.campaignStatus.no-options": "No statuses available",
    "search-page.salesforce.filter.caseStatus": "Case status",
    "search-page.salesforce.filter.caseStatus.no-options": "No statuses available",
    "search-page.salesforce.filter.dealStatus": "Deal status",
    "search-page.salesforce.filter.documentStatus": "Document status",
    "search-page.salesforce.filter.documentStatus.no-options": "No statuses available",
    "search-page.salesforce.filter.leadStatus": "Lead Status",
    "search-page.salesforce.filter.leadStatus.no-options": "No lead statuses available",
    "search-page.salesforce.filter.stage": "Deal stage",
    "search-page.salesforce.filter.stage.closed-lost-send-survey": "Closed Lost (Send Survey)",
    "search-page.salesforce.filter.stage.closed-won": "Closed Won",
    "search-page.salesforce.filter.stage.closed-won-auto-linked": "Closed Won (Auto Linked)",
    "search-page.salesforce.filter.stage.develop-opportunity": "Develop Opportunity",
    "search-page.salesforce.filter.stage.invalid-opp": "Invalid Opp",
    "search-page.salesforce.filter.stage.lost": "Lost",
    "search-page.salesforce.filter.stage.new": "New",
    "search-page.salesforce.filter.stage.no-opportunity": "No Opportunity",
    "search-page.salesforce.filter.stage.no-options": "No stages available",
    "search-page.salesforce.filter.stage.qualify-opportunity": "Qualify Opportunity",
    "search-page.salesforce.filter.taskStatus": "Task Status",
    "search-page.salesforce.filter.taskStatus.no-options": "No task statuses available",
    "search-page.salesforce.filter.taskType": "Task Type",
    "search-page.salesforce.filter.taskType.no-options": "No task types available",
    "search-page.search-link.label": "Search Link",
    "search-page.search-page-header.search-results": "Search results",
    "search-page.search-page-relay.filters.product-filters.contributor.confluenceFilterContributorDeactivatedLabel": "{userName} (Deactivated)",
    "search-page.search-page-relay.filters.product-filters.contributor.confluenceFilterContributorUnknownUser": "Unknown user",
    "search-page.search-page-relay.filters.product-filters.folder.folder": "Folder",
    "search-page.search-page-relay.filters.product-filters.folder.folder-icon": "Folder",
    "search-page.search-page-relay.filters.product-filters.folder.placeholder": "Find folders",
    "search-page.search-page-relay.filters.product-filters.folder.selected": "Selected",
    "search-page.search-page-relay.filters.product-filters.folder.suggested": "Suggested",
    "search-page.search-page-relay.filters.product-filters.site-select.currentSiteLabel": "{name} <hint>(current)</hint>",
    "search-page.search-page-relay.filters.product-filters.site-select.find-sites-placeholder.ai-non-final": "Find sites",
    "search-page.search-page-relay.filters.product-filters.site-select.label": "Sites",
    "search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingMax": "Selected <hint>(Select up to {max})</hint>",
    "search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingMaxReached": "Selected <hint>(Maximum selected)</hint>",
    "search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingPlain": "Selected",
    "search-page.search-page-relay.filters.product-filters.site-select.unselectedHeading": "{count, plural, one {Site} other {Sites}}",
    "search-page.search-page-relay.filters.product-filters.tag.placeholder": "Find tags",
    "search-page.search-page-relay.filters.product-filters.tag.selected": "Selected",
    "search-page.search-page-relay.filters.product-filters.tag.suggested": "Suggested",
    "search-page.search-page-relay.filters.product-filters.tag.tag": "Tag",
    "search-page.search-page-relay.filters.refresh-filter-row.apps.allApps": "All apps",
    "search-page.search-page-relay.filters.refresh-filter-row.apps.groupLabel": "Filter by app",
    "search-page.search-page-relay.filters.refresh-filter-row.filters-control.buttonLabel": "All filters",
    "search-page.search-page-relay.filters.refresh-filter-row.filters-control.buttonLabelWithCount": "All filters, {count} applied",
    "search-page.search-page-relay.filters.refresh-filter-row.filters-control.dropdownLabel": "Filters",
    "search-page.search-page-relay.filters.refresh-filter-row.inline-filters.groupLabel": "Filter results",
    "search-page.search-page-relay.filters.refresh-filter-row.more-apps.connect": "Connect",
    "search-page.search-page-relay.filters.refresh-filter-row.more-apps.discoverMoreApps": "Discover more apps",
    "search-page.search-page-relay.filters.refresh-filter-row.more-apps.findApps": "Find apps",
    "search-page.search-page-relay.filters.refresh-filter-row.more-apps.moreApps": "More apps",
    "search-page.search-page-relay.search-results.federated-results-box.emptyTitleManyApps": "Nothing came back from apps outside Atlassian",
    "search-page.search-page-relay.search-results.federated-results-box.emptyTitleWithApps": "Nothing came back from {apps}",
    "search-page.search-page-relay.search-results.federated-results-box.infoTooltip": "Live results are fetched from these apps the moment you search, instead of from our search index. They may take a little longer and aren't ranked together with the results outside this box.",
    "search-page.search-page-relay.search-results.federated-results-box.loadingTitleManyApps": "Looking in apps outside Atlassian",
    "search-page.search-page-relay.search-results.federated-results-box.loadingTitleWithApps": "Looking in {apps}",
    "search-page.search-page-relay.search-results.federated-results-box.noResults": "We couldn't find anything matching your search",
    "search-page.search-page-relay.search-results.federated-results-box.showLess": "Show less",
    "search-page.search-page-relay.search-results.federated-results-box.showMore": "Show more",
    "search-page.search-page-relay.search-results.federated-results-box.titleManyApps": "Results pulled directly from apps outside Atlassian",
    "search-page.search-page-relay.search-results.federated-results-box.titleWithApps": "Results pulled directly from {apps}",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.code": "Code",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.moreActions": "More actions",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.moreActionsLabel": "More actions for {scope}",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.openInCodeSearch": "Open in Code Search",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-project.projectLabel": "Project",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInHoursOnly": "{hours, plural, one {# hour} other {# hours}}",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInMinutes": "{minutes} min",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInMinutesAndSeconds": "{minutes} min {seconds} sec",
    "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-loom-entity.videoCount": "{count, plural, one {# video} other {# videos}}",
    "search-page.sharepoint.filter.site.placeholder": "Find sites",
    "search-page.show-more-breadcrumbs-button-label": "Show more breadcrumbs",
    "search-page.tab-filter.accessible-more-dropdown-label": "Filter by more apps",
    "search-page.tab-filter.all-filter-accessible-label": "Filter by all apps",
    "search-page.tab-filter.all-filter-visual-label": "All",
    "search-page.tab-filter.more-dropdown-label": "More",
    "search-page.talent.filter.focus-area.content.placeholder": "Find focus areas",
    "search-page.talent.filter.focus-area.content.selected": "Selected",
    "search-page.talent.filter.focus-area.content.unselected": "Suggested",
    "search-page.talent.filter.position-employment-type.content.placeholder": "Find employment types",
    "search-page.talent.filter.position-employment-type.content.selected": "Selected",
    "search-page.talent.filter.position-employment-type.content.unselected": "Suggested",
    "search-page.talent.filter.position-job-family.content.placeholder": "Find job families",
    "search-page.talent.filter.position-job-family.content.selected": "Selected",
    "search-page.talent.filter.position-job-family.content.unselected": "Suggested",
    "search-page.talent.filter.position-status-filter.content.placeholder": "Find filled status",
    "search-page.talent.filter.position-status-filter.content.selected": "Selected",
    "search-page.talent.filter.position-status-filter.content.unselected": "Suggested",
    "search-page.talent.filter.position-team.content.placeholder": "Find teams",
    "search-page.talent.filter.position-team.content.selected": "Selected",
    "search-page.talent.filter.position-team.content.unselected": "Suggested",
    "search-page.verified-icon-label": "Verified",
    "search-page.verified-icon-tooltip-message": "This page has been verified by an owner or admin.",
    "search-pull-request-result.comments-label": "{count} {count, plural, one {comment} other {comments}}",
    "search-pull-request-result.label": "Pull request",
    "search-pull-request-result.status.declined": "Declined",
    "search-pull-request-result.status.draft": "Draft",
    "search-pull-request-result.status.merged": "Merged",
    "search-pull-request-result.status.open": "Open",
    "search-pull-request-result.status.unknown": "Unknown",
    "search-respository-result.label": "Repository",
    "search-result.direct-message-single-user": "{name1} and 1 other",
    "search-result.direct-message-two-users": "{name1} and {name2}",
    "search-result.federated-group-direct-message": "{knownNamesCount, plural, =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {name4}} other {{name1}, {name2}, {name3}, and {name4}} }",
    "search-result.federated-group-direct-message-with-multiple-others": "{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} others} =2 {{name1}, {name2}, and {totalOthersCount} others} =3 {{name1}, {name2}, {name3}, and {totalOthersCount} others} =4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others} other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others} }",
    "search-result.federated-group-direct-message-with-one-other": "{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} other} =2 {{name1}, {name2}, and {totalOthersCount} other} =3 {{name1}, {name2}, {name3}, and {totalOthersCount} other} =4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other} other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other} }",
    "search-result.group-chat-title": "{contributorCount, plural, =0 {Group message with external users} =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other} other {{name1}, {name2}, {name3}, and {overflowContributorCount} others} }",
    "search-result.group-direct-message-unknown-names": "{totalPeopleCount} people",
    "search-result.group-meeting-title": "{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }{channelName}",
    "search-result.last-modified": "Updated {formattedDate}",
    "search-result.private-channel-label": "Private Channel",
    "search-result.remove-recent-search": "Remove recent search icon",
    "search-result.remove-recent-search-result-subheading": "Recent search",
    "search-result.thread-title-with-others-and-channel-name": "{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }#{channelName}",
    "search-result.unknown-channel-in-thread": "unknown-channel",
    "search-result.user-mention.external-person": "External person",
    "search.quickFind.intentRouter.allApps": "All apps",
    "search.quickFind.intentRouter.jiraWorkItemsJql": "Jira work items (JQL)",
    "search.quickFind.intentRouter.searchForAllApps": "Search for all apps",
    "search.quickFind.intentRouter.searchForJiraWorkItems": "Search for Jira work items",
    "search_dialog_aria_label": "Search Dialog",
    "search_dialog_assets_display_name_search_warning": "<b>Search by display name is coming soon.</b> Try searching by name.",
    "search_dialog_assets_unavailable_message": "<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>.",
    "search_dialog_autocomplete_suggestion": "Suggestion",
    "search_dialog_dismiss_banner_label": "Dismiss banner",
    "search_dialog_error_search_body": "It might just be a hiccup. Please try refreshing the page or <button>try again</button>.",
    "search_dialog_error_search_heading": "We're having trouble loading your recently viewed content.",
    "search_dialog_feedback_footer": "Help us improve search",
    "search_dialog_loading_search_results": "Loading search results",
    "search_dialog_no_content_body": "Search for what you're looking for in your Atlassian and integrated apps",
    "search_dialog_no_content_body_default": "Search for anything across your Atlassian apps",
    "search_dialog_no_content_body_with_ai": "Search or ask what you're looking for in your Atlassian and integrated apps",
    "search_dialog_no_content_body_with_atlassian_intelligence": "Search or ask anything across your Atlassian apps",
    "search_dialog_no_content_body_with_rovo": "Search or ask Rovo what you're looking for in your Atlassian and integrated apps",
    "search_dialog_no_content_heading": "Seek and you shall find",
    "search_dialog_no_results_heading": "We couldn't find any results with that title",
    "search_dialog_no_results_search_body": "<link>Search all content across your organization</link> or try again with a different term.",
    "search_dialog_recent_search": "Recent search",
    "search_dialog_recents_heading": "Recent",
    "search_dialog_recommended_heading": "Recommended",
    "search_dialog_remove_recent_search_label": "Remove recent search",
    "search_dialog_rovo_banner_message": "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer",
    "search_dialog_rovo_tip": "Rovo tip:",
    "search_dialog_search_across_products": "Search all apps",
    "search_dialog_search_across_products.more": "more",
    "search_dialog_search_across_products.more-apps": "+ {more}",
    "search_dialog_search_across_products.more-apps-count": "+{count}",
    "search_dialog_search_change_message": "Why has search changed?",
    "search_dialog_team": "Team",
    "search_dialog_zero_query": "Suggestion",
    "search_dialog_zero_query_bitbucket_prs_created_collaborator_suggestion": "{productIcon} Bitbucket pull requests by {personAvatar} {name}",
    "search_dialog_zero_query_bitbucket_prs_created_collaborator_topic_suggestion": "{productIcon} Bitbucket pull requests about <b>{topic}</b> by {personAvatar} {name}",
    "search_dialog_zero_query_collaborator_profile_suggestion": "{personAvatar} {name}'s profile",
    "search_dialog_zero_query_confluence_pages_collaborator_suggestion_v2": "{productIcon} Confluence pages by {personAvatar} {name}",
    "search_dialog_zero_query_confluence_pages_created_30_days_suggestion": "{productIcon} Confluence pages I created in the {dateIcon} last 30 days",
    "search_dialog_zero_query_confluence_pages_created_7_days_suggestion": "{productIcon} Confluence pages I created in the {dateIcon} last 7 days",
    "search_dialog_zero_query_confluence_pages_created_collaborator_7_days_suggestion": "{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 7 days",
    "search_dialog_zero_query_confluence_pages_created_collaborator_last_30_days_suggestion": "{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 30 days",
    "search_dialog_zero_query_confluence_pages_created_collaborator_suggestion": "{productIcon} Confluence pages created by {personAvatar} {name}",
    "search_dialog_zero_query_confluence_pages_created_collaborator_topic_suggestion_v2": "{productIcon} Confluence pages about <b>{topic}</b> by {personAvatar} {name}",
    "search_dialog_zero_query_confluence_pages_created_suggestion": "{productIcon} Confluence pages I created",
    "search_dialog_zero_query_icon_label": "Suggestion search",
    "search_dialog_zero_query_issues_assigned_to_me_in_the_past_7_days_suggestion": "Issues assigned to me in the past 7 days",
    "search_dialog_zero_query_issues_i_created_in_the_last_month_suggestion": "Issues I created in the last month",
    "search_dialog_zero_query_jira_my_work_items_suggestion": "Show my {productIcon} work items",
    "search_dialog_zero_query_jira_nlq_collaborator_suggestion": "Recent open items assigned to {name}",
    "search_dialog_zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion": "Progress for epics created by me",
    "search_dialog_zero_query_jira_tickets_assigned_collaborator_suggestion": "{productIcon} tickets assigned to {personAvatar} {name}",
    "search_dialog_zero_query_jira_tickets_assigned_suggestion": "{productIcon} Jira tickets assigned to me",
    "search_dialog_zero_query_jira_tickets_created_collaborator_suggestion": "{productIcon} Jira tickets created by {personAvatar} {name}",
    "search_dialog_zero_query_jira_tickets_created_collaborator_topic_suggestion_v2": "{productIcon} Jira work items about <b>{topic}</b> by {personAvatar} {name}",
    "search_dialog_zero_query_jira_tickets_created_suggestion": "{productIcon} Jira tickets I created",
    "search_dialog_zero_query_jira_work_items_collaborator_suggestion_v2": "{productIcon} Jira work items by {personAvatar} {name}",
    "search_dialog_zero_query_recent_tickets_created_by_me_suggestion": "Recent tickets created by me",
    "search_dialog_zero_query_show_all_the_bugs_assigned_to_me_suggestion": "Show all the bugs assigned to me",
    "search_dialog_zero_query_show_high_priority_tickets_assigned_to_me_suggestion": "Show high priority tickets assigned to me",
    "search_dialog_zero_query_show_me_all_of_my_in_progress_work_items_suggestion": "Show me all of my in-progress work items",
    "search_dialog_zero_query_show_tickets_due_this_week_suggestion": "Show tickets due this week",
    "search_dialog_zero_query_third_party_github_collaborator_prs_suggestion": "{productIcon} GitHub pull requests by {personAvatar} {name}",
    "search_dialog_zero_query_third_party_github_collaborator_prs_topic_suggestion": "{productIcon} GitHub pull requests about <b>{topic}</b> by {personAvatar} {name}",
    "search_dialog_zero_query_third_party_google_collaborator_docs_suggestion": "{productIcon} Google docs from {personAvatar} {name}",
    "search_dialog_zero_query_third_party_google_collaborator_docs_suggestion_v2": "{productIcon} Google docs by {personAvatar} {name}",
    "search_dialog_zero_query_third_party_google_collaborator_docs_topic_suggestion_v2": "{productIcon} Google docs about <b>{topic}</b> by {personAvatar} {name}",
    "search_dialog_zero_query_third_party_google_my_docs_suggestion": "My {productIcon} Google Drive docs",
    "search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion": "{productIcon} SharePoint docs from {personAvatar} {name}",
    "search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion_v2": "{productIcon} SharePoint docs by {personAvatar} {name}",
    "search_dialog_zero_query_third_party_sharepoint_collaborator_docs_topic_suggestion_v2": "{productIcon} SharePoint docs about <b>{topic}</b> by {personAvatar} {name}",
    "search_dialog_zero_query_third_party_sharepoint_my_docs_suggestion": "My {productIcon} SharePoint documents",
    "search_dialog_zero_query_third_party_slack_collaborator_messages_suggestion": "{productIcon} Slack messages from {personAvatar} {name}",
    "search_dialog_zero_query_third_party_slack_my_messages_suggestion": "My {productIcon} Slack messages",
    "search_dialog_zero_query_what_are_my_open_tickets_suggestion": "What are my open tickets?",
    "search_dialog_zero_query_who_is_suggestion": "Who is {name}?",
    "search_filters.more": "more",
    "search_filters.more-apps-search": "Open full page search for this term searching all apps",
    "search_page.lite_app_filter_bar.all": "All",
    "search_page.lite_app_filter_bar.connect": "Connect",
    "search_page.lite_app_filter_bar.connect_app_aria": "Connect {app}",
    "search_page.lite_app_filter_bar.find_apps": "Find apps",
    "search_page.lite_app_filter_bar.more_apps": "More apps",
    "search_page.lite_header.feedback_button_label": "Feedback",
    "search_result_skeleton_loading_result": "Loading result",
    "search_result_type_answer": "Answer",
    "search_result_type_ask": "Ask",
    "search_result_type_attachment": "Attachment",
    "search_result_type_blogpost": "Blog Post",
    "search_result_type_board": "Board",
    "search_result_type_branch": "Branch",
    "search_result_type_bug": "Bug",
    "search_result_type_calendar": "Calendar",
    "search_result_type_card": "Card",
    "search_result_type_change": "Change",
    "search_result_type_channel": "Channel",
    "search_result_type_comment": "Comment",
    "search_result_type_commit": "Commit",
    "search_result_type_component": "Component",
    "search_result_type_customer_contact": "Customer contact",
    "search_result_type_customer_org": "Customer Organization",
    "search_result_type_dashboard": "Dashboard",
    "search_result_type_data_table": "Data table",
    "search_result_type_database": "Database",
    "search_result_type_deal": "Deal",
    "search_result_type_document": "Document",
    "search_result_type_email": "Email",
    "search_result_type_embed": "Smart Link",
    "search_result_type_epic": "Epic",
    "search_result_type_file": "File",
    "search_result_type_filter": "Filter",
    "search_result_type_focus_area": "Focus area",
    "search_result_type_focus_area_status_update": "Focus area update",
    "search_result_type_folder": "Folder",
    "search_result_type_gliffy": "Gliffy Diagram",
    "search_result_type_goal": "Goal",
    "search_result_type_improvement": "Improvement",
    "search_result_type_incident": "Incident",
    "search_result_type_issue": "Work item",
    "search_result_type_learning": "Learning",
    "search_result_type_message": "Message",
    "search_result_type_new_feature": "New feature",
    "search_result_type_object": "Object",
    "search_result_type_organization": "Organization",
    "search_result_type_organization_status_update": "Organization update",
    "search_result_type_page": "Page",
    "search_result_type_plan": "Plan",
    "search_result_type_position": "Position",
    "search_result_type_presentation": "Presentation",
    "search_result_type_problem": "Problem",
    "search_result_type_project": "Project",
    "search_result_type_pull_request": "Pull Request",
    "search_result_type_question": "Question",
    "search_result_type_repository": "Repository",
    "search_result_type_risk": "Risk",
    "search_result_type_schema": "Schema",
    "search_result_type_service_request": "Service request",
    "search_result_type_sharepoint_document": "Sharepoint Document",
    "search_result_type_slide": "Slides",
    "search_result_type_space": "Space",
    "search_result_type_space_calendar": "Space calendar",
    "search_result_type_spreadsheet": "Spreadsheet",
    "search_result_type_story": "Story",
    "search_result_type_sub_task": "Sub-task",
    "search_result_type_subtask": "Sub-task",
    "search_result_type_tag": "Tag",
    "search_result_type_task": "Task",
    "search_result_type_type": "Object type",
    "search_result_type_unrecognised": "Unrecognised",
    "search_result_type_video": "Video",
    "search_result_type_whiteboard": "Whiteboard",
    "search_result_type_work_item": "Work Item",
    "search_results_lite_issue_table_header_assignee": "Assignee",
    "search_results_lite_issue_table_header_labels": "Labels",
    "search_results_lite_issue_table_header_priority": "Priority",
    "search_results_lite_issue_table_header_status": "Status",
    "search_results_lite_issue_table_header_work": "Work",
    "search_results_lite_project_table_header_category": "Category",
    "search_results_lite_project_table_header_key": "Key",
    "search_results_lite_project_table_header_lead": "Lead",
    "search_results_lite_project_table_header_spaceUrl": "Space URL",
    "search_results_lite_project_table_header_spaces": "Spaces",
    "search_results_lite_project_table_header_type": "Type",
    "search_talent_position.external_position_key": "External key {positionExternalKey}",
    "search_talent_position.position_title": "{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}",
    "sidebar-oauth-warning-authorize": "Authorize",
    "sidebar-oauth-warning-dismiss": "Dismiss",
    "sidebar-oauth-warning.app-filter-tooltip-content": "Connect your account to see missing results, including documents only you have access to.",
    "sidebar-oauth-warning.app-filter-tooltip-content-alternate": "Connect your account to see missing results, including content only you have access to.",
    "sidebar-oauth-warning.authorization-fail": "Failed to connect to {product}.",
    "sidebar-oauth-warning.authorization-success": "Successfully connected to {product}.",
    "sidebar-oauth-warning.connect": "Connect",
    "space.label": "Space",
    "spreadsheet.label": "Spreadsheet",
    "suggestion": "See all results for \"{inputQuery}\" across apps",
    "summarize-in-chat-button-text": "Summarize",
    "summarize-in-chat-label": "Summarize",
    "task.label": "Task",
    "team": "Team",
    "third-party-query-suggestion.dismiss": "Dismiss",
    "third-party-query-suggestion.title": "Do smarter searches with {product}",
    "updatedNewest": "Updated (newest)",
    "updatedOldest": "Updated (oldest)",
    "video.label": "Video",
    "web-page.label": "Web Page",
    "whiteboard_type": "Whiteboard",
    "work-item-assignee.assigned": "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}",
    "work-item-creator.created": "{created, select, internal {{firstName} created} other {External person created}}",
    "work-item-status.for": "{statusLozenge} for {dateLozenge}",
    "work-item.label": "Work Item",
    "work_item": "Work item"
};


var $6e2a0e01d55c9360$export$2e2bcd8739ae039 = (0, $295b7ff928e6276a$export$2e2bcd8739ae039);

});

parcelRegister("eesba", function(module, exports) {

let $a5c83b44e9fdea48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5c83b44e9fdea48$var$load("k73rC").then(()=>parcelRequire('gnkFp'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("bLTm3", function(module, exports) {

let $891f05cea736a671$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $891f05cea736a671$var$load("aT1FI").then(()=>parcelRequire('kcajw'));

});

parcelRegister("3XVa6", function(module, exports) {

let $2e3338f01b56c7f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e3338f01b56c7f8$var$load("76dF2").then(()=>parcelRequire('kWKcd'));

});

parcelRegister("jaYAM", function(module, exports) {

let $039a4a204ec8a801$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $039a4a204ec8a801$var$load("11uX1").then(()=>parcelRequire('8PAZb'));

});

parcelRegister("7Bkma", function(module, exports) {

let $588bc7789402af19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $588bc7789402af19$var$load("iQsOe").then(()=>parcelRequire('asQjt'));

});

parcelRegister("iJnNd", function(module, exports) {

let $da2ee2b99abcf819$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da2ee2b99abcf819$var$load("kspPT").then(()=>parcelRequire('bTdEJ'));

});

parcelRegister("ksjH0", function(module, exports) {

let $ee45b2bae6cfe4c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee45b2bae6cfe4c7$var$load("2vdCN").then(()=>parcelRequire('hE8ma'));

});

parcelRegister("kUbIB", function(module, exports) {

let $f38220a15fe52194$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f38220a15fe52194$var$load("jStPO").then(()=>parcelRequire('75kab'));

});

parcelRegister("kaNfw", function(module, exports) {

let $eafaf1b352a5f436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eafaf1b352a5f436$var$load("81fn2").then(()=>parcelRequire('dzPtg'));

});

parcelRegister("jO13r", function(module, exports) {

let $e6b3813d34188852$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6b3813d34188852$var$load("ljRTH").then(()=>parcelRequire('98f4B'));

});

parcelRegister("6mYVW", function(module, exports) {

let $4a3410431f114883$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a3410431f114883$var$load("hJCLg").then(()=>parcelRequire('12Cdy'));

});

parcelRegister("8ml2N", function(module, exports) {

let $6160b3b3be19f5f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6160b3b3be19f5f1$var$load("4inSo").then(()=>parcelRequire('itV7i'));

});

parcelRegister("fpOW4", function(module, exports) {

let $b390b38e295de6e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b390b38e295de6e3$var$load("aleYU").then(()=>parcelRequire('1gKG3'));

});

parcelRegister("7F4l3", function(module, exports) {

let $593fba50eff65939$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $593fba50eff65939$var$load("5Nr2n").then(()=>parcelRequire('fZTFf'));

});

parcelRegister("gfKOF", function(module, exports) {

let $bd525ccb566c0a28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd525ccb566c0a28$var$load("6y3Ya").then(()=>parcelRequire('1J1Lf'));

});

parcelRegister("fOS8M", function(module, exports) {

let $b84585b81d1cff0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b84585b81d1cff0c$var$load("hGtK1").then(()=>parcelRequire('yFbLe'));

});

parcelRegister("aSAb5", function(module, exports) {

let $7ebb02aff65be5f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ebb02aff65be5f1$var$load("lbAcV").then(()=>parcelRequire('1FqU4'));

});

parcelRegister("6trHz", function(module, exports) {

let $4b6af08391b4612d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b6af08391b4612d$var$load("cTBsP").then(()=>parcelRequire('574Af'));

});

parcelRegister("fl3PF", function(module, exports) {

let $b2abca3a710e2814$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2abca3a710e2814$var$load("di4bq").then(()=>parcelRequire('kdeFV'));

});

parcelRegister("dqkwI", function(module, exports) {

let $9c5da04016c71bf2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c5da04016c71bf2$var$load("6U78m").then(()=>parcelRequire('8iUSn'));

});

parcelRegister("3oOtg", function(module, exports) {

let $279ac37d35b37318$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $279ac37d35b37318$var$load("8Dmyz").then(()=>parcelRequire('8PZAu'));

});

parcelRegister("eP8bg", function(module, exports) {

let $acac2c9ae2fdf3b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acac2c9ae2fdf3b1$var$load("1bl5r").then(()=>parcelRequire('avWuI'));

});

parcelRegister("cu6Sm", function(module, exports) {

let $916d9ebf20eec742$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $916d9ebf20eec742$var$load("dY9Sh").then(()=>parcelRequire('ffr5O'));

});

parcelRegister("grzGi", function(module, exports) {

let $bf8ad87fc4e61406$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf8ad87fc4e61406$var$load("k058b").then(()=>parcelRequire('bHCuS'));

});

parcelRegister("9rVUk", function(module, exports) {

let $6e138deb6e9df0cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e138deb6e9df0cb$var$load("2026J").then(()=>parcelRequire('cZOuw'));

});

parcelRegister("jmCuW", function(module, exports) {

let $e18def5143ec8c95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e18def5143ec8c95$var$load("6zpyO").then(()=>parcelRequire('28Moa'));

});

parcelRegister("l5SiF", function(module, exports) {

let $f5b42f7de5c19246$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5b42f7de5c19246$var$load("aRuDI").then(()=>parcelRequire('bhwyo'));

});

parcelRegister("5SBU6", function(module, exports) {

let $447f65d3169a3fa4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $447f65d3169a3fa4$var$load("9riYE").then(()=>parcelRequire('iFup6'));

});

parcelRegister("jfjtW", function(module, exports) {

let $e02e87c1789655d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e02e87c1789655d1$var$load("eUHuf").then(()=>parcelRequire('ap9AQ'));

});

parcelRegister("a8J3L", function(module, exports) {

let $761d9aad5426ba10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $761d9aad5426ba10$var$load("cszkW").then(()=>parcelRequire('dIqfm'));

});

parcelRegister("hyjql", function(module, exports) {

let $cc74adcebc639df4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc74adcebc639df4$var$load("74Kmq").then(()=>parcelRequire('2JNgk'));

});

parcelRegister("4d7mR", function(module, exports) {

let $310e1769d668fb5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $310e1769d668fb5a$var$load("35IX9").then(()=>parcelRequire('lhhjl'));

});

parcelRegister("l414Y", function(module, exports) {

let $f55acf03fb6d4f94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f55acf03fb6d4f94$var$load("3GIiH").then(()=>parcelRequire('g8ITL'));

});

parcelRegister("d1vR7", function(module, exports) {

let $97b4144299995d21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97b4144299995d21$var$load("4kV5T").then(()=>parcelRequire('ac1R4'));

});

parcelRegister("lbIOK", function(module, exports) {

let $f6cd63e6276725cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6cd63e6276725cf$var$load("kypvv").then(()=>parcelRequire('7e4b1'));

});

parcelRegister("erEK7", function(module, exports) {

let $a84330fd3deaab75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a84330fd3deaab75$var$load("7q9cq").then(()=>parcelRequire('6G3fP'));

});

parcelRegister("dwQIL", function(module, exports) {

let $9d9728ccbf553a2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d9728ccbf553a2e$var$load("eHGU5").then(()=>parcelRequire('asn5j'));

});

parcelRegister("9mlgJ", function(module, exports) {

let $6d06aaafb7441a35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d06aaafb7441a35$var$load("hLlcq").then(()=>parcelRequire('aR3Oj'));

});

parcelRegister("g1JlU", function(module, exports) {

let $baafeb614b6ad174$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $baafeb614b6ad174$var$load("jA8Dl").then(()=>parcelRequire('bbXwh'));

});

parcelRegister("ZF1G9", function(module, exports) {

let $0b95858b55ef9d9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b95858b55ef9d9e$var$load("3xRvV").then(()=>parcelRequire('fKLcB'));

});

parcelRegister("fagXR", function(module, exports) {

let $b0a4f2f5988f3388$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0a4f2f5988f3388$var$load("2aYhb").then(()=>parcelRequire('3F4yA'));

});

parcelRegister("gJKhA", function(module, exports) {

let $c2f4c013cacbeb0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2f4c013cacbeb0e$var$load("eTz5K").then(()=>parcelRequire('eCWoW'));

});

parcelRegister("a0jez", function(module, exports) {

let $7488d2ecd5949cb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7488d2ecd5949cb3$var$load("lGmgj").then(()=>parcelRequire('1I19A'));

});

parcelRegister("ea0Re", function(module, exports) {

let $a4f2aa2ec838f126$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4f2aa2ec838f126$var$load("c5IHZ").then(()=>parcelRequire('kHsMr'));

});

parcelRegister("gL0Dx", function(module, exports) {

let $c331879192c45873$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c331879192c45873$var$load("01RV0").then(()=>parcelRequire('IV7cu'));

});

parcelRegister("bhJWq", function(module, exports) {

let $8374eb3cbaf38bfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8374eb3cbaf38bfe$var$load("1qUsO").then(()=>parcelRequire('dhBpP'));

});

parcelRegister("hUo4O", function(module, exports) {

let $d09a57c1784e3f41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d09a57c1784e3f41$var$load("kn0SI").then(()=>parcelRequire('768ND'));

});

parcelRegister("hDbbU", function(module, exports) {

let $cd5ec284bb37b0e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd5ec284bb37b0e6$var$load("kfz2N").then(()=>parcelRequire('hJ2oL'));

});

parcelRegister("77INV", function(module, exports) {

let $52fbf10edd1e05a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52fbf10edd1e05a3$var$load("hL2Ox").then(()=>parcelRequire('4GJLD'));

});

parcelRegister("9sz3K", function(module, exports) {

let $6e31ecae7dd61d0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e31ecae7dd61d0a$var$load("bplo5").then(()=>parcelRequire('46ahm'));

});

parcelRegister("ctEz6", function(module, exports) {

let $9157a8e065c5c420$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9157a8e065c5c420$var$load("fpQoY").then(()=>parcelRequire('aQ5Tz'));

});

parcelRegister("im1dt", function(module, exports) {

let $d5cb399c13c97b96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5cb399c13c97b96$var$load("3wUy9").then(()=>parcelRequire('5esOH'));

});

parcelRegister("fRkaa", function(module, exports) {

let $b8bb72359051e69a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8bb72359051e69a$var$load("gUBgW").then(()=>parcelRequire('9LFDS'));

});

parcelRegister("jOXsT", function(module, exports) {

let $e6e0d056bdbc3b93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6e0d056bdbc3b93$var$load("4Z6hE").then(()=>parcelRequire('72uMY'));

});

parcelRegister("5oZ61", function(module, exports) {

let $3eee960aad957c3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3eee960aad957c3c$var$load("jrPIf").then(()=>parcelRequire('iYfMn'));

});

parcelRegister("lXomr", function(module, exports) {

let $ffc2013f8d22e2e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ffc2013f8d22e2e1$var$load("iwZyn").then(()=>parcelRequire('49G5V'));

});

parcelRegister("6AJxn", function(module, exports) {

let $4cc96d9f255d58b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4cc96d9f255d58b2$var$load("jOvje").then(()=>parcelRequire('bw4dB'));

});

parcelRegister("3yxPO", function(module, exports) {

let $296ecaeafc3054dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $296ecaeafc3054dd$var$load("b697X").then(()=>parcelRequire('ihuI8'));

});

parcelRegister("agerH", function(module, exports) {

let $77869aa32814e433$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77869aa32814e433$var$load("8roB9").then(()=>parcelRequire('iUPOS'));

});

parcelRegister("1guW5", function(module, exports) {

let $0ebf484815edccae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ebf484815edccae$var$load("8p0tm").then(()=>parcelRequire('7lFmB'));

});

parcelRegister("fBVAD", function(module, exports) {

let $b5d6fbd95f7e26ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5d6fbd95f7e26ec$var$load("bvA6j").then(()=>parcelRequire('kThIJ'));

});

parcelRegister("540xp", function(module, exports) {

let $3afdbe4dccd46815$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3afdbe4dccd46815$var$load("lDY72").then(()=>parcelRequire('3st9s'));

});

parcelRegister("dDn4v", function(module, exports) {

let $9ed0d06bfafce5dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ed0d06bfafce5dd$var$load("hmIOy").then(()=>parcelRequire('52wUs'));

});

parcelRegister("fheBd", function(module, exports) {

let $b1f3c4a832b70faf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1f3c4a832b70faf$var$load("8FID8").then(()=>parcelRequire('hJHXJ'));

});

parcelRegister("h8W7L", function(module, exports) {

let $c7b04547c11d530f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7b04547c11d530f$var$load("3009f").then(()=>parcelRequire('8R8Ed'));

});

parcelRegister("aUnph", function(module, exports) {

let $7f114a6b125a47dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f114a6b125a47dc$var$load("7MNN1").then(()=>parcelRequire('ift71'));

});

parcelRegister("d7Xrz", function(module, exports) {

let $98ea0a196cc4377c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98ea0a196cc4377c$var$load("cTLJ3").then(()=>parcelRequire('gGJSc'));

});

parcelRegister("1vhaM", function(module, exports) {

let $118601e0142afacd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $118601e0142afacd$var$load("cVPtW").then(()=>parcelRequire('arZEy'));

});

parcelRegister("b1QGl", function(module, exports) {

let $8078a73aaa6f6e71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8078a73aaa6f6e71$var$load("gnbOU").then(()=>parcelRequire('cN3s9'));

});

parcelRegister("8RgFL", function(module, exports) {

let $01aa115e39a6de8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01aa115e39a6de8d$var$load("aiiZC").then(()=>parcelRequire('DvCR2'));

});

parcelRegister("imD26", function(module, exports) {

let $d5e88f36797f8011$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5e88f36797f8011$var$load("hMjWd").then(()=>parcelRequire('ffj9v'));

});

parcelRegister("dKwIN", function(module, exports) {

let $a028f407cfdcdec5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a028f407cfdcdec5$var$load("IhBze").then(()=>parcelRequire('lTN0T'));

});

parcelRegister("2TMvz", function(module, exports) {

let $21c658868d58172c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21c658868d58172c$var$load("lpt3C").then(()=>parcelRequire('fw0aI'));

});

parcelRegister("edNkB", function(module, exports) {

let $a5a88bbb9642364b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5a88bbb9642364b$var$load("kXIxn").then(()=>parcelRequire('fEvLi'));

});

parcelRegister("7v0d6", function(module, exports) {

let $575b977196bb2fd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $575b977196bb2fd8$var$load("6Q9lF").then(()=>parcelRequire('b4eRY'));

});

parcelRegister("i6YAa", function(module, exports) {

let $d2f7c7ec265ccbe0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d2f7c7ec265ccbe0$var$load("4cNqp").then(()=>parcelRequire('9J119'));

});

parcelRegister("8hihb", function(module, exports) {

let $606e1681ee668ae9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $606e1681ee668ae9$var$load("aleGF").then(()=>parcelRequire('by7sz'));

});

parcelRegister("2ZCu4", function(module, exports) {

let $22df216920b5c4d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22df216920b5c4d7$var$load("lcHkg").then(()=>parcelRequire('e6oLi'));

});

parcelRegister("byEb5", function(module, exports) {

let $86a20926b8e12f5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86a20926b8e12f5d$var$load("dBV4Q").then(()=>parcelRequire('hCB2M'));

});

parcelRegister("3pj4Z", function(module, exports) {

let $27b281b133f5f3a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27b281b133f5f3a4$var$load("98UUs").then(()=>parcelRequire('aGhJr'));

});

parcelRegister("jys7x", function(module, exports) {

let $e3c70171a2df9892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3c70171a2df9892$var$load("7riC8").then(()=>parcelRequire('jF6w4'));

});

parcelRegister("1KJtX", function(module, exports) {

let $146d5e22b51e681e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $146d5e22b51e681e$var$load("65lxD").then(()=>parcelRequire('4IIWN'));

});

parcelRegister("jA8mS", function(module, exports) {

let $e417ded6695ebae6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e417ded6695ebae6$var$load("4nogl").then(()=>parcelRequire('jjtQ9'));

});

parcelRegister("fjM8E", function(module, exports) {

let $b26df8a7d4de83e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b26df8a7d4de83e0$var$load("d44ni").then(()=>parcelRequire('10FmW'));

});

parcelRegister("kvVV6", function(module, exports) {

let $eef3a196b06bc6e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eef3a196b06bc6e4$var$load("1Eqvr").then(()=>parcelRequire('iyPW7'));

});

parcelRegister("cHEVj", function(module, exports) {

let $0262fce1f4df4432$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0262fce1f4df4432$var$load("44wmz").then(()=>parcelRequire('y7v0S'));

});

parcelRegister("ehjC2", function(module, exports) {

let $a651ddda02217e68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a651ddda02217e68$var$load("cO5a2").then(()=>parcelRequire('6GEqi'));

});

parcelRegister("lXiQY", function(module, exports) {

let $ffbdbb8992e3db0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ffbdbb8992e3db0b$var$load("8lqWA").then(()=>parcelRequire('4hUYF'));

});

parcelRegister("ceL5Y", function(module, exports) {

let $8e8b5304204c4a51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e8b5304204c4a51$var$load("iNx4G").then(()=>parcelRequire('1wCbk'));

});

parcelRegister("9PFi4", function(module, exports) {

let $7288e7e5fcf03bf0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7288e7e5fcf03bf0$var$load("2Vvbg").then(()=>parcelRequire('7Zjm5'));

});

parcelRegister("9XxAb", function(module, exports) {

let $7403ac8e62227f8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7403ac8e62227f8e$var$load("cbliz").then(()=>parcelRequire('8LZPn'));

});

parcelRegister("OStr5", function(module, exports) {

let $098eecfbad8ef0a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $098eecfbad8ef0a9$var$load("w5kq3").then(()=>parcelRequire('8Ufq7'));

});

parcelRegister("1J13e", function(module, exports) {

let $141acf231ad6f73e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $141acf231ad6f73e$var$load("8T4jX").then(()=>parcelRequire('lFgl9'));

});

parcelRegister("gyaDS", function(module, exports) {

let $c0c813a05a3bae9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0c813a05a3bae9e$var$load("awIQZ").then(()=>parcelRequire('1TKS1'));

});

parcelRegister("lSLlQ", function(module, exports) {

let $fee35f1d7ec59492$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fee35f1d7ec59492$var$load("ktJiV").then(()=>parcelRequire('9fR4t'));

});

parcelRegister("kMWsF", function(module, exports) {

let $f225a38ff59bb52e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f225a38ff59bb52e$var$load("k2NKg").then(()=>parcelRequire('jsK0e'));

});

parcelRegister("kP2Kb", function(module, exports) {

let $f28ab2f843922754$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f28ab2f843922754$var$load("35V4w").then(()=>parcelRequire('aOTyk'));

});

parcelRegister("cCQAD", function(module, exports) {

let $9311d3e32497017c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9311d3e32497017c$var$load("fd9zH").then(()=>parcelRequire('dJUEP'));

});

parcelRegister("d7Jf3", function(module, exports) {

let $98df05ea3ffdc63d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98df05ea3ffdc63d$var$load("jw64g").then(()=>parcelRequire('69xlO'));

});

parcelRegister("92nxS", function(module, exports) {

let $6946909a866c352e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6946909a866c352e$var$load("sKZUj").then(()=>parcelRequire('8KIPG'));

});

parcelRegister("deUzL", function(module, exports) {

let $9a3877f40d68371e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a3877f40d68371e$var$load("l0Mz3").then(()=>parcelRequire('d2I6i'));

});

parcelRegister("aykdQ", function(module, exports) {

let $7aecc4163bd958b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7aecc4163bd958b2$var$load("5waBG").then(()=>parcelRequire('dNc9t'));

});

parcelRegister("8gT6G", function(module, exports) {

let $605a9065d5008449$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $605a9065d5008449$var$load("5rP2y").then(()=>parcelRequire('3xF0f'));

});

parcelRegister("gRJMd", function(module, exports) {

let $c4751ae05be1bcfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4751ae05be1bcfa$var$load("fiBWE").then(()=>parcelRequire('d1Kho'));

});

parcelRegister("egG6R", function(module, exports) {

let $a633396e1498b365$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a633396e1498b365$var$load("eYOVp").then(()=>parcelRequire('hr2Qm'));

});

parcelRegister("2OF8N", function(module, exports) {

let $20d02a00ff17dcef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20d02a00ff17dcef$var$load("lbVei").then(()=>parcelRequire('02spC'));

});

parcelRegister("lRRyP", function(module, exports) {

let $feb8183ce4d847d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $feb8183ce4d847d8$var$load("cuyR5").then(()=>parcelRequire('54AMW'));

});

parcelRegister("atzeI", function(module, exports) {

let $7a07f1ff89cb22b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a07f1ff89cb22b5$var$load("lakqH").then(()=>parcelRequire('i6RHe'));

});

parcelRegister("ix7N8", function(module, exports) {

let $d7e15a4dd1c248f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7e15a4dd1c248f3$var$load("cuanT").then(()=>parcelRequire('7d5GQ'));

});

parcelRegister("fXCNp", function(module, exports) {

let $b9ea75c06abd605e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9ea75c06abd605e$var$load("aNRRd").then(()=>parcelRequire('eST2B'));

});

parcelRegister("bMuJn", function(module, exports) {

let $893c03e9a992a969$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $893c03e9a992a969$var$load("1QSLQ").then(()=>parcelRequire('7Ephn'));

});

parcelRegister("e0LRB", function(module, exports) {

let $a336317671bf8f82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a336317671bf8f82$var$load("iVQPs").then(()=>parcelRequire('7WwX6'));

});

parcelRegister("1ougv", function(module, exports) {

let $103f825c35464783$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $103f825c35464783$var$load("llV4l").then(()=>parcelRequire('auOWd'));

});

parcelRegister("4S2B8", function(module, exports) {

let $38be38745e348a18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38be38745e348a18$var$load("2WZd3").then(()=>parcelRequire('3Agpb'));

});

parcelRegister("79XJS", function(module, exports) {

let $5367b69606bc7ca6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5367b69606bc7ca6$var$load("9Dn1E").then(()=>parcelRequire('8Kulp'));

});

parcelRegister("emZZY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $318f13e1b27fe321$var$styles = {
    fillContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _0jFU0VN91d"
};
const $318f13e1b27fe321$var$WidthObserverContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $318f13e1b27fe321$export$75f7910544138d14 = ({ children: children })=>{
    const [elements, setElements] = (0, $cozmU.useState)({});
    const [callbacks, setCallbacks] = (0, $cozmU.useState)({});
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('data-width-observer-id');
                if (id && callbacks[id]) {
                    const width = entry.contentRect.width;
                    callbacks[id].forEach((callback)=>callback(width));
                }
            });
        };
        const observer = new ResizeObserver(handleResize);
        Object.values(elements).forEach((element)=>observer.observe(element));
        return ()=>{
            observer.disconnect();
        };
    }, [
        elements,
        callbacks
    ]);
    const registerElement = (0, $cozmU.useCallback)((id, element)=>{
        setElements((prev)=>({
                ...prev,
                [id]: element
            }));
    }, [
        setElements
    ]);
    const unregisterElement = (0, $cozmU.useCallback)((id)=>{
        setElements((prev)=>{
            const newElements = {
                ...prev
            };
            delete newElements[id];
            return newElements;
        });
    }, [
        setElements
    ]);
    const subscribe = (0, $cozmU.useCallback)((id, callback)=>{
        setCallbacks((prev)=>({
                ...prev,
                [id]: [
                    ...prev[id] || [],
                    callback
                ]
            }));
        return ()=>{
            setCallbacks((prev)=>({
                    ...prev,
                    [id]: (prev[id] || []).filter((cb)=>cb !== callback)
                }));
        };
    }, [
        setCallbacks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($318f13e1b27fe321$var$WidthObserverContext.Provider, {
        value: {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        }
    }, children);
};
const $318f13e1b27fe321$export$b78842cb7cd02769 = ()=>{
    const context = (0, $cozmU.useContext)($318f13e1b27fe321$var$WidthObserverContext);
    if (!context) throw new Error('useWidthObserver must be used within a WidthObserverProvider');
    return context;
};
const $318f13e1b27fe321$export$ad8c32a8eb05ab3d = (id, ref)=>{
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $318f13e1b27fe321$export$b78842cb7cd02769();
    (0, $cozmU.useEffect)(()=>{
        const element = ref.current;
        if (element) {
            element.setAttribute('data-width-observer-id', id);
            registerElement(id, element);
        }
        return ()=>{
            unregisterElement(id);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        ref,
        ref.current,
        // This is required as the useEffect is not triggered when ref.current becomes defined
        registerElement,
        unregisterElement
    ]);
};
const $318f13e1b27fe321$export$f8586f54f6b8f867 = ({ id: id, children: children, fillContainer: fillContainer = false })=>{
    const elementRef = (0, $cozmU.useRef)(null);
    $318f13e1b27fe321$export$ad8c32a8eb05ab3d(id, elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: elementRef,
        xcss: fillContainer && $318f13e1b27fe321$var$styles.fillContainer
    }, children);
};
const $318f13e1b27fe321$export$1217913212f99c7 = (id)=>{
    const { subscribe: subscribe } = $318f13e1b27fe321$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $cozmU.useState)(0);
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = subscribe(id, setWidth);
        return ()=>{
            unsubscribe();
        };
    }, [
        id,
        subscribe
    ]);
    return width;
};
const $318f13e1b27fe321$export$f29cb180c1a7eb72 = ({ target: id, children: children })=>{
    const width = $318f13e1b27fe321$export$1217913212f99c7(id);
    if (width === 0) return null;
    return children(width);
};
const $318f13e1b27fe321$var$breakpoints = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1768
};
const $318f13e1b27fe321$export$c44b7f69e7aa026 = ({ width: width, above: above, below: below })=>{
    return above && width > $318f13e1b27fe321$var$breakpoints[above] || below && width < $318f13e1b27fe321$var$breakpoints[below] || false;
};
const $318f13e1b27fe321$export$f6a3d19be20f5819 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($318f13e1b27fe321$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($318f13e1b27fe321$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    });
};
const $318f13e1b27fe321$export$bed28288a051538 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($318f13e1b27fe321$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($318f13e1b27fe321$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    });
};
module.exports["WidthObserverProvider"] = $318f13e1b27fe321$export$75f7910544138d14;
module.exports["useWidthObserverRegistration"] = $318f13e1b27fe321$export$ad8c32a8eb05ab3d;
module.exports["WidthObserverElement"] = $318f13e1b27fe321$export$f8586f54f6b8f867;
module.exports["useElementWidth"] = $318f13e1b27fe321$export$1217913212f99c7;
module.exports["Hide"] = $318f13e1b27fe321$export$bed28288a051538;

});

parcelRegister("535ZC", function(module, exports) {
/*
 * Minimize imports in this entrypoint to avoid increasing the product bundle size.
 */ 
var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7zn5c = parcelRequire("7zn5c");

const $950a68da474a5cd4$export$5f3101fcfc6eab72 = (value)=>{
    return typeof value === 'boolean';
};


const $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME = 'jira';
// This is referencing KnowledgeDiscoveryJiraIntentDetectionModel.GNIN_HEURISTIC from @atlassian/search-client package
// Do not import @atlassian/search-client package as it will increase the NIN bundle size. A unit test is associated to this reference.
// Update DEFAULT_MODEL_ID if the default model ID for intent detection changes
const $d2a20def158b4bc1$var$DEFAULT_MODEL_ID = 'GNIN_HEURISTIC';
const $d2a20def158b4bc1$var$navigationCtaVariants = [
    'control',
    'button'
];
const $d2a20def158b4bc1$export$2e05ac0a6fbb40c7 = (cohortValue)=>{
    return Boolean($d2a20def158b4bc1$var$navigationCtaVariants.find((variant)=>cohortValue === variant));
};
const $d2a20def158b4bc1$var$isEnglishLocale = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return Boolean(locale?.toLowerCase().startsWith('en'));
};
const $d2a20def158b4bc1$export$f2e8952d10c578ba = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME) return undefined;
    // cohortForIntentDetectionExperiment AKA Experiment 2
    const intentDetectionExperiment = $d2a20def158b4bc1$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: // Exposure should only be fired when intent detection has occured on Quick Find
        locale
    });
    const cohortForIntentDetectionExperiment = intentDetectionExperiment?.uiFeatures.navigationCTA;
    // Intent detection experiment takes priority on what CTA is used.
    // For example: If the Jira NIN FPS navigation experiment is decided and we start experiment 2, we still want to be able to set
    // different navigation CTAs in case we want to test different CTA variants in experiment 2.
    if (cohortForIntentDetectionExperiment) return {
        cohort: cohortForIntentDetectionExperiment,
        hideNavigationCTAOnGNIN: intentDetectionExperiment?.uiFeatures?.hideNavigationCTAOnGNIN,
        showQueryInHeader: intentDetectionExperiment?.uiFeatures?.showQueryInHeader
    };
    const layer = (0, $7zn5c.getMutuallyExclusiveUIExperiment)('rovo_jira_nin_fps_navigation_exp', 'rovo_jira_ui_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    // cohortForNinFpsExperiment AKA Experiment 1
    const cohortForNinFpsExperiment = layer?.get('cohort', undefined, $d2a20def158b4bc1$export$2e05ac0a6fbb40c7);
    return {
        cohort: cohortForNinFpsExperiment,
        hideNavigationCTAOnGNIN: undefined,
        showQueryInHeader: undefined
    };
};
const $d2a20def158b4bc1$export$cd09c61ec4486079 = {
    navigationCTA: 'button',
    hideNavigationCTAOnGNIN: false,
    showMatchingWorkItem: true,
    showQueryInHeader: true,
    maxRecentQueryCountWhenNoSuggestions: 1
};
const $d2a20def158b4bc1$var$variants = [
    'control',
    'test'
];
const $d2a20def158b4bc1$var$serveJiraNINFpsNLQNavigationUserBased = ({ primaryProduct: primaryProduct, locale: locale } = {})=>{
    if (primaryProduct !== $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $iDrrr.fg)('rovo_jira_intent_detection_audience_gate')) return undefined;
    if ($d2a20def158b4bc1$var$isEnglishLocale(locale)) return {
        cohort: 'test',
        uiFeatures: $d2a20def158b4bc1$export$cd09c61ec4486079,
        modelId: $d2a20def158b4bc1$var$DEFAULT_MODEL_ID
    };
    // If not an english user, do not show intent detection
    return;
};
const $d2a20def158b4bc1$var$serveMultiLangIntentDetection = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $iDrrr.fg)('jira_fps_intent_classifier_fg') || $d2a20def158b4bc1$var$isEnglishLocale(locale)) return;
    const experiment = (0, $cXtTj.default).getExperiment('rovo_jira_nin_fps_nlq_navigation_non_english_exp', {
        fireExperimentExposure: fireLayerExposure
    });
    const cohort = experiment?.get('cohort', undefined, (cohortValue)=>{
        return Boolean($d2a20def158b4bc1$var$variants.find((variant)=>cohortValue === variant));
    });
    const uiFeaturesFromStatsig = experiment?.get('uiFeatures', {}, (uiFeaturesValue)=>{
        if (!uiFeaturesValue || typeof uiFeaturesValue !== 'object') return false;
        const isEnableControlIntentDetectionAnalyticsValid = 'enableControlIntentDetectionAnalytics' in uiFeaturesValue ? (0, $950a68da474a5cd4$export$5f3101fcfc6eab72)(uiFeaturesValue.enableControlIntentDetectionAnalytics) : true; // Undefined values are valid
        return isEnableControlIntentDetectionAnalyticsValid;
    }) ?? {};
    const modelId = experiment?.get('modelId', $d2a20def158b4bc1$var$DEFAULT_MODEL_ID, (modelIdValue)=>typeof modelIdValue === 'string' && modelIdValue.length > 0) ?? $d2a20def158b4bc1$var$DEFAULT_MODEL_ID;
    const uiFeaturesWithDefaults = {
        ...uiFeaturesFromStatsig,
        ...$d2a20def158b4bc1$export$cd09c61ec4486079
    };
    return {
        cohort: cohort,
        uiFeatures: uiFeaturesWithDefaults,
        modelId: modelId
    };
};
const $d2a20def158b4bc1$export$678dc8b37f93853d = (props = {})=>{
    // Holdout gate for the Carillon release (Jira's 3x/year rollout). Users in this holdout group
    // are opted out of intent detection, allowing different models to be tested against the holdout.
    if ((0, $iDrrr.fg)('rovo_jira_intent_detection_holdout')) // This is where the future intent detection experiments will live
    return undefined;
    const serveUserBasedExp = $d2a20def158b4bc1$var$serveJiraNINFpsNLQNavigationUserBased(props);
    if (serveUserBasedExp) return serveUserBasedExp;
    return $d2a20def158b4bc1$var$serveMultiLangIntentDetection(props);
};
const $d2a20def158b4bc1$export$bf4748641fc251b9 = (primaryProduct, locale)=>{
    const experiment = $d2a20def158b4bc1$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: locale
    });
    return experiment?.cohort === 'test' || experiment?.cohort === 'control' && (experiment?.uiFeatures.enableControlIntentDetectionAnalytics ?? false);
};
module.exports["serveJiraNinFpsNavigation"] = $d2a20def158b4bc1$export$f2e8952d10c578ba;
module.exports["serveJiraNINFpsNLQNavigation"] = $d2a20def158b4bc1$export$678dc8b37f93853d;
module.exports["isIntentDetectionTriggeredForExperiment"] = $d2a20def158b4bc1$export$bf4748641fc251b9;

});

parcelRegister("68JhS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6yu7A = parcelRequire("6yu7A");


var $gLRLx = parcelRequire("gLRLx");


var $hnDqW = parcelRequire("hnDqW");


var $eyLp9 = parcelRequire("eyLp9");


var $32Eau = parcelRequire("32Eau");


var $5lH3O = parcelRequire("5lH3O");


var $1i979 = parcelRequire("1i979");

const $bdccd1375bb70356$export$82052fbad762998f = ()=>(0, $eyLp9.useSearchDialogAnalytics)();
const $bdccd1375bb70356$export$e44a494bf5ca923a = (query)=>(0, $gLRLx.getCommonQueryAttributes)(query);
const $bdccd1375bb70356$export$380f10e960af9b57 = ()=>{
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const fetchEntitiesRequestId = (0, $5lH3O.useFetchEntitiesRequestId)();
    const fetchSpacesRequestId = (0, $5lH3O.useFetchSpacesRequestId)();
    const rovoJourneyId = (0, $5lH3O.useRovoJourneyId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $1i979.useQueryUpdatedTime)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryVersion] = (0, $1i979.useQueryVersion)();
    const [experimentConfig] = (0, $32Eau.useExperimentConfig)();
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const [analyticsAttributes] = (0, $32Eau.useAnalyticsAttributes)();
    const [productSelected] = (0, $1i979.useSelectedProduct)();
    const filters = (0, $1i979.useFilterAttributesForTracking)();
    const [productEdition] = (0, $32Eau.useProductEdition)();
    return (0, $cozmU.useMemo)(()=>{
        const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
        const { filterSelections: filterSelections, filters: filterCategories } = filters;
        const commonAttributes = {
            productEdition: productEdition,
            frontendExperiments: {
                activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                ...frontendExperiments
            },
            ...$bdccd1375bb70356$export$e44a494bf5ca923a(quickFindQuery),
            queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
            queryVersion: queryVersion,
            searchSessionId: searchSessionId,
            fetchEntitiesTraceId: fetchEntitiesRequestId,
            fetchSpacesTraceId: fetchSpacesRequestId,
            isQuickFind: true,
            mode: applicationMode,
            productSelected: productSelected || (0, $6yu7A.ALL_PRODUCTS_STRING),
            filters: filterCategories,
            filterSelections: filterSelections,
            ...analyticsAttributes,
            ...(0, $hnDqW.canContinueRovoJourney)(primaryProduct) && rovoJourneyId && {
                rovoJourneyId: rovoJourneyId
            }
        };
        const nonPrivacySafeAttributes = {
            query: quickFindQuery
        };
        return {
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        };
    }, [
        analyticsAttributes,
        applicationMode,
        experimentConfig,
        fetchEntitiesRequestId,
        fetchSpacesRequestId,
        filters,
        productEdition,
        productSelected,
        primaryProduct,
        queryUpdatedTime,
        queryVersion,
        quickFindQuery,
        rovoJourneyId,
        searchSessionId
    ]);
};
module.exports["useQuickFindAnalytics"] = $bdccd1375bb70356$export$82052fbad762998f;
module.exports["getCommonQueryAttributes"] = $bdccd1375bb70356$export$e44a494bf5ca923a;
module.exports["useQuickFindAttributes"] = $bdccd1375bb70356$export$380f10e960af9b57;

});

parcelRegister("gLRLx", function(module, exports) {

var $e0v3Z = parcelRequire("e0v3Z");


var $7kBI6 = parcelRequire("7kBI6");

const $bdb3b0037ba76811$export$e44a494bf5ca923a = (query)=>{
    const wordCount = (0, $7kBI6.getWordCount)(query);
    return {
        numberOfTerms: wordCount,
        queryHash: (0, $e0v3Z.sha256Hash)(query),
        queryHashSHA256: (0, $e0v3Z.sha256Hash)(query),
        queryLength: query.length,
        wordCount: wordCount
    };
};
module.exports["getCommonQueryAttributes"] = $bdb3b0037ba76811$export$e44a494bf5ca923a;

});

parcelRegister("7kBI6", function(module, exports) {
const $f650f3ad3c0ad4d5$export$dba3e2bcdbd49da4 = (query)=>(query.match(/\w+/g) || []).length;
module.exports["getWordCount"] = $f650f3ad3c0ad4d5$export$dba3e2bcdbd49da4;

});

parcelRegister("eyLp9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6yu7A = parcelRequire("6yu7A");

const $5f5f72f0d4768f65$export$429250c08e9c5d0f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: 'searchDialog'
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsScreenEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: 'searchDialog'
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
module.exports["useSearchDialogAnalytics"] = $5f5f72f0d4768f65$export$429250c08e9c5d0f;

});

parcelRegister("5lH3O", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");


var $2pQiO = parcelRequire("2pQiO");


var $711hq = parcelRequire("711hq");


var $cI6da = parcelRequire("cI6da");

const $53cccb73f693e341$var$clearPendingPrefetch = ()=>({ getState: getState, setState: setState })=>{
        const pending = getState().pendingPrefetch;
        if (pending) {
            clearTimeout(pending.timeout);
            setState({
                pendingPrefetch: undefined
            });
        }
    };
const $53cccb73f693e341$export$d4c72bab9d6cc13a = {
    quickFindOpen: false,
    quickFindQuery: '',
    rovoJourneyId: '',
    isFeedbackModalOpen: false,
    retryCount: 0,
    updateRecentQueries: undefined,
    updateZeroQueries: undefined,
    selectedQueryFilters: [],
    openHoverCardId: null,
    searchErrors: []
};
const $53cccb73f693e341$var$actions = {
    setChatIntentMode: (chatIntentMode)=>({ getState: getState, setState: setState })=>{
            if (getState().chatIntentMode !== chatIntentMode) setState({
                chatIntentMode: chatIntentMode
            });
        },
    setQuickFindOpen: (quickFindOpen)=>({ setState: setState, dispatch: dispatch })=>{
            if (!quickFindOpen && (0, $2pQiO.UNSAFE_expValNoExposure)('quick_find_prefetch', 'isEnabled', false)) dispatch($53cccb73f693e341$var$clearPendingPrefetch());
            setState({
                quickFindOpen: quickFindOpen
            });
        },
    schedulePendingPrefetch: ({ dispatch: dispatchPrefetch })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            if (!(0, $2pQiO.UNSAFE_expValNoExposure)('quick_find_prefetch', 'isEnabled', false)) return;
            dispatch($53cccb73f693e341$var$clearPendingPrefetch());
            const pending = {
                // Matches the hover prefetch delay in react-resource-router.
                timeout: setTimeout(()=>{
                    const { pendingPrefetch: pendingPrefetch, quickFindOpen: quickFindOpen } = getState();
                    if (pendingPrefetch !== pending) return;
                    setState({
                        pendingPrefetch: undefined
                    });
                    if (quickFindOpen) pending.dispatch();
                }, 225),
                dispatch: dispatchPrefetch
            };
            setState({
                pendingPrefetch: pending
            });
        },
    cancelPendingPrefetch: $53cccb73f693e341$var$clearPendingPrefetch,
    setQuickFindQuery: (quickFindQuery)=>({ setState: setState })=>{
            setState({
                quickFindQuery: quickFindQuery
            });
        },
    refreshRovoJourneyId: ()=>({ setState: setState })=>{
            setState({
                rovoJourneyId: crypto.randomUUID()
            });
        },
    clearRovoJourneyId: ()=>({ setState: setState })=>{
            setState({
                rovoJourneyId: ''
            });
        },
    setRovoJourneyId: (rovoJourneyId)=>({ setState: setState })=>{
            setState({
                rovoJourneyId: rovoJourneyId
            });
        },
    setContent: (content)=>({ setState: setState })=>{
            setState({
                content: content
            });
        },
    setIsFeedbackModalOpen: (isFeedbackModalOpen)=>({ setState: setState })=>{
            setState({
                isFeedbackModalOpen: isFeedbackModalOpen
            });
        },
    setRetryCount: (retryCount)=>({ setState: setState })=>{
            setState({
                retryCount: retryCount
            });
        },
    setFetchSpacesRequestId: (fetchSpacesRequestId)=>({ setState: setState })=>{
            setState({
                fetchSpacesRequestId: fetchSpacesRequestId
            });
        },
    setFetchEntitiesRequestId: (fetchEntitiesRequestId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesRequestId: fetchEntitiesRequestId
            });
        },
    setFetchEntitiesTraceId: (fetchEntitiesTraceId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesTraceId: fetchEntitiesTraceId
            });
        },
    setSearchErrors: (searchErrors)=>({ setState: setState })=>{
            setState({
                searchErrors: searchErrors
            });
        },
    setUpdateRecentQueries: (updateRecentQueries)=>({ setState: setState })=>{
            setState({
                updateRecentQueries: updateRecentQueries
            });
        },
    setUpdateZeroQueries: (updateZeroQueries)=>({ setState: setState })=>{
            setState({
                updateZeroQueries: updateZeroQueries
            });
        },
    addSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const duplicate = selectedQueryFilters.find((currentQueryFilter)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            if (!duplicate) setState({
                selectedQueryFilters: [
                    ...selectedQueryFilters,
                    queryFilter
                ]
            });
        },
    deleteSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const newSelectedQueryFilters = selectedQueryFilters.filter((currentQueryFilter)=>!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            setState({
                selectedQueryFilters: newSelectedQueryFilters
            });
        },
    resetSelectedQueryFilters: ()=>({ setState: setState })=>{
            setState({
                selectedQueryFilters: []
            });
        },
    setCurrentQueryFilter: (currentQueryFilter)=>({ setState: setState })=>{
            setState({
                currentQueryFilter: currentQueryFilter
            });
        },
    setHoverCardOpen: (itemId, isOpen)=>({ setState: setState, getState: getState })=>{
            const { openHoverCardId: openHoverCardId } = getState();
            if (isOpen) setState({
                openHoverCardId: itemId
            });
            else if (openHoverCardId === itemId) setState({
                openHoverCardId: null
            });
        }
};
const $53cccb73f693e341$var$Store = (0, $8s9DV.createStore)({
    initialState: $53cccb73f693e341$export$d4c72bab9d6cc13a,
    actions: $53cccb73f693e341$var$actions,
    name: 'quick-find'
});
const $53cccb73f693e341$export$5125bb5a97b0c344 = (0, $kBr4q.createActionsHook)($53cccb73f693e341$var$Store);
const $53cccb73f693e341$export$6f7ec6ed84e85154 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.quickFindOpen
});
const $53cccb73f693e341$export$db9af4f90ab0e536 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.quickFindQuery
});
const $53cccb73f693e341$export$65a92c12f81b7ab3 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.rovoJourneyId
});
const $53cccb73f693e341$export$ee83783e2ce4cc63 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.content
});
const $53cccb73f693e341$export$7ad206e53500e3b8 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.chatIntentMode ?? (0, $711hq.ChatIntentMode).SEARCH
});
const $53cccb73f693e341$export$77d37aafe976487d = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: ({ content: content })=>Boolean(content && (0, $cI6da.isLoadingState)(content.state))
});
const $53cccb73f693e341$export$5bdbafc4abc135c7 = (0, $kBr4q.createHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.isFeedbackModalOpen
});
const $53cccb73f693e341$export$140d37088821fcb1 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.retryCount
});
const $53cccb73f693e341$export$e260c85752b77e7c = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.fetchSpacesRequestId
});
const $53cccb73f693e341$export$8d6bc416cb50c4b8 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.fetchEntitiesRequestId
});
const $53cccb73f693e341$export$83bd9ae2aed68ab4 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.fetchEntitiesTraceId
});
const $53cccb73f693e341$export$65391f387dac24a5 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.updateRecentQueries
});
const $53cccb73f693e341$export$4c5c5c3d8a37ed5d = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.updateZeroQueries
});
const $53cccb73f693e341$export$285abcbc8aa402a2 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.selectedQueryFilters
});
const $53cccb73f693e341$export$31b21a5d8580f4a9 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.currentQueryFilter
});
const $53cccb73f693e341$export$d25011725d5aa3a6 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.searchErrors || []
});
const $53cccb73f693e341$var$quickFindStoreOnInit = ()=>({ setState: setState }, { initialRovoJourneyId: initialRovoJourneyId, shouldStartRovoJourneyId: shouldStartRovoJourneyId = false })=>{
        setState({
            rovoJourneyId: initialRovoJourneyId || (shouldStartRovoJourneyId ? crypto.randomUUID() : '')
        });
    };
const $53cccb73f693e341$export$3e5bb5570cf53089 = (0, $j8on0.createContainer)($53cccb73f693e341$var$Store, {
    onInit: $53cccb73f693e341$var$quickFindStoreOnInit,
    onCleanup: ()=>({ dispatch: dispatch })=>{
            dispatch($53cccb73f693e341$var$clearPendingPrefetch());
        }
});
module.exports["useQuickFindActions"] = $53cccb73f693e341$export$5125bb5a97b0c344;
module.exports["useQuickFindOpen"] = $53cccb73f693e341$export$6f7ec6ed84e85154;
module.exports["useQuickFindQuery"] = $53cccb73f693e341$export$db9af4f90ab0e536;
module.exports["useRovoJourneyId"] = $53cccb73f693e341$export$65a92c12f81b7ab3;
module.exports["useContent"] = $53cccb73f693e341$export$ee83783e2ce4cc63;
module.exports["useQuickFindChatIntentMode"] = $53cccb73f693e341$export$7ad206e53500e3b8;
module.exports["useQuickFindLoading"] = $53cccb73f693e341$export$77d37aafe976487d;
module.exports["useIsFeedbackModalOpen"] = $53cccb73f693e341$export$5bdbafc4abc135c7;
module.exports["useFetchSpacesRequestId"] = $53cccb73f693e341$export$e260c85752b77e7c;
module.exports["useFetchEntitiesRequestId"] = $53cccb73f693e341$export$8d6bc416cb50c4b8;
module.exports["useFetchEntitiesTraceId"] = $53cccb73f693e341$export$83bd9ae2aed68ab4;
module.exports["useUpdateRecentQueries"] = $53cccb73f693e341$export$65391f387dac24a5;
module.exports["useUpdateZeroQueries"] = $53cccb73f693e341$export$4c5c5c3d8a37ed5d;
module.exports["useSelectedQueryFilters"] = $53cccb73f693e341$export$285abcbc8aa402a2;
module.exports["useCurrentQueryFilter"] = $53cccb73f693e341$export$31b21a5d8580f4a9;
module.exports["useSearchErrors"] = $53cccb73f693e341$export$d25011725d5aa3a6;
module.exports["QuickFindStoreContainer"] = $53cccb73f693e341$export$3e5bb5570cf53089;

});

parcelRegister("cI6da", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $f1e4b17e8f362f29$export$7254cc27399e90bd = {
    PREQUERY_ERROR: 'PREQUERY_ERROR',
    PREQUERY_LOADING: 'PREQUERY_LOADING',
    PREQUERY_NO_RESULTS: 'PREQUERY_NO_RESULTS',
    PREQUERY_RESULTS: 'PREQUERY_RESULTS',
    POSTQUERY_ERROR: 'POSTQUERY_ERROR',
    POSTQUERY_LOADING: 'POSTQUERY_LOADING',
    POSTQUERY_NO_RESULTS: 'POSTQUERY_NO_RESULTS',
    POSTQUERY_RESULTS: 'POSTQUERY_RESULTS'
};
const $f1e4b17e8f362f29$export$bbc0e9ab60a7c746 = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_ERROR || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_RESULTS;
};
const $f1e4b17e8f362f29$export$f33d0292f2f7a82a = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_ERROR || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $f1e4b17e8f362f29$export$3d387094581134ab = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $f1e4b17e8f362f29$export$de6adf92470c6d4 = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_LOADING;
};
const $f1e4b17e8f362f29$export$8984dd36dcb68400 = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_ERROR || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_ERROR;
};
module.exports["State"] = $f1e4b17e8f362f29$export$7254cc27399e90bd;
module.exports["isPreQueryState"] = $f1e4b17e8f362f29$export$bbc0e9ab60a7c746;
module.exports["isPostQueryState"] = $f1e4b17e8f362f29$export$f33d0292f2f7a82a;
module.exports["isPostQueryLoadingOrResults"] = $f1e4b17e8f362f29$export$3d387094581134ab;
module.exports["isLoadingState"] = $f1e4b17e8f362f29$export$de6adf92470c6d4;
module.exports["isNotResultsState"] = $f1e4b17e8f362f29$export$8984dd36dcb68400;

});

parcelRegister("5pcom", function(module, exports) {

var $6yu7A = parcelRequire("6yu7A");

const $a28a1ba2d45336f8$export$caa1a4a1a0abbf91 = {
    quickFindFilter: 'quick-find-filter',
    quickFindOAuthBanner: 'quick-find-oauth-banner',
    quickFindBulkConnect: 'quick-find-bulk-connect',
    quickFindGithubTipBanner: 'quick-find-github-tip-banner',
    searchPageFilter: 'search-page-filter',
    searchPageOAuthBanner: 'search-page-oauth-banner',
    searchPageBulkConnect: 'search-page-bulk-connect',
    sainThirdPartyBanner: 'sain-third-party-banner'
};
const $a28a1ba2d45336f8$export$54863d2084195ac7 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'clicked',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $a28a1ba2d45336f8$export$1caeb8956b6720dc = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'completed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $a28a1ba2d45336f8$export$50898fe380812840 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'failed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $a28a1ba2d45336f8$export$b6f5ff07ced3e735 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'hovered',
        actionSubject: 'thirdPartyOAuth',
        actionSubjectId: 'thirdPartyOAuthConnectButton',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'ui'
    };
};
module.exports["OAuthSource"] = $a28a1ba2d45336f8$export$caa1a4a1a0abbf91;
module.exports["onOAuthStarted"] = $a28a1ba2d45336f8$export$54863d2084195ac7;
module.exports["onOAuthCompleted"] = $a28a1ba2d45336f8$export$1caeb8956b6720dc;
module.exports["onOAuthFailed"] = $a28a1ba2d45336f8$export$50898fe380812840;
module.exports["onOAuthConnectHovered"] = $a28a1ba2d45336f8$export$b6f5ff07ced3e735;

});

parcelRegister("9PGk3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $eh6Ml = parcelRequire("eh6Ml");


var $24dy7 = parcelRequire("24dy7");


var $eEPSE = parcelRequire("eEPSE");


var $iDrrr = parcelRequire("iDrrr");


var $kQgL7 = parcelRequire("kQgL7");


var $dv1ov = parcelRequire("dv1ov");


var $51bn2 = parcelRequire("51bn2");


var $bFOSn = parcelRequire("bFOSn");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $c11PZ = parcelRequire("c11PZ");


var $gPOtu = parcelRequire("gPOtu");


var $95n8y = parcelRequire("95n8y");


var $lDUCP = parcelRequire("lDUCP");


var $32Eau = parcelRequire("32Eau");


var $5lH3O = parcelRequire("5lH3O");


var $1i979 = parcelRequire("1i979");




const $a76917150290cb9d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    understoodAction: {
        id: "oauth-banner.acknowledgement.success-flag-action",
        defaultMessage: "Understood"
    }
});


/**
 * Updates the in-memory bootstrap configs synchronously (for immediate UI feedback)
 * and asynchronously updates the combined-config promiseCache so that both the
 * in-memory cache and localStorage stay consistent for subsequent page loads.
 *
 * This always produces updated configs with userNeedsOAuth=false.
 */ const $1fd89922a22afd0b$var$refreshCombinedOAuthCache = (product, userId, cloudId, thirdPartyConfigs, datasourceId)=>{
    const newThirdPartyConfigs = {
        ...thirdPartyConfigs
    };
    const productKey = product;
    const existingConfig = newThirdPartyConfigs[productKey];
    if (existingConfig) {
        if (datasourceId) newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            datasources: existingConfig.datasources?.map((ds)=>ds.datasourceId === datasourceId ? {
                    ...ds,
                    userNeedsOAuth: false
                } : ds)
        };
        else newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            userNeedsOAuth: false
        };
    }
    const thirdPartyTypes = (0, $95n8y.getThirdPartyTypes)();
    (0, $kQgL7.updateCombinedConfigCacheEntry)(userId, cloudId, (config)=>({
            ...config,
            thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                if (datasourceId) {
                    if (entry.datasourceId === datasourceId) return {
                        ...entry,
                        isUserOAuthed: true,
                        hasAuthUpgrade: false
                    };
                } else if (thirdPartyTypes[entry.name] === product) return {
                    ...entry,
                    isUserOAuthed: true,
                    hasAuthUpgrade: false
                };
                return entry;
            })
        }));
    return newThirdPartyConfigs;
};
const $1fd89922a22afd0b$export$4de3515a937b03f6 = ({ product: product, connectorSource: connectorSource, successFlagTitle: successFlagTitle, successFlagDescription: successFlagDescription, showUnderstoodButton: showUnderstoodButton = false, failFlagTitle: failFlagTitle, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction = ()=>{}, onDismissAction: onDismissAction = ()=>{}, onFailAction: onFailAction = ()=>{}, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, query: query = '', datasourceId: datasourceId, extraAttributes: extraAttributes })=>{
    const [cloudId] = (0, $32Eau.useCloudId)();
    const [user] = (0, $32Eau.useUser)();
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const setThirdPartyConfigs = (0, $32Eau.useSetThirdPartyConfigs)();
    const onOAuthSuccess = (0, $32Eau.useOnOAuthSuccess)();
    // Keep a ref to the latest thirdPartyConfigs so that the onSuccess closure
    // (which fires asynchronously after the auth popup closes) always reads the
    // current store value instead of a stale captured snapshot.
    const thirdPartyConfigsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(thirdPartyConfigs);
    thirdPartyConfigsRef.current = thirdPartyConfigs;
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $1i979.useSearchActions)();
    const { showFlag: showFlag, hideFlag: hideFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $5lH3O.useQuickFindActions)();
    const oAuthAnalyticsProps = {
        product: product || '',
        connectorSource: connectorSource,
        cloudId: cloudId || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs,
        extraAttributes: extraAttributes
    };
    const fireOAuthStartedEvent = (0, $lDUCP.useFireOAuthStarted)(oAuthAnalyticsProps);
    const fireOAuthCompletedEvent = (0, $lDUCP.useFireOAuthCompleted)(oAuthAnalyticsProps);
    const fireOAuthFailedEvent = (0, $lDUCP.useFireOAuthFailed)(oAuthAnalyticsProps);
    const onSuccess = (oAuthSource)=>{
        fireOAuthCompletedEvent(oAuthSource);
        if (product === 'slack') (0, $51bn2.sendSlackAuthSuccessRequest)({
            cloudId: cloudId
        });
        if (product === 'teams' && (0, $iDrrr.fg)('ai_3p_is_teams_platform_connector_enabled')) (0, $bFOSn.sendTeamsAuthSuccessRequest)({
            cloudId: cloudId
        });
        onCompletedAction();
        const successFlagId = `oauth-success-flag-${product ?? 'unknown'}-${Date.now()}`;
        showFlag({
            id: successFlagId,
            title: successFlagTitle,
            ...successFlagDescription !== undefined && {
                description: successFlagDescription
            },
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            isAutoDismiss: true,
            ...showUnderstoodButton && {
                actions: [
                    {
                        content: formatMessage((0, $a76917150290cb9d$export$defe85febe8b728c).understoodAction),
                        onClick: ()=>hideFlag(successFlagId)
                    }
                ]
            }
        });
        if (onOAuthSuccess && (0, $iDrrr.fg)('rovo_fps_use_rovo_config')) onOAuthSuccess({
            product: product,
            datasourceId: datasourceId
        });
        else {
            const newOutboundAuthConfigs = $1fd89922a22afd0b$var$refreshCombinedOAuthCache(product, userId || '', cloudId || '', // Read from ref to get the latest store value, not the stale closure snapshot.
            thirdPartyConfigsRef.current || {}, // Mirror the datasource `isUserOAuthed` resolved to, so the connect clears that specific
            // connector rather than flipping every entry for the product.
            datasourceId ?? (0, $gPOtu.getPreferredConnectorDatasource)(product, thirdPartyConfigsRef.current || {})?.datasourceId);
            setThirdPartyConfigs(newOutboundAuthConfigs);
        }
        (0, $dv1ov.searchPageQueryCache).clear();
        retrySearch();
        if (!isBulkConnect && isOnSearchDialog) {
            setQuickFindOpen(false);
            /* TODO: use onNavigate callback once bootstrap store is lifted. Details in https://hello.atlassian.net/wiki/spaces/CASE/pages/4670854655/3P+Discoverability+Bug
      const onNavigateCallback =
      	typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
      onNavigateCallback(
      	generateSearchUrl({
      		...queryParams,
      		text: query,
      		product: product,
      	}),
      	'push',
      );
      */ const searchUrl = generateSearchUrl({
                ...queryParams,
                text: query,
                product: product
            });
            window.location.href = searchUrl;
        }
    };
    //eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onFail = (oAuthSource, error)=>{
        fireOAuthFailedEvent(oAuthSource);
        onFailAction();
        showFlag({
            title: failFlagTitle,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            isAutoDismiss: true
        });
    };
    const onAuthorize = (oAuthSource)=>{
        fireOAuthStartedEvent(oAuthSource);
        (0, $eEPSE.auth)(outboundAuthUrl).then(()=>onSuccess(oAuthSource)).catch((error)=>onFail(oAuthSource, error));
    };
    const onDismiss = ()=>{
        onDismissAction();
    };
    return {
        onAuthorize: onAuthorize,
        onDismiss: onDismiss,
        onSuccess: onSuccess,
        onFail: onFail
    };
};
const $1fd89922a22afd0b$export$e90b3746b95097c9 = (productKey, selectedDatasourceId)=>{
    const [thirdPartyConfigsValue] = (0, $32Eau.useThirdPartyConfigs)();
    return $1fd89922a22afd0b$export$3515cf7f98d16dad(productKey, thirdPartyConfigsValue, selectedDatasourceId);
};
const $1fd89922a22afd0b$export$3515cf7f98d16dad = (productKey, thirdPartyConfigs, selectedDatasourceId)=>{
    let userNeedsOAuth, outboundAuthUrl;
    // Handle Forge connectors first (they're not in is3pProductKey)
    if (productKey && (0, $8fNUp.isForgeConnectorProductKey)(productKey)) {
        const productOutboundAuthConfig = thirdPartyConfigs[productKey];
        if (!productOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    if (!productKey || !(0, $dvVWp.is3pProductKey)(productKey)) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    // If datasource is provided, check specific datasource config
    if (selectedDatasourceId) {
        const datasourceOutboundAuthConfig = thirdPartyConfigs[productKey]?.datasources?.find((datasource)=>datasource.datasourceId === selectedDatasourceId);
        if (!datasourceOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = datasourceOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = datasourceOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    // When several connectors of differing priority back one product, the merged product config
    // reflects whichever resource was processed last, so prefer the connector that should own the
    // affordance. Resolved here rather than at each call site so every surface — filter pills, header
    // tabs, right rail, Quick Find — is covered without threading a datasourceId through.
    const preferredDatasource = (0, $gPOtu.getPreferredConnectorDatasource)(productKey, thirdPartyConfigs);
    if (preferredDatasource) return {
        userNeedsOAuth: preferredDatasource.userNeedsOAuth,
        outboundAuthUrl: preferredDatasource.outboundAuthUrl
    };
    // If no datasource provided, check base product config
    const productOutboundAuthConfig = thirdPartyConfigs[productKey];
    if (!productOutboundAuthConfig) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
    outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
    return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
};
module.exports["useOAuthHandlers"] = $1fd89922a22afd0b$export$4de3515a937b03f6;
module.exports["useIsUserOAuthed"] = $1fd89922a22afd0b$export$e90b3746b95097c9;
module.exports["isUserOAuthed"] = $1fd89922a22afd0b$export$3515cf7f98d16dad;

});

parcelRegister("bFOSn", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';
const $1b7a3bd80ac34d5e$var$cache = (0, $bHHWv.inMemoryCache)();
const $1b7a3bd80ac34d5e$export$a4f9b7f788f9e71f = (request)=>{
    const keyObj = {
        teamIds: request.teamIds.sort()
    };
    return (0, $bZF61.generateHashFromVariables)(keyObj);
};
const $1b7a3bd80ac34d5e$export$eb16261a2bb165d4 = async (request, onError)=>{
    return $1b7a3bd80ac34d5e$var$cache.inMemoryDecorator($1b7a3bd80ac34d5e$export$a4f9b7f788f9e71f(request), ()=>fetch($1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(request)
        }).then((response)=>{
            if (response.ok) return response.json();
            const errorMessage = `Unable to fetch ${$1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL}. ${response.statusText}`;
            onError?.(errorMessage);
            return Promise.reject({
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            });
        }).catch((error)=>{
            const errorMessage = `Unable to fetch ${$1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL}. ${error.message}`;
            onError?.(errorMessage);
            return {
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            };
        }));
};
const $1b7a3bd80ac34d5e$export$5a635a8efc086412 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeTeamsUrl = `/gateway/api/third-party-user-auth/teams/user-authed`;
    const baseUrl = absoluteUrl || relativeTeamsUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
module.exports["fetchTeamsBulk"] = $1b7a3bd80ac34d5e$export$eb16261a2bb165d4;
module.exports["sendTeamsAuthSuccessRequest"] = $1b7a3bd80ac34d5e$export$5a635a8efc086412;

});

parcelRegister("i28CG", function(module, exports) {

var $fR63l = parcelRequire("fR63l");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $cwPfG = parcelRequire("cwPfG");

const $56c3f4ee696c4a89$export$b4d0899ce57e542f = (product, thirdPartyConfigs)=>{
    return !!(product && (0, $dvVWp.is3pProductKey)(product) ? thirdPartyConfigs[product]?.impersonationEnabled : false);
};
const $56c3f4ee696c4a89$export$65ae2534332320d4 = (product, connectorSource, thirdPartyConfigs)=>{
    if (product !== (0, $fR63l.ProductKeys3P).Sharepoint) return $56c3f4ee696c4a89$export$b4d0899ce57e542f(product, thirdPartyConfigs);
    return connectorSource === (0, $8fNUp.FULL_CONNECTOR_SOURCE) && (0, $cwPfG.hasImpersonatedFullConnector)(product, thirdPartyConfigs);
};
module.exports["isProductImpersonated"] = $56c3f4ee696c4a89$export$b4d0899ce57e542f;

});

parcelRegister("fIeaC", function(module, exports) {

var $dOgct = parcelRequire("dOgct");


var $8N8EQ = parcelRequire("8N8EQ");


var $fQ7Ra = parcelRequire("fQ7Ra");


var $jyixt = parcelRequire("jyixt");


var $7QpO7 = parcelRequire("7QpO7");

/**
 * Extracts the gateway object from the latest captured Relay extensions
 * for the given query type.
 */ const $cbc0182d59505d21$var$getLatestGateway = (isCQL)=>{
    const extensions = (0, $dOgct.getExtensions)(isCQL ? (0, $jyixt.default).operation.name : (0, $fQ7Ra.default).operation.name)?.slice(-1)[0];
    return extensions?.gateway;
};
function $cbc0182d59505d21$export$4fff3ed4eba4f4ee(isCQL) {
    const gateway = $cbc0182d59505d21$var$getLatestGateway(isCQL);
    const traceId = gateway?.['trace_id'];
    const queryUpdatedAgo = (0, $7QpO7.getQueryUpdatedTime)();
    return {
        traceId: traceId,
        queryUpdatedAgo: queryUpdatedAgo
    };
}
function $cbc0182d59505d21$export$7a619f7611b5a09e(isCQL) {
    const gateway = $cbc0182d59505d21$var$getLatestGateway(isCQL);
    if (!gateway) return undefined;
    return (0, $8N8EQ.extractTraceInfoFromResponse)({
        extensions: {
            gateway: gateway
        }
    });
}
module.exports["getExtensionData"] = $cbc0182d59505d21$export$4fff3ed4eba4f4ee;
module.exports["getRelayNetworkTraceInfo"] = $cbc0182d59505d21$export$7a619f7611b5a09e;

});

parcelRegister("fQ7Ra", function(module, exports) {
/**
 * @generated SignedSource<<2d0ee6fe0daa3a72c554f7b0f9348955>>
 * @relayHash bdf3b816161438b9e52d0db41ad73b54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c26a0822e9d917157513144d6dd817c0be149e4fa8a793cdc98cf8b0bbc52500

var $hd5Dy = parcelRequire("hd5Dy");


var $8NMWF = parcelRequire("8NMWF");


var $iK48f = parcelRequire("iK48f");


var $8dp6J = parcelRequire("8dp6J");


var $hFjUk = parcelRequire("hFjUk");


var $4Pgy4 = parcelRequire("4Pgy4");


var $b9kI4 = parcelRequire("b9kI4");


var $jfrG1 = parcelRequire("jfrG1");

const $b16e14c5cbb2e6b9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARIs"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "deferFederatedResults"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableRelevanceDebugging"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "expectResult"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCaseEmbeddedComments"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCodeSearch"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDatasourceId"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFastJiraHydration"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraEmbeddedComments"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraLiteModeFields"
    }, v22 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeMercuryAsk"
    }, v23 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v24 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeOriginalEntityType"
    }, v25 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v26 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v27 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRisk"
    }, v28 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomFilters"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "matchingLayerExperimentsMetadata"
    }, v33 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v34 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v35 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v36 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v37 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v38 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v39 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v40 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v41 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceSubProduct"
    }, v42 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v43 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v44 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v45 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useCaseId"
    }, v46 = {
        "kind": "Variable",
        "name": "useCaseId",
        "variableName": "useCaseId"
    }, v47 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                },
                {
                    "kind": "Variable",
                    "name": "sourceSubProduct",
                    "variableName": "sourceSubProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "enableRelevanceDebugging",
            "variableName": "enableRelevanceDebugging"
        },
        {
            "kind": "Variable",
            "name": "expectResult",
            "variableName": "expectResult"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "cloudIdARIs"
                },
                {
                    "kind": "Variable",
                    "name": "loomFilters",
                    "variableName": "loomFilters"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "matchingLayerExperimentsMetadata",
            "variableName": "matchingLayerExperimentsMetadata"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        },
        v46 /*: any*/ 
    ], v48 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v49 = {
        "kind": "ScalarField",
        "name": "id"
    }, v50 = {
        "kind": "ScalarField",
        "name": "description"
    }, v51 = {
        "condition": "includeDatasourceId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "datasourceId"
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v53 = {
        "kind": "ScalarField",
        "name": "title"
    }, v54 = {
        "kind": "ScalarField",
        "name": "url"
    }, v55 = {
        "kind": "ScalarField",
        "name": "type"
    }, v56 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v57 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v58 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v59 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v60 = {
        "concreteType": "SearchLinkedResult",
        "kind": "LinkedField",
        "name": "linkedResults",
        "plural": true,
        "selections": [
            v49 /*: any*/ ,
            v51 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "category"
            },
            v52 /*: any*/ ,
            v53 /*: any*/ ,
            v54 /*: any*/ ,
            v55 /*: any*/ ,
            v50 /*: any*/ ,
            v56 /*: any*/ ,
            v57 /*: any*/ ,
            v58 /*: any*/ ,
            v59 /*: any*/ 
        ]
    }, v61 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isSearchResult"
    }, v62 = {
        "kind": "ScalarField",
        "name": "value"
    }, v63 = {
        "kind": "ScalarField",
        "name": "label"
    }, v64 = [
        v63 /*: any*/ 
    ], v65 = {
        "kind": "ScalarField",
        "name": "key"
    }, v66 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "TownsquareGoal",
                "kind": "LinkedField",
                "name": "goal",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "TownsquareStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "TownsquareLocalizationField",
                                "kind": "LinkedField",
                                "name": "localizedLabel",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "messageId"
                                    }
                                ]
                            },
                            v62 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": v64 /*: any*/ 
                    },
                    v49 /*: any*/ ,
                    v65 /*: any*/ ,
                    v50 /*: any*/ 
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "SearchResultAtlasGoal"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "TownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrivate"
                    },
                    {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v64 /*: any*/ 
                    },
                    {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                            v63 /*: any*/ ,
                            v62 /*: any*/ 
                        ]
                    },
                    v49 /*: any*/ ,
                    v65 /*: any*/ 
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "SearchResultAtlasProject"
    }, v69 = {
        "kind": "ScalarField",
        "name": "name"
    }, v70 = [
        v69 /*: any*/ 
    ], v71 = {
        "kind": "InlineFragment",
        "selections": [
            v56 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "SearchFederatedEmailUser",
                                "kind": "LinkedField",
                                "name": "sender",
                                "plural": false,
                                "selections": v70 /*: any*/ 
                            }
                        ],
                        "type": "SearchFederatedEmailEntity"
                    }
                ]
            }
        ],
        "type": "SearchResultFederated"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            v56 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "tier"
            },
            {
                "concreteType": "CompassComponent",
                "kind": "LinkedField",
                "name": "component",
                "plural": false,
                "selections": [
                    v50 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    },
                    v49 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "ownerId"
            }
        ],
        "type": "SearchResultCompassComponent"
    }, v73 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v74 = {
        "kind": "ScalarField",
        "name": "total"
    }, v75 = {
        "kind": "ScalarField",
        "name": "count"
    }, v76 = [
        v75 /*: any*/ 
    ], v77 = [
        v49 /*: any*/ 
    ], v78 = {
        "kind": "InlineFragment",
        "selections": v77 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v79 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v80 = {
        "kind": "ScalarField",
        "name": "email"
    }, v81 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v82 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v69 /*: any*/ ,
                    v79 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v80 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v81 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v49 /*: any*/ 
                ]
            }
        ]
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            v73 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isVerified"
            },
            v66 /*: any*/ ,
            {
                "concreteType": "SearchConfluenceResultSpace",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v49 /*: any*/ ,
                    v69 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "webUiLink"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "confluenceEntity",
                "plural": false,
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v57 /*: any*/ ,
                            {
                                "concreteType": "ConfluenceCommentCountSummary",
                                "kind": "LinkedField",
                                "name": "commentCountSummary",
                                "plural": false,
                                "selections": [
                                    v74 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "ConfluenceLikesSummary",
                                "kind": "LinkedField",
                                "name": "likesSummary",
                                "plural": false,
                                "selections": v76 /*: any*/ 
                            }
                        ],
                        "type": "ConfluencePage"
                    },
                    v78 /*: any*/ 
                ]
            },
            v82 /*: any*/ ,
            {
                "condition": "includeNavBoostScore",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "navBoostScore"
                    }
                ]
            }
        ],
        "type": "SearchConfluencePageBlogAttachment"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            v66 /*: any*/ ,
            v73 /*: any*/ 
        ],
        "type": "SearchConfluenceSpace"
    }, v85 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v70 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v78 /*: any*/ 
        ]
    }, v86 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v87 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v86 /*: any*/ ,
                    v54 /*: any*/ ,
                    v57 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v78 /*: any*/ 
        ]
    }, v88 = [
        {
            "kind": "ScalarField",
            "name": "reactionType"
        },
        v74 /*: any*/ 
    ], v89 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v90 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v81 /*: any*/ 
    }, v91 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": [
                    v69 /*: any*/ ,
                    v80 /*: any*/ ,
                    v79 /*: any*/ ,
                    v89 /*: any*/ ,
                    v90 /*: any*/ ,
                    v49 /*: any*/ 
                ]
            }
        ]
    }, v92 = [
        v48 /*: any*/ ,
        v69 /*: any*/ ,
        v79 /*: any*/ ,
        v49 /*: any*/ 
    ], v93 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v92 /*: any*/ 
    }, v94 = {
        "kind": "ScalarField",
        "name": "status"
    }, v95 = [
        v86 /*: any*/ 
    ], v96 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v97 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v48 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v89 /*: any*/ ,
                                            v69 /*: any*/ ,
                                            v96 /*: any*/ ,
                                            v80 /*: any*/ ,
                                            v79 /*: any*/ ,
                                            v90 /*: any*/ ,
                                            v49 /*: any*/ 
                                        ],
                                        "type": "ThirdPartyUser"
                                    },
                                    v78 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v86 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v49 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v98 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v99 = [
        v49 /*: any*/ ,
        v69 /*: any*/ ,
        v80 /*: any*/ ,
        v79 /*: any*/ ,
        v89 /*: any*/ ,
        v90 /*: any*/ 
    ], v100 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v99 /*: any*/ 
            },
            {
                "condition": "__relay_internal__pv__skiplinkeduserhydrationrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                        "kind": "LinkedField",
                        "name": "linkedUsers",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v48 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v69 /*: any*/ ,
                                                    v79 /*: any*/ ,
                                                    v49 /*: any*/ 
                                                ],
                                                "type": "AtlassianAccountUser"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v77 /*: any*/ ,
                                                "type": "AppUser"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v77 /*: any*/ ,
                                                "type": "CustomerUser"
                                            }
                                        ]
                                    },
                                    v49 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v101 = [
        v49 /*: any*/ ,
        v69 /*: any*/ 
    ], v102 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v101 /*: any*/ 
    }, v103 = [
        v102 /*: any*/ 
    ], v104 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v103 /*: any*/ 
    }, v105 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v106 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v107 = [
        v69 /*: any*/ ,
        v49 /*: any*/ 
    ], v108 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v107 /*: any*/ 
    }, v109 = [
        v108 /*: any*/ 
    ], v110 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": v109 /*: any*/ 
    }, v111 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v109 /*: any*/ 
    }, v112 = [
        v48 /*: any*/ ,
        v69 /*: any*/ ,
        v49 /*: any*/ 
    ], v113 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v112 /*: any*/ 
    }, v114 = [
        v48 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v49 /*: any*/ ,
                v86 /*: any*/ 
            ],
            "type": "ExternalCustomerOrg"
        },
        v78 /*: any*/ 
    ], v115 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": v114 /*: any*/ 
    }, v116 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v117 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v103 /*: any*/ 
    }, v118 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v103 /*: any*/ 
    }, v119 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v120 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v121 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v122 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v123 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v124 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v125 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v126 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v127 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v69 /*: any*/ ,
            v96 /*: any*/ ,
            v80 /*: any*/ ,
            v79 /*: any*/ ,
            v89 /*: any*/ ,
            v90 /*: any*/ ,
            v49 /*: any*/ 
        ]
    }, v128 = {
        "kind": "InlineFragment",
        "selections": [
            v59 /*: any*/ ,
            v52 /*: any*/ ,
            v58 /*: any*/ ,
            v57 /*: any*/ ,
            v56 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v69 /*: any*/ ,
                            v85 /*: any*/ 
                        ],
                        "type": "ExternalBranch"
                    },
                    v78 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v87 /*: any*/ ,
                            {
                                "concreteType": "ExternalReaction",
                                "kind": "LinkedField",
                                "name": "reactionsV2",
                                "plural": true,
                                "selections": v88 /*: any*/ 
                            },
                            v91 /*: any*/ 
                        ],
                        "type": "ExternalComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                    v93 /*: any*/ 
                                ]
                            },
                            v85 /*: any*/ 
                        ],
                        "type": "ExternalCommit"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    v48 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v86 /*: any*/ ,
                                            v54 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    },
                                    v78 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "ExternalReaction",
                                "kind": "LinkedField",
                                "name": "reactions",
                                "plural": true,
                                "selections": v88 /*: any*/ 
                            },
                            {
                                "condition": "includeThirdPartyId",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "thirdPartyId"
                                    }
                                ]
                            },
                            v94 /*: any*/ ,
                            {
                                "concreteType": "ExternalDocumentType",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": [
                                    v66 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "ExternalLargeContent",
                                "kind": "LinkedField",
                                "name": "nonIndexableContent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "mediaThumbnailUrl"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                    v48 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v95 /*: any*/ ,
                                        "type": "ExternalDocument"
                                    },
                                    v78 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentCount"
                            }
                        ],
                        "type": "ExternalDocument"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v89 /*: any*/ ,
                            v97 /*: any*/ ,
                            v50 /*: any*/ ,
                            {
                                "concreteType": "ExternalAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": [
                                    v53 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "mimeType"
                                    },
                                    v54 /*: any*/ ,
                                    v98 /*: any*/ ,
                                    v48 /*: any*/ 
                                ]
                            },
                            v100 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    v48 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v86 /*: any*/ ,
                                            v104 /*: any*/ ,
                                            v55 /*: any*/ ,
                                            v49 /*: any*/ ,
                                            v105 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "membershipType"
                                            }
                                        ],
                                        "type": "ExternalConversation"
                                    },
                                    v78 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "lastActive"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reactionCount"
                            }
                        ],
                        "type": "ExternalMessage"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v50 /*: any*/ ,
                            v86 /*: any*/ ,
                            v105 /*: any*/ ,
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": true,
                                "selections": [
                                    v48 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "ExternalConversation"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v94 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "endDate"
                            },
                            v106 /*: any*/ ,
                            v110 /*: any*/ ,
                            v111 /*: any*/ 
                        ],
                        "type": "ExternalCampaign"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "displayNumber"
                            },
                            v94 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "closedAt"
                            },
                            v106 /*: any*/ ,
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "owners",
                                "plural": true,
                                "selections": [
                                    v108 /*: any*/ ,
                                    v113 /*: any*/ 
                                ]
                            },
                            v111 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": v114 /*: any*/ 
                            }
                        ],
                        "type": "ExternalCase"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v86 /*: any*/ ,
                            v110 /*: any*/ ,
                            v115 /*: any*/ ,
                            {
                                "concreteType": "ExternalCustomerOrgLastActivity",
                                "kind": "LinkedField",
                                "name": "customerOrgLastActivity",
                                "plural": false,
                                "selections": v116 /*: any*/ 
                            }
                        ],
                        "type": "ExternalCustomerOrg"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "stage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dealClosedAt"
                            },
                            {
                                "concreteType": "ExternalDealLastActivity",
                                "kind": "LinkedField",
                                "name": "lastActivity",
                                "plural": false,
                                "selections": v116 /*: any*/ 
                            },
                            v110 /*: any*/ ,
                            v115 /*: any*/ 
                        ],
                        "type": "ExternalDeal"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v87 /*: any*/ ,
                            v117 /*: any*/ ,
                            v118 /*: any*/ ,
                            v119 /*: any*/ ,
                            v65 /*: any*/ ,
                            v94 /*: any*/ 
                        ],
                        "type": "ExternalProject"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v87 /*: any*/ ,
                            v117 /*: any*/ ,
                            v118 /*: any*/ ,
                            v119 /*: any*/ ,
                            v94 /*: any*/ ,
                            v57 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "team"
                            },
                            {
                                "concreteType": "ExternalWorkItemProject",
                                "kind": "LinkedField",
                                "name": "workItemProject",
                                "plural": false,
                                "selections": v101 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalProvider",
                                "kind": "LinkedField",
                                "name": "provider",
                                "plural": false,
                                "selections": v70 /*: any*/ 
                            }
                        ],
                        "type": "ExternalWorkItem"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v53 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "lastUpdate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "pullRequestId"
                            },
                            {
                                "alias": "pullRequestStatus",
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            v85 /*: any*/ 
                        ],
                        "type": "ExternalPullRequest"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "durationInSeconds"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "embedUrl"
                            },
                            {
                                "condition": "__relay_internal__pv__ismetadatacontentenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ExternalMetadataContentLink",
                                        "kind": "LinkedField",
                                        "name": "metadataContentLinks",
                                        "plural": true,
                                        "selections": [
                                            v54 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "metadataContentUrl"
                                    }
                                ]
                            },
                            v98 /*: any*/ ,
                            {
                                "concreteType": "ExternalEntityExtendedValue",
                                "kind": "LinkedField",
                                "name": "entityExtendedValues",
                                "plural": true,
                                "selections": [
                                    v120 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldValue"
                                    },
                                    {
                                        "concreteType": "ExternalEntityExtendedValueDisplayName",
                                        "kind": "LinkedField",
                                        "name": "fieldDisplayName",
                                        "plural": false,
                                        "selections": v95 /*: any*/ 
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDisplayed"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "dataType"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalChapter",
                                "kind": "LinkedField",
                                "name": "chapters",
                                "plural": true,
                                "selections": [
                                    v53 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "startTimeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    v102 /*: any*/ ,
                                    v113 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "ExternalVideo"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v49 /*: any*/ ,
                            v54 /*: any*/ ,
                            v121 /*: any*/ ,
                            v110 /*: any*/ 
                        ],
                        "type": "ExternalDashboard"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v49 /*: any*/ ,
                            v54 /*: any*/ ,
                            {
                                "alias": "dataTableType",
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            v121 /*: any*/ ,
                            v110 /*: any*/ 
                        ],
                        "type": "ExternalDataTable"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountName"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "contactUser",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            v69 /*: any*/ ,
                                            v90 /*: any*/ ,
                                            v49 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalCustomerContact"
                    }
                ]
            },
            v122 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v118 /*: any*/ ,
                            v123 /*: any*/ ,
                            v124 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "recurringEventId"
                            },
                            v125 /*: any*/ 
                        ],
                        "type": "ExternalCalendarEvent"
                    },
                    v78 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalThumbnail",
                                "kind": "LinkedField",
                                "name": "thumbnail",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "externalUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDesign"
                    }
                ]
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v49 /*: any*/ ,
                    v53 /*: any*/ ,
                    v54 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            v48 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v124 /*: any*/ ,
                                    v123 /*: any*/ ,
                                    v125 /*: any*/ 
                                ],
                                "type": "ExternalCalendarEvent"
                            },
                            v78 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v86 /*: any*/ ,
                                    v91 /*: any*/ 
                                ],
                                "type": "ExternalComment"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v100 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                            v48 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v104 /*: any*/ ,
                                                    v55 /*: any*/ 
                                                ],
                                                "type": "ExternalConversation"
                                            },
                                            v78 /*: any*/ 
                                        ]
                                    },
                                    v89 /*: any*/ ,
                                    v97 /*: any*/ ,
                                    v50 /*: any*/ 
                                ],
                                "type": "ExternalMessage"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v50 /*: any*/ 
                                ],
                                "type": "ExternalConversation"
                            }
                        ]
                    },
                    v126 /*: any*/ ,
                    v122 /*: any*/ ,
                    {
                        "concreteType": "ThirdPartyUser",
                        "kind": "LinkedField",
                        "name": "initialContributors",
                        "plural": true,
                        "selections": v99 /*: any*/ 
                    },
                    v58 /*: any*/ ,
                    v127 /*: any*/ 
                ]
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "initialContributors",
                "plural": true,
                "selections": [
                    v69 /*: any*/ ,
                    v79 /*: any*/ ,
                    v49 /*: any*/ ,
                    v80 /*: any*/ ,
                    v89 /*: any*/ ,
                    v90 /*: any*/ 
                ]
            },
            {
                "concreteType": "SearchResultGraphTab",
                "kind": "LinkedField",
                "name": "tabs",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "tabId"
                    },
                    v53 /*: any*/ ,
                    v54 /*: any*/ ,
                    v48 /*: any*/ 
                ]
            },
            v121 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "createdBy"
            },
            {
                "concreteType": "SearchResultGraphAttachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                    v53 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "fileType"
                    },
                    v54 /*: any*/ ,
                    v48 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "containerName"
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "allContributors",
                "plural": true,
                "selections": v101 /*: any*/ 
            },
            v127 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "links"
            },
            {
                "kind": "ScalarField",
                "name": "linkedEntitiesType"
            },
            {
                "kind": "ScalarField",
                "name": "connectorId"
            },
            {
                "kind": "ScalarField",
                "name": "connectorProduct"
            },
            v51 /*: any*/ ,
            {
                "condition": "includeOriginalEntityType",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "originalEntityType"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isSharedChannel"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__isleadnounenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v94 /*: any*/ ,
                                    v106 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__isleaduserastitleenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "concreteType": "ExternalUser",
                                                "kind": "LinkedField",
                                                "name": "leadUser",
                                                "plural": false,
                                                "selections": v109 /*: any*/ 
                                            }
                                        ]
                                    },
                                    v110 /*: any*/ ,
                                    v111 /*: any*/ 
                                ],
                                "type": "ExternalLead"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SearchSlackReaction",
                        "kind": "LinkedField",
                        "name": "topReaction",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emojiUrl"
                            },
                            v75 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    }, v129 = {
        "condition": "includeCodeSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "language"
                    },
                    v56 /*: any*/ ,
                    {
                        "concreteType": "SearchResultCodeChunk",
                        "kind": "LinkedField",
                        "name": "matchedChunks",
                        "plural": true,
                        "selections": [
                            v49 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "sourceCode"
                            },
                            {
                                "concreteType": "SearchResultCodeLineRange",
                                "kind": "LinkedField",
                                "name": "lineRange",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "start"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "matchedRanges"
                            }
                        ]
                    },
                    {
                        "concreteType": "SearchResultCodeRepository",
                        "kind": "LinkedField",
                        "name": "repository",
                        "plural": false,
                        "selections": [
                            v69 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "namespace"
                            },
                            v54 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "scm"
                            },
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "SearchResultGraphCode"
            }
        ]
    }, v130 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": v101 /*: any*/ 
    }, v131 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v132 = [
        v66 /*: any*/ ,
        v69 /*: any*/ ,
        v49 /*: any*/ 
    ], v133 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v134 = [
        {
            "concreteType": "JiraLabelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraLabel",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v70 /*: any*/ 
                }
            ]
        }
    ], v135 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            {
                "condition": "includeFastJiraHydration",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "issueTypeAvatarUrl"
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": v107 /*: any*/ 
                            },
                            v49 /*: any*/ 
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "project"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v48 /*: any*/ ,
                                            v69 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v130 /*: any*/ 
                                                ],
                                                "type": "JiraProjectField"
                                            },
                                            v49 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"project\"])"
                    },
                    {
                        "concreteType": "JiraSingleSelectUserPickerField",
                        "kind": "LinkedField",
                        "name": "assigneeField",
                        "plural": false,
                        "selections": [
                            v93 /*: any*/ ,
                            v49 /*: any*/ 
                        ]
                    }
                ]
            },
            v131 /*: any*/ ,
            v65 /*: any*/ ,
            {
                "condition": "includeFastJiraHydration",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": [
                            v69 /*: any*/ ,
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "medium"
                                    }
                                ]
                            },
                            v49 /*: any*/ 
                        ]
                    },
                    v130 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "assignee",
                        "plural": false,
                        "selections": v92 /*: any*/ 
                    },
                    {
                        "condition": "includeJiraLiteModeFields",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "fastPriority",
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": v132 /*: any*/ 
                            },
                            {
                                "alias": "fastLabels",
                                "args": v133 /*: any*/ ,
                                "concreteType": "JiraLabelConnection",
                                "kind": "LinkedField",
                                "name": "labels",
                                "plural": false,
                                "selections": v134 /*: any*/ ,
                                "storageKey": "labels(first:5)"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeJiraLiteModeFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "condition": "includeFastJiraHydration",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraPriorityField",
                                "kind": "LinkedField",
                                "name": "priorityField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": v132 /*: any*/ 
                                    },
                                    v49 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraLabelsField",
                                "kind": "LinkedField",
                                "name": "labelsField",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v133 /*: any*/ ,
                                        "concreteType": "JiraLabelConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedLabelsConnection",
                                        "plural": false,
                                        "selections": v134 /*: any*/ ,
                                        "storageKey": "selectedLabelsConnection(first:5)"
                                    },
                                    v49 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v49 /*: any*/ 
        ]
    }, v136 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "projectKey"
            },
            v56 /*: any*/ ,
            v66 /*: any*/ ,
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v131 /*: any*/ ,
                    {
                        "condition": "includeJiraLiteModeFields",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "lead",
                                "plural": false,
                                "selections": v92 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "small"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraProjectCategory",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": v107 /*: any*/ 
                            }
                        ]
                    },
                    v49 /*: any*/ 
                ]
            },
            v82 /*: any*/ 
        ],
        "type": "SearchResultJiraProject"
    }, v137 = [
        v56 /*: any*/ ,
        v66 /*: any*/ 
    ], v138 = {
        "kind": "InlineFragment",
        "selections": v137 /*: any*/ ,
        "type": "SearchResultJiraPlan"
    }, v139 = {
        "kind": "InlineFragment",
        "selections": [
            v56 /*: any*/ ,
            v66 /*: any*/ ,
            {
                "concreteType": "JiraBoard",
                "kind": "LinkedField",
                "name": "board",
                "plural": false,
                "selections": [
                    v66 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "boardFrontendUrl"
                    },
                    v49 /*: any*/ 
                ]
            }
        ],
        "type": "SearchResultJiraBoard"
    }, v140 = {
        "kind": "InlineFragment",
        "selections": v137 /*: any*/ ,
        "type": "SearchResultJiraDashboard"
    }, v141 = {
        "kind": "InlineFragment",
        "selections": v137 /*: any*/ ,
        "type": "SearchResultJiraFilter"
    }, v142 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalNestedVideos"
            }
        ],
        "type": "SearchResultLoomFolder"
    }, v143 = {
        "kind": "ScalarField",
        "name": "creatorName"
    }, v144 = {
        "kind": "InlineFragment",
        "selections": [
            v143 /*: any*/ 
        ],
        "type": "SearchResultLoomPlaylist"
    }, v145 = {
        "kind": "InlineFragment",
        "selections": v76 /*: any*/ ,
        "type": "SearchResultLoomTag"
    }, v146 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "durationSeconds"
            },
            v143 /*: any*/ 
        ],
        "type": "SearchResultLoomVideo"
    }, v147 = [
        v65 /*: any*/ ,
        v86 /*: any*/ ,
        v49 /*: any*/ 
    ], v148 = [
        {
            "kind": "ScalarField",
            "name": "targetDate"
        },
        {
            "kind": "ScalarField",
            "name": "targetDateType"
        }
    ], v149 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "MercuryFocusArea",
                "kind": "LinkedField",
                "name": "focusArea",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MercuryFocusAreaStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": v147 /*: any*/ 
                    },
                    {
                        "concreteType": "MercuryFocusAreaHealth",
                        "kind": "LinkedField",
                        "name": "health",
                        "plural": false,
                        "selections": [
                            v65 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "color"
                            },
                            v86 /*: any*/ ,
                            v49 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "MercuryTargetDate",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": v148 /*: any*/ 
                    },
                    v49 /*: any*/ ,
                    v69 /*: any*/ ,
                    {
                        "concreteType": "MercuryFocusAreaType",
                        "kind": "LinkedField",
                        "name": "focusAreaType",
                        "plural": false,
                        "selections": v101 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": v112 /*: any*/ 
                    }
                ]
            },
            v56 /*: any*/ 
        ],
        "type": "SearchResultMercuryFocusArea"
    }, v150 = {
        "kind": "InlineFragment",
        "selections": [
            v56 /*: any*/ ,
            {
                "concreteType": "MercuryFocusArea",
                "kind": "LinkedField",
                "name": "focusArea",
                "plural": false,
                "selections": v107 /*: any*/ 
            }
        ],
        "type": "SearchResultMercuryFocusAreaStatusUpdate"
    }, v151 = {
        "condition": "includeRisk",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "MercuryRisk",
                        "kind": "LinkedField",
                        "name": "risk",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "MercuryRiskStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": v147 /*: any*/ 
                            },
                            {
                                "concreteType": "MercuryRiskTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": v148 /*: any*/ 
                            },
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "SearchResultMercuryRisk"
            }
        ]
    }, v152 = {
        "condition": "includeMercuryAsk",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "alias": "mercuryAsk",
                        "concreteType": "MercuryAsk",
                        "kind": "LinkedField",
                        "name": "ask",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "askStatus"
                            },
                            {
                                "concreteType": "MercuryAskTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": v148 /*: any*/ 
                            },
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "SearchResultMercuryAsk"
            }
        ]
    }, v153 = {
        "condition": "includePassionfruitAsk",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "SpfAsk",
                        "kind": "LinkedField",
                        "name": "ask",
                        "plural": false,
                        "selections": [
                            v94 /*: any*/ ,
                            {
                                "concreteType": "SpfAskTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": v148 /*: any*/ 
                            },
                            v49 /*: any*/ 
                        ]
                    },
                    v56 /*: any*/ 
                ],
                "type": "SearchResultSpfAsk"
            }
        ]
    }, v154 = [
        v56 /*: any*/ 
    ], v155 = {
        "kind": "InlineFragment",
        "selections": v154 /*: any*/ ,
        "type": "SearchResultTrelloBoard"
    }, v156 = {
        "kind": "InlineFragment",
        "selections": v154 /*: any*/ ,
        "type": "SearchResultTrelloCard"
    }, v157 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v158 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": [
            v69 /*: any*/ ,
            v86 /*: any*/ ,
            v49 /*: any*/ 
        ]
    }, v159 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v160 = {
        "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "AssetsSchema",
                        "kind": "LinkedField",
                        "name": "objectSchemaEntity",
                        "plural": false,
                        "selections": [
                            v69 /*: any*/ ,
                            v86 /*: any*/ ,
                            v157 /*: any*/ ,
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "SearchResultAssetsObjectSchema"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    v158 /*: any*/ ,
                    {
                        "concreteType": "AssetsObjectType",
                        "kind": "LinkedField",
                        "name": "objectTypeEntity",
                        "plural": false,
                        "selections": [
                            v69 /*: any*/ ,
                            v86 /*: any*/ ,
                            {
                                "concreteType": "AssetsIcon",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": v159 /*: any*/ 
                            },
                            v157 /*: any*/ ,
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "SearchResultAssetsObjectType"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    v158 /*: any*/ ,
                    {
                        "concreteType": "AssetsObject",
                        "kind": "LinkedField",
                        "name": "objectEntity",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AssetsAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": v159 /*: any*/ 
                            },
                            v157 /*: any*/ ,
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "SearchResultAssetsObject"
            }
        ]
    }, v161 = [
        v65 /*: any*/ ,
        v49 /*: any*/ 
    ], v162 = {
        "condition": "includePositions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "RadarPosition",
                        "kind": "LinkedField",
                        "name": "position",
                        "plural": false,
                        "selections": [
                            v48 /*: any*/ ,
                            {
                                "concreteType": "RadarWorker",
                                "kind": "LinkedField",
                                "name": "worker",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "preferredName"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v48 /*: any*/ ,
                                            v79 /*: any*/ ,
                                            v49 /*: any*/ 
                                        ]
                                    },
                                    v49 /*: any*/ 
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "fieldIdIsIn",
                                        "value": [
                                            "positionId",
                                            "positionStatus",
                                            "positionJobTitle",
                                            "positionPositionTitle",
                                            "positionKey",
                                            "positionExternalPositionKey",
                                            "positionWorker",
                                            "focusArea"
                                        ]
                                    }
                                ],
                                "concreteType": "RadarFieldValueIdPair",
                                "kind": "LinkedField",
                                "name": "fieldValues",
                                "plural": true,
                                "selections": [
                                    v120 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "fieldValue",
                                        "plural": false,
                                        "selections": [
                                            v48 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": "stringValue",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "RadarStringFieldValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "value",
                                                        "plural": false,
                                                        "selections": [
                                                            v48 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v69 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "MercuryFocusAreaStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": v161 /*: any*/ 
                                                                    },
                                                                    {
                                                                        "concreteType": "MercuryFocusAreaHealth",
                                                                        "kind": "LinkedField",
                                                                        "name": "health",
                                                                        "plural": false,
                                                                        "selections": v161 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "MercuryFocusArea"
                                                            },
                                                            v78 /*: any*/ 
                                                        ]
                                                    }
                                                ],
                                                "type": "RadarAriFieldValue"
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                            },
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "SearchResultTalentPosition"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ ,
                v37 /*: any*/ ,
                v38 /*: any*/ ,
                v39 /*: any*/ ,
                v40 /*: any*/ ,
                v41 /*: any*/ ,
                v42 /*: any*/ ,
                v43 /*: any*/ ,
                v44 /*: any*/ ,
                v45 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "deferFederatedResults",
                            "variableName": "deferFederatedResults"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeCaseEmbeddedComments",
                            "variableName": "includeCaseEmbeddedComments"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeCodeSearch",
                            "variableName": "includeCodeSearch"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeDatasourceId",
                            "variableName": "includeDatasourceId"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeFastJiraHydration",
                            "variableName": "includeFastJiraHydration"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraEmbeddedComments",
                            "variableName": "includeJiraEmbeddedComments"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraLiteModeFields",
                            "variableName": "includeJiraLiteModeFields"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeMercuryAsk",
                            "variableName": "includeMercuryAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeOriginalEntityType",
                            "variableName": "includeOriginalEntityType"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeRisk",
                            "variableName": "includeRisk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        },
                        v46 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v34 /*: any*/ ,
                v2 /*: any*/ ,
                v43 /*: any*/ ,
                v30 /*: any*/ ,
                v10 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ ,
                v37 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v29 /*: any*/ ,
                v31 /*: any*/ ,
                v1 /*: any*/ ,
                v33 /*: any*/ ,
                v42 /*: any*/ ,
                v4 /*: any*/ ,
                v44 /*: any*/ ,
                v39 /*: any*/ ,
                v40 /*: any*/ ,
                v41 /*: any*/ ,
                v13 /*: any*/ ,
                v38 /*: any*/ ,
                v14 /*: any*/ ,
                v32 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v12 /*: any*/ ,
                v45 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v26 /*: any*/ ,
                v28 /*: any*/ ,
                v18 /*: any*/ ,
                v24 /*: any*/ ,
                v23 /*: any*/ ,
                v25 /*: any*/ ,
                v27 /*: any*/ ,
                v22 /*: any*/ ,
                v21 /*: any*/ ,
                v19 /*: any*/ ,
                v17 /*: any*/ ,
                v16 /*: any*/ ,
                v6 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isleadnounenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isleaduserastitleenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__skiplinkeduserhydrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isprojectrendererenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__ismetadatacontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "search",
                            "args": v47 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "asyncSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCachedResult"
                                },
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v48 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v61 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v55 /*: any*/ ,
                                                v54 /*: any*/ ,
                                                v67 /*: any*/ ,
                                                v68 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v83 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v128 /*: any*/ ,
                                                v129 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v56 /*: any*/ ,
                                                        v66 /*: any*/ ,
                                                        v135 /*: any*/ ,
                                                        {
                                                            "condition": "includeJiraEmbeddedComments",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SearchResultJiraComment",
                                                                    "kind": "LinkedField",
                                                                    "name": "comments",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        v126 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "body"
                                                                        },
                                                                        v54 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "authorUser",
                                                                            "plural": false,
                                                                            "selections": v92 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                v136 /*: any*/ ,
                                                v138 /*: any*/ ,
                                                v139 /*: any*/ ,
                                                v140 /*: any*/ ,
                                                v141 /*: any*/ ,
                                                v142 /*: any*/ ,
                                                v144 /*: any*/ ,
                                                v145 /*: any*/ ,
                                                v146 /*: any*/ ,
                                                v149 /*: any*/ ,
                                                v150 /*: any*/ ,
                                                v151 /*: any*/ ,
                                                v152 /*: any*/ ,
                                                v153 /*: any*/ ,
                                                v155 /*: any*/ ,
                                                v156 /*: any*/ ,
                                                v160 /*: any*/ ,
                                                v162 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "traceId"
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                },
                                {
                                    "condition": "deferFederatedResults",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "if": "deferFederatedResults",
                                            "kind": "Defer",
                                            "label": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$defer$searchResultsAsyncQuery_federatedEdges",
                                            "selections": [
                                                {
                                                    "concreteType": "SearchResultItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "federatedEdges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v48 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v50 /*: any*/ ,
                                                                v60 /*: any*/ ,
                                                                v61 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                v67 /*: any*/ ,
                                                                v68 /*: any*/ ,
                                                                v71 /*: any*/ ,
                                                                v72 /*: any*/ ,
                                                                v83 /*: any*/ ,
                                                                v84 /*: any*/ ,
                                                                v128 /*: any*/ ,
                                                                v129 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v56 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v135 /*: any*/ 
                                                                    ],
                                                                    "type": "SearchResultJiraIssue"
                                                                },
                                                                v136 /*: any*/ ,
                                                                v138 /*: any*/ ,
                                                                v139 /*: any*/ ,
                                                                v140 /*: any*/ ,
                                                                v141 /*: any*/ ,
                                                                v142 /*: any*/ ,
                                                                v144 /*: any*/ ,
                                                                v145 /*: any*/ ,
                                                                v146 /*: any*/ ,
                                                                v149 /*: any*/ ,
                                                                v150 /*: any*/ ,
                                                                v151 /*: any*/ ,
                                                                v152 /*: any*/ ,
                                                                v153 /*: any*/ ,
                                                                v155 /*: any*/ ,
                                                                v156 /*: any*/ ,
                                                                v160 /*: any*/ ,
                                                                v162 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "search",
                            "args": v47 /*: any*/ ,
                            "filters": [
                                "experience",
                                "useCaseId",
                                "enableHighlighting",
                                "enableRelevanceDebugging",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "expectResult",
                                "filters",
                                "analytics",
                                "experimentContext",
                                "matchingLayerExperimentsMetadata"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsAsyncPagination__search",
                            "kind": "LinkedHandle",
                            "name": "asyncSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c26a0822e9d917157513144d6dd817c0be149e4fa8a793cdc98cf8b0bbc52500",
            "metadata": {},
            "name": "searchResultsAsyncQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $hd5Dy.default),
                "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": (0, $hFjUk.default),
                "__relay_internal__pv__isleadnounenabledrelayprovider": (0, $iK48f.default),
                "__relay_internal__pv__isleaduserastitleenabledrelayprovider": (0, $8dp6J.default),
                "__relay_internal__pv__isslacktopreactionenabledrelayprovider": (0, $4Pgy4.default),
                "__relay_internal__pv__skiplinkeduserhydrationrelayprovider": (0, $8NMWF.default),
                "__relay_internal__pv__isprojectrendererenabledrelayprovider": (0, $b9kI4.default),
                "__relay_internal__pv__ismetadatacontentenabledrelayprovider": (0, $jfrG1.default)
            }
        }
    };
}();
$b16e14c5cbb2e6b9$var$node.hash = "c20a83d58979e4dd0c6b09f9420b4012";
var $b16e14c5cbb2e6b9$export$2e2bcd8739ae039 = $b16e14c5cbb2e6b9$var$node;
module.exports["default"] = $b16e14c5cbb2e6b9$export$2e2bcd8739ae039;

});

parcelRegister("hd5Dy", function(module, exports) {
$parcel$export(module.exports, "default", () => $537e39b311f76645$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var $537e39b311f76645$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('assets_rovo_search_all');
    }
};

});

parcelRegister("8NMWF", function(module, exports) {
$parcel$export(module.exports, "default", () => $527d36de48ed8654$export$2e2bcd8739ae039);

var $4o0zT = parcelRequire("4o0zT");

var $527d36de48ed8654$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4o0zT.isExperimentEnabled)('rovo_fps_remove_linked_user_hydration');
    }
};

});

parcelRegister("iK48f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f04067010154282e$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var // https://switcheroo.atlassian.com/ui/gates/rovo-fps-3p-ux-salesforce-lead-noun
$f04067010154282e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-lead-noun');
    }
};

});

parcelRegister("8dp6J", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6f58341d7ed5e13$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var // https://switcheroo.atlassian.com/ui/gates/rovo_fps_lead_user_as_title
$e6f58341d7ed5e13$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('rovo_fps_lead_user_as_title');
    }
};

});

parcelRegister("hFjUk", function(module, exports) {
$parcel$export(module.exports, "default", () => $760084c5b07c8f2d$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var $760084c5b07c8f2d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('ai_3p_slack_eg_workspace_metadata_enabled');
    }
};

});

parcelRegister("4Pgy4", function(module, exports) {
$parcel$export(module.exports, "default", () => $102dbd473905b15e$export$2e2bcd8739ae039);

var $cJff5 = parcelRequire("cJff5");

var $102dbd473905b15e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cJff5.serveSlackTopReactionInSearchExperiment)({
            fireExperimentExposure: false
        });
    }
};

});

parcelRegister("b9kI4", function(module, exports) {
$parcel$export(module.exports, "default", () => $32f6f0b1131ac6c0$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var // https://switcheroo.atlassian.com/ui/gates/rovo_fps_servicenow_project_renderer
$32f6f0b1131ac6c0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('rovo_fps_servicenow_project_renderer');
    }
};

});

parcelRegister("jfrG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c515c647cb3de5a$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var $3c515c647cb3de5a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('rovo_fps_video_include_metadata_content');
    }
};

});

parcelRegister("jyixt", function(module, exports) {
/**
 * @generated SignedSource<<403f147e916912fe0c48265692200865>>
 * @relayHash 68a75d183b7539fe986ed18773f1120a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76
const $8392099c2a71c856$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v4 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v5 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        v4 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResultsCql_AtlassianSearchPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                            "kind": "LinkedField",
                                                            "name": "links",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webui"
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModified"
                                        },
                                        {
                                            "concreteType": "LinksContextBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "base"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "filters": [
                        "cql"
                    ],
                    "handle": "connection",
                    "key": "SearchResultsCQLPagination__confluence_search",
                    "kind": "LinkedHandle",
                    "name": "confluence_search"
                }
            ]
        },
        "params": {
            "id": "b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76",
            "metadata": {},
            "name": "searchResultsCqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8392099c2a71c856$var$node.hash = "8714af4459ffedbd0699977be49d7cf7";
var $8392099c2a71c856$export$2e2bcd8739ae039 = $8392099c2a71c856$var$node;
module.exports["default"] = $8392099c2a71c856$export$2e2bcd8739ae039;

});

parcelRegister("7QpO7", function(module, exports) {

var $6onJ6 = parcelRequire("6onJ6");

const $deb1c3471472a179$export$fa81019546daea36 = (0, $6onJ6.disposableValue)();
const $deb1c3471472a179$export$821c81800cc5b1e1 = ()=>{
    return $deb1c3471472a179$export$fa81019546daea36.value() || undefined;
};
const $deb1c3471472a179$export$c3c881dbbb056bcd = ()=>{
    $deb1c3471472a179$export$fa81019546daea36.update(Date.now());
};
const $deb1c3471472a179$export$99f330c261037d6f = ()=>{
    $deb1c3471472a179$export$fa81019546daea36.dispose();
};
module.exports["getQueryUpdatedTime"] = $deb1c3471472a179$export$821c81800cc5b1e1;
module.exports["setQueryUpdatedTime"] = $deb1c3471472a179$export$c3c881dbbb056bcd;
module.exports["disposeQueryUpdatedTime"] = $deb1c3471472a179$export$99f330c261037d6f;

});

parcelRegister("dsOco", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6yu7A = parcelRequire("6yu7A");


var $9pcjO = parcelRequire("9pcjO");


var $32Eau = parcelRequire("32Eau");


var $1i979 = parcelRequire("1i979");


var $94CaV = parcelRequire("94CaV");


var $c4G7r = parcelRequire("c4G7r");

const $b5cd5ad05ff5fdff$export$e955abb82869dc84 = (props = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // analytics attributes passed in from the product
    const [analyticsAttributes] = (0, $32Eau.useAnalyticsAttributes)();
    const [searchExperience] = (0, $1i979.useSearchExperience)();
    const experiencePayload = (0, $cozmU.useMemo)(()=>{
        // determine experience payload for analytics attributes, defaulting to store value if not provided
        const experience = props.experience || searchExperience;
        const isQuickFind = experience === (0, $9pcjO.SearchExperience).QUICK_FIND;
        const isFullPageSearch = experience === (0, $9pcjO.SearchExperience).SEARCH_PAGE;
        return {
            isFullPageSearch: isFullPageSearch,
            isQuickFind: isQuickFind
        };
    }, [
        props.experience,
        searchExperience
    ]);
    // use this hook to fire UI, track, and operational event types
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || (0, $6yu7A.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    // use this hook to fire screen event types
    const fireAnalyticsScreenEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: (0, $6yu7A.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $b5cd5ad05ff5fdff$export$58bac47385d8e8f4 = ()=>{
    return (0, $c4G7r.getAttributes)((0, $94CaV.useCommonAttributeInputs)());
};
module.exports["useAnalytics"] = $b5cd5ad05ff5fdff$export$e955abb82869dc84;
module.exports["useCommonAndPrivateAttributes"] = $b5cd5ad05ff5fdff$export$58bac47385d8e8f4;

});

parcelRegister("94CaV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c11PZ = parcelRequire("c11PZ");


var $32Eau = parcelRequire("32Eau");


var $1i979 = parcelRequire("1i979");

const $b47226d4a14382a9$export$664b411245a84458 = ({ analyticsAttributes: analyticsAttributes, experience: experience } = {})=>{
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestId] = (0, $1i979.useResultsRequestId)();
    const [searchQuery] = (0, $1i979.useSearchQuery)();
    const [inputQuery] = (0, $1i979.useInputQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $1i979.useQueryUpdatedTime)();
    const [productSelected] = (0, $1i979.useSelectedProduct)();
    const availableProducts = (0, $32Eau.useAvailableProducts)();
    const [sort] = (0, $1i979.useResultsSort)();
    const [experimentConfig] = (0, $32Eau.useExperimentConfig)();
    const filters = (0, $1i979.useFilterAttributesForTracking)();
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const [productEdition] = (0, $32Eau.useProductEdition)();
    const cqlState = (0, $1i979.useCQL)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const [features] = (0, $32Eau.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    return (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            requestId: requestId,
            searchQuery: searchQuery,
            inputQuery: inputQuery,
            filters: filters,
            queryUpdatedTime: queryUpdatedTime,
            productSelected: productSelected,
            availableProducts: availableProducts,
            sort: sort,
            experimentConfig: experimentConfig,
            applicationMode: applicationMode,
            productEdition: productEdition,
            isCQL: !!cqlState,
            isLiteMode: isLiteMode,
            primaryProduct: primaryProduct,
            queryParams: queryParams,
            analyticsAttributes: analyticsAttributes,
            experience: experience
        }), [
        searchSessionId,
        requestId,
        searchQuery,
        inputQuery,
        filters,
        queryUpdatedTime,
        productSelected,
        availableProducts,
        sort,
        experimentConfig,
        applicationMode,
        productEdition,
        cqlState,
        isLiteMode,
        primaryProduct,
        queryParams,
        analyticsAttributes,
        experience
    ]);
};
module.exports["useCommonAttributeInputs"] = $b47226d4a14382a9$export$664b411245a84458;

});

parcelRegister("c4G7r", function(module, exports) {

var $6yu7A = parcelRequire("6yu7A");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $e0v3Z = parcelRequire("e0v3Z");


var $hnDqW = parcelRequire("hnDqW");

const $8b685f31f0cb0433$export$fe94072fee8a6976 = ({ searchSessionId: searchSessionId, requestId: requestId, searchQuery: searchQuery, inputQuery: inputQuery, filters: filters, queryUpdatedTime: queryUpdatedTime, productSelected: productSelected, availableProducts: availableProducts, sort: sort, experimentConfig: experimentConfig, applicationMode: applicationMode, productEdition: productEdition, isCQL: isCQL, isLiteMode: isLiteMode, primaryProduct: primaryProduct, queryParams: queryParams, analyticsAttributes: analyticsAttributes, experience: experience })=>{
    const { filterSelections: filterSelections, filters: filterCategories } = filters;
    const rovoJourneyId = (0, $hnDqW.canContinueRovoJourney)(primaryProduct ?? undefined) ? (0, $hnDqW.normalizeRovoJourneyId)(queryParams?.rovoJourneyId) : undefined;
    const has3pProducts = !!availableProducts.find((product)=>(0, $dvVWp.is3pProductKey)(product));
    const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
    const is3pSearch = !!(has3pProducts && !productSelected || productSelected && (0, $dvVWp.is3pProductKey)(productSelected));
    const archivedStatus = filterSelections.some((selection)=>selection.value === (0, $6yu7A.OptionIds).ARCHIVED) ? [
        (0, $6yu7A.CURRENT),
        (0, $6yu7A.ARCHIVED)
    ] : [
        (0, $6yu7A.CURRENT)
    ];
    const commonAttributes = {
        ...analyticsAttributes,
        searchSessionId: searchSessionId,
        traceId: requestId,
        productSelected: productSelected || (0, $6yu7A.ALL_PRODUCTS_STRING),
        availableProducts: availableProducts,
        mode: applicationMode,
        has3pProducts: has3pProducts,
        is3pSearch: is3pSearch,
        numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
        queryLength: searchQuery.length,
        inputQueryLength: inputQuery.length,
        queryHash: (0, $e0v3Z.sha256Hash)(searchQuery),
        filters: filterCategories,
        filterSelections: filterSelections,
        containerStatuses: archivedStatus,
        contentStatuses: archivedStatus,
        productEdition: productEdition,
        frontendExperiments: {
            activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
            ...frontendExperiments
        },
        version: 2,
        api: (0, $6yu7A.CROSSPRODUCT_SEARCH_API),
        wordCount: (searchQuery.match(/\w+/g) || []).length,
        isCQL: isCQL ?? false,
        queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
        sort: sort,
        isSearchPageRelay: true,
        isLiteMode: isLiteMode ?? false,
        ...rovoJourneyId ? {
            rovoJourneyId: rovoJourneyId
        } : {},
        ...experience ? {
            isFullPageSearch: experience === (0, $9pcjO.SearchExperience).SEARCH_PAGE,
            isQuickFind: experience === (0, $9pcjO.SearchExperience).QUICK_FIND
        } : {}
    };
    const nonPrivacySafeAttributes = {
        query: searchQuery,
        inputQuery: inputQuery
    };
    return {
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
module.exports["getAttributes"] = $8b685f31f0cb0433$export$fe94072fee8a6976;

});

parcelRegister("eUI6V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $lj9HS = parcelRequire("lj9HS");

function $fe7ce83b909ba07b$export$865a2f088c837665() {
    const { canAnimate: canAnimate } = (0, $lj9HS.useConnectAppsCooldown)();
    const suppressAtMount = (0, $cozmU.useRef)((0, $iDrrr.fg)('quick_find_hide_connect_apps_pill') ? false : canAnimate());
    return suppressAtMount.current;
}
module.exports["useShouldSuppressBannerForAnimation"] = $fe7ce83b909ba07b$export$865a2f088c837665;

});

parcelRegister("fq2CX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $esfRg = parcelRequire("esfRg");


var $8fNUp = parcelRequire("8fNUp");


var $bhyuO = parcelRequire("bhyuO");


var $6yu7A = parcelRequire("6yu7A");


var $9pcjO = parcelRequire("9pcjO");

const $0208c4d27a824e4a$export$6244fd8f3fa9025d = ({ cloudId: cloudId, experience: experience, productCount: productCount, usages: usages })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9pcjO.SearchExperience).QUICK_FIND ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                productCount: productCount,
                usages: usages ? JSON.stringify(usages) : undefined
            }
        }
    };
};
const $0208c4d27a824e4a$export$973cdfe8c0b26a2b = ({ cloudId: cloudId, experience: experience, reason: reason })=>{
    return {
        action: 'taskFail',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9pcjO.SearchExperience).QUICK_FIND ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                reason: reason
            }
        }
    };
};



var $fd0l2 = parcelRequire("fd0l2");


var $fR63l = parcelRequire("fR63l");


var $dvVWp = parcelRequire("dvVWp");




const $e33ca8d70c8991e5$export$98ca9e3e34f377b = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    let productOrder = [];
    if (isOnSearchDialog) // TODO: we should consolidate the behaviour of banners between FPS and QF (both order and what products are shown).
    // See https://atlassian.slack.com/archives/C0A8GKLU6PQ/p1770850523754429
    productOrder = [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).Sharepoint,
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $fR63l.ProductKeys3P).Gitbook
    ];
    else {
        const requiredProducts = [];
        (0, $fd0l2.ThirdPartyConfigsSync).forEach((_, productKey3P)=>{
            if ((0, $fd0l2.ThirdPartyConfigsSync).get(productKey3P)?.requiresOauth) requiredProducts.push(productKey3P);
        });
        // Filter and order static products based on PRODUCTS_ORDER
        const staticProducts = (0, $dvVWp.PRODUCTS_ORDER).filter((product)=>requiredProducts.includes(product));
        // Add Forge connectors that need OAuth (ordered after static products)
        const forgeConnectors = availableProducts.filter((product)=>(0, $8fNUp.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]?.userNeedsOAuth && thirdPartyConfigs[product]?.outboundAuthUrl);
        productOrder = [
            ...staticProducts,
            ...forgeConnectors
        ];
    }
    return productOrder.filter((product)=>availableProducts.includes(product));
};



var $dsOco = parcelRequire("dsOco");


var $32Eau = parcelRequire("32Eau");




const $00a2e817e8110fe9$export$ce0553f0f2dae7c8 = {
    'widely-adopted': 25,
    'mid-adoption': 15,
    niche: 10
};
const $00a2e817e8110fe9$export$b64145217f45680a = {
    'widely-adopted': new Set([
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $fR63l.ProductKeys3P).Gitlab,
        (0, $fR63l.ProductKeys3P).AzureDevops,
        (0, $fR63l.ProductKeys3P).Sentry,
        (0, $fR63l.ProductKeys3P).Miro,
        (0, $fR63l.ProductKeys3P).Salesforce,
        (0, $fR63l.ProductKeys3P).Notion,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ]),
    'mid-adoption': new Set([
        (0, $fR63l.ProductKeys3P).Pipedrive,
        (0, $fR63l.ProductKeys3P).Box,
        (0, $fR63l.ProductKeys3P).ClickUp,
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Asana
    ]),
    niche: new Set([
        (0, $fR63l.ProductKeys3P).Todoist,
        (0, $fR63l.ProductKeys3P).Zeplin,
        (0, $fR63l.ProductKeys3P).Dropbox,
        (0, $fR63l.ProductKeys3P).Lucid,
        (0, $fR63l.ProductKeys3P).Amplitude,
        (0, $fR63l.ProductKeys3P).Mural,
        (0, $fR63l.ProductKeys3P).Airtable,
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        (0, $fR63l.ProductKeys3P).Stripe,
        (0, $fR63l.ProductKeys3P).Smartsheet,
        (0, $fR63l.ProductKeys3P).Docusign,
        (0, $fR63l.ProductKeys3P).PagerDuty,
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $fR63l.ProductKeys3P).Dovetail,
        (0, $fR63l.ProductKeys3P).Webex
    ])
};
// Reverse lookup for quicker/easier product → tier resolution.
const $00a2e817e8110fe9$var$CONNECTOR_TO_TIER = new Map(Object.entries($00a2e817e8110fe9$export$b64145217f45680a).flatMap(([tier, products])=>[
        ...products
    ].map((product)=>[
            product,
            tier
        ])));
const $00a2e817e8110fe9$export$bcc396963ce06343 = (product)=>{
    return $00a2e817e8110fe9$var$CONNECTOR_TO_TIER.get(product) ?? 'niche';
};
const $00a2e817e8110fe9$export$fb50a930cc5288bf = (product)=>{
    return $00a2e817e8110fe9$export$ce0553f0f2dae7c8[$00a2e817e8110fe9$export$bcc396963ce06343(product)];
};
const $00a2e817e8110fe9$export$835ec42bc9d6e801 = (product, usagePercent)=>{
    if (usagePercent === undefined) return true;
    const threshold = $00a2e817e8110fe9$export$fb50a930cc5288bf(product);
    return usagePercent >= threshold;
};


const $048ea08a2a4e64ef$export$8e364fc6aecba9a9 = (experience, cloudId)=>{
    const [smartLinkUsage, setSmartLinkUsage] = (0, $cozmU.useState)(undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)({
        experience: experience
    });
    (0, $cozmU.useEffect)(()=>{
        if (cloudId) (0, $esfRg.getTenantSmartlinkUsage)({
            siteId: cloudId
        }).then((usageData)=>{
            setSmartLinkUsage(usageData);
            fireAnalyticsEvent((0, $0208c4d27a824e4a$export$6244fd8f3fa9025d)({
                cloudId: cloudId,
                experience: experience,
                productCount: Object.keys(usageData).length,
                usages: usageData
            }));
        }).catch((error)=>{
            fireAnalyticsEvent((0, $0208c4d27a824e4a$export$973cdfe8c0b26a2b)({
                cloudId: cloudId,
                experience: experience,
                reason: error instanceof Error ? error.message : String(error)
            }));
        });
    }, [
        cloudId,
        experience,
        fireAnalyticsEvent
    ]);
    return smartLinkUsage;
};
const $048ea08a2a4e64ef$export$7e6da2e188a2a79d = ({ products: products, thirdPartyConfigs: thirdPartyConfigs })=>{
    const isBannerOptedOut = (0, $iDrrr.fg)('rovo_search_3p_banner_opt_out');
    const usageData = (0, $32Eau.useSmartLinkUsage)();
    return (0, $cozmU.useMemo)(()=>{
        if (isBannerOptedOut || !usageData) return products;
        return products.filter((product)=>{
            const config = thirdPartyConfigs[product];
            const isSmartlinksOnly = config?.connectorSources?.includes((0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE)) && !config?.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE));
            // The logic to hide banners based on usage is only applicable to smart-link connectors
            // and only if there's no full-connector for the same product.
            if (!isSmartlinksOnly) return true;
            return (0, $00a2e817e8110fe9$export$835ec42bc9d6e801)(product, usageData[product]);
        });
    }, [
        isBannerOptedOut,
        usageData,
        products,
        thirdPartyConfigs
    ]);
};
const $048ea08a2a4e64ef$export$51f63d7c1c9ec5d4 = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    const orderedAvailableProducts = (0, $cozmU.useMemo)(()=>(0, $e33ca8d70c8991e5$export$98ca9e3e34f377b)({
            isOnSearchDialog: isOnSearchDialog,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts
        }), [
        isOnSearchDialog,
        thirdPartyConfigs,
        availableProducts
    ]);
    const productsWithSufficientUsage = $048ea08a2a4e64ef$export$7e6da2e188a2a79d({
        products: orderedAvailableProducts,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const orderedAvailableProductsAfterUsageFilter = (0, $cozmU.useMemo)(()=>{
        if (productsWithSufficientUsage?.length) return orderedAvailableProducts.filter((p)=>productsWithSufficientUsage.includes(p));
        return orderedAvailableProducts;
    }, [
        orderedAvailableProducts,
        productsWithSufficientUsage
    ]);
    const enforceMaxDismissals = true;
    return orderedAvailableProductsAfterUsageFilter.filter((product)=>(0, $bhyuO.shouldShowOAuthBanner)(product, enforceMaxDismissals));
};
module.exports["useFetchSmartLinkUsage"] = $048ea08a2a4e64ef$export$8e364fc6aecba9a9;
module.exports["useBannerEligibleProductsOrder"] = $048ea08a2a4e64ef$export$51f63d7c1c9ec5d4;

});

parcelRegister("esfRg", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $3OOLc = parcelRequire("3OOLc");


var $b3qPd = parcelRequire("b3qPd");

const { refreshOnAccessDecorator: $5d1f628fd49a3aa7$var$refreshOnAccessDecoratorSmartlink, get: $5d1f628fd49a3aa7$var$getSmartlinkCache, clear: $5d1f628fd49a3aa7$var$clearSmartlinkCache } = (0, $fyjce.promiseCache)({
    name: (0, $3OOLc.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY),
    expiration: (0, $3OOLc.SEVEN_DAY_MS_TTL)
});
const $5d1f628fd49a3aa7$var$fetchSiteSmartlinkService = async (siteId)=>{
    const requestUrl = (0, $b3qPd.getSmartlinkSiteTraitsUrl)(siteId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $5d1f628fd49a3aa7$var$fetchSmartlinkProductUsageRate = async ({ siteId: siteId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $bZF61.generateHash)(`${(0, $3OOLc.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY)}|${siteId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $5d1f628fd49a3aa7$var$fetchSiteSmartlinkService(siteId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === (0, $3OOLc.SMARTLINK_APP_EXPOSURE_RATE_TRAIT));
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $9C63M.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise().catch(async (e)=>{
            // On degrade/timeout, re-set cache entry to resolved undefined with ONE_HOUR_TTL
            // so callers won't hammer the service for the next hour, but will retry after.
            // Since we're in supplier, we can't directly set here without re-entrant complexity.
            // Instead, throw and let refreshOnAccessDecorator store this rejecting promise; after this call,
            // callers should rely on our external code path to clear or retry as needed.
            throw e;
        });
    };
    const existing = $5d1f628fd49a3aa7$var$getSmartlinkCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    // We cannot know the outcome until supplier resolves/rejects; so we approximate:
    //   if no existing value, we assume empty path (ONE_HOUR_MS_TTL) to avoid hammering
    //   then, within supplier, we adjust by re-setting the cache on rejection with ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $3OOLc.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $5d1f628fd49a3aa7$var$refreshOnAccessDecoratorSmartlink({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            // force refresh to apply new TTL
            expiration: ttl
        });
    };
    return $5d1f628fd49a3aa7$var$refreshOnAccessDecoratorSmartlink({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $3OOLc.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $3OOLc.ONE_DAY_MS_TTL));
                return result;
            } catch  {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $3OOLc.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $5d1f628fd49a3aa7$export$a618d8f3094322c9 = (key)=>$5d1f628fd49a3aa7$var$clearSmartlinkCache(key);
const $5d1f628fd49a3aa7$export$f0ea64eab9ebcb2f = (trait)=>{
    if (trait?.name === (0, $3OOLc.SMARTLINK_APP_EXPOSURE_RATE_TRAIT) && typeof trait?.value === 'string') {
        const result = {};
        const pairs = trait.value.split(',').map((s)=>s.trim());
        for (const pair of pairs){
            const [app, rateStr] = pair.split(':').map((s)=>s.trim());
            if (app && rateStr) {
                const rate = parseInt(rateStr, 10);
                if (!isNaN(rate)) result[app] = rate;
            }
        }
        return result;
    }
    return {};
};
const $5d1f628fd49a3aa7$export$b95bec45d0bca567 = async ({ siteId: siteId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!siteId) return {};
    const trait = await $5d1f628fd49a3aa7$var$fetchSmartlinkProductUsageRate({
        siteId: siteId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'rovo-search-smartlink-usage'
    });
    return $5d1f628fd49a3aa7$export$f0ea64eab9ebcb2f(trait);
};
module.exports["getTenantSmartlinkUsage"] = $5d1f628fd49a3aa7$export$b95bec45d0bca567;

});

parcelRegister("3OOLc", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $7253096097f49bfd$export$34e8837a1913e572 = 'search-personalization-site-user';
const $7253096097f49bfd$export$f80bd7d8a13f050a = 604800000; // 7 days
const $7253096097f49bfd$export$18406d9c8318a338 = 86400000; // 1 day
const $7253096097f49bfd$export$2383b9b3bc711073 = 3600000; // 1 hour
const $7253096097f49bfd$export$d0bbd8e7f2e797 = 'search_user_3p_recommendations_right_panel_v1';
const $7253096097f49bfd$export$330c7df40d69ab27 = 'search-personalization-smartlink-site';
const $7253096097f49bfd$export$15fc832cc21ada61 = 'smartlink_app_exposure_rate';
const $7253096097f49bfd$export$c25c73d04a24471b = 'search-personalization-smartlink-usage-and-top-apps-site';
const $7253096097f49bfd$export$7b7ea824b946adee = 'rovo_nudge_end_user_rendered_smartlinks_percent_and_most_used_apps';
module.exports["SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY"] = $7253096097f49bfd$export$34e8837a1913e572;
module.exports["SEVEN_DAY_MS_TTL"] = $7253096097f49bfd$export$f80bd7d8a13f050a;
module.exports["ONE_DAY_MS_TTL"] = $7253096097f49bfd$export$18406d9c8318a338;
module.exports["ONE_HOUR_MS_TTL"] = $7253096097f49bfd$export$2383b9b3bc711073;
module.exports["RIGHT_PANEL_TRAIT"] = $7253096097f49bfd$export$d0bbd8e7f2e797;
module.exports["SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY"] = $7253096097f49bfd$export$330c7df40d69ab27;
module.exports["SMARTLINK_APP_EXPOSURE_RATE_TRAIT"] = $7253096097f49bfd$export$15fc832cc21ada61;

});

parcelRegister("bhyuO", function(module, exports) {

var $6dPGs = parcelRequire("6dPGs");

const $8b926be8ea5670fb$var$OAUTH_BANNER_DISMISS_KEY = 'atlassian.unified-search.oauth-banner-dismiss-counts';
const $8b926be8ea5670fb$export$afe8c16e492e553f = (product, enforceMaxDismissals)=>{
    const dismissCounts = $8b926be8ea5670fb$var$getLocalStorageData();
    const hasUserDismissedThisProductBefore = (dismissCounts[product] ?? 0) > 0;
    if (enforceMaxDismissals) return !(hasUserDismissedThisProductBefore || $8b926be8ea5670fb$export$67e3eb5caec4ff4c(dismissCounts));
    return !hasUserDismissedThisProductBefore;
};
/**
 * The max number of times the user dismisses **across products**
 */ const $8b926be8ea5670fb$var$MAX_DISMISSALS = 4;
const $8b926be8ea5670fb$export$67e3eb5caec4ff4c = (dismissCounts)=>{
    const totalDismissalsAcrossProducts = Object.values(dismissCounts).reduce((prev, curr)=>(prev ?? 0) + (curr ?? 0), 0);
    return (totalDismissalsAcrossProducts ?? 0) >= $8b926be8ea5670fb$var$MAX_DISMISSALS;
};
const $8b926be8ea5670fb$export$94f957a0ee1d39c8 = (product)=>{
    const dismissCounts = $8b926be8ea5670fb$var$getLocalStorageData();
    dismissCounts[product] = (dismissCounts[product] ?? 0) + 1;
    $8b926be8ea5670fb$var$saveToLocalStorage(dismissCounts);
};
/**
 * @returns the local storage object that stores products and their dismiss counts
 */ const $8b926be8ea5670fb$var$getLocalStorageData = ()=>{
    const serializedDismissCounts = (0, $6dPGs.getLocalStorageItemAsString)($8b926be8ea5670fb$var$OAUTH_BANNER_DISMISS_KEY);
    if (!serializedDismissCounts) return {};
    let localStorageObject;
    try {
        localStorageObject = JSON.parse(serializedDismissCounts);
    } catch  {
        return {};
    }
    return localStorageObject;
};
/**
 * Saves the local storage object that stores products and their dismiss counts
 */ const $8b926be8ea5670fb$var$saveToLocalStorage = (localStorageObject)=>{
    (0, $6dPGs.setLocalStorageItem)($8b926be8ea5670fb$var$OAUTH_BANNER_DISMISS_KEY, JSON.stringify(localStorageObject));
};
module.exports["shouldShowOAuthBanner"] = $8b926be8ea5670fb$export$afe8c16e492e553f;
module.exports["increaseProductDismissCount"] = $8b926be8ea5670fb$export$94f957a0ee1d39c8;

});

parcelRegister("1sz28", function(module, exports) {
$parcel$export(module.exports, "CancelError", () => (parcelRequire("ZLNmD")).CancelError);

var $ZLNmD = parcelRequire("ZLNmD");

const $38db88d18aad1515$var$CANCEL_ERROR = new (0, $ZLNmD.CancelError)('Promise is cancelled');
class $38db88d18aad1515$export$5782acf08706f13d {
    static from(promise) {
        return new $38db88d18aad1515$export$5782acf08706f13d(promise);
    }
    constructor(promise){
        this.cancellablePromiseInternal = void 0;
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($38db88d18aad1515$var$CANCEL_ERROR);
            })
        ]);
    }
}
module.exports["CancellablePromise"] = $38db88d18aad1515$export$5782acf08706f13d;

});

parcelRegister("ZLNmD", function(module, exports) {
class $3f7ced46b8e6af18$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args);
        this.isCancelled = true;
    }
}
module.exports["CancelError"] = $3f7ced46b8e6af18$export$d7f5e52d091a66db;

});

parcelRegister("5RzlA", function(module, exports) {
// Pure product key constants imported from product-keys.ts (source of truth).
// Re-exported below so existing consumers continue to work.

var $dvVWp = parcelRequire("dvVWp");

const $9e02b46183d36411$export$ee811373b5708646 = (key)=>!Object.values((0, $dvVWp.ProductKeys1PForAnalytics)).includes(key);
module.exports["is3pProductKeyForAnalytics"] = $9e02b46183d36411$export$ee811373b5708646;

});

parcelRegister("bQ6i3", function(module, exports) {

var $6dPGs = parcelRequire("6dPGs");

const $4b70dfba64774c7f$export$ad9e8f9d9536c33d = ()=>{
    // The key is defined in packages/atlassian-analytics-pipeline/analytics-web-client/src/sessionTracking.ts.
    const LOCAL_STORAGE_KEY = 'awc.session.id';
    try {
        return (0, $6dPGs.getLocalStorageItemAsString)(LOCAL_STORAGE_KEY) ?? undefined;
    } catch (error) {
        return undefined;
    }
};
module.exports["getSessionIdFromLocalStorage"] = $4b70dfba64774c7f$export$ad9e8f9d9536c33d;

});

parcelRegister("jTbFT", function(module, exports) {
const $fd1c8d41c6057873$export$5e8268eaa81797f5 = {
    SEARCH_PAGE_FIRST_PARTY_CONFIG_UX: 'search-page/first-party-config-ux',
    SEARCH_PAGE_FIRST_PARTY_CONFIG_NETWORK: 'search-page/first-party-config-network',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_UX: 'search-page/third-party-config-ux',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_NETWORK: 'search-page/third-party-config-network',
    SEARCH_PAGE_COMBINED_CONFIG_UX: 'search-page/combined-config-ux',
    SEARCH_PAGE_COMBINED_CONFIG_NETWORK: 'search-page/combined-config-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX: 'search-page/full-page-search-results-ux',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK: 'search-page/full-page-search-results-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS: 'search-page/full-page-search-async-search-results',
    QUICK_FIND_RECENT_ACTIVITIES_UX: 'quick-find/recent-activities-ux',
    QUICK_FIND_RECENT_ACTIVITIES_NETWORK: 'quick-find/recent-activities-network',
    QUICK_FIND_PRE_QUERY_RESULTS: 'quick-find/prequery-search-results-ux',
    QUICK_FIND_POST_QUERY_UX: 'quick-find/postquery-search-results-ux',
    QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK: 'quick-find/confluence-entities-network',
    QUICK_FIND_CONFLUENCE_SPACES_NETWORK: 'quick-find/confluence-spaces-network',
    QUICK_FIND_LOOM_ENTITIES_NETWORK: 'quick-find/loom-entities-network',
    QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK: 'quick-find/jira-issues-and-types-network',
    QUICK_FIND_JIRA_ENTITIES_NETWORK: 'quick-find/jira-entities-network',
    QUICK_FIND_ATLAS_ENTITIES_NETWORK: 'quick-find/atlas-entities-network',
    QUICK_FIND_MERCURY_ENTITIES_NETWORK: 'quick-find/mercury-entities-network',
    QUICK_FIND_TALENT_ENTITIES_NETWORK: 'quick-find/talent-entities-network',
    QUICK_FIND_ASSETS_ENTITIES_NETWORK: 'quick-find/assets-entities-network',
    QUICK_FIND_INTENT_DETECTION_NETWORK: 'quick-find/intent-detection-network',
    QUICK_FIND_INTENT_DETECTION_UX: 'quick-find/intent-detection-ux'
};
module.exports["TASK_NAMES"] = $fd1c8d41c6057873$export$5e8268eaa81797f5;

});

parcelRegister("hnyex", function(module, exports) {


const $2edf73f89ca55348$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: window.location.hostname,
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $2edf73f89ca55348$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $2edf73f89ca55348$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $2edf73f89ca55348$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $2edf73f89ca55348$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["onTaskStart"] = $2edf73f89ca55348$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $2edf73f89ca55348$export$3e9761d670712e50;
module.exports["onTaskFail"] = $2edf73f89ca55348$export$2e311f5a2c70a936;
module.exports["onTaskAbort"] = $2edf73f89ca55348$export$807d68038784dd59;

});

parcelRegister("kPgkn", function(module, exports) {
// Modified from platform/packages/search/product-search-dialog/src/extensible/product-router/product/result-provider/faster-search-helpers.ts

var $1b6u9 = parcelRequire("1b6u9");


var $iyIUv = parcelRequire("iyIUv");

function $669765c73535f9bf$export$399f177751711473(searchResults, query, numberOfResultItems = 3, negateTitleHighlight) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $1b6u9.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result,
                    highlightedTitle: negateTitleHighlight ? negatedHighlightedTitle : highlightedTitle
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0).slice(0, numberOfResultItems);
    return filteredResults;
}
function $669765c73535f9bf$export$18f3758fc3685a84(searchResults, query) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { score: score = 0 } = (0, $1b6u9.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0);
    return filteredResults;
}
function $669765c73535f9bf$export$bf5c34de39b9bf13(recentActivities, query) {
    const normalizedQuery = (0, $iyIUv.normalizeWorkItemKey)(query);
    // Search by both the normalized key and the literal query, deduplicating by id
    const byNormalized = normalizedQuery && query !== normalizedQuery ? $669765c73535f9bf$export$18f3758fc3685a84(recentActivities, normalizedQuery) : [];
    const byLiteral = $669765c73535f9bf$export$18f3758fc3685a84(recentActivities, query);
    const seen = new Set(byNormalized.map((r)=>r.id));
    return [
        ...byNormalized,
        ...byLiteral.filter((r)=>!seen.has(r.id))
    ];
}
module.exports["filterSearchResultsWithHighlighting"] = $669765c73535f9bf$export$399f177751711473;
module.exports["filterSearchResults"] = $669765c73535f9bf$export$18f3758fc3685a84;
module.exports["filterRecentActivities"] = $669765c73535f9bf$export$bf5c34de39b9bf13;

});

parcelRegister("1b6u9", function(module, exports) {
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $01f8c86da976ec83$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $01f8c86da976ec83$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $01f8c86da976ec83$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $01f8c86da976ec83$var$CONSECUTIVE_START_REGEX = new RegExp(`${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`, 'g');
const $01f8c86da976ec83$var$CONSECUTIVE_END_REGEX = new RegExp(`${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`, 'g');
const $01f8c86da976ec83$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`, 'g');
const $01f8c86da976ec83$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $01f8c86da976ec83$var$cleanStartRegex = new RegExp($01f8c86da976ec83$var$HIGHLIGHT_START_TAG, 'g');
const $01f8c86da976ec83$var$cleanEndRegex = new RegExp($01f8c86da976ec83$var$HIGHLIGHT_END_TAG, 'g');
const $01f8c86da976ec83$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($01f8c86da976ec83$var$cleanStartRegex, '').replace($01f8c86da976ec83$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($01f8c86da976ec83$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($01f8c86da976ec83$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}|${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}$1${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`).replace($01f8c86da976ec83$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`]: `${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`,
                [`${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`]: `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`.replace($01f8c86da976ec83$var$CONSECUTIVE_START_REGEX, `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`).replace($01f8c86da976ec83$var$CONSECUTIVE_END_REGEX, `${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`).replace($01f8c86da976ec83$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${word}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};
module.exports["highlightMatchedText"] = $01f8c86da976ec83$export$9f4c92a576b56d82;

});

parcelRegister("iyIUv", function(module, exports) {
/**
 * Normalizes an issue key query by removing hyphens and spaces so that
 * queries like "AAA34", "AAA 34", and "AAA-34" all match the canonical key "AAA-34".
 * Returns undefined if the value does not look like an issue key.
 */ const $69c994a3660d08f7$export$2c6ff4235668ce91 = (value)=>{
    const normalized = value.replace(/^([a-zA-Z]+)[\s-]?(\d+)$/, '$1-$2').toLowerCase();
    return normalized !== value.toLowerCase() || /^[a-zA-Z]+-\d+$/.test(value) ? normalized : undefined;
};
module.exports["normalizeWorkItemKey"] = $69c994a3660d08f7$export$2c6ff4235668ce91;

});

parcelRegister("krr0S", function(module, exports) {

var $dmqXD = parcelRequire("dmqXD");


var $6onJ6 = parcelRequire("6onJ6");

const $9d711010670eb6ee$export$3d3f5f86906a7f73 = (0, $dmqXD.KnowledgeDiscoveryJiraSearchClassification);
const $9d711010670eb6ee$export$928cec68d7595d16 = (0, $6onJ6.disposableValue)(null);
const $9d711010670eb6ee$export$3d750f4e9f4d0fc8 = {
    Jql: 'JQL'
};
const $9d711010670eb6ee$export$5cd976a4b4b84eb3 = (currentQuery)=>{
    const stored = $9d711010670eb6ee$export$928cec68d7595d16.value();
    if (!stored || stored.patternType !== $9d711010670eb6ee$export$3d750f4e9f4d0fc8.Jql) return false;
    return stored.query.trim() === currentQuery.trim();
};
module.exports["IntentMode"] = $9d711010670eb6ee$export$3d3f5f86906a7f73;
module.exports["INTENT_DETECTION"] = $9d711010670eb6ee$export$928cec68d7595d16;
module.exports["PatternType"] = $9d711010670eb6ee$export$3d750f4e9f4d0fc8;
module.exports["isJqlQueryDetected"] = $9d711010670eb6ee$export$5cd976a4b4b84eb3;

});

parcelRegister("dmqXD", function(module, exports) {
const $4121050074bea17a$export$52027d47033ea8ad = {
    GNIN: 'GNIN',
    FPS: 'FPS'
};
module.exports["KnowledgeDiscoveryJiraSearchClassification"] = $4121050074bea17a$export$52027d47033ea8ad;

});

parcelRegister("9gI1G", function(module, exports) {
/**
 * This file provides the necessary wrappers and utility functions to provide
 * analytics data for Quick Find result positions. Quick Find analytics contains
 * data such as the number of results, the number of sections, and the
 * position / section of a selected result.
 *
 * It does this by using the DOM as the source of truth rather than having to
 * maintain section objects and indexes in the code. This allows rendering
 * display components to be simplified and could prove to be more robust, e.g.
 * if a search result doesn't render due to an error and subsequently hits
 * its error boundary, section and results count remain correct.
 *
 * Legacy heading and result components must be siblings. Chat convergence reads
 * logical section IDs from the existing result elements across its containers.
 */ /* eslint-disable @atlaskit/platform/no-direct-document-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $gPOtu = parcelRequire("gPOtu");


var $fNtG8 = parcelRequire("fNtG8");

var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");

var $c1a3c9ec44435bf6$require$differenceInMinutes = $fNtG8.default;
var $c1a3c9ec44435bf6$require$parseISO = $k5sGX.default;
var $c1a3c9ec44435bf6$require$isValid = $esV19.default;
const $c1a3c9ec44435bf6$export$e7b6022782937b95 = 'search-dialog-heading';
const $c1a3c9ec44435bf6$export$926357658a80ff2a = 'search-dialog-result';
const $c1a3c9ec44435bf6$export$f8cbabfc03558964 = 'bulk-connect-banner';
const $c1a3c9ec44435bf6$var$resultTypes = [
    'peopleAndTeams',
    'recentQueries',
    'recentActivities',
    'queryFilters',
    'searchResults',
    'zeroQueries',
    'autocompleteSuggestions',
    'intentRouter',
    'recommendations',
    'intentRouterWorkItem'
];
const $c1a3c9ec44435bf6$export$8814e97d826fd90d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, id: id, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: $c1a3c9ec44435bf6$export$e7b6022782937b95,
        "data-section-id": id,
        "data-testid": "search-dialog-heading-analytics-wrapper",
        ref: ref,
        ...rest
    }, children));
});
const $c1a3c9ec44435bf6$export$e01f22447ddebe43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, resultType: resultType, product: product, datasourceId: datasourceId, id: id, connectorType: connectorType, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, recentActivityEventType: recentActivityEventType, objectType: objectType, zeroQueryType: zeroQueryType, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // Ignoring this check as class is not being used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $c1a3c9ec44435bf6$export$926357658a80ff2a,
        "data-result-type": resultType,
        "data-product": product,
        "data-id": id,
        "data-connector-type": connectorType,
        "data-datasource-id": datasourceId,
        "data-since-activity-timestamp": minutesSinceActivityTimestamp,
        "data-recent-activity-event-type": recentActivityEventType,
        "data-object-type": objectType,
        "data-zero-query-type": zeroQueryType,
        ref: ref,
        ...rest
    }, children);
});
const $c1a3c9ec44435bf6$export$75fc08fd8853e1c3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: $c1a3c9ec44435bf6$export$f8cbabfc03558964,
        ref: ref,
        ...rest
    }, children));
});
const $c1a3c9ec44435bf6$export$1be6c28d5e945bdf = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const counts = {};
    for(let i = 0; i < resultNodes.length; i++){
        const product = resultNodes[i].getAttribute('data-product');
        if (!product) continue;
        counts[product] = (counts[product] ?? 0) + 1;
    }
    return counts;
};
const $c1a3c9ec44435bf6$export$e21758a6ca606f0a = ()=>{
    return Object.keys($c1a3c9ec44435bf6$export$1be6c28d5e945bdf());
};
const $c1a3c9ec44435bf6$export$a9cb3c6c659d9dfe = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const productSet = new Set();
    for(let i = 0; i < resultNodes.length; i++){
        if (resultNodes[i].getAttribute('data-result-type') !== 'recommendations') continue;
        const product = resultNodes[i].getAttribute('data-product');
        product && productSet.add(product);
    }
    return Array.from(productSet);
};
const $c1a3c9ec44435bf6$export$d812a070b2ee9d66 = ()=>{
    const bannerNode = document.querySelector(`.${$c1a3c9ec44435bf6$export$f8cbabfc03558964}`);
    return bannerNode !== null;
};
const $c1a3c9ec44435bf6$var$isNotRecentQuery = (product)=>{
    return Boolean(product);
};
function $c1a3c9ec44435bf6$export$4e2371c785c39b57(compareWithTimeInMs) {
    try {
        if (typeof compareWithTimeInMs !== 'string') return null;
        const startTime = $c1a3c9ec44435bf6$require$parseISO(compareWithTimeInMs);
        if (!$c1a3c9ec44435bf6$require$isValid(startTime)) return null;
        const difference = $c1a3c9ec44435bf6$require$differenceInMinutes(new Date(), startTime, 'floor');
        return difference >= 0 ? difference : null;
    } catch  {
        // Swallowing error, bad timestamp should not throw error
        return null;
    }
}
/**
 * Maps each result's data-id to its sectionId by walking sibling heading/result
 * nodes, mirroring how `ItemsAnalyticsProvider.getItemIndexes` resolves sectionId.
 */ const $c1a3c9ec44435bf6$var$buildResultSectionIdMap = ()=>{
    const map = new Map();
    let allNodes;
    try {
        allNodes = $c1a3c9ec44435bf6$var$getAllHeadingsAndResults().allNodes;
    } catch  {
        return map;
    }
    let currentSectionId = null;
    for (const node of allNodes){
        if ($c1a3c9ec44435bf6$var$isHeading(node)) currentSectionId = node.getAttribute('data-section-id');
        else if ($c1a3c9ec44435bf6$var$isResult(node)) {
            const resultId = node.getAttribute('data-id');
            if (resultId) map.set(resultId, currentSectionId);
        }
    }
    return map;
};
const $c1a3c9ec44435bf6$export$8841f6f549512fc2 = (thirdPartyConfigs = {}, { includeSectionIds: includeSectionIds = false } = {})=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const sectionIdMap = includeSectionIds ? undefined : $c1a3c9ec44435bf6$var$buildResultSectionIdMap();
    const resultList = [];
    for(let i = 0; i < resultNodes.length; i++){
        const id = resultNodes[i].getAttribute('data-id');
        const product = resultNodes[i].getAttribute('data-product');
        const connectorType = resultNodes[i].getAttribute('data-connector-type');
        const datasourceId = resultNodes[i].getAttribute('data-datasource-id');
        const resultType = resultNodes[i].getAttribute('data-result-type');
        const rawMinutesSinceActivityTimestamp = parseInt(resultNodes[i].getAttribute('data-since-activity-timestamp') || '', 10);
        const minutesSinceActivityTimestamp = isNaN(rawMinutesSinceActivityTimestamp) ? null : rawMinutesSinceActivityTimestamp;
        // Missing attribute -> explicit `null` (mirrors `minutesSinceActivityTimestamp`).
        const recentActivityEventType = resultNodes[i].getAttribute('data-recent-activity-event-type') || null;
        // Missing attribute -> `null` here; the field is then omitted from the
        // payload below (see the conditional spread in `metadata`).
        const objectType = resultNodes[i].getAttribute('data-object-type') || null;
        if (id && $c1a3c9ec44435bf6$var$isNotRecentQuery(product)) {
            const resultShown = {
                id: id,
                product: product,
                position: i,
                metadata: {
                    minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
                    ...connectorType && {
                        connectorType: connectorType
                    },
                    resultType: resultType,
                    sectionId: includeSectionIds ? resultNodes[i].getAttribute('data-section-id') : sectionIdMap?.get(id) ?? null,
                    recentActivityEventType: recentActivityEventType,
                    // Omit `objectType` entirely when unknown (absent DOM attribute).
                    ...objectType != null && {
                        objectType: objectType
                    }
                },
                connectorInfo: connectorType && datasourceId ? {
                    datasource_id: datasourceId,
                    connector_position: i,
                    connector_product: product,
                    connector_type: connectorType,
                    // Omitted entirely when gated off, so an absent attribute reads as
                    // "not instrumented" rather than as an unresolvable mode.
                    ...(0, $iDrrr.fg)('rovo_3p_auth_resolution_mode_analytics') ? {
                        auth_resolution_mode: (0, $gPOtu.getAuthResolutionMode)({
                            datasourceId: datasourceId,
                            productKey: product ?? undefined,
                            thirdPartyConfigs: thirdPartyConfigs
                        })
                    } : {},
                    ari: id
                } : undefined
            };
            resultList.push(resultShown);
        }
    }
    return resultList;
};
const $c1a3c9ec44435bf6$export$837a07087631b7e0 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const zeroQueryNodes = resultNodes.filter((node)=>node.getAttribute('data-result-type') === 'zeroQueries');
    return zeroQueryNodes.map((node, idx)=>({
            zeroQueryType: node.getAttribute('data-zero-query-type') ?? '',
            zeroQueryPosition: idx
        }));
};
const $c1a3c9ec44435bf6$export$334c5c15d40bbec1 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    return $c1a3c9ec44435bf6$var$resultTypes.reduce((o, resultType)=>{
        o[resultType] = resultNodes.filter((node)=>node.getAttribute('data-result-type') === resultType).length || 0;
        return o;
    }, {});
};
const $c1a3c9ec44435bf6$var$getAllHeadingsAndResults = ({ includeHeadinglessResults: includeHeadinglessResults = false } = {})=>{
    const headingNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$e7b6022782937b95));
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    if (!includeHeadinglessResults && !headingNodes.length || !resultNodes.length) return {
        allNodes: [],
        headingNodes: [],
        resultNodes: []
    };
    const parentNode = headingNodes.length ? headingNodes[0].parentNode : resultNodes.length ? resultNodes[0].parentNode : undefined;
    if (!parentNode) throw new Error('Could not find a parent node for headings and results');
    const allNodes = Array.from(parentNode.children).filter((e)=>$c1a3c9ec44435bf6$var$isHeading(e) || $c1a3c9ec44435bf6$var$isResult(e));
    return {
        allNodes: allNodes,
        headingNodes: headingNodes,
        resultNodes: resultNodes
    };
};
const $c1a3c9ec44435bf6$var$isHeading = (e)=>{
    return e.classList.contains($c1a3c9ec44435bf6$export$e7b6022782937b95);
};
const $c1a3c9ec44435bf6$var$isResult = (e)=>{
    return e.classList.contains($c1a3c9ec44435bf6$export$926357658a80ff2a) || e.querySelector(`.${$c1a3c9ec44435bf6$export$926357658a80ff2a}`) !== null;
};
const $c1a3c9ec44435bf6$export$e9dac44129e02fa9 = (options = {})=>{
    try {
        if (options.includeSectionIds) {
            const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
            // Unlabelled intent/query rows form one group; absent sections have no result nodes.
            const sectionIds = new Set(resultNodes.map((node)=>node.getAttribute('data-section-id')));
            return {
                resultCount: resultNodes.length,
                sectionCount: sectionIds.size
            };
        }
        const { allNodes: allNodes, headingNodes: headingNodes, resultNodes: resultNodes } = $c1a3c9ec44435bf6$var$getAllHeadingsAndResults(options);
        // If the first node is a result, then we count it as a section
        const sectionCount = allNodes.length ? headingNodes.length + ($c1a3c9ec44435bf6$var$isResult(allNodes[0]) ? 1 : 0) : 0;
        return {
            sectionCount: sectionCount,
            resultCount: resultNodes.length
        };
    } catch  {
        return {};
    }
};
module.exports["SearchDialogHeaderAnalyticsWrapper"] = $c1a3c9ec44435bf6$export$8814e97d826fd90d;
module.exports["SearchDialogResultAnalyticsWrapper"] = $c1a3c9ec44435bf6$export$e01f22447ddebe43;
module.exports["getProductResultCounts"] = $c1a3c9ec44435bf6$export$1be6c28d5e945bdf;
module.exports["getProductsInResults"] = $c1a3c9ec44435bf6$export$e21758a6ca606f0a;
module.exports["getProductsInRecommendations"] = $c1a3c9ec44435bf6$export$a9cb3c6c659d9dfe;
module.exports["getIsBulkConnectBannerShown"] = $c1a3c9ec44435bf6$export$d812a070b2ee9d66;
module.exports["calculateMinuteDifference"] = $c1a3c9ec44435bf6$export$4e2371c785c39b57;
module.exports["getResultsShown"] = $c1a3c9ec44435bf6$export$8841f6f549512fc2;
module.exports["getShownZeroQueries"] = $c1a3c9ec44435bf6$export$837a07087631b7e0;
module.exports["getResultTypeCounts"] = $c1a3c9ec44435bf6$export$334c5c15d40bbec1;
module.exports["getSectionsAndResultsCount"] = $c1a3c9ec44435bf6$export$e9dac44129e02fa9;

});

parcelRegister("1mE5s", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $1hmDb = parcelRequire("1hmDb");


var $bE7SN = parcelRequire("bE7SN");


var $gPOtu = parcelRequire("gPOtu");


const $ac7a146a7f2bdd3b$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $ac7a146a7f2bdd3b$export$e6a288d5cd4cda6 = (partial)=>partial.__typename === 'SearchResultGoogleDocument' || $ac7a146a7f2bdd3b$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $ac7a146a7f2bdd3b$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'document';
const $ac7a146a7f2bdd3b$export$34ee1a2c0a1a45b7 = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $ac7a146a7f2bdd3b$var$SMART_LINK_ENTITY_REGEX = /^ari:.*::remote-link/;
const $ac7a146a7f2bdd3b$export$8cc78980eb89e95d = (resultAri)=>$ac7a146a7f2bdd3b$var$SMART_LINK_ENTITY_REGEX.test(resultAri);
const $ac7a146a7f2bdd3b$export$c5fdbcc9e7462013 = ({ connectorType: connectorType, resultAri: resultAri, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>connectorType === (0, $1hmDb.ConnectorSources).Smartlinks || $ac7a146a7f2bdd3b$export$8cc78980eb89e95d(resultAri) || (0, $gPOtu.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    }) || eventType === (0, $bE7SN.VIEWED_EVENT).SL_VIEWED || eventType === (0, $bE7SN.VIEWED_EVENT).SL_CLICKED;
const $ac7a146a7f2bdd3b$var$getProduct3PConfig = (productKey, thirdPartyConfigs)=>{
    return productKey && (0, $dvVWp.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
};
const $ac7a146a7f2bdd3b$export$15ebd9395cf27aef = ({ connectorType: connectorType, resultNodeId: resultNodeId, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    // Return the connectorType if it's already valid
    if ((0, $8fNUp.isConnectorSource)(connectorType)) return connectorType;
    // connectorType will not exist for the following cases:
    // * when search GraphQL response returns null for connectorType
    // * when the given API doesn't return a connectorType. E.g. user documents.
    // as a result, we use fallback logic to determine the connectorType.
    if ($ac7a146a7f2bdd3b$export$c5fdbcc9e7462013({
        connectorType: connectorType,
        resultAri: resultNodeId,
        eventType: eventType,
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    })) return (0, $1hmDb.ConnectorSources).Smartlinks;
    const config = $ac7a146a7f2bdd3b$var$getProduct3PConfig(productKey, thirdPartyConfigs);
    // No config found for the product
    if (!config) return undefined;
    if (config.isFederated) return (0, $1hmDb.ConnectorSources).Federated;
    // Return the single connector source if it's valid
    if (config.connectorSources?.length === 1) {
        const source = config.connectorSources[0];
        if ((0, $8fNUp.isConnectorSource)(source)) return source;
    }
    // Default to Full for any other case where config exists
    return (0, $1hmDb.ConnectorSources).Full;
};
module.exports["isResultSmartLink"] = $ac7a146a7f2bdd3b$export$c5fdbcc9e7462013;
module.exports["getResultConnectorSource"] = $ac7a146a7f2bdd3b$export$15ebd9395cf27aef;

});

parcelRegister("bE7SN", function(module, exports) {
// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/eventTypeMessage.tsx
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $cozmU = parcelRequire("cozmU");


var $mr7nI = parcelRequire("mr7nI");


var $zxlpF = parcelRequire("zxlpF");


var $P1m33 = parcelRequire("P1m33");


var $kSwu1 = parcelRequire("kSwu1");


var $iC0LJ = parcelRequire("iC0LJ");


var $2NJB3 = parcelRequire("2NJB3");

var $609baf9740b7c579$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SL_CLICKED"] = "sl-clicked";
    VIEWED_EVENT["CLICKED"] = "clicked";
    return VIEWED_EVENT;
}({});
var $609baf9740b7c579$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    WORKED_EVENT["SHARED"] = "shared";
    WORKED_EVENT["LINKSENT"] = "linksent";
    return WORKED_EVENT;
}({});
function $609baf9740b7c579$export$e873c799b137eec4(date) {
    return (0, $mr7nI.default)(new Date(date), $609baf9740b7c579$var$startOfOneWeekAgo());
}
function $609baf9740b7c579$var$startOfOneWeekAgo() {
    return (0, $zxlpF.default)((0, $P1m33.default)(new Date(), 1));
}
const $609baf9740b7c579$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData })=>{
    const isAbsolute = $609baf9740b7c579$export$e873c799b137eec4(timestamp);
    const message = (0, $2NJB3.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $iC0LJ.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...message,
        values: values
    });
};
module.exports["VIEWED_EVENT"] = $609baf9740b7c579$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $609baf9740b7c579$export$eb4e9f525aef1cc3;
module.exports["isMoreThanOneWeekAgo"] = $609baf9740b7c579$export$e873c799b137eec4;
module.exports["EventTypeMessage"] = $609baf9740b7c579$export$9e4fb3fb50a3c754;

});

parcelRegister("cRSxF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $856f049156dd2177$export$e70e6da722faba05 = (callback, debounceTime)=>{
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $cozmU.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(func, debounceTime);
    }, [
        debounceTime
    ]);
    return debouncedCallback;
};
module.exports["useDebouncedCallback"] = $856f049156dd2177$export$e70e6da722faba05;

});

parcelRegister("3P0Fk", function(module, exports) {
var $4b89818c31b7a877$export$fb160374438e1cd7 = /*#__PURE__*/ function(SearchConfluenceSubtype) {
    SearchConfluenceSubtype["LIVE"] = "LIVE";
    return SearchConfluenceSubtype;
}({});
module.exports["SearchConfluenceSubtype"] = $4b89818c31b7a877$export$fb160374438e1cd7;

});

parcelRegister("7ta9v", function(module, exports) {

var $bqUaZ = parcelRequire("bqUaZ");

const $9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR = '---';
const $9238d4b3c991adc2$var$CONFLUENCE_ATTRIBUTE_SEPARATOR = '___';
const $9238d4b3c991adc2$export$ce6d1d009c92f1be = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${$9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR}${(0, $bqUaZ.hashData)(query)}`);
    if (additionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${$9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR}${value}`);
    });
    if (events.length === 0) return urlObject.toString();
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join($9238d4b3c991adc2$var$CONFLUENCE_ATTRIBUTE_SEPARATOR));
    urlObject.searchParams.set('additional_analytics', analyticsFormattedForUrlParsing);
    return urlObject.toString();
};
const $9238d4b3c991adc2$export$2e67c54459604a9 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split($9238d4b3c991adc2$var$CONFLUENCE_ATTRIBUTE_SEPARATOR);
    events.forEach((event)=>{
        const formattedEvent = event?.split($9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $9238d4b3c991adc2$export$b780bd7096d811c5 = ({ url: url, searchSessionId: searchSessionId, resultId: resultId, projectId: projectId })=>{
    const jiraResultARIPattern = /^ari:cloud:jira:[a-z0-9-]+:[a-z]+\/[0-9]+$/;
    if (!resultId.match(jiraResultARIPattern)) return url;
    const jiraProjectARIPattern = /^ari:cloud:jira:[a-z0-9-]+:project\/[0-9]+$/;
    if (projectId && !projectId.match(jiraProjectARIPattern)) return url;
    const urlObject = new URL(url);
    urlObject.searchParams.set('searchSessionId', searchSessionId);
    const searchObjectId = resultId.split('/').pop();
    searchObjectId && urlObject.searchParams.set('searchObjectId', searchObjectId);
    const searchContentType = resultId.split('/')[0].split(':').pop();
    searchContentType && urlObject.searchParams.set('searchContentType', searchContentType);
    const searchContainerId = projectId?.split('/').pop();
    searchContainerId && urlObject.searchParams.set('searchContainerId', searchContainerId);
    return urlObject.toString();
};
const $9238d4b3c991adc2$export$a5abc05a86b8de68 = ({ url: url, searchSessionId: searchSessionId, customParams: customParams = new Map([]) })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    customParams.forEach((value, key)=>{
        urlObject.searchParams.set(key || '', value || '');
    });
    return urlObject.toString();
};
module.exports["getConfluenceUrlWithAnalyticsQueryParams"] = $9238d4b3c991adc2$export$ce6d1d009c92f1be;
module.exports["getJiraUrlWithAnalyticsQueryParams"] = $9238d4b3c991adc2$export$b780bd7096d811c5;
module.exports["getGenericUrlWithAnalyticsQueryParams"] = $9238d4b3c991adc2$export$a5abc05a86b8de68;

});

parcelRegister("bqUaZ", function(module, exports) {

var $eVK28 = parcelRequire("eVK28");


var $7Ag9o = parcelRequire("7Ag9o");


var $aNIeI = parcelRequire("aNIeI");


var $5IGsg = parcelRequire("5IGsg");

// copied over from @confluence/hash
const $bd8081de7523fd56$var$hash = (data, asBytes = false)=>{
    const hash = (0, $eVK28.sha256).create();
    hash.update(data);
    if (asBytes) return hash.array();
    return hash.hex();
};
const $bd8081de7523fd56$export$5fdf8c875acfc1b3 = (data)=>{
    return $bd8081de7523fd56$var$hash(data, true);
};
const $bd8081de7523fd56$export$7904c6256691057a = (data)=>{
    return $bd8081de7523fd56$var$hash(data);
};
module.exports["hashData"] = $bd8081de7523fd56$export$7904c6256691057a;

});

parcelRegister("aNIeI", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hMCZS = parcelRequire("hMCZS");

const $2ca479284d1e4523$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'home'
    }).href : `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
module.exports["getUserPath"] = $2ca479284d1e4523$export$451f7a1e7c934f54;

});

parcelRegister("5IGsg", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hMCZS = parcelRequire("hMCZS");

const $7ea46911e63dbdd0$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId
    }).href : `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};
module.exports["getTeamPath"] = $7ea46911e63dbdd0$export$9456a8e088bfede1;

});

parcelRegister("jY1sc", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $5Styu = parcelRequire("5Styu");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $kSwu1 = parcelRequire("kSwu1");

const $6c62c1b8deee893a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    branchLabel: {
        id: "branch.label",
        defaultMessage: "Branch"
    },
    commitLabel: {
        id: "commit.label",
        defaultMessage: "Commit"
    },
    pullRequestLabel: {
        id: "pull-request.label",
        defaultMessage: "Pull Request"
    },
    workItemLabel: {
        id: "work-item.label",
        defaultMessage: "Work Item"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    channelLabel: {
        id: "channel.label",
        defaultMessage: "Channel"
    },
    knowledgeArticleLabel: {
        id: "3p-result-labeling.knowledge_article.label",
        defaultMessage: "Knowledge article"
    },
    newsArticleLabel: {
        id: "3p-result-labeling.news_article.label",
        defaultMessage: "News article"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});


const $d3f1af1f92c5a308$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $dvVWp.ProductKeys).Sharepoint || product === (0, $dvVWp.ProductKeys).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $dvVWp.ProductKeys).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    else if (product.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler) && // QF returns subtype with underscores, f.e. 'WEB_PAGE', so we need to support both
    subtype.replace('_', '-') === (0, $7ydfN.NounSubtypeKey).WebPage) label = (0, $6c62c1b8deee893a$export$defe85febe8b728c).webPageLabel;
    else if (subtype === (0, $7ydfN.NounSubtypeKey).KnowledgeArticle || // QF returns subtype in uppercase (e.g. 'KNOWLEDGE_ARTICLE'), so we support both casings
    normalizedSubtype === 'KNOWLEDGE_ARTICLE') label = (0, $6c62c1b8deee893a$export$defe85febe8b728c).knowledgeArticleLabel;
    else if (subtype === (0, $7ydfN.NounSubtypeKey).NewsArticle || // QF returns subtype in uppercase (e.g. 'NEWS_ARTICLE'), so we support both casings
    normalizedSubtype === 'NEWS_ARTICLE') label = (0, $6c62c1b8deee893a$export$defe85febe8b728c).newsArticleLabel;
    if (!label && normalizedSubtype === 'WEB_PAGE' && (0, $8fNUp.isForgeConnectorProductKey)(product) && (0, $iDrrr.fg)('rovo_qf_artifacts_web_page_label')) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).webPageLabel;
    return label;
};
// Provider-aware label so that e.g. GitHub work items render as "Issue"
// rather than the generic "Work item". Mirrors the providerDefaultLabelMap
// in the full search results page work-item renderer.
const $d3f1af1f92c5a308$var$providerDefaultLabelMap = {
    [(0, $dvVWp.ProductKeys).Github]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).issueLabel
};
const $d3f1af1f92c5a308$export$67bc9d7952cf216d = ({ product: product, subtype: subtype, resourceType: resourceType })=>{
    const documentLabel = $d3f1af1f92c5a308$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    if (documentLabel) return documentLabel;
    if (!resourceType) return;
    if (resourceType === (0, $5Styu.ResourceType).VIDEO) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).videoLabel;
    else if (resourceType === (0, $5Styu.ResourceType).REPOSITORY) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).repositoryLabel;
    else if (resourceType === (0, $5Styu.ResourceType).PULL_REQUEST) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).pullRequestLabel;
    else if (resourceType === (0, $5Styu.ResourceType).BRANCH) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).branchLabel;
    else if (resourceType === (0, $5Styu.ResourceType).COMMIT) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).commitLabel;
    else if (resourceType === (0, $5Styu.ResourceType).WORK_ITEM) {
        if (product && $d3f1af1f92c5a308$var$providerDefaultLabelMap[product]) return $d3f1af1f92c5a308$var$providerDefaultLabelMap[product];
        return (0, $6c62c1b8deee893a$export$defe85febe8b728c).workItemLabel;
    }
    return undefined;
};
// Converts kebab-case categories (e.g. 'pull-request') to camelCase to match message keys (e.g. pullRequestLabel).
const $d3f1af1f92c5a308$var$normalizeRemoteLinkSubtype = (subtype)=>subtype.replace(/-([a-z])/g, (_match, character)=>character.toUpperCase());
const $d3f1af1f92c5a308$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const normalizedSubtype = $d3f1af1f92c5a308$var$normalizeRemoteLinkSubtype(subtype);
    const labelKey = `${normalizedSubtype}Label`;
    if (labelKey in (0, $6c62c1b8deee893a$export$defe85febe8b728c)) return (0, $6c62c1b8deee893a$export$defe85febe8b728c)[labelKey];
    else return (0, $6c62c1b8deee893a$export$defe85febe8b728c).otherLabel;
};
module.exports["getDocumentSubtypeLabel"] = $d3f1af1f92c5a308$export$a47c0c6de01249fd;
module.exports["getSubtypeLabel"] = $d3f1af1f92c5a308$export$67bc9d7952cf216d;
module.exports["getRemoteLinkSubtypeLabel"] = $d3f1af1f92c5a308$export$19dc2415a5fa9123;

});

parcelRegister("dtCp5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");

const $6bd01af1bd5a238c$var$messages = (0, $kSwu1.defineMessages)({
    displayNameLabel: {
        id: "search-page.common.display-name-tooltip.displayNameLabel",
        defaultMessage: "Display name: {displayName}"
    },
    nameLabel: {
        id: "search-page.common.display-name-tooltip.nameLabel",
        defaultMessage: "Name: {name}"
    }
});
const $6bd01af1bd5a238c$export$2bb992c63b690a64 = ({ displayName: displayName, name: name })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.inverse"
    }, formatMessage($6bd01af1bd5a238c$var$messages.displayNameLabel, {
        displayName: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.inverse"
    }, formatMessage($6bd01af1bd5a238c$var$messages.nameLabel, {
        name: name
    })));
};
const $6bd01af1bd5a238c$export$35bd5615255f5466 = ({ displayName: displayName, name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6bd01af1bd5a238c$export$2bb992c63b690a64, {
            displayName: displayName,
            name: name
        }),
        position: "bottom"
    }, children);
module.exports["DisplayNameTooltip"] = $6bd01af1bd5a238c$export$35bd5615255f5466;

});

parcelRegister("6PqYl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aCJyI = parcelRequire("aCJyI");




const $f525fcb99dc58070$export$373c576b545d33cb = (0, $kSwu1.defineMessages)({
    open: {
        id: "search-page.common.graph-work-item-status.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.common.graph-work-item-status.closed",
        defaultMessage: "Closed"
    }
});


/**
 * Map a third-party **work-item** status (e.g. GitHub issue states) onto the
 * appropriate Atlaskit Lozenge appearance.
 *
 * Only the two canonical GitHub work-item states (`OPEN`, `CLOSED`) are
 * supported. Inputs are case-insensitive — callers may pass the value as it
 * comes from the API (`"open"`, `"OPEN"`, …). Anything else falls back to
 * `'neutral'`.
 *
 * Kept separate from `getPullRequestStatusAppearance` so the two domains stay
 * decoupled and additions to either map can't accidentally affect the other.
 */ const $ef348498d1d97321$var$workItemStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    CLOSED: 'success' // green
};
const $ef348498d1d97321$var$getAppearance = (status)=>(status ? $ef348498d1d97321$var$workItemStatusToLozengeMap[status.toUpperCase()] : undefined) ?? 'neutral';
const $ef348498d1d97321$export$c8ca8b382bc642d1 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!status) return null;
    const message = (0, $f525fcb99dc58070$export$373c576b545d33cb)[status.toLowerCase()];
    const label = message ? formatMessage(message) : status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aCJyI.default), {
        appearance: $ef348498d1d97321$var$getAppearance(status),
        testId: "graph-work-item-status-lozenge-test-id"
    }, label);
};
module.exports["GraphWorkItemStatusLozenge"] = $ef348498d1d97321$export$c8ca8b382bc642d1;

});

parcelRegister("jL46I", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kWSTb = parcelRequire("kWSTb");


var $8OpiN = parcelRequire("8OpiN");


var $h1gZq = parcelRequire("h1gZq");


var $fayTW = parcelRequire("fayTW");


var $aOjGz = parcelRequire("aOjGz");


var $gxI48 = parcelRequire("gxI48");


var $4MdqE = parcelRequire("4MdqE");


var $eDtFr = parcelRequire("eDtFr");


var $itpo2 = parcelRequire("itpo2");


var $1LOGx = parcelRequire("1LOGx");


var $7A1BE = parcelRequire("7A1BE");


var $6CsCB = parcelRequire("6CsCB");


var $ipvL3 = parcelRequire("ipvL3");


var $iFXu4 = parcelRequire("iFXu4");


var $ijkxh = parcelRequire("ijkxh");


var $foj7F = parcelRequire("foj7F");


var $iRFKG = parcelRequire("iRFKG");


var $cJ0FD = parcelRequire("cJ0FD");


var $iW3KC = parcelRequire("iW3KC");


var $lFTzz = parcelRequire("lFTzz");


var $hkAs2 = parcelRequire("hkAs2");


var $2qJQZ = parcelRequire("2qJQZ");


var $7pJjg = parcelRequire("7pJjg");


var $aKhvB = parcelRequire("aKhvB");


var $dt415 = parcelRequire("dt415");


var $9NPFC = parcelRequire("9NPFC");


var $dvVWp = parcelRequire("dvVWp");


var $4DhjM = parcelRequire("4DhjM");

const $c8b0f3dfd738db5f$var$isImageDataUrl = (str)=>/^data:image\/[^;]+;base64,/.test(str); /**
                                                                                 * Returns the appropriate icon for a Jira item based on the provided parameters.
                                                                                 *
                                                                                 * @param {string | null | undefined} iconUrl - The URL of the icon image.
                                                                                 * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
                                                                                 * @param {boolean} isIssue - Flag indicating if the item is an issue.
                                                                                 * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
                                                                                 * @returns {React.JSX.Element} The JSX element representing the icon.
                                                                                 */ 
const $c8b0f3dfd738db5f$export$348a13c9e1254ce4 = ({ iconUrl: iconUrl, type: type, isIssue: isIssue, size: size = 'small', productConfigs: productConfigs })=>{
    const imageSize = size === 'medium' ? 22 : 16; // Use the iconUrl if available
    if (iconUrl) {
        if (isIssue) // wrapper is only needed for issues. Other types don't need the background and padding with iconUrl.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "Work item icon",
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: "Work item icon",
            testId: "jira-entity-icon",
            width: imageSize,
            height: imageSize,
            src: iconUrl
        }));
        return(// The image covers up the whole wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: `${type} icon`,
            testId: "jira-entity-icon",
            src: iconUrl
        })));
    }
    if (isIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "Work item icon",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        spacing: "none",
        size: size,
        label: "work-item-icon"
    }));
    let icon;
    switch(type){
        case 'board':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4MdqE))), {
                spacing: "none",
                size: size,
                label: "board-icon"
            });
            break;
        case 'plan':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ijkxh))), {
                spacing: "none",
                size: size,
                label: "plan-icon"
            });
            break;
        case 'filter':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
                spacing: "none",
                size: size,
                label: "filter-icon"
            });
            break;
        case 'dashboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($itpo2))), {
                spacing: "none",
                size: size,
                label: "dashboard-icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), {
                spacing: "none",
                size: size,
                label: "space-icon"
            });
            break;
        case 'incident':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))), {
                spacing: "none",
                size: size,
                label: "incident-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                productConfigs: productConfigs,
                size: size,
                product: (0, $dvVWp.ProductKeys).Jira
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $c8b0f3dfd738db5f$export$e375917bfb190d26 = ({ iconUrl: iconUrl, type: type, size: size = 'small', isLiveDoc: isLiveDoc = false, productConfigs: productConfigs })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Confluence entities is usually an absolute URL
        // We only use custom iconUrl for Spaces
        if (type === 'space' && iconUrl && ($c8b0f3dfd738db5f$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: `${type} icon`,
            src: iconUrl
        }));
    } catch  {} /*
              ** For finding all the Confluence entities look at platform/packages/search/search-page/src/common/utils/filters/constants.ts -> typeFilter1PMapping
              * */ 
    let icon;
    switch(type){
        case 'space':
            // spaces usually have an iconUrl, but if not we fall back to the project icon
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                size: size,
                label: "space icon"
            });
            break;
        case 'page':
            if (isLiveDoc) icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7pJjg.default), {
                size: size,
                label: "live page icon"
            });
            else icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
                size: size,
                label: "page icon"
            });
            break;
        case 'blogpost':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iW3KC.default), {
                size: size,
                label: "blogpost icon"
            });
            break;
        case 'attachment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxI48))), {
                spacing: "none",
                size: size,
                label: "attachment icon"
            });
            break;
        case 'comment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                spacing: "none",
                size: size,
                label: "comment icon"
            });
            break;
        case 'whiteboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dt415.default), {
                size: size,
                label: "whiteboard icon"
            });
            break;
        case 'slide':
            // CNS-25852: render the slide icon for slides search results so
            // they no longer fall back to the generic Confluence product icon.
            // Imported directly from icon-lab rather than @atlaskit/object
            // because the object codegen entry doesn't exist yet.
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))), {
                spacing: "none",
                size: size,
                label: "slide icon",
                color: "var(--ds-icon-accent-green, #22A06B)"
            });
            break;
        case 'database':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hkAs2.default), {
                size: size,
                label: "database icon"
            });
            break;
        case 'question':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKhvB.default), {
                size: size,
                label: "question icon"
            });
            break;
        case 'calendar':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lFTzz.default), {
                size: size,
                label: "calendar icon"
            });
            break;
        case 'embed':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($foj7F))), {
                spacing: "none",
                size: size,
                label: "embed icon"
            });
            break;
        case 'folder':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))), {
                spacing: "none",
                size: size,
                label: "folder icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                productConfigs: productConfigs,
                label: "confluence icon",
                size: size,
                product: (0, $dvVWp.ProductKeys).Confluence
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $c8b0f3dfd738db5f$export$397605bdd85a2f89 = ({ iconUrl: iconUrl, type: type, size: size = 'small', productConfigs: productConfigs })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Atlas entities is usually an absolute URL
        if (iconUrl && ($c8b0f3dfd738db5f$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: `${type} icon`,
            src: iconUrl
        }));
    } catch  {}
    let icon;
    switch(type){
        case 'goal':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CsCB))), {
                size: size,
                label: "goal icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                size: size,
                label: "project icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                productConfigs: productConfigs,
                label: "Atlas icon",
                size: size,
                product: (0, $dvVWp.ProductKeys).Atlas
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
}; /**
    * Returns the appropriate icon for a Jira item based on the provided parameters.
    *
    * @param {string | null | undefined} iconUrl - The URL of the icon image.
    * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
    * @param {boolean} isIssue - Flag indicating if the item is an issue.
    * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
    * @returns {React.JSX.Element} The JSX element representing the icon.
    */ 
const $c8b0f3dfd738db5f$export$fbba347fb6ffa903 = ({ iconUrl: iconUrl, type: type, size: size = 'small', productConfigs: productConfigs })=>{
    // Use the iconUrl if available
    if (iconUrl) return(// The image covers up the whole wrapper
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        testId: "assets-entity-icon",
        src: iconUrl
    })));
    let icon;
    switch(type){
        case 'schema':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fayTW))), {
                spacing: "none",
                size: size,
                label: "schema-icon"
            });
            break;
        case 'type':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1gZq))), {
                spacing: "none",
                size: size,
                label: "type-icon"
            });
            break;
        case 'object':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8OpiN))), {
                spacing: "none",
                size: size,
                label: "object-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                productConfigs: productConfigs,
                size: size,
                product: (0, $dvVWp.ProductKeys).Assets
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
module.exports["getJiraEntityIcon"] = $c8b0f3dfd738db5f$export$348a13c9e1254ce4;
module.exports["getConfluenceEntityIcon"] = $c8b0f3dfd738db5f$export$e375917bfb190d26;
module.exports["getAtlasEntityIcon"] = $c8b0f3dfd738db5f$export$397605bdd85a2f89;
module.exports["getAssetsEntityIcon"] = $c8b0f3dfd738db5f$export$fbba347fb6ffa903;

});

parcelRegister("h1gZq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::decf66d41803709df2492509b2874d52>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63fb5735b8a6c27$var$_react = $c63fb5735b8a6c27$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c63fb5735b8a6c27$var$_iconNew = $c63fb5735b8a6c27$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c63fb5735b8a6c27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObjectType".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object-type
 * Usage guidance:
 * Reserved for representing object types in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63fb5735b8a6c27$var$AssetsObjectTypeIcon = (props)=>/*#__PURE__*/ $c63fb5735b8a6c27$var$_react.default.createElement($c63fb5735b8a6c27$var$_iconNew.default, Object.assign({
        name: "AssetsObjectTypeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 14.5h3.5V11H11zm-5.5-11a2 2 0 1 0-4 0 2 2 0 0 0 4 0M16 14.625c0 .76-.616 1.375-1.375 1.375h-3.75c-.76 0-1.375-.616-1.375-1.375v-3.75c0-.76.616-1.375 1.375-1.375h3.75c.76 0 1.375.616 1.375 1.375zM7 3.5a3.5 3.5 0 0 1-2.75 3.418V11.5a.5.5 0 0 0 .5.5H8v1.5H4.75a2 2 0 0 1-2-2V6.918A3.5 3.5 0 1 1 7 3.5"/>`
    }, props));
$c63fb5735b8a6c27$var$AssetsObjectTypeIcon.displayName = 'AssetsObjectTypeIcon';
var $c63fb5735b8a6c27$var$_default = module.exports.default = $c63fb5735b8a6c27$var$AssetsObjectTypeIcon;

});

parcelRegister("4DhjM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmUhx = parcelRequire("jmUhx");


var $6TaGl = parcelRequire("6TaGl");


var $iDrrr = parcelRequire("iDrrr");


var $kHRmO = parcelRequire("kHRmO");


var $73Hia = parcelRequire("73Hia");


var $8fNUp = parcelRequire("8fNUp");


var $cJff5 = parcelRequire("cJff5");


var $7MBm9 = parcelRequire("7MBm9");

const $b1a90898fa400b1e$export$1a199e029d5e93d6 = ({ productConfigs: productConfigs, ...props })=>{
    return productConfigs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1a90898fa400b1e$var$ProductIconWithProductConfigs, {
        ...props,
        productConfigs: productConfigs
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1a90898fa400b1e$var$ProductIconWithLocalProductConfigs, props);
};
const $b1a90898fa400b1e$var$ProductIconWithLocalProductConfigs = (props)=>{
    const productConfigs = (0, $73Hia.useProductConfigs)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1a90898fa400b1e$var$ProductIconWithProductConfigs, {
        ...props,
        productConfigs: productConfigs
    });
};
const $b1a90898fa400b1e$var$ProductIconWithProductConfigs = ({ product: product, subtype: subtype, size: size = 'large', isSelected: isSelected = false, useSearchResultIcon: useSearchResultIcon = false, productConfigs: productConfigs, ...props })=>{
    if (product) {
        // First check if it's a Forge connector - prioritize dynamic API icons
        if ((0, $8fNUp.isForgeConnectorProductKey)(product)) {
            const forgeIcon = (0, $8fNUp.getForgeConnectorIcon)(product);
            if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
            return forgeIcon({
                ...props,
                size: size
            });
        }
        // Fallback to static products map (covers hardcoded Forge connectors and all other products)
        const config = productConfigs[product];
        if (config) {
            const Icon = useSearchResultIcon && config.SearchResultIcon || config.Icon;
            if (Icon) {
                const legacyIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...props,
                    size: size
                });
                const BrandIcon = subtype && (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library') ? (0, $7MBm9.getFileTypeBrandIcon)(product, subtype) : null;
                return BrandIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                    fallback: legacyIcon
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BrandIcon, {
                    ...props,
                    label: props.label ?? '',
                    size: size
                })) : legacyIcon;
            }
        }
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
const $b1a90898fa400b1e$export$f73e324780005aef = ({ isShowMore: isShowMore, productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    if (isShowMore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "",
        size: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
    return $b1a90898fa400b1e$export$fe03eddc92730a5c({
        productOrNounKey: productOrNounKey,
        size: size,
        isSelected: isSelected,
        ...props
    });
};
const $b1a90898fa400b1e$export$fe03eddc92730a5c = ({ productConfigs: productConfigs, ...props })=>{
    return productConfigs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1a90898fa400b1e$var$ProductOrNounIconWithProductConfigs, {
        ...props,
        productConfigs: productConfigs
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1a90898fa400b1e$var$ProductOrNounIconWithLocalProductConfigs, props);
};
const $b1a90898fa400b1e$var$ProductOrNounIconWithLocalProductConfigs = (props)=>{
    const productConfigs = (0, $73Hia.useProductConfigs)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1a90898fa400b1e$var$ProductOrNounIconWithProductConfigs, {
        ...props,
        productConfigs: productConfigs
    });
};
const $b1a90898fa400b1e$var$ProductOrNounIconWithProductConfigs = ({ productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, productConfigs: productConfigs, ...props })=>{
    let Icon;
    if (productOrNounKey) {
        const isNounFilter = (0, $kHRmO.isNounKey)(productOrNounKey);
        if (isNounFilter) Icon = (0, $kHRmO.nouns)[productOrNounKey].Icon;
        else {
            // First check if it's a Forge connector - prioritize dynamic API icons
            if ((0, $8fNUp.isForgeConnectorProductKey)(productOrNounKey)) {
                const forgeIcon = (0, $8fNUp.getForgeConnectorIcon)(productOrNounKey);
                if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
                return forgeIcon({
                    ...props,
                    size: size
                });
            }
            // Fallback to static products map (covers hardcoded Forge connectors and all other products)
            const productConfig = productConfigs[productOrNounKey];
            if (productConfig?.Icon) Icon = productConfig.Icon;
        }
        if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            ...props,
            size: size
        });
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        size: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
module.exports["ProductIcon"] = $b1a90898fa400b1e$export$1a199e029d5e93d6;
module.exports["IconDecider"] = $b1a90898fa400b1e$export$f73e324780005aef;
module.exports["ProductOrNounIcon"] = $b1a90898fa400b1e$export$fe03eddc92730a5c;

});

parcelRegister("kHRmO", function(module, exports) {

var $5k2zo = parcelRequire("5k2zo");


var $hQVHS = parcelRequire("hQVHS");


var $hAvnk = parcelRequire("hAvnk");

/* custom-link-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

function $ee8b2e1789bef4d1$export$5efe8561ca252843({ size: size = 'medium', label: label = '', testId: testId }) {
    return(// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        label: label,
        size: size,
        isInset: false,
        backgroundColor: "white",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ $cozmU.createElement("rect", {
        //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        fill: "#dddee1",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#101214",
        fillRule: "evenodd",
        d: "M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75",
        clipRule: "evenodd"
    }))));
}



var $kSwu1 = parcelRequire("kSwu1");

const $21b240a73fe078e8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    webPage: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    },
    webPages: {
        id: "search-page.products.custom-websites",
        defaultMessage: "Web pages"
    },
    project: {
        id: "search-page.nouns.project",
        defaultMessage: "Project"
    },
    projects: {
        id: "search-page.nouns.projects",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.nouns.goal",
        defaultMessage: "Goal"
    },
    goals: {
        id: "search-page.nouns.goals",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.nouns.tag",
        defaultMessage: "Tag"
    },
    tags: {
        id: "search-page.nouns.tags",
        defaultMessage: "Tags"
    }
});


const $c5ea98c1cf33f481$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    // tag: 'tag',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $c5ea98c1cf33f481$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($c5ea98c1cf33f481$export$a93cddd79e3ea530).includes(key);
};
const $c5ea98c1cf33f481$export$5cb7c19fcb84c9cd = {
    [$c5ea98c1cf33f481$export$a93cddd79e3ea530.project]: {
        displayName: (0, $21b240a73fe078e8$export$defe85febe8b728c).project,
        displayNamePlural: (0, $21b240a73fe078e8$export$defe85febe8b728c).projects,
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $hQVHS.ProjectsIcon), 'Project')
    },
    [$c5ea98c1cf33f481$export$a93cddd79e3ea530.goal]: {
        displayName: (0, $21b240a73fe078e8$export$defe85febe8b728c).goal,
        displayNamePlural: (0, $21b240a73fe078e8$export$defe85febe8b728c).goals,
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $5k2zo.GoalsIcon), 'Goal')
    },
    //Tag Noun has been omitted because it is not currently implemented in FPS and risks visual degradation with the t25 icon update
    //Discussion here: https://atlassian.slack.com/archives/C08HFJLM7J5/p1742856483784089
    // [NounKeys.tag]: {
    // 	displayName: messages.tag,
    // 	displayNamePlural: messages.tags,
    // 	Icon: RovoLogoFromLogo(HashtagIcon, 'Tag'),
    // },
    [$c5ea98c1cf33f481$export$a93cddd79e3ea530.AtlassianWebCrawler]: {
        displayName: (0, $21b240a73fe078e8$export$defe85febe8b728c).webPage,
        displayNamePlural: (0, $21b240a73fe078e8$export$defe85febe8b728c).webPages,
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $ee8b2e1789bef4d1$export$5efe8561ca252843), 'Atlassian Web Crawler')
    }
};
const $c5ea98c1cf33f481$export$341b1567666c2663 = [
    $c5ea98c1cf33f481$export$a93cddd79e3ea530.project,
    $c5ea98c1cf33f481$export$a93cddd79e3ea530.goal,
    // NounKeys.tag,
    $c5ea98c1cf33f481$export$a93cddd79e3ea530.AtlassianWebCrawler // Web Crawler is not a noun, we should improve this
];
module.exports["NounKeys"] = $c5ea98c1cf33f481$export$a93cddd79e3ea530;
module.exports["isNounKey"] = $c5ea98c1cf33f481$export$cc6a3ce6b37346b2;
module.exports["nouns"] = $c5ea98c1cf33f481$export$5cb7c19fcb84c9cd;
module.exports["NOUNS_ORDER"] = $c5ea98c1cf33f481$export$341b1567666c2663;

});

parcelRegister("hAvnk", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * A RovoLogo is a subset API that works for both @atlaskit/logo and @atlaskit/icon
 * We use one or the other depending on 1P or 3P and need a consistent API internall
 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");








var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

// Legacy custom @atlaskit/icon glyphs render one size smaller than requested, so this container
// is bumped up a step to compensate (see RovoLogoFromSVG's `correctedSize`).
const $fd912e7334a59c73$var$legacyContainerStyles = {
    small: (0, $buxP3.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $buxP3.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $buxP3.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $buxP3.xcss)({
        width: '32px',
        height: '32px'
    })
};
// The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches this 1:1 — no compensation needed.
const $fd912e7334a59c73$var$accurateContainerStyles = {
    xxsmall: (0, $buxP3.xcss)({
        width: '16px',
        height: '16px'
    }),
    xsmall: (0, $buxP3.xcss)({
        width: '20px',
        height: '20px'
    }),
    small: (0, $buxP3.xcss)({
        width: '24px',
        height: '24px'
    }),
    medium: (0, $buxP3.xcss)({
        width: '32px',
        height: '32px'
    }),
    large: (0, $buxP3.xcss)({
        width: '40px',
        height: '40px'
    })
};
const $fd912e7334a59c73$var$iconStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $fd912e7334a59c73$export$1776e6671850176d = ({ glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize })=>{
    const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            isAccurateSizeEnabled ? $fd912e7334a59c73$var$accurateContainerStyles[accurateSize] : $fd912e7334a59c73$var$legacyContainerStyles[legacySize],
            $fd912e7334a59c73$var$iconStyles
        ],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: accurateSize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};


const $e0650b7625faeac1$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $e0650b7625faeac1$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $e0650b7625faeac1$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; // The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — unlike the legacy
// custom @atlaskit/icon glyphs above, it needs no "one size bigger" compensation.
const $e0650b7625faeac1$var$accurateSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $e0650b7625faeac1$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const resolvedSize = size && $e0650b7625faeac1$var$isCorrectableRovoSize(size) ? size : defaultSize;
        const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                isAccurateSizeEnabled ? $e0650b7625faeac1$var$accurateSizeStyles[resolvedSize] : $e0650b7625faeac1$var$sizeStyles[$e0650b7625faeac1$var$correctedSize[resolvedSize]]
            ])
        }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: resolvedSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $e0650b7625faeac1$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize, testId: testId })=>{
        const resolvedSize = size && $e0650b7625faeac1$var$isCorrectableRovoSize(size) ? size : defaultSize ?? 'medium';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd912e7334a59c73$export$1776e6671850176d), {
            label: label,
            glyph: glyph,
            legacySize: $e0650b7625faeac1$var$correctedSize[resolvedSize],
            accurateSize: resolvedSize
        });
    };
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $e0650b7625faeac1$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $e0650b7625faeac1$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $e0650b7625faeac1$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $e0650b7625faeac1$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $e0650b7625faeac1$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $e0650b7625faeac1$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $e0650b7625faeac1$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $e0650b7625faeac1$export$dae027fade2c6d1d($e0650b7625faeac1$export$f9f7178f66750cba(iconUrl), iconLabel, size);
}
module.exports["RovoLogoFromLogo"] = $e0650b7625faeac1$export$32db889b380fa03c;
module.exports["get3PLogo"] = $e0650b7625faeac1$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $e0650b7625faeac1$export$97ac28be52c9e29f;

});

parcelRegister("73Hia", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6vPLm = parcelRequire("6vPLm");


var $NlHoa = parcelRequire("NlHoa");


var $fxqZn = parcelRequire("fxqZn");


var $hZx6a = parcelRequire("hZx6a");


var $5lkNm = parcelRequire("5lkNm");


var $ffVxZ = parcelRequire("ffVxZ");


var $dL3KD = parcelRequire("dL3KD");


var $ldJ1U = parcelRequire("ldJ1U");


var $33FWk = parcelRequire("33FWk");


var $1SyEw = parcelRequire("1SyEw");


var $hupj2 = parcelRequire("hupj2");


var $8JGXU = parcelRequire("8JGXU");


var $fd0l2 = parcelRequire("fd0l2");



var $hAvnk = parcelRequire("hAvnk");




const $7e38c84ca82e0760$export$24d355ce80de5803 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));





const $0273546edb01e5e1$export$b0a52366c3fb9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));





const $c6d4958cc5e5b261$export$4b1b9db11d699ccb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $bd60ef2a82de5097$export$93ca83db1787dea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));





const $278594cad80ad367$export$4d0238652f4b6bc4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $8e46bad3b7be5e7d$export$1afe31d4b2891d7a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));





const $797166fcbb90ccba$export$f68d29dbb4f2da82 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.7923 27.2286H11.0183C6.83464 27.2286 3.83331 24.666 3.83331 20.9137H18.749C19.5221 20.9137 20.0223 21.4628 20.0223 22.2407V37.25C16.2934 37.25 13.7923 34.2299 13.7923 30.0199V27.2286ZM21.1592 19.7697H18.3852C14.2015 19.7697 11.2002 17.2529 11.2002 13.5006H26.1159C26.889 13.5006 27.4347 14.0039 27.4347 14.7819V29.7911C23.7058 29.7911 21.1592 26.771 21.1592 22.5611V19.7697ZM28.5715 12.3566H25.7976C21.6139 12.3566 18.6126 9.79401 18.6126 6.04169H33.5283C34.3014 6.04169 34.8016 6.59081 34.8016 7.32297V22.3323C31.0727 22.3323 28.5715 19.3121 28.5715 15.1022V12.3566Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "30.9683",
        height: "31.2083",
        fill: "white",
        transform: "translate(3.83331 6.04169)"
    }))));





const $fe783867988c674e$export$ceeb1de9ca56c2f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M23.4886 16.3121H32.6441C34.0191 16.3121 34.4886 17.62 33.6502 18.6596L19.3301 36.3334C14.702 32.6444 15.138 26.809 18.5252 22.5499L23.4886 16.3121ZM16.4124 23.3547H7.2569C5.8819 23.3547 5.41238 22.0468 6.2508 21.0072L20.5709 3.3334C25.199 7.02243 24.6959 12.7907 21.3423 17.0834L16.4124 23.3547Z",
        fill: "#0C66E4"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.2341",
        height: "33",
        fill: "white",
        transform: "translate(5.83331 3.33334)"
    }))));



var $8r2NN = parcelRequire("8r2NN");




const $950ee89ab585e7f2$export$7221b4e3b691d1b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));




var $dvVWp = parcelRequire("dvVWp");



const $78ddbe15426907d6$export$2e51523f0c1b4542 = {
    [(0, $dvVWp.ProductKeys).Confluence]: {
        displayName: 'Confluence',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $5lkNm.ConfluenceIcon), 'Confluence'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $bd60ef2a82de5097$export$93ca83db1787dea), 'Confluence', 'large')
    },
    [(0, $dvVWp.ProductKeys).Atlas]: {
        displayName: 'Home',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $NlHoa.AtlassianIcon), 'Home'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $0273546edb01e5e1$export$b0a52366c3fb9b), 'Home', 'large')
    },
    [(0, $dvVWp.ProductKeys).Jira]: {
        displayName: 'Jira',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $ldJ1U.JiraIcon), 'Jira'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $797166fcbb90ccba$export$f68d29dbb4f2da82), 'Jira', 'large')
    },
    [(0, $dvVWp.ProductKeys).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $33FWk.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $8e46bad3b7be5e7d$export$1afe31d4b2891d7a), 'Jira Product Discovery', 'large')
    },
    [(0, $dvVWp.ProductKeys).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $1SyEw.JiraServiceManagementIcon), 'Jira Service Management'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $fe783867988c674e$export$ceeb1de9ca56c2f7), 'Jira Service Management', 'large')
    },
    [(0, $dvVWp.ProductKeys).CustomerServiceManagement]: {
        displayName: 'Customer Service Management',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $ffVxZ.CustomerServiceManagementIcon), 'Customer Service Management'),
        SearchResultIcon: (0, $hAvnk.RovoLogoFromLogo)((0, $ffVxZ.CustomerServiceManagementIcon), 'Customer Service Management')
    },
    [(0, $dvVWp.ProductKeys).Bitbucket]: {
        displayName: 'Bitbucket',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $fxqZn.BitbucketIcon), 'Bitbucket'),
        SearchResultIcon: (0, $hAvnk.RovoLogoFromLogo)((0, $fxqZn.BitbucketIcon), 'large')
    },
    [(0, $dvVWp.ProductKeys).Trello]: {
        displayName: 'Trello',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $8JGXU.TrelloIcon), 'Trello'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $950ee89ab585e7f2$export$7221b4e3b691d1b3), 'Trello', 'large')
    },
    [(0, $dvVWp.ProductKeys).Compass]: {
        displayName: 'Compass',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $hZx6a.CompassIcon), 'Compass'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $c6d4958cc5e5b261$export$4b1b9db11d699ccb), 'Compass', 'large')
    },
    [(0, $dvVWp.ProductKeys).Focus]: {
        displayName: 'Focus',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $dL3KD.FocusIcon), 'Focus'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $278594cad80ad367$export$4d0238652f4b6bc4), 'Focus', 'large')
    },
    [(0, $dvVWp.ProductKeys).Assets]: {
        displayName: 'Assets',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $6vPLm.AssetsIcon), 'Assets'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $7e38c84ca82e0760$export$24d355ce80de5803), 'Assets', 'large')
    },
    [(0, $dvVWp.ProductKeys).Talent]: {
        displayName: 'Talent',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $hupj2.TalentIcon), 'Talent'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $8r2NN.TalentSearchResultIcon), 'Talent', 'large')
    }
};
const $78ddbe15426907d6$var$getProducts3PFromConfig = ()=>{
    // The use of Partial, the if (config) and the cast here are intentional TS gymnastics
    // We KNOW that this returns a config for all the ProductKeys3P, so we cast that
    // The TS compiler can't know that, and we'd be forced to write UI code like:
    //
    // const Icon = configs[productKey].Icon
    // return Icon && <Icon />
    //
    // Because TS can't prove productKey can be guaranteed to index into configs. But we know it can!
    const thirdPartyProducts = (0, $fd0l2.ThirdPartyConfigsSync);
    const configs = {};
    (0, $dvVWp.all3pProductKeys).map((productKey3P)=>{
        const config = thirdPartyProducts.get(productKey3P);
        if (config) configs[productKey3P] = {
            displayName: config.displayName,
            Icon: config.icon,
            IconBorderless: config.iconBorderless,
            is3P: true,
            ...config.searchResultIcon && {
                SearchResultIcon: config.searchResultIcon
            }
        };
    });
    return configs;
};
const $78ddbe15426907d6$export$e2c1afe0b1afaf49 = ()=>{
    return (0, $cozmU.useMemo)(()=>{
        const thirdPartyProducts = $78ddbe15426907d6$var$getProducts3PFromConfig();
        return {
            ...$78ddbe15426907d6$export$2e51523f0c1b4542,
            ...thirdPartyProducts
        };
    }, []);
};
const $78ddbe15426907d6$export$ede9abe489c9321b = (productKey)=>{
    return $78ddbe15426907d6$export$e2c1afe0b1afaf49()[productKey];
};
// Used by SAIN to detrermine knowledge source filtering
var $78ddbe15426907d6$var$KnowledgeSourceTypeValues = /*#__PURE__*/ function(KnowledgeSourceTypeValues) {
    KnowledgeSourceTypeValues["GITHUB"] = "github";
    KnowledgeSourceTypeValues["CONFLUENCE"] = "confluence";
    KnowledgeSourceTypeValues["JIRA"] = "jira";
    KnowledgeSourceTypeValues["ATLAS"] = "atlas";
    KnowledgeSourceTypeValues["HELP_AGGREGATOR"] = "help_aggregator";
    KnowledgeSourceTypeValues["GOOGLE_DRIVE"] = "google_drive";
    KnowledgeSourceTypeValues["MICROSOFT_SHAREPOINT"] = "microsoft_sharepoint";
    KnowledgeSourceTypeValues["SLACK"] = "slack";
    KnowledgeSourceTypeValues["MICROSOFT_TEAMS"] = "teams";
    KnowledgeSourceTypeValues["FIGMA"] = "figma";
    KnowledgeSourceTypeValues["CONFLUENCE_DC"] = "confluence-dc";
    KnowledgeSourceTypeValues["ATLASSIAN_WEB_CRAWLER"] = "atlassian-web-crawler";
    KnowledgeSourceTypeValues["LOOM"] = "loom";
    KnowledgeSourceTypeValues["GOOGLE_CALENDAR"] = "google_calendar";
    KnowledgeSourceTypeValues["ASSETS"] = "cmdb";
    KnowledgeSourceTypeValues["SALESFORCE"] = "salesforce";
    KnowledgeSourceTypeValues["ZENDESK"] = "zendesk";
    KnowledgeSourceTypeValues["SERVICENOW"] = "servicenow";
    KnowledgeSourceTypeValues["GMAIL"] = "gmail";
    return KnowledgeSourceTypeValues;
}($78ddbe15426907d6$var$KnowledgeSourceTypeValues || {});
const $78ddbe15426907d6$export$4fbc006e529fd6c0 = {
    [(0, $dvVWp.ProductKeys).Confluence]: "confluence",
    [(0, $dvVWp.ProductKeys).Github]: "github",
    [(0, $dvVWp.ProductKeys).Jira]: "jira",
    [(0, $dvVWp.ProductKeys).Atlas]: "atlas",
    [(0, $dvVWp.ProductKeys).GoogleDrive]: "google_drive",
    [(0, $dvVWp.ProductKeys).Sharepoint]: "microsoft_sharepoint",
    [(0, $dvVWp.ProductKeys).Slack]: "slack",
    [(0, $dvVWp.ProductKeys).Teams]: "teams",
    [(0, $dvVWp.ProductKeys).Figma]: "figma",
    [(0, $dvVWp.ProductKeys).ConfluenceDC]: "confluence-dc",
    [(0, $dvVWp.ProductKeys).AtlassianWebCrawler]: "atlassian-web-crawler",
    [(0, $dvVWp.ProductKeys).Loom]: "loom",
    [(0, $dvVWp.ProductKeys).GoogleCalendar]: "google_calendar",
    [(0, $dvVWp.ProductKeys).Assets]: "cmdb",
    [(0, $dvVWp.ProductKeys).Salesforce]: "salesforce",
    [(0, $dvVWp.ProductKeys).Zendesk]: "zendesk",
    [(0, $dvVWp.ProductKeys).ServiceNow]: "servicenow",
    [(0, $dvVWp.ProductKeys).Gmail]: "gmail"
};
module.exports["products1P"] = $78ddbe15426907d6$export$2e51523f0c1b4542;
module.exports["useProductConfigs"] = $78ddbe15426907d6$export$e2c1afe0b1afaf49;
module.exports["useProductConfig"] = $78ddbe15426907d6$export$ede9abe489c9321b;
module.exports["MapProductToKnowledgeSources"] = $78ddbe15426907d6$export$4fbc006e529fd6c0;

});

parcelRegister("8r2NN", function(module, exports) {
// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx

var $cozmU = parcelRequire("cozmU");

const $10b6f9203403c8be$export$5427c633f31d110f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));
module.exports["TalentSearchResultIcon"] = $10b6f9203403c8be$export$5427c633f31d110f;

});

parcelRegister("7MBm9", function(module, exports) {

var $5mh7K = parcelRequire("5mh7K");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


const $8bdff88bb7ebfd0f$var$GoogleDocs = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ytiX")).then((module)=>module.GoogleDocsIcon), {
    moduleId: '@atlassian/logo-third-party/google-docs'
});

const $8bdff88bb7ebfd0f$var$GoogleSheets = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7OcIk")).then((module)=>module.GoogleSheetsIcon), {
    moduleId: '@atlassian/logo-third-party/google-sheets'
});

const $8bdff88bb7ebfd0f$var$GoogleSlides = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("54D8T")).then((module)=>module.GoogleSlidesIcon), {
    moduleId: '@atlassian/logo-third-party/google-slides'
});

const $8bdff88bb7ebfd0f$var$MicrosoftWord = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dO0uT")).then((module)=>module.MicrosoftWordIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-word'
});

const $8bdff88bb7ebfd0f$var$MicrosoftExcel = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5CwnC")).then((module)=>module.MicrosoftExcelIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-excel'
});

const $8bdff88bb7ebfd0f$var$MicrosoftPowerPoint = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwKo8")).then((module)=>module.MicrosoftPowerPointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-power-point'
});
const $8bdff88bb7ebfd0f$export$94ecce29f485360b = (product, subtype)=>{
    if (product === (0, $dvVWp.ProductKeys).GoogleDrive) switch(subtype){
        case (0, $7ydfN.NounSubtypeKey).Document:
            return $8bdff88bb7ebfd0f$var$GoogleDocs;
        case (0, $7ydfN.NounSubtypeKey).Spreadsheet:
            return $8bdff88bb7ebfd0f$var$GoogleSheets;
        case (0, $7ydfN.NounSubtypeKey).Presentation:
            return $8bdff88bb7ebfd0f$var$GoogleSlides;
    }
    if (product === (0, $dvVWp.ProductKeys).Sharepoint) switch(subtype){
        case (0, $7ydfN.NounSubtypeKey).Document:
            return $8bdff88bb7ebfd0f$var$MicrosoftWord;
        case (0, $7ydfN.NounSubtypeKey).Spreadsheet:
            return $8bdff88bb7ebfd0f$var$MicrosoftExcel;
        case (0, $7ydfN.NounSubtypeKey).Presentation:
            return $8bdff88bb7ebfd0f$var$MicrosoftPowerPoint;
    }
    return null;
};
module.exports["getFileTypeBrandIcon"] = $8bdff88bb7ebfd0f$export$94ecce29f485360b;

});

parcelRegister("8ytiX", function(module, exports) {

let $63a83b0538a7262d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63a83b0538a7262d$var$load("2gN4E").then(()=>parcelRequire('jx3SX'));

});

parcelRegister("7OcIk", function(module, exports) {

let $5af710ab7c34f843$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5af710ab7c34f843$var$load("e1OlX").then(()=>parcelRequire('1448l'));

});

parcelRegister("54D8T", function(module, exports) {

let $3b1bb05e78b8fe1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b1bb05e78b8fe1c$var$load("3dSbb").then(()=>parcelRequire('2XmSX'));

});

parcelRegister("dO0uT", function(module, exports) {

let $a0d0549940bc501f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0d0549940bc501f$var$load("9oJcv").then(()=>parcelRequire('ejmAU'));

});

parcelRegister("5CwnC", function(module, exports) {

let $41799e572afe3527$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41799e572afe3527$var$load("6cRVP").then(()=>parcelRequire('hJgYU'));

});

parcelRegister("jwKo8", function(module, exports) {

let $e374fd3bd5ad2941$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e374fd3bd5ad2941$var$load("2zYic").then(()=>parcelRequire('iavlo'));

});

parcelRegister("kl6Mg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $6d9646ded84ad880$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $6d9646ded84ad880$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $6d9646ded84ad880$var$highlightMarkerRE = new RegExp(`${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}|${$6d9646ded84ad880$var$HIGHLIGHT_END_TAG}`, 'g');
const $6d9646ded84ad880$export$8ebd5c051fe06ad1 = (text)=>text.replace($6d9646ded84ad880$var$highlightMarkerRE, '');
const $6d9646ded84ad880$var$highlightRE = new RegExp(`${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}(.*?)${$6d9646ded84ad880$var$HIGHLIGHT_END_TAG}.*`);
const $6d9646ded84ad880$var$openingTagRE = new RegExp(`(.*?)${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}`);
const $6d9646ded84ad880$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($6d9646ded84ad880$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($6d9646ded84ad880$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($6d9646ded84ad880$var$highlightRE) || [];
        title = title.replace(`${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}${highlightText}${$6d9646ded84ad880$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "strong",
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};
module.exports["stripHighlightMarkers"] = $6d9646ded84ad880$export$8ebd5c051fe06ad1;
module.exports["enrichResultTitle"] = $6d9646ded84ad880$export$c43ff622b37ceaa9;

});

parcelRegister("4g98k", function(module, exports) {
/**
 * Returns true for middle-clicks (button === 1). Right-clicks are excluded to avoid
 * double-counting with onContextMenu.
 */ const $02d4cf935ae99537$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};
module.exports["isAuxClick"] = $02d4cf935ae99537$export$15213acd7ac7d39a;

});

parcelRegister("3MEmE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $buHp0 = parcelRequire("buHp0");


var $9DHhW = parcelRequire("9DHhW");


var $6yu7A = parcelRequire("6yu7A");


var $4g98k = parcelRequire("4g98k");


var $iuvXK = parcelRequire("iuvXK");

const $137098e641823691$export$8280134f2e1dd939 = (url)=>{
    if (!url) return null;
    try {
        // A base is supplied so relative URLs parse; `generateUrlWithParams` accepts
        // them too, and it is stripped again because only the query is read.
        const { searchParams: searchParams } = new URL(url, 'http://localhost/');
        const encoded = searchParams.get((0, $iuvXK.URL_QUERY_PARAM_INTERACTION_SESSION));
        if (!encoded) return null;
        // `searchParams.get` has already percent-decoded the value.
        const decoded = JSON.parse(atob(encoded));
        if (!decoded?.bridge || !decoded?.id || !decoded?.source) return null;
        return {
            bridge: decoded.bridge,
            id: decoded.id,
            source: decoded.source
        };
    } catch  {
        // Malformed base64, malformed JSON, or an unparseable URL. A corrupt param
        // must not break navigation, so it is treated as absent.
        return null;
    }
};


/**
 * One id for every search result link. `bridge` (from the decoded param) already
 * separates the Search Page from Quick Find, and `destinationApp` already says
 * where the link goes, so a per-surface id would mostly duplicate those while
 * forcing consumers to know the full set of values.
 */ const $e5a2431687918cbd$var$ACTION_SUBJECT_ID = 'searchResultLink';
const $e5a2431687918cbd$export$1ac7aaf3243265d1 = ({ href: href, destinationApp: destinationApp })=>{
    // `fireCustomCrossAppAnalytic` needs the raw `createAnalyticsEvent`, not the
    // `useAnalytics` controller wrapper, so this hook owns the analytics-next
    // dependency. It lives in `common/utils` rather than `controllers/events`
    // because `common/ui` consumes it and must not depend on `controllers`.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireCrossAppAnalytic = (0, $cozmU.useCallback)(()=>{
        if (!destinationApp) return;
        const interactionSession = (0, $137098e641823691$export$8280134f2e1dd939)(href);
        // No usable `xpis` means the link was never wrapped, so there is no
        // cross-product interaction to report.
        if (!interactionSession) return;
        (0, $buHp0.fireCustomCrossAppAnalytic)({
            tags: [
                'navigationExperiences'
            ],
            analyticsEventFireName: (0, $6yu7A.DEFAULT_GAS_CHANNEL),
            destinationApp: destinationApp,
            bridge: interactionSession.bridge,
            source: interactionSession.source,
            actionSubjectId: $e5a2431687918cbd$var$ACTION_SUBJECT_ID,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        href,
        destinationApp,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onClick: fireCrossAppAnalytic,
            // `auxclick` covers middle-click (button 1) but also right-click (button 2),
            // and opening the context menu is not a navigation, so it must be filtered.
            onAuxClick: (event)=>{
                if ((0, $4g98k.isAuxClick)(event)) fireCrossAppAnalytic();
            }
        }), [
        fireCrossAppAnalytic
    ]);
};
module.exports["useCrossAppLinkHandlers"] = $e5a2431687918cbd$export$1ac7aaf3243265d1;

});

parcelRegister("gUz4r", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $dvVWp = parcelRequire("dvVWp");

/**
 * Explicitly OPT IN a non-1P product to cross-product URL wrapping.
 *
 * Use sparingly — most products that should be wrapped are expressible via
 * the 1P default rule. Typed loosely as `Record<string, true>` because, by
 * definition, these keys are not in {@link ProductKeys1P}.
 */ const $e3a66e73ec1fc558$var$ADDITIONAL_WRAPPABLE_PRODUCTS = {
    goals: true,
    projects: true,
    loom: true,
    teams: true
};
/**
 * Explicitly OPT OUT a 1P product from cross-product URL wrapping.
 *
 * Typed against {@link ProductKeys1P} so a stale entry (e.g. after a 1P key
 * is removed from the master `ProductKeys1P` constant) fails the build.
 */ const $e3a66e73ec1fc558$var$NON_WRAPPABLE_1P = {
};
const $e3a66e73ec1fc558$export$4cf40959dee0db9c = (resultProduct)=>{
    if (resultProduct in $e3a66e73ec1fc558$var$NON_WRAPPABLE_1P) return false;
    if (resultProduct in $e3a66e73ec1fc558$var$ADDITIONAL_WRAPPABLE_PRODUCTS) return true;
    return (0, $dvVWp.is1pProductKey)(resultProduct);
};
const $e3a66e73ec1fc558$export$8e7034cb7abd8b0f = {
    ADDITIONAL_WRAPPABLE_PRODUCTS: $e3a66e73ec1fc558$var$ADDITIONAL_WRAPPABLE_PRODUCTS,
    NON_WRAPPABLE_1P: $e3a66e73ec1fc558$var$NON_WRAPPABLE_1P
};
const $e3a66e73ec1fc558$export$2a57f89490774c5c = (args)=>{
    const { bridge: bridge, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct } = args;
    // `useCrossProductUrlWrapper` requires a non-empty `product` string. When
    // `primaryProduct` is undefined the outer guard below short-circuits and
    // the wrapper is never invoked, so this fallback is only there to keep
    // the hook call legal.
    const wrapUrl = (0, $aIlZA.default)({
        bridge: bridge,
        product: primaryProduct ?? 'unknown',
        subProduct: primarySubProduct || undefined
    });
    return (0, $cozmU.useMemo)(()=>(url, resultProduct)=>{
            if (!url || !primaryProduct || !resultProduct) return url;
            if (!$e3a66e73ec1fc558$export$4cf40959dee0db9c(resultProduct)) return url;
            return wrapUrl(url);
        }, [
        wrapUrl,
        primaryProduct
    ]);
};
module.exports["useSearchCrossProductUrlWrapper"] = $e3a66e73ec1fc558$export$2a57f89490774c5c;

});

parcelRegister("3zSbE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $l8Rhq = parcelRequire("l8Rhq");


var $c11PZ = parcelRequire("c11PZ");

const $c757ad1271939867$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { onNavigate: onNavigate } = (0, $c11PZ.useAppContext)();
    const { href: href, target: target, onClick: originalOnClick } = props;
    const onClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        originalOnClick?.(event, analyticsEvent);
        // Leave navigation to other browsing contexts to the browser, including host overrides.
        if ((0, $iDrrr.fg)('rovo_qf_people_teams_link_navigation') && target && target !== '_self') return;
        // Use onNavigate if
        // - alwaysUseOnLinkClick is true
        // - navigating to the same site and not new tab/window
        const metaPressed = event.ctrlKey || event.metaKey || event.shiftKey;
        const sameOrigin = window.location.origin === new URL(href).origin;
        const onNavigateOverride = typeof onNavigate === 'object' ? onNavigate.options.alwaysUseOnLinkClick : false;
        const useOnNavigate = onNavigateOverride || sameOrigin && !metaPressed;
        if (useOnNavigate) {
            event.preventDefault();
            // Handles SPA navigation if consumer provides their own onNavigate
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(href, 'push', event);
        }
    }, [
        href,
        target,
        onNavigate,
        originalOnClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
        ref: ref,
        ...props,
        onClick: onClick
    });
});
module.exports["Link"] = $c757ad1271939867$export$a6c7ac8248d6e38a;

});

parcelRegister("9S5yN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $73Hia = parcelRequire("73Hia");


var $7pmcn = parcelRequire("7pmcn");


var $6Vsfx = parcelRequire("6Vsfx");


var $bgCtI = parcelRequire("bgCtI");


var $6ShBo = parcelRequire("6ShBo");


var $9ycOp = parcelRequire("9ycOp");

const $0d5eeb69065ed4b2$var$socialMetadataStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050'
});
const $0d5eeb69065ed4b2$var$subheadingStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $0d5eeb69065ed4b2$var$subheadingLeftAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden'
});
const $0d5eeb69065ed4b2$var$inlineStyles = (0, $buxP3.xcss)({
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$hiddenReferenceInlineStyles = (0, $buxP3.xcss)({
    flex: '1 0 auto',
    visibility: 'hidden',
    position: 'relative',
    zIndex: '1',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$staticInlineStyles = (0, $buxP3.xcss)({
    flex: '1 0 auto',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$visibleMeasurementInlineStyles = (0, $buxP3.xcss)({
    flex: '1 0 auto',
    position: 'relative',
    zIndex: 'card',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$metadataItemStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
        key: key
    }, value, spacer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ShBo.Spacer), null));
};
const $0d5eeb69065ed4b2$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $0d5eeb69065ed4b2$var$renderSocialMetadata = (defaultSocialParts)=>{
    const socialSignalIndex = defaultSocialParts.findIndex((item)=>Array.isArray(item) && item[1] === 'social-signal');
    const hasBreadcrumb = socialSignalIndex !== -1;
    const parts = defaultSocialParts.filter((_, index)=>index !== socialSignalIndex).filter($0d5eeb69065ed4b2$var$filterPart);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        space: "space.150",
        xcss: $0d5eeb69065ed4b2$var$socialMetadataStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, parts?.map((m)=>$0d5eeb69065ed4b2$var$renderParts(m, false)))), hasBreadcrumb && defaultSocialParts[defaultSocialParts.length - 1]);
};
const $0d5eeb69065ed4b2$var$SearchMetadataWithOverflowObserver = ({ metadataItems: metadataItems, searchResultId: searchResultId, containerRef: containerRef })=>{
    const useSingleMetadataTree = (0, $4o0zT.isExperimentEnabled)('rovo_fps_agentic_rendering_optimisation');
    const headerMetadataWithIds = metadataItems.map((item, index)=>{
        const prefix = searchResultId || 'default';
        return {
            index: index,
            id: `metadata-${prefix}-${index}`,
            content: item
        };
    });
    const hiddenMetadataRefs = (0, $cozmU.useRef)([]);
    const visibleMetadataRefs = (0, $cozmU.useRef)([]);
    hiddenMetadataRefs.current = headerMetadataWithIds.map((_, i)=>hiddenMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $cozmU.createRef)());
    if (useSingleMetadataTree) visibleMetadataRefs.current = headerMetadataWithIds.map((_, i)=>visibleMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $cozmU.createRef)());
    const visibleItems = (0, $9ycOp.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: useSingleMetadataTree ? visibleMetadataRefs : hiddenMetadataRefs,
        overflowItemRefs: useSingleMetadataTree ? hiddenMetadataRefs : undefined,
        itemIds: headerMetadataWithIds.map((item)=>item.id)
    });
    const hasHiddenItems = headerMetadataWithIds.length > visibleItems.length;
    const processVisibleItems = ()=>{
        const visibleMetadata = headerMetadataWithIds.filter((item)=>visibleItems.includes(item.id));
        // If we have hidden items, remove spacer from last visible item
        if (hasHiddenItems && visibleMetadata.length > 0) {
            const lastIndex = visibleMetadata.length - 1;
            visibleMetadata[lastIndex] = {
                ...visibleMetadata[lastIndex],
                content: (0, $7pmcn.filterSpacer)(visibleMetadata[lastIndex].content)
            };
        }
        return visibleMetadata;
    };
    const processedVisibleItems = processVisibleItems();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $0d5eeb69065ed4b2$var$subheadingLeftAreaStyles,
            $0d5eeb69065ed4b2$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, (!useSingleMetadataTree || hasHiddenItems) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: [
            $0d5eeb69065ed4b2$var$hiddenReferenceInlineStyles
        ],
        testId: "search-page-result-metadata-hidden"
    }, headerMetadataWithIds.map((item, index)=>{
        const elementId = `reference:${item.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            key: elementId,
            id: elementId,
            ref: hiddenMetadataRefs.current[index],
            xcss: $0d5eeb69065ed4b2$var$metadataItemStyles
        }, item.content);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: [
            useSingleMetadataTree && !hasHiddenItems ? $0d5eeb69065ed4b2$var$visibleMeasurementInlineStyles : $0d5eeb69065ed4b2$var$inlineStyles
        ],
        testId: "search-page-result-metadata-visible"
    }, processedVisibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            key: `visible-${item.id}`,
            id: useSingleMetadataTree && !hasHiddenItems ? `reference:${item.id}` : undefined,
            ref: useSingleMetadataTree ? visibleMetadataRefs.current[item.index] : undefined,
            xcss: $0d5eeb69065ed4b2$var$metadataItemStyles
        }, item.content)), hasHiddenItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bgCtI.MetadataPopupButton), {
        metadata: headerMetadataWithIds.filter((item)=>!visibleItems.includes(item.id)).map((item)=>item.content),
        isFirstElement: processedVisibleItems.length === 0
    })));
};
const $0d5eeb69065ed4b2$var$SearchMetadataStatic = ({ metadataItems: metadataItems })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $0d5eeb69065ed4b2$var$subheadingLeftAreaStyles,
            $0d5eeb69065ed4b2$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: [
            $0d5eeb69065ed4b2$var$staticInlineStyles
        ],
        testId: "search-page-result-metadata-visible"
    }, metadataItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            key: `static-${index}`,
            xcss: $0d5eeb69065ed4b2$var$metadataItemStyles
        }, item))));
};
const $0d5eeb69065ed4b2$export$8e7fb1f8fe599124 = ({ productConfigs: productConfigs, ...props })=>{
    return productConfigs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d5eeb69065ed4b2$var$SearchMetadataWithProductConfigs, {
        ...props,
        productConfigs: productConfigs
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d5eeb69065ed4b2$var$SearchMetadataWithLocalProductConfigs, props);
};
const $0d5eeb69065ed4b2$var$SearchMetadataWithLocalProductConfigs = (props)=>{
    const productConfigs = (0, $73Hia.useProductConfigs)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d5eeb69065ed4b2$var$SearchMetadataWithProductConfigs, {
        ...props,
        productConfigs: productConfigs
    });
};
const $0d5eeb69065ed4b2$var$SearchMetadataWithProductConfigs = ({ searchResultId: searchResultId, product: product, productSelected: productSelected, parts: defaultParts = [], socialParts: defaultSocialParts = [], displaySpacer: displaySpacer = true, containerRef: containerRef, disableOverflowObserver: disableOverflowObserver = false, selectedSites: selectedSites, productConfigs: productConfigs })=>{
    // TODO: Shouldn't need to cast here, need to clean up the stack above this to not pass string around as product
    // Product name is hidden when productSelected=true (i.e. a specific app is selected)
    const productDisplayName = !product || productSelected ? '' : productConfigs[product]?.displayName || '';
    const parts = defaultParts.filter($0d5eeb69065ed4b2$var$filterPart);
    const hasSocialParts = defaultSocialParts.filter($0d5eeb69065ed4b2$var$filterPart).length > 0;
    if (hasSocialParts) parts.push([
        'social-metadata',
        $0d5eeb69065ed4b2$var$renderSocialMetadata(defaultSocialParts)
    ]);
    if (productDisplayName) parts.unshift([
        'product-display-name',
        productDisplayName
    ]);
    // More than one site in scope means the search spans sites, so results are worth attributing.
    const siteName = (selectedSites?.size ?? 0) > 1 ? (0, $6Vsfx.getSiteName)(searchResultId, selectedSites) : undefined;
    if (siteName) parts.unshift([
        'site-name',
        siteName
    ]);
    const metadataItems = parts.map((m, i)=>$0d5eeb69065ed4b2$var$renderParts(m, displaySpacer && i < parts.length - 1));
    // If we don't have a containerRef, we don't want to use the overflow observer
    if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, metadataItems);
    if (disableOverflowObserver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d5eeb69065ed4b2$var$SearchMetadataStatic, {
        metadataItems: metadataItems
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d5eeb69065ed4b2$var$SearchMetadataWithOverflowObserver, {
        metadataItems: metadataItems,
        searchResultId: searchResultId,
        containerRef: containerRef
    });
};
module.exports["SearchMetadata"] = $0d5eeb69065ed4b2$export$8e7fb1f8fe599124;

});

parcelRegister("7pmcn", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $cozmU = parcelRequire("cozmU");

const $4ee30c55723646c9$export$325faed136549eaf = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return node;
    // Check if element is a Spacer component
    if (typeof node.type === 'function' && node.type.IS_METADATA_SPACER) return null;
    // If the element has children, filter out spacers
    if (node.props.children) {
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(node.props.children);
        const filteredChildren = children.filter((child)=>!/*#__PURE__*/ ((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child) && typeof child.type === 'function' && child.type.IS_METADATA_SPACER));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(node, node.props, ...filteredChildren);
    }
    return node;
};
module.exports["filterSpacer"] = $4ee30c55723646c9$export$325faed136549eaf;

});

parcelRegister("bgCtI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $4n1IT = parcelRequire("4n1IT");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $7pmcn = parcelRequire("7pmcn");

const $4b9e0a09d5f453aa$var$popupContentContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    padding: 'space.200',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'space.100',
    borderRadius: 'radius.small',
    background: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $4b9e0a09d5f453aa$var$subheadingStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $4b9e0a09d5f453aa$var$iconButtonContainerStyles = (0, $buxP3.xcss)({
    margin: 'space.025',
    marginLeft: 'space.075',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $4b9e0a09d5f453aa$var$iconButtonContainerIsFirstElementStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.025'
});
const $4b9e0a09d5f453aa$export$b31e3e19fb9e4d37 = ({ metadata: metadata, isFirstElement: isFirstElement })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $4b9e0a09d5f453aa$var$popupContentContainerStyles,
                    $4b9e0a09d5f453aa$var$subheadingStyles
                ]
            }, metadata.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    key: index
                }, (0, $7pmcn.filterSpacer)(item)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $4b9e0a09d5f453aa$var$iconButtonContainerStyles,
                    isFirstElement && $4b9e0a09d5f453aa$var$iconButtonContainerIsFirstElementStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: "More"
            }))
    });
};
module.exports["MetadataPopupButton"] = $4b9e0a09d5f453aa$export$b31e3e19fb9e4d37;

});

parcelRegister("6ShBo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

const $be86f90767df5829$var$metadataSpacerStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $be86f90767df5829$export$d7a54cba636a8cd6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        xcss: $be86f90767df5829$var$metadataSpacerStyles
    }, "\u2022");
$be86f90767df5829$export$d7a54cba636a8cd6.IS_METADATA_SPACER = true;
module.exports["Spacer"] = $be86f90767df5829$export$d7a54cba636a8cd6;

});

parcelRegister("9ycOp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f3d70ec76b2062a4$var$INTERSECTION_THRESHOLD = 1;
// Checks whether two ordered item ID lists are identical so observer updates do not trigger
// unnecessary React renders when the set of visible items has not changed.
const $f3d70ec76b2062a4$var$areItemIdsEqual = (first, second)=>first.length === second.length && first.every((id, index)=>id === second[index]);
// Extracts the item ID from a hidden reference element (for example, "reference:contributor")
// so an IntersectionObserver entry can be associated with the item it is measuring.
const $f3d70ec76b2062a4$var$getReferenceElementId = (element)=>{
    const targetId = element.getAttribute('id');
    return targetId?.startsWith('reference:') ? targetId.slice(10) : undefined;
};
// Reads the layout gap between the dynamic filters and alwaysVisibleRef so the observer reserves
// the same amount of space as the visible row. There is no gap to reserve without a parent.
const $f3d70ec76b2062a4$var$getParentColumnGap = (element)=>{
    if (!element.parentElement) return 0;
    return Number.parseFloat(getComputedStyle(element.parentElement).columnGap || '0') || 0;
};
const $f3d70ec76b2062a4$export$c376cfef3a1f950d = ({ containerRef: containerRef, itemRefs: itemRefs, overflowItemRefs: overflowItemRefs, itemIds: itemIds, alwaysVisibleRef: alwaysVisibleRef, firstRenderVisibility: firstRenderVisibility = 'show' })=>{
    const [measurement, setMeasurement] = (0, $cozmU.useState)();
    const [alwaysVisibleReservedSpace, setAlwaysVisibleReservedSpace] = (0, $cozmU.useState)(alwaysVisibleRef ? undefined : 0);
    // Tracks which items are being shown and the space reserved for alwaysVisibleRef and its gap.
    const measurementKey = JSON.stringify([
        itemIds,
        alwaysVisibleReservedSpace ?? 'pending'
    ]);
    const itemIdsRef = (0, $cozmU.useRef)(itemIds);
    itemIdsRef.current = itemIds;
    // A single-tree caller cannot keep rendering IDs from a prior measurement: its visible refs
    // would unmount before the replacement IDs could be observed. The regular two-tree callers do
    // not supply overflowItemRefs, so their established behavior remains unchanged.
    const currentMeasurement = overflowItemRefs && measurement?.key !== measurementKey ? undefined : measurement;
    const observedItemRefs = currentMeasurement !== undefined && currentMeasurement.visibleItems.length < itemIds.length && overflowItemRefs ? overflowItemRefs : itemRefs;
    // Measures alwaysVisibleRef and its parent gap, keeping the reserved space updated as its
    // contents change.
    // For example, selecting a filter adds the Clear all control and increases the reserved width.
    (0, $cozmU.useEffect)(()=>{
        if (!alwaysVisibleRef) {
            setAlwaysVisibleReservedSpace(0);
            return;
        }
        const element = alwaysVisibleRef.current;
        if (!element) return;
        const updateWidth = ()=>{
            const nextWidth = element.offsetWidth + $f3d70ec76b2062a4$var$getParentColumnGap(element);
            setAlwaysVisibleReservedSpace((currentWidth)=>currentWidth === nextWidth ? currentWidth : nextWidth);
        };
        updateWidth();
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        alwaysVisibleRef
    ]);
    // Observes every hidden reference item, publishes visibility only after all items have been
    // measured, and keeps the visible list updated as the available layout space changes.
    (0, $cozmU.useEffect)(()=>{
        if (alwaysVisibleReservedSpace === undefined) return;
        let isDisposed = false;
        const intersections = new Map();
        const observer = new IntersectionObserver((entries)=>{
            if (isDisposed) return;
            entries.forEach((entry)=>{
                const elementId = $f3d70ec76b2062a4$var$getReferenceElementId(entry.target);
                if (!elementId || !itemIdsRef.current.includes(elementId)) return;
                intersections.set(elementId, entry.isIntersecting && entry.intersectionRatio >= $f3d70ec76b2062a4$var$INTERSECTION_THRESHOLD);
            });
            const currentItemIds = itemIdsRef.current;
            if (!currentItemIds.every((id)=>intersections.has(id))) return;
            const nextVisibleItems = currentItemIds.filter((id)=>intersections.get(id) === true);
            setMeasurement((previousMeasurement)=>previousMeasurement?.key === measurementKey && $f3d70ec76b2062a4$var$areItemIdsEqual(previousMeasurement.visibleItems, nextVisibleItems) ? previousMeasurement : {
                    key: measurementKey,
                    visibleItems: nextVisibleItems
                });
        }, {
            root: containerRef.current,
            rootMargin: `0px -${alwaysVisibleReservedSpace}px 0px 0px`,
            threshold: $f3d70ec76b2062a4$var$INTERSECTION_THRESHOLD
        });
        observedItemRefs.current.forEach((itemRef)=>{
            if (itemRef?.current) observer.observe(itemRef.current);
        });
        return ()=>{
            isDisposed = true;
            observer.disconnect();
        };
    }, [
        alwaysVisibleReservedSpace,
        containerRef,
        measurementKey,
        observedItemRefs
    ]);
    const visibleItems = currentMeasurement?.visibleItems ?? itemIds;
    const hasMeasured = itemIds.length === 0 || currentMeasurement !== undefined;
    return hasMeasured || firstRenderVisibility === 'show' ? visibleItems : [];
};
module.exports["useOverflowObserver"] = $f3d70ec76b2062a4$export$c376cfef3a1f950d;

});

parcelRegister("1xRe4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3P0Fk = parcelRequire("3P0Fk");


var $7nrkp = parcelRequire("7nrkp");

const $1e114c24d4299a03$export$95cacd63dfd98bee = ({ type: type, defaultMessage: defaultMessage = null, subtype: subtype })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = (0, $7nrkp.messages)[type];
    const isLiveDoc = subtype === (0, $3P0Fk.SearchConfluenceSubtype).LIVE;
    if (!message) return defaultMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLiveDoc ? formatMessage((0, $7nrkp.messages).liveDoc) : formatMessage(message));
};
const $1e114c24d4299a03$export$446974e6d8045139 = (type)=>{
    if (!type || !(0, $7nrkp.messages)[type]) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e114c24d4299a03$export$95cacd63dfd98bee, {
        type: type
    });
};
module.exports["SearchResultType"] = $1e114c24d4299a03$export$95cacd63dfd98bee;
module.exports["getSearchResultType"] = $1e114c24d4299a03$export$446974e6d8045139;

});

parcelRegister("7nrkp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $72c471fbf2b42026$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "search_result_type_page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "search_result_type_blogpost",
        defaultMessage: "Blog Post"
    },
    whiteboard: {
        id: "search_result_type_whiteboard",
        defaultMessage: "Whiteboard"
    },
    slide: {
        id: "search_result_type_slide",
        defaultMessage: "Slides"
    },
    database: {
        id: "search_result_type_database",
        defaultMessage: "Database"
    },
    space: {
        id: "search_result_type_space",
        defaultMessage: "Space"
    },
    attachment: {
        id: "search_result_type_attachment",
        defaultMessage: "Attachment"
    },
    comment: {
        id: "search_result_type_comment",
        defaultMessage: "Comment"
    },
    folder: {
        id: "search_result_type_folder",
        defaultMessage: "Folder"
    },
    calendar: {
        id: "search_result_type_calendar",
        defaultMessage: "Calendar"
    },
    space_calendar: {
        // snake_case returned by the API
        id: "search_result_type_space_calendar",
        defaultMessage: "Space calendar"
    },
    question: {
        id: "search_result_type_question",
        defaultMessage: "Question"
    },
    answer: {
        id: "search_result_type_answer",
        defaultMessage: "Answer"
    },
    embed: {
        id: "search_result_type_embed",
        defaultMessage: "Smart Link"
    },
    board: {
        id: "search_result_type_board",
        defaultMessage: "Board"
    },
    dashboard: {
        id: "search_result_type_dashboard",
        defaultMessage: "Dashboard"
    },
    filter: {
        id: "search_result_type_filter",
        defaultMessage: "Filter"
    },
    issue: {
        id: "search_result_type_issue",
        defaultMessage: "Work item"
    },
    plan: {
        id: "search_result_type_plan",
        defaultMessage: "Plan"
    },
    playlist: {
        id: "search-page.common.search-result-type.playlist",
        defaultMessage: "Playlist"
    },
    project: {
        id: "search_result_type_project",
        defaultMessage: "Project"
    },
    goal: {
        id: "search_result_type_goal",
        defaultMessage: "Goal"
    },
    tag: {
        id: "search_result_type_tag",
        defaultMessage: "Tag"
    },
    learning: {
        id: "search_result_type_learning",
        defaultMessage: "Learning"
    },
    unrecognised: {
        id: "search_result_type_unrecognised",
        defaultMessage: "Unrecognised"
    },
    document: {
        id: "search_result_type_document",
        defaultMessage: "Document"
    },
    spreadsheet: {
        id: "search_result_type_spreadsheet",
        defaultMessage: "Spreadsheet"
    },
    presentation: {
        id: "search_result_type_presentation",
        defaultMessage: "Presentation"
    },
    'sharepoint-document': {
        id: "search_result_type_sharepoint_document",
        defaultMessage: "Sharepoint Document"
    },
    message: {
        id: "search_result_type_message",
        defaultMessage: "Message"
    },
    repository: {
        id: "search_result_type_repository",
        defaultMessage: "Repository"
    },
    'pull-request': {
        id: "search_result_type_pull_request",
        defaultMessage: "Pull Request"
    },
    commit: {
        id: "search_result_type_commit",
        defaultMessage: "Commit"
    },
    branch: {
        id: "search_result_type_branch",
        defaultMessage: "Branch"
    },
    file: {
        id: "search_result_type_file",
        defaultMessage: "File"
    },
    channel: {
        id: "search_result_type_channel",
        defaultMessage: "Channel"
    },
    component: {
        id: "search_result_type_component",
        defaultMessage: "Component"
    },
    'work-item': {
        id: "search_result_type_work_item",
        defaultMessage: "Work Item"
    },
    card: {
        id: "search_result_type_card",
        defaultMessage: "Card"
    },
    incident: {
        id: "search_result_type_incident",
        defaultMessage: "Incident"
    },
    focus_area: {
        id: "search_result_type_focus_area",
        defaultMessage: "Focus area"
    },
    focus_area_status_update: {
        id: "search_result_type_focus_area_status_update",
        defaultMessage: "Focus area update"
    },
    organization: {
        id: "search_result_type_organization",
        defaultMessage: "Organization"
    },
    organization_status_update: {
        id: "search_result_type_organization_status_update",
        defaultMessage: "Organization update"
    },
    ask: {
        id: "search_result_type_ask",
        defaultMessage: "Ask"
    },
    risk: {
        id: "search_result_type_risk",
        defaultMessage: "Risk"
    },
    email: {
        id: "search_result_type_email",
        defaultMessage: "Email"
    },
    gliffy: {
        id: "search_result_type_gliffy",
        defaultMessage: "Gliffy Diagram"
    },
    deal: {
        id: "search_result_type_deal",
        defaultMessage: "Deal"
    },
    'customer-org': {
        id: "search_result_type_customer_org",
        defaultMessage: "Customer Organization"
    },
    'data-table': {
        id: "search_result_type_data_table",
        defaultMessage: "Data table"
    },
    'customer-contact': {
        id: "search_result_type_customer_contact",
        defaultMessage: "Customer contact"
    },
    object: {
        id: "search_result_type_object",
        defaultMessage: "Object"
    },
    schema: {
        id: "search_result_type_schema",
        defaultMessage: "Schema"
    },
    type: {
        id: "search_result_type_type",
        defaultMessage: "Object type"
    },
    position: {
        id: "search_result_type_position",
        defaultMessage: "Position"
    },
    video: {
        id: "search_result_type_video",
        defaultMessage: "Video"
    },
    task: {
        id: "search_result_type_task",
        defaultMessage: "Task"
    },
    epic: {
        id: "search_result_type_epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search_result_type_bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search_result_type_story",
        defaultMessage: "Story"
    },
    'sub-task': {
        id: "search_result_type_sub_task",
        defaultMessage: "Sub-task"
    },
    subtask: {
        id: "search_result_type_subtask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "search_result_type_improvement",
        defaultMessage: "Improvement"
    },
    'new feature': {
        id: "search_result_type_new_feature",
        defaultMessage: "New feature"
    },
    change: {
        id: "search_result_type_change",
        defaultMessage: "Change"
    },
    problem: {
        id: "search_result_type_problem",
        defaultMessage: "Problem"
    },
    'service request': {
        id: "search_result_type_service_request",
        defaultMessage: "Service request"
    }
});
module.exports["messages"] = $72c471fbf2b42026$export$defe85febe8b728c;

});

parcelRegister("3Z7rz", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $d66d59d73fe8c0b4$export$b697429ad83cc9eb = (thirdPartyConfigs, providerId)=>{
    if (!thirdPartyConfigs || !providerId) return undefined;
    // Find by providerId (dynamic API adds this field to configs, even for static Forge connectors)
    const [product] = Object.entries(thirdPartyConfigs).find(([, config])=>config?.providerId === providerId) || [];
    // Ensure the product is in our defined set or is a Forge connector so we can cast it safely
    if (product && !(0, $dvVWp.all3pProductKeys).includes(product) && !(0, $8fNUp.isForgeConnectorProductKey)(product)) return undefined;
    return product ? product : undefined;
};
module.exports["getProductFromProviderId"] = $d66d59d73fe8c0b4$export$b697429ad83cc9eb;

});

parcelRegister("7uIpT", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0e5c4e232a3baf9a$var$pullRequestStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    MERGED: 'success',
    // green
    DECLINED: 'danger',
    // red
    DRAFT: 'neutral' // grey
};
const $0e5c4e232a3baf9a$export$2e2105095afb1fad = (status)=>$0e5c4e232a3baf9a$var$pullRequestStatusToLozengeMap[status] ?? 'neutral';
const $0e5c4e232a3baf9a$export$43932e794c008e49 = (0, $kSwu1.defineMessages)({
    status_open: {
        id: "search-pull-request-result.status.open",
        defaultMessage: "Open"
    },
    status_merged: {
        id: "search-pull-request-result.status.merged",
        defaultMessage: "Merged"
    },
    status_declined: {
        id: "search-pull-request-result.status.declined",
        defaultMessage: "Declined"
    },
    status_draft: {
        id: "search-pull-request-result.status.draft",
        defaultMessage: "Draft"
    },
    status_unknown: {
        id: "search-pull-request-result.status.unknown",
        defaultMessage: "Unknown"
    }
});
const $0e5c4e232a3baf9a$export$d8a08f59b3eb7920 = {
    OPEN: $0e5c4e232a3baf9a$export$43932e794c008e49.status_open,
    MERGED: $0e5c4e232a3baf9a$export$43932e794c008e49.status_merged,
    DECLINED: $0e5c4e232a3baf9a$export$43932e794c008e49.status_declined,
    DRAFT: $0e5c4e232a3baf9a$export$43932e794c008e49.status_draft,
    UNKNOWN: $0e5c4e232a3baf9a$export$43932e794c008e49.status_unknown
};
const $0e5c4e232a3baf9a$export$348ea44fc966c8f3 = (status)=>(status && $0e5c4e232a3baf9a$export$d8a08f59b3eb7920[status]) ?? $0e5c4e232a3baf9a$export$43932e794c008e49.status_unknown;
module.exports["getPullRequestStatusAppearance"] = $0e5c4e232a3baf9a$export$2e2105095afb1fad;
module.exports["pullRequestStatusMessages"] = $0e5c4e232a3baf9a$export$43932e794c008e49;
module.exports["getPullRequestStatusMessage"] = $0e5c4e232a3baf9a$export$348ea44fc966c8f3;

});

parcelRegister("ir4XI", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cozmU = parcelRequire("cozmU");


var $eDWBm = parcelRequire("eDWBm");

const $3e6c385b00a79f7b$export$2804e03de329c539 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, failSection: failSection })=>{
    return {
        eventType: 'track',
        source: failSection,
        actionSubject: 'searchPageErrorBoundary',
        action: 'failed',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};



var $dsOco = parcelRequire("dsOco");


var $2csHQ = parcelRequire("2csHQ");


const $c19520959e68844c$export$e926676385687eaf = ({ children: children, fallback: fallback, renderWithErrorInfo: renderWithErrorInfo, section: section, onException: customOnException, setErrorBoundaryResetCb: setErrorBoundaryResetCb })=>{
    const logException = (0, $2csHQ.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const onException = (0, $cozmU.useCallback)((error)=>{
        fireAnalyticsEvent((0, $3e6c385b00a79f7b$export$2804e03de329c539)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            failSection: section
        }));
        logException(error);
        // Call custom handler if provided
        customOnException?.(error);
    }, [
        logException,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        section,
        customOnException
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDWBm.ErrorBoundary), {
        fallback: fallback,
        renderWithErrorInfo: renderWithErrorInfo,
        onException: onException,
        setErrorBoundaryResetCb: setErrorBoundaryResetCb
    }, children);
};
module.exports["ErrorBoundary"] = $c19520959e68844c$export$e926676385687eaf;

});

parcelRegister("2csHQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $32Eau = parcelRequire("32Eau");


var $eD8r5 = parcelRequire("eD8r5");

const $96947b87cac7f0db$export$67ff3bc9583d7c16 = ()=>{
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [user] = (0, $32Eau.useUser)();
    // Store data required for logging exceptions in refs to prevent re-renders
    return (0, $cozmU.useCallback)(async (error)=>await (0, $eD8r5.logException)(error, user?.id, primaryProduct), [
        primaryProduct,
        user?.id
    ]);
};
module.exports["useLogException"] = $96947b87cac7f0db$export$67ff3bc9583d7c16;

});

parcelRegister("GHTO7", function(module, exports) {

var $d2hGj = parcelRequire("d2hGj");


var $f6RxU = parcelRequire("f6RxU");


var $lSbhE = parcelRequire("lSbhE");

const $72498c90ccdf0220$export$b0d5f79a828d791e = (durationInSeconds, options)=>{
    if (durationInSeconds === undefined || durationInSeconds === null) return null;
    const ONE_HOUR = 3600;
    const ONE_MINUTE = 60;
    if (options?.readable) {
        const roundedDurationInSeconds = Math.ceil(durationInSeconds);
        const roundedHours = Math.floor(roundedDurationInSeconds / ONE_HOUR);
        const roundedMinutes = Math.floor(roundedDurationInSeconds % ONE_HOUR / ONE_MINUTE);
        const roundedSeconds = roundedDurationInSeconds % ONE_MINUTE;
        if (options.formatMessage) {
            if (roundedDurationInSeconds < ONE_MINUTE) return options.formatMessage((0, $lSbhE.messages).durationInSeconds, {
                seconds: roundedSeconds
            });
            else if (roundedDurationInSeconds < ONE_HOUR) {
                if (options.largestUnitOnly || roundedSeconds === 0) return options.formatMessage((0, $lSbhE.messages).durationInMinutes, {
                    minutes: roundedMinutes
                });
                return options.formatMessage((0, $lSbhE.messages).durationInMinutesAndSeconds, {
                    minutes: roundedMinutes,
                    seconds: roundedSeconds
                });
            } else if (options.largestUnitOnly) return options.formatMessage((0, $lSbhE.messages).durationInHoursOnly, {
                hours: roundedHours
            });
            else return options.formatMessage((0, $lSbhE.messages).durationInHours, {
                hours: roundedHours,
                minutes: roundedMinutes
            });
        }
        if (roundedDurationInSeconds < ONE_MINUTE) return `${roundedSeconds} sec`;
        else if (roundedDurationInSeconds < ONE_HOUR) {
            if (options.largestUnitOnly || roundedSeconds === 0) return `${roundedMinutes} min`;
            return `${roundedMinutes} min ${roundedSeconds} sec`;
        } else if (options.largestUnitOnly) return `${roundedHours} hour`;
        else return `${roundedHours} hour ${roundedMinutes} min`;
    }
    const date = (0, $d2hGj.default)(new Date(0), durationInSeconds);
    if (durationInSeconds < ONE_HOUR) return (0, $f6RxU.default)(date, 'mm:ss');
    return (0, $f6RxU.default)(date, 'HH:mm:ss');
};
module.exports["convertVideoDuration"] = $72498c90ccdf0220$export$b0d5f79a828d791e;

});

parcelRegister("lSbhE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e3822027923e034d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    videoThumbnailAltText: {
        id: "search-graph-video.video-thumbnail-alt-text",
        defaultMessage: "Video thumbnail"
    },
    videoIconLabel: {
        id: "search-graph-video.video-icon-label",
        defaultMessage: "video icon"
    },
    dropdownMessage: {
        id: "search-graph-video.dropdown-message",
        defaultMessage: "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}"
    },
    videoType: {
        id: "search-graph-video.video-type",
        defaultMessage: "Video"
    },
    gongTopics: {
        id: "search-graph-video.gong-topics",
        defaultMessage: "{chapterCount, plural, one {# topic in this call} other {# topics in this call}}"
    },
    durationInSeconds: {
        id: "search-graph-video.duration.seconds",
        defaultMessage: "{seconds} sec"
    },
    durationInMinutes: {
        id: "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInMinutes",
        defaultMessage: "{minutes} min"
    },
    durationInMinutesAndSeconds: {
        id: "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInMinutesAndSeconds",
        defaultMessage: "{minutes} min {seconds} sec"
    },
    durationInHours: {
        id: "search-graph-video.duration.hours",
        defaultMessage: "{hours} hour {minutes} min"
    },
    durationInHoursOnly: {
        id: "search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInHoursOnly",
        defaultMessage: "{hours, plural, one {# hour} other {# hours}}"
    },
    seeAll: {
        id: "search-graph-video.see-all",
        defaultMessage: "See all"
    },
    pastMeetings: {
        id: "search-graph-video.past-meetings",
        defaultMessage: "Past meetings"
    },
    pastMeetingsUpdated: {
        id: "search-graph-video.past-meetings-updated",
        defaultMessage: "Updated {relativeTime}"
    },
    sharedLinks: {
        id: "search-graph-video.shared-links",
        defaultMessage: "Shared links"
    },
    inMeetingChat: {
        id: "search-graph-video.in-meeting-chat",
        defaultMessage: "In-Meeting Chat"
    }
});
module.exports["messages"] = $e3822027923e034d$export$defe85febe8b728c;

});

parcelRegister("hMXVq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9pcjO = parcelRequire("9pcjO");


var $32Eau = parcelRequire("32Eau");


var $1i979 = parcelRequire("1i979");


var $gDBUP = parcelRequire("gDBUP");

const $2856d9cebc408f96$export$e90e90fddddd8154 = ({ experience: experience = (0, $9pcjO.SearchExperience).SEARCH_PAGE })=>{
    const [search] = (0, $1i979.useSearch)();
    const [selectedDatasource] = (0, $1i979.useSelectedDatasource)();
    const [{ products: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs }] = (0, $32Eau.useBootstrap)();
    const currentUserId = (0, $32Eau.useCurrentUserId)();
    const { filters: filters, selectedProducts: selectedProducts, jsmIncidentFilterIds: jsmIncidentFilterIds } = search;
    return (0, $cozmU.useMemo)(()=>{
        return (0, $gDBUP.getSelectedFilters)({
            filters: filters,
            selectedProducts: selectedProducts,
            selectedDatasource: selectedDatasource,
            availableProducts: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            thirdPartyConfigs: thirdPartyConfigs,
            jsmIncidentFilterIds: jsmIncidentFilterIds,
            experience: experience,
            currentUserId: currentUserId
        });
    }, [
        filters,
        selectedProducts,
        selectedDatasource,
        products,
        allFilterExcludedProducts,
        thirdPartyConfigs,
        jsmIncidentFilterIds,
        experience,
        currentUserId
    ]);
};
module.exports["useSelectedFilters"] = $2856d9cebc408f96$export$e90e90fddddd8154;

});

parcelRegister("gDBUP", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $2khPJ = parcelRequire("2khPJ");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $hea5O = parcelRequire("hea5O");

const $e448f1dace6eee30$export$68a801b7b3c0bfaa = ({ selectedProducts: selectedProducts, availableProducts: availableProducts })=>{
    const selectedProduct = selectedProducts?.[0];
    const filteredProducts = selectedProduct ? [
        selectedProduct
    ] : availableProducts;
    return {
        selectedProduct: selectedProduct,
        filteredProducts: filteredProducts,
        availableProducts: availableProducts
    };
};



var $c3cgJ = parcelRequire("c3cgJ");


var $gkHoc = parcelRequire("gkHoc");

var $f6RxU = parcelRequire("f6RxU");

var $1xxT0 = parcelRequire("1xxT0");

/**
 * Calendar date in the user's local timezone as YYYY-MM-DD (matches backend
 * {@code ContentSearcherQueryHelper#buildSalesforceCloseDateQuery} contract).
 */ function $a46b99d3f7761005$var$toYmdLocal(d) {
    return (0, $f6RxU.default)(d, 'yyyy-MM-dd');
}
function $a46b99d3f7761005$var$startOfTodayLocal() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}
const $a46b99d3f7761005$var$ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function $a46b99d3f7761005$export$63976aebd4b36830(selectedOption, customIsoDate) {
    if (!selectedOption || selectedOption === 'anytime') return undefined;
    if (selectedOption === 'custom') {
        if (!customIsoDate || !$a46b99d3f7761005$var$ISO_DATE.test(customIsoDate)) return undefined;
        return customIsoDate;
    }
    const today = $a46b99d3f7761005$var$startOfTodayLocal();
    const tomorrow = (0, $gkHoc.default)(today, 1);
    switch(selectedOption){
        case 'today':
            return $a46b99d3f7761005$var$toYmdLocal(today);
        case 'last7days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 6))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'last30days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 29))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'last90days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 89))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'last365days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 364))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'next7days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 7))}`;
        case 'next30days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 30))}`;
        case 'next90days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 90))}`;
        case 'next365days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 365))}`;
        default:
            // Already-resolved ISO single date or range (e.g. restored from URL)
            if ($a46b99d3f7761005$var$ISO_DATE.test(selectedOption)) return selectedOption;
            if (/^\d{4}-\d{2}-\d{2}:\d{4}-\d{2}-\d{2}$/.test(selectedOption)) return selectedOption;
            return undefined;
    }
}



var $8JYuM = parcelRequire("8JYuM");


var $fuajF = parcelRequire("fuajF");


var $hggbF = parcelRequire("hggbF");

const $028e561f94414f18$var$GRAPH_DOCUMENT_ENTITY_ATI = 'ati:cloud:graph:document';
const $028e561f94414f18$export$f6546bb98204a0ca = ({ filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, availableProducts: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds, experience: experience = (0, $9pcjO.SearchExperience).SEARCH_PAGE })=>{
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $e448f1dace6eee30$export$68a801b7b3c0bfaa)({
        selectedProducts: selectedProducts,
        availableProducts: products
    });
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedTypes: selectedTypes } = (0, $fuajF.getTypeEntities)({
        availableProducts: availableProducts,
        filters: filters,
        selectedProducts: selectedProducts,
        allFilterExcludedProducts: allFilterExcludedProducts
    }, {
        thirdPartyConfigs: thirdPartyConfigs
    });
    const watchedByMeValue = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.watchedFilterId]);
    const titleMatchValue = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.titleMatchFilterId]);
    const selectedDateRange = (0, $hggbF.getSelectedDateRange)(filters[0, $8JYuM.lastUpdatedFilterId]);
    const filterDateRange = (0, $hggbF.getFilterDateRange)(filters[0, $8JYuM.lastUpdatedFilterId]);
    const commonContributors = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contributorFilterId]).length ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contributorFilterId]) : undefined;
    const pageStatusValue = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.pageStatusFilterId])[0];
    const assigneeARIValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assigneeFilterId]).map((assigneeId)=>{
        return `ari:cloud:identity::user/${assigneeId}`;
    });
    const reporterARIValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.reporterFilterId]).map((reporterId)=>{
        return `ari:cloud:identity::user/${reporterId}`;
    });
    const watcherARIValues = (watchedByMeValue && currentUserId ? [
        currentUserId
    ] : []).map((watcherId)=>{
        return `ari:cloud:identity::user/${watcherId}`;
    });
    const commenterARIValues = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.commentedByMeFilterId]) && currentUserId ? [
        `ari:cloud:identity::user/${currentUserId}`
    ] : [];
    const assignee3PValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assigneeFilterId]).map((assigneeId)=>{
        if (assigneeId.startsWith('ari:cloud:')) return (0, $2khPJ.IdentityUserAri).parse(assigneeId).resourceId;
        return assigneeId;
    });
    const isSelectedThirdPartyProduct = !!selectedProduct && (0, $dvVWp.is3pProductKey)(selectedProduct);
    const isSelectedLoomProduct = selectedProduct === (0, $dvVWp.ProductKeys).Loom;
    const selectedSpaceValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.spaceFilterId]);
    const selectedContentValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contentFilterId]);
    const confluenceOnlyValues = (values)=>isSelectedThirdPartyProduct || isSelectedLoomProduct ? [] : values;
    const thirdPartySpaceValues = selectedProduct === (0, $dvVWp.ProductKeys).GoogleDrive || selectedProduct === (0, $dvVWp.ProductKeys).Sharepoint ? selectedSpaceValues : [];
    const thirdPartyContentValues = isSelectedThirdPartyProduct ? selectedContentValues : [];
    const containerAris = [
        ...(0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.projectFilterId])
    ];
    const createdByValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.createdByFilterId]);
    const labelsValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.labelFilterId]);
    const folderValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.folderFilterId]);
    const tagValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.tagFilterId]);
    const lastUpdatedByValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.lastUpdatedByFilterId]);
    // When both the primary (space) and dependent (contentUnder) filters are selected, the backend
    // treats ancestorAris with OR logic, which would incorrectly broaden results.
    // Prefer the dependent filter when present since it is more specific; otherwise fall back to
    // the primary filter. The store handles the reverse: when the primary filter is selected after
    // the dependent, it clears the dependent so only the primary is sent.
    const ancestorAris = thirdPartyContentValues.length > 0 ? thirdPartyContentValues : thirdPartySpaceValues;
    const ownerValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]);
    const isLoomRovoSearchEnabled = isSelectedLoomProduct && (0, $iDrrr.fg)('loom-rovo-search');
    const selectedLoomVideoTypes = isLoomRovoSearchEnabled ? selectedTypes.flatMap((selectedType)=>{
        if (selectedType === (0, $7ydfN.TypeFilterValueKey).AsyncVideo) return [
            'ASYNC_VIDEO'
        ];
        if (selectedType === (0, $7ydfN.TypeFilterValueKey).MeetingRecording) return [
            'MEETING_RECORDING'
        ];
        return [];
    }) : [];
    const hasSelectedLoomNativeEntityFilter = isLoomRovoSearchEnabled && (selectedSpaceValues.length > 0 || folderValues.length > 0 || tagValues.length > 0);
    const hasSelectedNativeLoomEntity = entitiesForQuery.some((entity)=>entity.startsWith('ati:cloud:loom:'));
    // Space, folder, and tag filters only apply to Loom native entity types. When one is
    // selected without an existing native Loom entity, constrain the query to Loom videos.
    const entities = hasSelectedLoomNativeEntityFilter && !hasSelectedNativeLoomEntity ? [
        'ati:cloud:loom:video'
    ] : entitiesForQuery;
    const opportunityStatusValue = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.opportunityStatusFilterId])[0];
    const pullRequestStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.pullRequestStatusFilterId]);
    const repositoryValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.repositoryFilterId]);
    const reviewerValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.reviewerFilterId]);
    const campaignStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.campaignStatusFilterId]);
    const caseStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.caseStatusFilterId]);
    const documentStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.documentStatusFilterId]);
    const calendarTypeValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.calendarTypeFilterId]);
    const leadStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.leadStatusFilterId]);
    const taskStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.taskStatusFilterId]);
    const taskTypeValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.taskTypeFilterId]);
    const salesforceStageValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.salesforceStageFilterId]);
    const slackChannelValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.slackChannelFilterId]);
    const workspaceNameValues = (0, $iDrrr.fg)('rovo_fps_show_workspace_name_filter') ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.workspaceNameFilterId]) : [];
    const hasAttachmentValue = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.hasAttachmentFilterId]);
    const sortFilters = (0, $hggbF.getSortFilters)(filters[0, $8JYuM.sortFilterId]);
    // Get close date value for Salesforce filter
    const closeDateFilterState = filters[0, $8JYuM.closeDateFilterId];
    const closeDateSelectedOption = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.closeDateFilterId])[0];
    const closeDateCustomValue = closeDateFilterState && 'customValue' in closeDateFilterState && closeDateFilterState.customValue ? closeDateFilterState.customValue.closeDateVal : undefined;
    const salesforceCloseDate = (0, $a46b99d3f7761005$export$63976aebd4b36830)(closeDateSelectedOption, closeDateSelectedOption === 'custom' ? closeDateCustomValue : undefined);
    const isAllProductsSelected = (0, $c3cgJ.isAllProductSearch)(selectedProducts);
    const selectedFilters = {
        commonFilters: {
            range: {
                lastModified: selectedDateRange
            },
            contributorsFilter: commonContributors
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: (0, $hggbF.omitNonJiraFilterValues)((0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.projectFilterId]), selectedProduct),
                watcherARIs: (0, $hggbF.omitNonJiraFilterValues)(watcherARIValues, selectedProduct),
                assigneeARIs: (0, $hggbF.omitNonJiraFilterValues)(assigneeARIValues, selectedProduct),
                issueTypeIDs: jsmIncidentFilterIds,
                issueLabels: (0, $hggbF.omitNonJiraFilterValues)((0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.labelFilterId]), selectedProduct),
                statusCategories: (0, $hggbF.omitNonJiraFilterValues)((0, $hggbF.getJiraIssueStatusFilterOptions)(filters[0, $8JYuM.statusFilterId]), selectedProduct),
                reporterARIs: (0, $hggbF.omitNonJiraFilterValues)(reporterARIValues, selectedProduct),
                commenterARIs: (0, $hggbF.omitNonJiraFilterValues)(commenterARIValues, selectedProduct),
                issueTypes: (0, $hggbF.getSelectedJiraWorkType)(selectedTypes, selectedProduct)
            },
            projectFilter: {
                projectTypes: experience === (0, $9pcjO.SearchExperience).QUICK_FIND ? [] : (0, $hggbF.getJiraProjectFilter)(selectedProduct)
            }
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: (0, $iDrrr.fg)('assets_rovo_search_all') ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assetsSchemaFilterId]) : []
            },
            objectTypeFilter: {
                typeARIs: (0, $iDrrr.fg)('assets_rovo_search_all') ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assetsTypeFilterId]) : []
            }
        },
        confluenceFilters: {
            spacesFilter: confluenceOnlyValues(selectedSpaceValues),
            isVerified: (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.verifiedFilterId]) || undefined,
            contributorsFilter: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contributorFilterId]),
            ancestorIdsFilter: confluenceOnlyValues(selectedContentValues),
            range: selectedProduct !== (0, $dvVWp.ProductKeys).Confluence ? filterDateRange : [],
            owners: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]),
            labelsFilter: selectedProduct === (0, $dvVWp.ProductKeys).Confluence ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.labelFilterId]) : [],
            titleMatchOnly: titleMatchValue,
            ...pageStatusValue ? {
                pageStatus: [
                    pageStatusValue
                ]
            } : {},
            contentStatuses: selectedProduct === (0, $dvVWp.ProductKeys).Confluence ? (0, $hggbF.getContentStatusValue)(filters[0, $8JYuM.archivedFilterId]) : [],
            containerStatus: selectedProduct === (0, $dvVWp.ProductKeys).Confluence ? (0, $hggbF.getContainerStatusValue)(filters[0, $8JYuM.archivedFilterId]) : []
        },
        loomFilters: {
            spaceIds: isSelectedLoomProduct ? selectedSpaceValues : [],
            folderIds: isSelectedLoomProduct && (0, $iDrrr.fg)('loom-rovo-search') ? folderValues : [],
            tagNames: isSelectedLoomProduct && (0, $iDrrr.fg)('loom-rovo-search') ? tagValues : [],
            ...selectedLoomVideoTypes.length > 0 ? {
                videoTypes: selectedLoomVideoTypes
            } : {}
        },
        mercuryFilters: {
            owners: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]),
            focusAreaTypeIds: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.focusAreaTypeFilterId]),
            ancestorIds: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.focusAreaUnderFilterId])
        },
        ...(0, $iDrrr.fg)('talent_global_search') ? {
            talentFilters: {
                owners: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]),
                employmentTypes: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionEmploymentTypeFilterId]).map((value)=>decodeURIComponent(value)),
                focusAreas: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionFocusAreaFilterId]),
                jobFamilies: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionJobFamilyFilterId]).map((value)=>decodeURIComponent(value)),
                statuses: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionStatusFilterId]).map((value)=>decodeURIComponent(value)),
                teams: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionTeamFilterId])
            }
        } : {},
        compassFilters: {
            componentFilter: {
                componentStates: (0, $hggbF.getArchivedAndPendingComponentsValue)(filters[0, $8JYuM.archivedAndPendingComponentsFilterId])
            }
        },
        thirdPartyFilters: (0, $hea5O.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, assignee3PValues, containerAris, createdByValues, lastUpdatedByValues, ancestorAris, labelsValues, undefined, selectedDatasource?.datasourceId, ownerValues, salesforceStageValues, salesforceCloseDate, opportunityStatusValue, pullRequestStatusValues, repositoryValues, campaignStatusValues, caseStatusValues, slackChannelValues, hasAttachmentValue, workspaceNameValues, reviewerValues, documentStatusValues, calendarTypeValues, leadStatusValues, taskStatusValues, taskTypeValues),
        sortFilters: sortFilters
    };
    const unselectedProductsThirdPartyFilters = (0, $hea5O.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, loomFilters: loomFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, assetsFilters: assetsFilters, talentFilters: talentFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && !commonFilters.contributorsFilter && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && !confluenceFilters.titleMatchOnly && confluenceFilters.contentStatuses.length === 0 && confluenceFilters.containerStatus.length === 0 && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && (!confluenceFilters.pageStatus || confluenceFilters.pageStatus.length === 0) && (!loomFilters.spaceIds || loomFilters.spaceIds.length === 0) && (!loomFilters.folderIds || loomFilters.folderIds.length === 0) && (!loomFilters.tagNames || loomFilters.tagNames.length === 0) && (!loomFilters.videoTypes || loomFilters.videoTypes.length === 0) && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && jiraFilters.issueFilter.statusCategories.length === 0 && jiraFilters.issueFilter.reporterARIs.length === 0 && jiraFilters.issueFilter.commenterARIs.length === 0 && mercuryFilters.owners.length === 0 && jiraFilters.issueFilter.issueLabels.length === 0 && (!jiraFilters.issueFilter.issueTypes || jiraFilters.issueFilter.issueTypes?.length === 0) && mercuryFilters.owners.length === 0 && mercuryFilters.focusAreaTypeIds.length === 0 && mercuryFilters.ancestorIds.length === 0 && compassFilters.componentFilter.componentStates.length === 0 && ((0, $iDrrr.fg)('talent_global_search') ? talentFilters?.owners.length === 0 && talentFilters?.employmentTypes.length === 0 && talentFilters?.focusAreas.length === 0 && talentFilters?.jobFamilies.length === 0 && talentFilters?.statuses.length === 0 && talentFilters?.teams.length === 0 : true) && ((0, $iDrrr.fg)('assets_rovo_search_all') ? assetsFilters.objectSchemaFilter.schemaARIs.length === 0 && assetsFilters.objectTypeFilter.typeARIs.length === 0 : true) && (!thirdPartyFilters.range || Object.keys(thirdPartyFilters.range).length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0 && (!thirdPartyFilters.assignees || thirdPartyFilters.assignees?.length === 0) && (!thirdPartyFilters.lastUpdatedBy || thirdPartyFilters.lastUpdatedBy?.length === 0) && (!thirdPartyFilters.createdBy || thirdPartyFilters.createdBy?.length === 0) && (!thirdPartyFilters.ancestorAris || thirdPartyFilters.ancestorAris?.length === 0) && (!thirdPartyFilters.containerAris || thirdPartyFilters.containerAris?.length === 0) && (!thirdPartyFilters.salesforceFilters?.stage || thirdPartyFilters.salesforceFilters.stage.length === 0) && (!thirdPartyFilters.salesforceFilters?.owners || thirdPartyFilters.salesforceFilters.owners.length === 0) && !thirdPartyFilters.salesforceFilters?.closeDate && (!thirdPartyFilters.salesforceFilters?.campaignStatuses || thirdPartyFilters.salesforceFilters.campaignStatuses.length === 0) && (!thirdPartyFilters.salesforceFilters?.caseStatuses || thirdPartyFilters.salesforceFilters.caseStatuses.length === 0) && (!thirdPartyFilters.salesforceFilters?.knowledgeArticlePublishStatuses || thirdPartyFilters.salesforceFilters.knowledgeArticlePublishStatuses.length === 0) && (!thirdPartyFilters.gitFilters?.pullRequestStatus || thirdPartyFilters.gitFilters.pullRequestStatus.length === 0) && (!thirdPartyFilters.gitFilters?.repoName || thirdPartyFilters.gitFilters.repoName.length === 0) && !thirdPartyFilters.teamsFilters?.hasAttachment && !thirdPartyFilters.thirdPartyProducts?.some((p)=>p.product === 'slack' && p.channels && p.channels.length > 0);
    // Federated email is served through the federated graph scope, which the aggregator only enters
    // when a graph entity is requested. A Gmail / Outlook product search only has the email ATI, so add
    // the graph document ATI there. It is only added when every third-party product in the request is
    // email: otherwise (e.g. all apps with a type filter) it would widen other products' results, and
    // those requests already carry other graph entities. `selectedEntities` and
    // `entitiesForResultsCountQuery` are intentionally left unchanged.
    const isFederatedEmailOnlyRequest = !!thirdPartyFilters.thirdPartyProducts?.length && thirdPartyFilters.thirdPartyProducts.every((p)=>p.product === (0, $dvVWp.ProductKeys).Gmail || p.product === (0, $dvVWp.ProductKeys).OutlookMail);
    const entitiesForRequest = isFederatedEmailOnlyRequest && !entities.includes($028e561f94414f18$var$GRAPH_DOCUMENT_ENTITY_ATI) ? [
        ...entities,
        $028e561f94414f18$var$GRAPH_DOCUMENT_ENTITY_ATI
    ] : entities;
    return {
        selectedFilters: selectedFilters,
        unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
        selectedEntities: selectedEntities,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        entities: entitiesForRequest,
        hasFiltersSelected: !isEmpty
    };
};
module.exports["getSelectedFilters"] = $028e561f94414f18$export$f6546bb98204a0ca;

});

parcelRegister("hggbF", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $l9zYm = parcelRequire("l9zYm");


var $c9Etd = parcelRequire("c9Etd");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $gNJMT = parcelRequire("gNJMT");


var $i5kPq = parcelRequire("i5kPq");


var $dzatQ = parcelRequire("dzatQ");


var $jbIQp = parcelRequire("jbIQp");


var $kSwu1 = parcelRequire("kSwu1");

const $9ea5e96d5d9820f0$export$c054401256af44b9 = '[System] Incident';
const $9ea5e96d5d9820f0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    incident: {
        id: "search-client.jira.issue.incident.label",
        defaultMessage: "[System] Incident"
    }
});


const $635420a0a67bc45f$export$1c47b2cd6d3f5b5a = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT'
    ]
};
const $635420a0a67bc45f$export$7069271803c33dc3 = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT',
        'DRAFT'
    ]
};
const $635420a0a67bc45f$export$a240a4826113d43 = (filter)=>{
    const archivedContentOption = $635420a0a67bc45f$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $635420a0a67bc45f$export$7069271803c33dc3['showArchived'] : $635420a0a67bc45f$export$7069271803c33dc3['showCurrent'];
};
const $635420a0a67bc45f$export$b934b4f495e2c091 = (filter)=>{
    const archivedContentOption = $635420a0a67bc45f$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $635420a0a67bc45f$export$1c47b2cd6d3f5b5a['showArchived'] : $635420a0a67bc45f$export$1c47b2cd6d3f5b5a['showCurrent'];
};
const $635420a0a67bc45f$export$fa0dcd7cda441845 = (filter)=>{
    const archivedContentOption = $635420a0a67bc45f$export$49b41db8fadc5da(filter);
    return archivedContentOption ? [
        'ACTIVE',
        'PENDING',
        'ARCHIVED'
    ] : [];
};
const $635420a0a67bc45f$export$ba6044efb2e123e9 = {
    [(0, $dvVWp.ProductKeys).Jira]: [
        'software',
        'business'
    ],
    [(0, $dvVWp.ProductKeys).JiraProductDiscovery]: [
        'product_discovery'
    ],
    [(0, $dvVWp.ProductKeys).JiraServiceManagement]: [
        'service_desk'
    ],
    [(0, $dvVWp.ProductKeys).CustomerServiceManagement]: [
        'customer_service'
    ]
};
const $635420a0a67bc45f$export$e1f376159111dbe6 = (filterValues, selectedProduct)=>{
    // when all products are searched
    if (!selectedProduct) // don't return any values in all product selected mode for assignee and project filters
    return [];
    switch(selectedProduct){
        case (0, $dvVWp.ProductKeys).Jira:
        case (0, $dvVWp.ProductKeys).JiraProductDiscovery:
        case (0, $dvVWp.ProductKeys).JiraServiceManagement:
        case (0, $dvVWp.ProductKeys).CustomerServiceManagement:
            return filterValues;
    }
    return [];
};
const $635420a0a67bc45f$export$5c4691ac7ffb1183 = 'DUMMY_JIRA_ISSUE_TYPE_ID';
const $635420a0a67bc45f$export$4df832a1d124a3d4 = async (cloudId, intl, issueType, activationId, primaryProduct)=>{
    if (!cloudId) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const searchString = intl.formatMessage((0, $9ea5e96d5d9820f0$export$defe85febe8b728c)[issueType]);
    const issueTypes = await (0, $l9zYm.jiraIssueTypeJQLQuery)(cloudId, searchString, headers);
    const ids = issueTypes?.data?.jira.jqlBuilder.fieldValues.edges;
    if (!ids || ids.length === 0) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
    if (ids.length > 1) {
        const issueTypeNode = ids.find((id)=>id.node?.displayName === searchString);
        if (!issueTypeNode) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
        const issueType = issueTypeNode.node?.issueTypes[0];
        return issueType && issueType.issueTypeId ? issueType.issueTypeId : $635420a0a67bc45f$export$5c4691ac7ffb1183;
    } else {
        const node = ids[0].node;
        if (!node) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
        return node.issueTypes[0].issueTypeId || $635420a0a67bc45f$export$5c4691ac7ffb1183;
    }
};
const $635420a0a67bc45f$export$75ec3b8bb22cb14f = (filter)=>{
    return (0, $jbIQp.isSelectFilter)(filter?.type) ? filter.value : [];
};
const $635420a0a67bc45f$export$1800e9d06ef0f63b = (filter)=>{
    return (0, $jbIQp.isSelectFilter)(filter?.type) ? filter.customValue : {};
};
const $635420a0a67bc45f$export$49b41db8fadc5da = (filter)=>{
    return filter?.type === 'boolean' ? filter.value : false;
};
const $635420a0a67bc45f$export$7efdc6b7aa39e72a = (filter)=>{
    const selectedDateOption = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $c9Etd.CUSTOM_OPTION_VALUE)) return (0, $dzatQ.convertLastUpdatedToDateRange)(selectedDateOption);
    else if (selectedDateOption === (0, $c9Etd.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $635420a0a67bc45f$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from || customDateRange?.to) return (0, $gNJMT.convertCustomDateToRange)(customDateRange.from, customDateRange.to);
    }
    return;
};
const $635420a0a67bc45f$export$9ec55eff3923c72 = (filter)=>{
    const selectedDateOption = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $c9Etd.CUSTOM_OPTION_VALUE)) return [
        (0, $dzatQ.getConfluenceDateOptionValues)(selectedDateOption)
    ];
    else if (selectedDateOption === (0, $c9Etd.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $635420a0a67bc45f$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from && customDateRange?.to) return [
            (0, $dzatQ.getConfluenceDateOptionFromCustomDates)(customDateRange.from, customDateRange.to)
        ];
    }
    return [];
};
const $635420a0a67bc45f$export$ac0baabacf9504ae = (selectedProduct)=>{
    if (!selectedProduct) return []; // In the BE, it will target all Jira products if the array is empty
    switch(selectedProduct){
        case (0, $dvVWp.ProductKeys).Jira:
        case (0, $dvVWp.ProductKeys).JiraProductDiscovery:
        case (0, $dvVWp.ProductKeys).JiraServiceManagement:
        case (0, $dvVWp.ProductKeys).CustomerServiceManagement:
            return $635420a0a67bc45f$export$ba6044efb2e123e9[selectedProduct];
    }
    return [];
};
const $635420a0a67bc45f$export$b8e499230f5115d8 = {
    [(0, $7ydfN.TypeFilterValueKey).Epic]: 'Epic',
    [(0, $7ydfN.TypeFilterValueKey).Bug]: 'Bug',
    [(0, $7ydfN.TypeFilterValueKey).Story]: 'Story',
    [(0, $7ydfN.TypeFilterValueKey).Task]: 'Task',
    [(0, $7ydfN.TypeFilterValueKey).Subtask]: 'Subtask'
};
const $635420a0a67bc45f$export$f548e13b50401f80 = (selectedType, selectedProduct)=>{
    const hasSelectedProductThatIsNotJira = Boolean(selectedProduct) && selectedProduct !== (0, $dvVWp.ProductKeys).Jira;
    if (hasSelectedProductThatIsNotJira || selectedType.length === 0) return [];
    return selectedType.flatMap((typeOption)=>{
        const workType = $635420a0a67bc45f$export$b8e499230f5115d8[typeOption];
        return workType ? [
            workType
        ] : [];
    });
};
const $635420a0a67bc45f$export$7dcf1656cd04caad = [
    'OPEN',
    'NEW',
    'INDETERMINATE',
    'DONE',
    'UNDEFINED'
];
const $635420a0a67bc45f$export$5f47ad4f5e0267c4 = (filter)=>{
    const filterValues = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter);
    const appliedFilterOptions = filterValues.flatMap((filtervalue)=>{
        const filterOptions = $635420a0a67bc45f$export$7dcf1656cd04caad.filter((status)=>status !== 'OPEN').find((allowedValue)=>filtervalue === allowedValue);
        return filterOptions ? [
            filterOptions
        ] : [];
    });
    return appliedFilterOptions;
};
const $635420a0a67bc45f$export$97dd8d7ab50aafbd = (filter)=>{
    const selectedSortOption = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter)[0];
    return (0, $i5kPq.convertSortToFilter)(selectedSortOption);
};
module.exports["getContentStatusValue"] = $635420a0a67bc45f$export$a240a4826113d43;
module.exports["getBooleanFilterValue"] = $635420a0a67bc45f$export$49b41db8fadc5da;
module.exports["getContainerStatusValue"] = $635420a0a67bc45f$export$b934b4f495e2c091;
module.exports["getArchivedAndPendingComponentsValue"] = $635420a0a67bc45f$export$fa0dcd7cda441845;
module.exports["JiraProductProjectFilterKey"] = $635420a0a67bc45f$export$ba6044efb2e123e9;
module.exports["omitNonJiraFilterValues"] = $635420a0a67bc45f$export$e1f376159111dbe6;
module.exports["getJiraIssueTypesFilter"] = $635420a0a67bc45f$export$4df832a1d124a3d4;
module.exports["getSelectFilterValue"] = $635420a0a67bc45f$export$75ec3b8bb22cb14f;
module.exports["getSelectedDateRange"] = $635420a0a67bc45f$export$7efdc6b7aa39e72a;
module.exports["getFilterDateRange"] = $635420a0a67bc45f$export$9ec55eff3923c72;
module.exports["getJiraProjectFilter"] = $635420a0a67bc45f$export$ac0baabacf9504ae;
module.exports["getSelectedJiraWorkType"] = $635420a0a67bc45f$export$f548e13b50401f80;
module.exports["allowedJiraIssueStatuses"] = $635420a0a67bc45f$export$7dcf1656cd04caad;
module.exports["getJiraIssueStatusFilterOptions"] = $635420a0a67bc45f$export$5f47ad4f5e0267c4;
module.exports["getSortFilters"] = $635420a0a67bc45f$export$97dd8d7ab50aafbd;

});

parcelRegister("l9zYm", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $e0b09446cd765a75$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME = 'SearchPageJiraIssueTypeQuery';
const $e0b09446cd765a75$var$jqlIssueTypeQueryString = `query ${$e0b09446cd765a75$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME}(
	$cloudId: ID!,
	$first: Int = 10,
	$jqlTerm: String!,
	$jql: String!,
	$searchString: String!) {
		jira {
			jqlBuilder(cloudId: $cloudId) {
				fieldValues (
					first: $first
					jqlTerm: $jqlTerm
					jqlContext: $jql
					searchString: $searchString
				) {
					edges {
						node {
							displayName
							... on JiraJqlIssueTypeFieldValue {
								issueTypes {
									issueTypeId
								}
							}
						}
					}
          		}
			}
		}
	}`;
const $e0b09446cd765a75$export$bd7a9ccdb07f26a6 = (0, $bHHWv.inMemoryCache)();
const $e0b09446cd765a75$export$299504e13b0b41d4 = async (cloudId, searchString, headers)=>{
    return $e0b09446cd765a75$export$bd7a9ccdb07f26a6.inMemoryDecorator(`${cloudId}-${searchString}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $e0b09446cd765a75$var$jqlIssueTypeQueryString,
            variables: {
                cloudId: cloudId,
                jqlTerm: 'type',
                searchString: searchString,
                jql: ''
            },
            operationName: $e0b09446cd765a75$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'JiraJqlBuilder',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["jiraIssueTypeJQLQuery"] = $e0b09446cd765a75$export$299504e13b0b41d4;

});

parcelRegister("c9Etd", function(module, exports) {
const $701404cfc7d9161d$export$5ef321009a5b450c = 'custom';
const $701404cfc7d9161d$export$62fed45313a13eff = 'universalTypeFilter';
module.exports["CUSTOM_OPTION_VALUE"] = $701404cfc7d9161d$export$5ef321009a5b450c;
module.exports["universalTypeFilterId"] = $701404cfc7d9161d$export$62fed45313a13eff;

});

parcelRegister("gNJMT", function(module, exports) {
const $e31d6ff2cb09b363$export$79cd775d0d5c2a2 = (from, to)=>{
    const fromDate = from ? new Date(from) : new Date();
    const startOfTheFromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
    const toDate = to ? new Date(to) : new Date();
    const endOfTheToDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999);
    return {
        gt: from ? startOfTheFromDate.toISOString().split('Z')[0] : undefined,
        lt: to ? endOfTheToDate.toISOString().split('Z')[0] : undefined
    };
};
module.exports["convertCustomDateToRange"] = $e31d6ff2cb09b363$export$79cd775d0d5c2a2;

});

parcelRegister("i5kPq", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $3yJeH = parcelRequire("3yJeH");


var $cZKQq = parcelRequire("cZKQq");

const $2d612f146acf804b$export$5b3e7019b3acc145 = (value)=>{
    switch(value){
        case (0, $cZKQq.Sort).Relevance:
            return [];
        case (0, $cZKQq.Sort).UpdatedNewest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).DESC
                }
            ];
        case (0, $cZKQq.Sort).UpdatedOldest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).ASC
                }
            ];
        case (0, $cZKQq.Sort).CreatedNewest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).DESC
                }
            ];
        case (0, $cZKQq.Sort).CreatedOldest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).ASC
                }
            ];
        default:
            return [];
    }
};
module.exports["convertSortToFilter"] = $2d612f146acf804b$export$5b3e7019b3acc145;

});

parcelRegister("dzatQ", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $gNJMT = parcelRequire("gNJMT");


var $eIazx = parcelRequire("eIazx");


const $2ee72c5a01a78f84$export$50da93f10cdc6a84 = (lastUpdated)=>{
    let dateRangeValues;
    switch(lastUpdated){
        case 'today':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(0, 0);
            break;
        case 'yesterday':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(1, 1);
            break;
        case 'past7Days':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(7, 0);
            break;
        case 'past30Days':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(30, 0);
            break;
        case 'pastYear':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(365, 0);
            break;
        default:
            dateRangeValues = {
                gt: '',
                lt: ''
            };
    }
    return dateRangeValues;
};
const $2ee72c5a01a78f84$export$e048252fb7949a77 = (from, to)=>{
    const { gt: gt, lt: lt } = (0, $gNJMT.convertCustomDateToRange)(from, to);
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $2ee72c5a01a78f84$export$405f2efecb6f5de6 = (selectedDateOption)=>{
    const dateRangeValues = $2ee72c5a01a78f84$export$50da93f10cdc6a84(selectedDateOption);
    const { gt: gt, lt: lt } = dateRangeValues;
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
module.exports["convertLastUpdatedToDateRange"] = $2ee72c5a01a78f84$export$50da93f10cdc6a84;
module.exports["getConfluenceDateOptionFromCustomDates"] = $2ee72c5a01a78f84$export$e048252fb7949a77;
module.exports["getConfluenceDateOptionValues"] = $2ee72c5a01a78f84$export$405f2efecb6f5de6;

});

parcelRegister("eIazx", function(module, exports) {
// considering the user's locale-based definition of start OR end of day
const $7b8c0c52f4503ae1$export$8db446d8af54b4b5 = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        gt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        lt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
module.exports["getUTCDateRange"] = $7b8c0c52f4503ae1$export$8db446d8af54b4b5;

});

parcelRegister("3t6NJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $12a09c41d3bbe130$var$SearchUseCaseIdContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $12a09c41d3bbe130$export$90b29e4e818768c5 = ({ children: children, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12a09c41d3bbe130$var$SearchUseCaseIdContext.Provider, {
        value: value
    }, children);
const $12a09c41d3bbe130$export$78e5b7b05e8cd8c3 = ()=>{
    const useCaseId = (0, $cozmU.useContext)($12a09c41d3bbe130$var$SearchUseCaseIdContext);
    if (useCaseId === undefined) throw new Error('SearchUseCaseIdProvider is required');
    return useCaseId;
};
module.exports["SearchUseCaseIdProvider"] = $12a09c41d3bbe130$export$90b29e4e818768c5;
module.exports["useSearchUseCaseId"] = $12a09c41d3bbe130$export$78e5b7b05e8cd8c3;

});

parcelRegister("8D0XM", function(module, exports) {

var $8N8EQ = parcelRequire("8N8EQ");


var $hnyex = parcelRequire("hnyex");

const $cbff08791821dd53$export$b551db3ea2671aa7 = (taskId, taskName, searchSessionId, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName,
        searchSessionId: searchSessionId
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent((0, $hnyex.onTaskStart)({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent((0, $hnyex.onTaskSuccess)({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent((0, $hnyex.onTaskFail)({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};
module.exports["createVitalStatsNetworkCallbacks"] = $cbff08791821dd53$export$b551db3ea2671aa7;

});

parcelRegister("emjGn", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $8N8EQ = parcelRequire("8N8EQ");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $11a667c9caf33b52$export$6635638df40163e1 = 'quick-find-recent-activities';


/* eslint-disable @atlaskit/platform/no-module-level-eval */ 
var $iDrrr = parcelRequire("iDrrr");

const $bac41c75ad7043f0$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$ConfluenceSlideFragment = `
  fragment ConfluenceSlideFragment on ConfluenceSlide {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $bac41c75ad7043f0$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $bac41c75ad7043f0$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
		issue @include(if: $includeJiraIssueMetadata) {
			projectField {
				project {
					name
				}
			}
			issueTypeField {
				issueType {
					name
				}
			}
		}
  }
`;
const $bac41c75ad7043f0$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    statusCategory {
      name,
      colorName
    }
    issueType {
      avatar {
        small
      }
    }
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$bac41c75ad7043f0$var$JiraSingleIssueLineTextFieldFragment}
`;
const $bac41c75ad7043f0$var$GraphDocumentFragment = `
  fragment GraphDocumentFragment on ExternalDocument {
    id
    type {
        category
    }
    displayName
    parent @optIn(to: "ExternalDataDepotQueryV2"){
        ... on ExternalDocument {
            displayName
        }
    }
    url
    provider {
        providerId
    }
  }
`;
const $bac41c75ad7043f0$var$GraphRemoteLinkFragment = `
  fragment GraphRemoteLinkFragment on ExternalRemoteLink {
	  id
		displayName
		category @optIn(to: "ExternalDataDepotQueryV2")
		url
    provider {
			providerId
		}
  }
`;
const $bac41c75ad7043f0$var$LoomVideoFragment = `
  fragment LoomVideoFragment on LoomVideo {
    name
    loomUrl: url
    owner @include(if: $includeLoomVideoMetadata) {
      name
    }
    playableDuration @include(if: $includeLoomVideoMetadata)
  }
`;
const $bac41c75ad7043f0$var$ExternalPullRequestFragment = `
  fragment ExternalPullRequestFragment on ExternalPullRequest {
    id
    displayName
    url
    status
    provider {
      providerId
    }
  }
`;
const $bac41c75ad7043f0$var$ExternalWorkItemFragment = `
  fragment ExternalWorkItemFragment on ExternalWorkItem {
    id
    displayName
    url
    workItemStatus: status
    provider {
      providerId
    }
  }
`;
const $bac41c75ad7043f0$var$AssetsObjectFragment = `
  fragment AssetsObjectFragment on AssetsObject {
    id
		displayTypename @optIn(to: "AssetsApFields")
    links {
      web
    }
    assetsLabel: label
    objectKey
    assetsIcon: avatar {
      url48
    }
    objectType {
      schema {
        name
        ${(0, $iDrrr.fg)('cdm_ga') ? `assetsSchemaDisplayName: displayName` : ''}
      }
    }
  }
`;
const $bac41c75ad7043f0$var$AssetsObjectTypeFragment = `
fragment AssetsObjectTypeFragment on AssetsObjectType {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
	${(0, $iDrrr.fg)('cdm_ga') ? `assetsDisplayName: displayName` : ''}
	assetsIcon: icon {
		url48
	}
	schema {
		assetsSchemaName: name
		${(0, $iDrrr.fg)('cdm_ga') ? `assetsSchemaDisplayName: displayName` : ''}
	}
}
`;
const $bac41c75ad7043f0$var$AssetsSchemaFragment = `
fragment AssetsSchemaFragment on AssetsSchema {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
	${(0, $iDrrr.fg)('cdm_ga') ? `assetsDisplayName: displayName` : ''}
}
`;
const $bac41c75ad7043f0$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $bac41c75ad7043f0$export$8a781e50bcd90a75 = `
  query ${$bac41c75ad7043f0$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $filteredEventTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
    $after: String
    $includeJiraIssueMetadata: Boolean = false
    $includeLoomVideoMetadata: Boolean = false
    $includeSearchAppMetadata: Boolean = false
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
              eventTypes: $filteredEventTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
          after: $after
        ) {
          __typename
          edges {
            cursor
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                contributors @include(if: $includeSearchAppMetadata) {
                  profile {
                    accountId
                    name
                    picture
                  }
                }
                data {
                  __typename
                  ... on JiraIssue {
                    statusField @include(if: $includeSearchAppMetadata) {
                      status {
                        name
                        statusCategory {
                          mercuryName
                        }
                      }
                    }
                  }
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...ConfluenceSlideFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                  ...GraphDocumentFragment
									...GraphRemoteLinkFragment
									...LoomVideoFragment
									...ExternalPullRequestFragment
									...ExternalWorkItemFragment
                  ${(0, $iDrrr.fg)('assets_rovo_search_all') ? `...AssetsObjectFragment` : ''}
									${(0, $iDrrr.fg)('assets_rovo_search_all') ? `...AssetsObjectTypeFragment` : ''}
									${(0, $iDrrr.fg)('assets_rovo_search_all') ? `...AssetsSchemaFragment` : ''}
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$bac41c75ad7043f0$var$ConfluencePageFragment}
  ${$bac41c75ad7043f0$var$ConfluenceBlogPostFragment}
  ${$bac41c75ad7043f0$var$ConfluenceWhiteboardFragment}
  ${$bac41c75ad7043f0$var$ConfluenceSlideFragment}
  ${$bac41c75ad7043f0$var$AtlasProjectFragment}
  ${$bac41c75ad7043f0$var$AtlasGoalFragment}
  ${$bac41c75ad7043f0$var$JiraIssueFragment}
  ${$bac41c75ad7043f0$var$GraphDocumentFragment}
	${$bac41c75ad7043f0$var$GraphRemoteLinkFragment}
	${$bac41c75ad7043f0$var$LoomVideoFragment}
	${$bac41c75ad7043f0$var$ExternalPullRequestFragment}
	${$bac41c75ad7043f0$var$ExternalWorkItemFragment}
  ${(0, $iDrrr.fg)('assets_rovo_search_all') ? $bac41c75ad7043f0$var$AssetsObjectFragment : ''}
	${(0, $iDrrr.fg)('assets_rovo_search_all') ? $bac41c75ad7043f0$var$AssetsObjectTypeFragment : ''}
	${(0, $iDrrr.fg)('assets_rovo_search_all') ? $bac41c75ad7043f0$var$AssetsSchemaFragment : ''}
`;


const $39e3e5eb4404f224$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, networkCallbacks: networkCallbacks })=>{
    networkCallbacks?.onStart();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $bac41c75ad7043f0$export$8a781e50bcd90a75),
        operationName: $bac41c75ad7043f0$export$5db520940cf00715,
        headers: headers
    }).then((result)=>{
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(result);
        networkCallbacks?.onSuccess(traceInfo);
        return result;
    }, (error)=>{
        networkCallbacks?.onError(error?.name || 'UnknownError', error?.message || 'An unknown error occurred');
        throw error;
    });
};
const { refreshOnAccessDecorator: $39e3e5eb4404f224$var$refreshOnAccessDecoratorRecentActivities, clear: $39e3e5eb4404f224$var$clearRecentActivitiesCache } = (0, $fyjce.promiseCache)({
    name: (0, $11a667c9caf33b52$export$6635638df40163e1)
});
const $39e3e5eb4404f224$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $39e3e5eb4404f224$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $39e3e5eb4404f224$export$ffce414fbab0f879 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks })=>{
    const cacheKey = (0, $bZF61.generateHash)(`${(0, $11a667c9caf33b52$export$6635638df40163e1)}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $39e3e5eb4404f224$var$refreshOnAccessDecoratorRecentActivities({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $39e3e5eb4404f224$var$refreshOnAccessDecoratorRecentActivities({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await (0, $b0Mpu.fetchAgg)({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    graphQuery: (0, $bac41c75ad7043f0$export$8a781e50bcd90a75),
                    operationName: $bac41c75ad7043f0$export$5db520940cf00715,
                    headers: headers
                });
                writeBackWithTTL(result, $39e3e5eb4404f224$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $39e3e5eb4404f224$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired,
        analyticsCallback: analyticsCallback,
        networkCallbacks: networkCallbacks
    });
};
const $39e3e5eb4404f224$export$b0de6826751f4fe0 = ({ variables: variables, graphQuery: graphQuery, aggAbsoluteUrl: aggAbsoluteUrl, operationName: operationName, headers: headers })=>{
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: operationName,
        headers: headers
    });
};
const $39e3e5eb4404f224$export$a13e8bf43a8d56c7 = (key)=>$39e3e5eb4404f224$var$clearRecentActivitiesCache(key);
module.exports["recentActivitiesQuery"] = $39e3e5eb4404f224$export$ba6bff93c920ff4a;
module.exports["cachedRecentActivitiesQuery"] = $39e3e5eb4404f224$export$ffce414fbab0f879;

});

parcelRegister("9AIBu", function(module, exports) {
const $809f2bf065d723e6$export$80900e9d9f3bb70f = (thirdPartyConfigs)=>Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
module.exports["isEligibleFor3PClickIngestion"] = $809f2bf065d723e6$export$80900e9d9f3bb70f;

});

parcelRegister("6h661", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");

const $313e4b4bb95fb0d7$export$194e5f2c2ebfcf47 = 'quick-find-dialog';
const $313e4b4bb95fb0d7$export$954ad19cca7aaecd = 'quick-find-open';
const $313e4b4bb95fb0d7$export$d73367afdae3e8ef = 'quick-find-close';
const $313e4b4bb95fb0d7$export$529299d30909140a = 'quick-find-post-query';
const $313e4b4bb95fb0d7$export$b1255d59856835f2 = 'quick-find-loading';
const $313e4b4bb95fb0d7$export$90774abdf51eb445 = [
    (0, $3Ydx7.PrimaryProductKeys).Confluence,
    (0, $3Ydx7.PrimaryProductKeys).Jira,
    (0, $3Ydx7.PrimaryProductKeys).Assets,
    (0, $3Ydx7.PrimaryProductKeys).RovoExtension,
    (0, $3Ydx7.PrimaryProductKeys).Talent,
    (0, $3Ydx7.PrimaryProductKeys).Loom
];
const $313e4b4bb95fb0d7$export$4551c7df8148d8af = 'atlassian.search-dialog.ai-dialog.referrer';
const $313e4b4bb95fb0d7$export$fffb71ae1a2b6d2f = 2;
module.exports["SEARCH_DIALOG_WIDTH_OBSERVER_ID"] = $313e4b4bb95fb0d7$export$194e5f2c2ebfcf47;
module.exports["QUICK_FIND_OPEN_INTERACTION"] = $313e4b4bb95fb0d7$export$954ad19cca7aaecd;
module.exports["QUICK_FIND_CLOSE_INTERACTION"] = $313e4b4bb95fb0d7$export$d73367afdae3e8ef;
module.exports["QUICK_FIND_POST_QUERY_INTERACTION"] = $313e4b4bb95fb0d7$export$529299d30909140a;
module.exports["QUICK_FIND_LOADING_HOLD"] = $313e4b4bb95fb0d7$export$b1255d59856835f2;
module.exports["PRODUCTS_WITH_INLINE_FILTERS"] = $313e4b4bb95fb0d7$export$90774abdf51eb445;
module.exports["SEARCH_DIALOG_AI_DIALOG_REFERER_KEY"] = $313e4b4bb95fb0d7$export$4551c7df8148d8af;
module.exports["DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT"] = $313e4b4bb95fb0d7$export$fffb71ae1a2b6d2f;

});

parcelRegister("cHss8", function(module, exports) {
/**
 * Generic builder for the `ml_lens` envelope that lets the ML Lens transformer
 * split a single GASv3 event into one metric per logical dimension (e.g. one
 * metric per product/connector).
 *
 * See: https://hello.atlassian.net/wiki/spaces/~93171358/pages/6820686403/
 *   GASv3+Events+Transformation+for+ML+Lens+Metrics+Schema
 *
 * This module is intentionally domain-agnostic: callers provide the namespace,
 * the metric-set base tags and the list of metrics. Surface-specific helpers
 * (e.g. Quick Find post-query, Full Page Search results) live alongside this
 * file and delegate to {@link buildMlLensEnvelope}.
 */ const $6bdcec8d8e221cf0$export$aaa5dab2f0c84de8 = ({ namespace: namespace, baseTags: baseTags, metrics: metrics, userId: userId })=>{
    if (!userId) return null;
    if (metrics.length === 0) return null;
    return {
        version: '1',
        metric_sets: [
            {
                namespace: namespace,
                tags: {
                    ...baseTags,
                    user_id: userId
                },
                metrics: metrics
            }
        ]
    };
};
module.exports["buildMlLensEnvelope"] = $6bdcec8d8e221cf0$export$aaa5dab2f0c84de8;

});

parcelRegister("fnx12", function(module, exports) {
const $783d3b233540dfe9$export$52f97816f69502ce = 'atl-edge-region-hint';
function $783d3b233540dfe9$export$ef0639c0600b3b26(primaryProduct, productDataRegions) {
    const primaryProductDataRegion = primaryProduct ? productDataRegions[primaryProduct]?.[0] : undefined;
    const confluenceDataRegion = productDataRegions['confluence']?.[0];
    const jiraDataRegion = productDataRegions['jira']?.[0];
    const firstDataRegion = Object.entries(productDataRegions)[0]?.[0];
    return primaryProductDataRegion ?? confluenceDataRegion ?? jiraDataRegion ?? firstDataRegion;
}
module.exports["EDGE_REGION_HINT_HEADER"] = $783d3b233540dfe9$export$52f97816f69502ce;
module.exports["getEdgeRegionHint"] = $783d3b233540dfe9$export$ef0639c0600b3b26;

});

parcelRegister("7ohhA", function(module, exports) {
const $fd6591e4d2b3206e$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $fd6591e4d2b3206e$export$c28231fcae6448eb;

});

parcelRegister("fM05T", function(module, exports) {

var $6dPGs = parcelRequire("6dPGs");

const $2bcec8fe5bd92ace$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $2bcec8fe5bd92ace$export$c1b7badf23670c19 = 50;
const $2bcec8fe5bd92ace$export$98712b4e855f892c = (item)=>typeof item === 'string' ? {
        query: item
    } : item;
const $2bcec8fe5bd92ace$export$74e99d9695eabee6 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $6dPGs.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[productId]) userSearches[productId] = [];
    let productSearches = userSearches[productId];
    // Normalize the value: if it's a string, trim it; if it's an object, trim the query
    const normalizedValue = typeof value === 'string' ? value.trim() : {
        ...value,
        query: value.query.trim()
    };
    // Pop the last value of the array if it is too long
    if (productSearches.length === $2bcec8fe5bd92ace$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate (based on query), remove it from the array
    const { query: normalizedQuery } = $2bcec8fe5bd92ace$export$98712b4e855f892c(normalizedValue);
    productSearches = productSearches.filter((v)=>$2bcec8fe5bd92ace$export$98712b4e855f892c(v).query !== normalizedQuery);
    productSearches.unshift(normalizedValue);
    recentSearches[userId][productId] = productSearches;
    (0, $6dPGs.setLocalStorageItem)(key, JSON.stringify(recentSearches));
};
const $2bcec8fe5bd92ace$export$1216255791599668 = ({ userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $6dPGs.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[productId] || [];
};
const $2bcec8fe5bd92ace$export$6adb2cc1366d1e30 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $6dPGs.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][productId]) return [];
    const { query: queryToRemove } = $2bcec8fe5bd92ace$export$98712b4e855f892c(value);
    recentSearches[userId][productId] = recentSearches[userId][productId].filter((v)=>$2bcec8fe5bd92ace$export$98712b4e855f892c(v).query !== queryToRemove);
    (0, $6dPGs.setLocalStorageItem)(key, JSON.stringify(recentSearches));
    return recentSearches[userId][productId];
};
module.exports["RECENT_SEARCH_KEY"] = $2bcec8fe5bd92ace$export$ec4722d39a5031c0;
module.exports["getRecentQueryObject"] = $2bcec8fe5bd92ace$export$98712b4e855f892c;
module.exports["addRecentSearch"] = $2bcec8fe5bd92ace$export$74e99d9695eabee6;
module.exports["getRecentSearches"] = $2bcec8fe5bd92ace$export$1216255791599668;
module.exports["removeRecentSearch"] = $2bcec8fe5bd92ace$export$6adb2cc1366d1e30;

});

parcelRegister("50CxG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $7zn5c = parcelRequire("7zn5c");


var $3ZYG5 = parcelRequire("3ZYG5");


var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $cJff5 = parcelRequire("cJff5");


var $9NmsO = parcelRequire("9NmsO");


var $3Ydx7 = parcelRequire("3Ydx7");




const $809a409e9024e632$export$a75feafd6c41cba5 = (features, primaryProduct)=>{
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira && (0, $cJff5.shouldShowRefreshedFilterRow)(primaryProduct)) return {
        ...features,
        lite: {
            ...features?.lite,
            enabled: true
        }
    };
    return features;
};



var $fq2CX = parcelRequire("fq2CX");





var $iDrrr = parcelRequire("iDrrr");


var $7SkLu = parcelRequire("7SkLu");


var $hCtla = parcelRequire("hCtla");


var $AgYeH = parcelRequire("AgYeH");


var $kQgL7 = parcelRequire("kQgL7");


var $dv1ov = parcelRequire("dv1ov");


var $6yu7A = parcelRequire("6yu7A");


var $kHRmO = parcelRequire("kHRmO");





var $73Hia = parcelRequire("73Hia");

const $17f714e6aec73e0c$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};


const $b8d00dcc62437b77$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId,
                ...moreContext || {}
            }
        }
    };
};


const $f68f5b4eef793981$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};



var $jTbFT = parcelRequire("jTbFT");


var $hnyex = parcelRequire("hnyex");


var $2gvXK = parcelRequire("2gvXK");


var $8D0XM = parcelRequire("8D0XM");


var $dsOco = parcelRequire("dsOco");


var $2csHQ = parcelRequire("2csHQ");


var $32Eau = parcelRequire("32Eau");

const $bafee2afb26ee146$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $bafee2afb26ee146$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $bafee2afb26ee146$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $bafee2afb26ee146$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $bafee2afb26ee146$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $bafee2afb26ee146$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $bafee2afb26ee146$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            hasAuthUpgrade: product.hasAuthUpgrade,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            authResolutionMode: product.authResolutionMode ?? undefined,
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $bafee2afb26ee146$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $bafee2afb26ee146$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            // Unused by search-page — `TSearchConfigAPIResponse` still requires the field.
            intercomHmac: '',
            siteMetadata: $bafee2afb26ee146$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $bafee2afb26ee146$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};


/**
 * Site-metadata helper functions used by `useFetchConfig`.
 *
 * These helpers each have **two implementations**, switched by the
 * `rovo_fps_use_rovo_config` feature gate:
 *
 * - **On** — delegate to the canonical implementation in
 *   `@atlassian/rovo-connectors-config/utils/site-metadata-helpers`. This is
 *   the path that will become the sole implementation once the gate is
 *   fully ramped and `useFetchConfig` is replaced by `useRovoConfig`.
 * - **Off** — run the original inline logic. Preserves verbatim behaviour
 *   for everyone not on the gate.
 *
 * Both branches must return identical results for any given input — see
 * `__tests__/site-metadata-helpers-equivalence.test.ts` for the `ffTest.both`
 * coverage that enforces this.
 *
 * **Not exported from the package.** Lives at
 * `controllers/config/site-metadata-helpers.ts` and is intentionally absent
 * from `package.json` `"exports"`. External consumers should keep going
 * through the `./use-fetch-config` subpath.
 */ 



var $9XgN6 = parcelRequire("9XgN6");

/** Matches `ari:cloud:<product>::<resource-type>/<cloudId>` and captures the cloudId. */ const $c608e301114d7356$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $c608e301114d7356$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return (0, $9XgN6.getFirstCloudId)(firstPartyResponse);
    const match = firstPartyResponse.resources[0]?.id.match($c608e301114d7356$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $c608e301114d7356$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $c608e301114d7356$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return (0, $9XgN6.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $c608e301114d7356$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return (0, $9XgN6.getProductEdition)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $c608e301114d7356$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return (0, $9XgN6.getProductDataRegions)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $c608e301114d7356$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return (0, $9XgN6.getRovoFeatures)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};


/**
 * Helper functions to parse the search combined config response. Ideally
 * this file should exist in the search-client package, however there are
 * too many 3P types defined in search-page.
 */ 













var $fd0l2 = parcelRequire("fd0l2");


var $hAvnk = parcelRequire("hAvnk");





var $8fNUp = parcelRequire("8fNUp");


var $7ydfN = parcelRequire("7ydfN");

/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $60ad9faf99641d2c$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': (0, $7ydfN.TypeFilterValueKey).Document,
    'ati:cloud:graph:message': (0, $7ydfN.TypeFilterValueKey).Message,
    'ati:cloud:graph:conversation': (0, $7ydfN.TypeFilterValueKey).Conversation,
    'ati:cloud:graph:design': (0, $7ydfN.TypeFilterValueKey).Design,
    'ati:cloud:graph:video': (0, $7ydfN.TypeFilterValueKey).Video,
    'ati:cloud:graph:space': (0, $7ydfN.TypeFilterValueKey).Space,
    'ati:cloud:graph:comment': (0, $7ydfN.TypeFilterValueKey).Comment,
    'ati:cloud:graph:repository': (0, $7ydfN.TypeFilterValueKey).Repository,
    'ati:cloud:graph:pull-request': (0, $7ydfN.TypeFilterValueKey).PullRequest,
    'ati:cloud:graph:commit': (0, $7ydfN.TypeFilterValueKey).Commit,
    'ati:cloud:graph:branch': (0, $7ydfN.TypeFilterValueKey).Branch,
    'ati:cloud:graph:calendar-event': (0, $7ydfN.TypeFilterValueKey).Calendar,
    'ati:cloud:graph:work-item': (0, $7ydfN.TypeFilterValueKey).WorkItem,
    'ati:cloud:graph:project': (0, $7ydfN.TypeFilterValueKey).Project,
    'ati:cloud:graph:deal': (0, $7ydfN.TypeFilterValueKey).Deal,
    'ati:cloud:graph:customer-org': (0, $7ydfN.TypeFilterValueKey).CustomerOrg,
    'ati:cloud:graph:dashboard': (0, $7ydfN.TypeFilterValueKey).Dashboard,
    'ati:cloud:graph:data-table': (0, $7ydfN.TypeFilterValueKey).DataTable
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $60ad9faf99641d2c$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $60ad9faf99641d2c$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($60ad9faf99641d2c$var$isCloudGraphAti(ati)) {
        const typeKey = $60ad9faf99641d2c$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: []
    });
    return typeFilterConfig;
}






var $95n8y = parcelRequire("95n8y");

const $79d324e98214d5e7$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
const $79d324e98214d5e7$var$mapForgeConnectorToThirdPartyConfig = (forgeConnector)=>{
    // Validate required fields
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $hAvnk.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $hAvnk.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    // Register the icon in the registry so ProductOrNounIcon can access it without props
    (0, $8fNUp.registerForgeConnectorIcon)(productKey, icon);
    // Build type filter config
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $60ad9faf99641d2c$export$770175465f396551)(forgeConnector.entityTypes) : new Map();
    (0, $2gvXK.registerForgeConnectorTypeMapping)(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $8fNUp.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
const $79d324e98214d5e7$export$4cb8ef4a677c563c = (resources)=>{
    const THIRD_PARTY_TYPES = (0, $95n8y.getThirdPartyTypes)();
    // Use a map to track connector sources for each providerId
    // This is useful for deduping search results for providers that are hybrid smartlink and full connectors
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        // Handle Forge connectors first
        if ((0, $8fNUp.isForgeConnectorProductKey)(resource.type)) {
            const config = $79d324e98214d5e7$var$mapForgeConnectorToThirdPartyConfig(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return; // Early return for Forge connectors
        }
        // Handle hardcoded connectors (existing logic)
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = (0, $iDrrr.fg)('ai_3p_slack_connector_status_transition_enabled') && productKey === 'slack';
            const isFederatedNoOAuthConnector = $79d324e98214d5e7$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $8fNUp.LITE_CONNECTOR_SOURCE))) sourceType = (0, $8fNUp.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE) : (0, $8fNUp.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $8fNUp.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                authResolutionMode: resource.authResolutionMode,
                connectorCreatedAt: resource.connectorCreatedAt
            };
            const datasourceList = [];
            // Add the main config without the nested datasources
            // eslint-disable-next-line no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            // TODO: Leave config level logic at the root of the datasource itself and datasource specific logic in the datasources -> https://hello.jira.atlassian.cloud/browse/DCCNT-1386
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            // Add third-party configs, also without the nested datasources
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            // Assign the cleaned datasourceList back to the main config
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    // Note: Only filter hardcoded product keys, Forge connectors use their own type as product key
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $8fNUp.isForgeConnectorProductKey)(productKey)) return true; // Forge connectors are always valid
        // For hardcoded 3P connectors, check if they're in allProductKeys
        return (0, $dvVWp.getAllProductKeys)().includes(productKey);
    });
    // Deduplicate product keys.
    // Multiple raw resources can map to the same product key (e.g. smartlinks-connector-gdrive
    // and google-drive-connector both map to 'drive'). While thirdPartyConfigs is an object
    // and naturally deduplicates, productKeys is an array that accumulates duplicates.
    // Without dedup, SSR produces different query variables than SPA (which accidentally
    // deduplicates via buildProducts in the bootstrap store's onUpdate handler).
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};


const $c01ed8b87fffede0$export$fc6c3173f0bc0482 = ({ configuration: configuration })=>{
    if (configuration.firstPartyProducts) {
        const firstPartyProducts = configuration.firstPartyProducts.map((product)=>product.name);
        const accessibleNouns = firstPartyProducts.filter((product)=>product in (0, $kHRmO.nouns));
        return accessibleNouns;
    } else return [];
};
const $c01ed8b87fffede0$export$b38c0215344366f7 = ({ configuration: configuration, primaryProduct: primaryProduct, cloudId: cloudId })=>{
    let accessibleProducts = [];
    // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    const { thirdPartyConfig: thirdPartyConfig } = (0, $bafee2afb26ee146$export$160fbca21b53d78a)(configuration, cloudId);
    // Add first party products to the array (deduplicated — multiple resource ARIs
    // can map to the same product key, e.g. bitbucket::site and bitbucket::workspace)
    if (configuration.firstPartyProducts) {
        const knownProductKeys = (0, $dvVWp.getAllProductKeys)();
        const firstPartyProducts = [
            ...new Set(configuration.firstPartyProducts.map((product)=>product.name).filter((product)=>knownProductKeys.includes(product)))
        ];
        accessibleProducts.push(...firstPartyProducts);
    }
    // Add Atlas to the array if there is more than one accessible noun
    const accessibleNouns = $c01ed8b87fffede0$export$fc6c3173f0bc0482({
        configuration: configuration,
        primaryProduct: primaryProduct,
        cloudId: cloudId
    });
    if (accessibleNouns.length > 1) accessibleProducts.push((0, $dvVWp.ProductKeys).Atlas);
    // Add third party products to the array
    if (configuration?.siteMetadata?.isRovoEnabled) {
        const { productKeys: thirdPartyProductKeys } = (0, $79d324e98214d5e7$export$4cb8ef4a677c563c)(thirdPartyConfig);
        accessibleProducts.push(...thirdPartyProductKeys);
    }
    // Always ensure the primary product is in the list, even if the config
    // response doesn't include it (e.g. resources only contain other products).
    if (!accessibleProducts.includes(primaryProduct)) accessibleProducts.unshift(primaryProduct);
    return accessibleProducts;
};
const $c01ed8b87fffede0$export$c635d3296555e2da = ({ configuration: configuration })=>{
    if (configuration?.siteMetadata?.productInfo?.length) {
        const entries = configuration.siteMetadata.productInfo.reduce((acc, product)=>{
            if (product.name) {
                const dataRegion = Array.isArray(product.dataRegion) ? product.dataRegion : typeof product.dataRegion === 'string' ? [
                    product.dataRegion
                ] : [];
                acc.push([
                    product.name,
                    dataRegion
                ]);
            }
            return acc;
        }, []);
        return Object.fromEntries(entries);
    } else return undefined;
};
const $c01ed8b87fffede0$export$53e066a63a960439 = ({ configuration: configuration })=>{
    const productEdition = configuration?.siteMetadata?.productEdition;
    if (typeof productEdition === 'string' && productEdition) return {
        confluence: productEdition
    };
    else return undefined;
};
const $c01ed8b87fffede0$export$37755e2ec7a40bc1 = ({ configuration: configuration, cloudId: cloudId })=>{
    if (configuration?.siteMetadata?.isRovoEnabled) // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    return (0, $79d324e98214d5e7$export$4cb8ef4a677c563c)((0, $bafee2afb26ee146$export$160fbca21b53d78a)(configuration, cloudId).thirdPartyConfig).thirdPartyConfigs;
    else return {};
};
const $c01ed8b87fffede0$export$5a5f668a90736418 = (args)=>{
    const { configuration: configuration } = args;
    const accessibleProducts = $c01ed8b87fffede0$export$b38c0215344366f7(args);
    return {
        accessibleNouns: $c01ed8b87fffede0$export$fc6c3173f0bc0482(args),
        accessibleProducts: accessibleProducts,
        isJiraIssueIndexed: Boolean(configuration?.siteMetadata?.isJiraIssueIndexed),
        isRovoEnabled: Boolean(configuration?.siteMetadata?.isRovoEnabled),
        productDataRegions: $c01ed8b87fffede0$export$c635d3296555e2da(args),
        productEdition: $c01ed8b87fffede0$export$53e066a63a960439(args),
        rovoFeatures: undefined,
        thirdPartyConfigs: $c01ed8b87fffede0$export$37755e2ec7a40bc1(args),
        supportedAccessibleProducts: (0, $9NmsO.getAccessibleProducts)({
            supportedProducts: (0, $dvVWp.getAllProductKeys)(),
            accessibleProducts: accessibleProducts
        })
    };
};



const $4136576e659ad67d$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $4136576e659ad67d$var$EMPTY_RESPONSE = [];
/**
 * Public `useFetchConfig` hook consumed by `BootstrapStoreProvider` and
 * (transitively) the rest of the search-page bootstrap pipeline.
 *
 * RAOC-22: this hook is now a thin **dispatcher** between two
 * implementations, gated by `rovo_fps_use_rovo_config`:
 *
 * The FG dispatch lives **inside** the public hook (not at the call
 * site) so that consumers see a single, stable `useFetchConfig`
 * interface and rules-of-hooks are upheld: each branch is itself a
 * hook, and the FG value is stable for the component lifetime
 * (Statsig SDK semantics).
 */ const $4136576e659ad67d$var$reportConfigCacheState = (state)=>{
    (0, $7SkLu.addUFOCustomCohortData)('configCacheState', state);
};
/**
 * `useRovoConfig` includes this predicate in the dependency list for its config-fetch effect.
 * Keep the identity stable so unrelated Quick Find rerenders cannot restart an in-flight config
 * task and emit another combined-config UX event pair.
 */ const $4136576e659ad67d$var$shouldBypassQuickFindPreload = (preloaded)=>preloaded?.source === 'quick-find';
const $4136576e659ad67d$export$2b0ac18f7cd43e19 = (props)=>{
    // These return the same type and are like for like replacements, this is the easiest way to safely FG without generating extra network calls.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? $4136576e659ad67d$export$d8e38f995daf9dc5(props) : $4136576e659ad67d$export$757ae11853c85282(props);
/* eslint-enable react-hooks/rules-of-hooks */ };
const $4136576e659ad67d$export$757ae11853c85282 = ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, activationId: activationId, preloadDataProvider: preloadDataProvider })=>{
    const supportedProducts = (0, $73Hia.useProductConfigs)();
    // Unnecessary, should be removed to save react cycles
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    // Unnecessary, should be removed to save react cycles
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $cozmU.useState)({});
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    // Combined Config Response
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $cozmU.useState)();
    // Unnecessary, should be removed to save react cycles
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)({
        experience: experience
    });
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    const logException = (0, $2csHQ.useLogException)();
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $c608e301114d7356$export$c1871fdf674a03c4)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = combinedThirdPartyResponse;
    const atlAttributionHeaders = (0, $cozmU.useMemo)(()=>(0, $AgYeH.buildAtlAttributionHeaders)({
            cloudId: cloudIdProp,
            activationId: activationId,
            product: primaryProduct
        }), [
        cloudIdProp,
        activationId,
        primaryProduct
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: atlAttributionHeaders
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            // Move current cloudId to index 0 if it exists and isn't already there
            // This is a temporary solution for multiple site search in rovo with correct CloudIdARIs sequence
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                // Remove from current position and add to beginning
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl,
        atlAttributionHeaders
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            /**
       * Combined config caching strategy shared across both:
       * - network fetch path (`getCombinedSearchConfig`)
       * - SSR-preloaded network seed path (`seedCombinedConfigCacheEntry`)
       *
       * Strategy:
       * - refresh only when cached data is expired
       * - return cached value even if expired
       */ const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = {
                    searchSessionId: searchSessionId,
                    taskId: uxTaskId,
                    task: (0, $jTbFT.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX
                };
                // DegradedDependency may not be visible to the end-user due to request caching. This is a health metric for our BE
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $17f714e6aec73e0c$export$e98932ab9e22c265)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: (0, $6yu7A.EVENT_SOURCE)
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    $4136576e659ad67d$var$reportConfigCacheState((0, $hCtla.toConfigCacheState)(state));
                    fireAnalyticsEvent((0, $f68f5b4eef793981$export$786813d6840571a0)({
                        requestName: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: (0, $6yu7A.EVENT_SOURCE)
                    }));
                };
                // Create network callbacks for tracking network requests
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $8D0XM.createVitalStatsNetworkCallbacks)(configNetworkTaskId, (0, $jTbFT.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_NETWORK, searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    userId: userId,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks,
                    headers: atlAttributionHeaders
                };
                // Fire task start for UX tracking
                fireAnalyticsEvent((0, $hnyex.onTaskStart)(baseUXVitalStatsParams));
                (0, $kQgL7.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $bafee2afb26ee146$export$160fbca21b53d78a)(configuration, cloudIdProp);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse((0, $79d324e98214d5e7$export$4cb8ef4a677c563c)(thirdPartyConfig));
                    // Fire user experience metric - user got data (success from UX perspective)
                    fireAnalyticsEvent((0, $hnyex.onTaskSuccess)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    logException(error);
                    // FailedDependency is visible to the end-user. This is a health metric for our UX
                    fireAnalyticsEvent((0, $b8d00dcc62437b77$export$7199f2d13e6ae9f7)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        source: (0, $6yu7A.EVENT_SOURCE)
                    }));
                    // Fire user experience metric - user did not get data (failure from UX perspective)
                    fireAnalyticsEvent((0, $hnyex.onTaskFail)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        // Unused by search-page — `TSearchConfigAPIResponse` still requires the field.
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $4136576e659ad67d$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // We skip trying to access the config from the preload provider if
            // the preload came from Quick Find. The reason for this is that the
            // combined config call will have already been cached in memory and
            // there's no reason to pipe it through the preload provider.
            let isPreloadFromQuickFind = false;
            try {
                const preloadedSearch = preloadDataProvider?.getPreloadedSearch({
                    cloudId: cloudIdProp
                });
                isPreloadFromQuickFind = Boolean(preloadedSearch && preloadedSearch.source === 'quick-find');
            } catch  {
            // Reading the preload provider should never throw, but be defensive
            // — a bad lookup must not block config loading.
            }
            if (preloadDataProvider && !isPreloadFromQuickFind) {
                try {
                    const preloadedSearch = preloadDataProvider.getPreloadedSearch({
                        cloudId: cloudIdProp
                    });
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = {
                            searchSessionId: searchSessionId,
                            taskId: preloadUxTaskId,
                            task: (0, $jTbFT.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX,
                            moreContext: preloadMoreContext
                        };
                        fireAnalyticsEvent((0, $hnyex.onTaskStart)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $bafee2afb26ee146$export$160fbca21b53d78a)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $79d324e98214d5e7$export$4cb8ef4a677c563c)(thirdPartyConfig));
                            if (!preloadedSearch.isConfigFromCache) (0, $kQgL7.seedCombinedConfigCacheEntry)({
                                cloudId: cloudIdProp,
                                userId: userId,
                                config: preloadedSearch.config,
                                expiration: combinedConfigTTL
                            }).catch((seedError)=>{
                                logException(seedError);
                            });
                            fireAnalyticsEvent((0, $hnyex.onTaskSuccess)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            if (preloadedSearch.isConfigFromCache) // Preload gives immediate UI data, but we still run the normal combined-config
                            // path so cache TTL rules can trigger a network refresh when the entry is expired.
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        } catch (error) {
                            logException(error);
                            fireAnalyticsEvent((0, $hnyex.onTaskFail)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $b8d00dcc62437b77$export$7199f2d13e6ae9f7)({
                        dependency: 'search-config-ssr',
                        searchSessionId: searchSessionId,
                        source: (0, $6yu7A.EVENT_SOURCE),
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    logException(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        userId,
        aggAbsoluteUrl,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        atlAttributionHeaders,
        preloadDataProvider,
        primaryProduct
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($4136576e659ad67d$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2 && match[1] in supportedProducts) return [
                        match[1]
                    ];
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) // Use the primary product if the 1P Search Config request fails
            allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            // Always ensure the primary product is in the list, even if the config
            // response doesn't include it (e.g. resources only contain other products).
            // This mirrors the error fallback behavior where the primary product is
            // always available so users can search within their hosting product.
            if (primaryProduct && !allAccessibleProducts.includes(primaryProduct)) allAccessibleProducts.unshift(primaryProduct);
            // Goal and Project nouns are now returned via the first party product list in the combined config response.
            const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match($4136576e659ad67d$var$EXTRACT_PRODUCT);
                if (match && match.length >= 2 && match[1] in (0, $kHRmO.nouns)) return [
                    match[1]
                ];
                return [];
            });
            // If nouns are available we also need to add Townsquare to the list of accessible products.
            // This way Projects will be fetched by default when no filters are selected.
            if (accessibleNouns.length > 0) allAccessibleProducts.push((0, $dvVWp.ProductKeys).Atlas);
            // with combined config, bitbucket is handled in the BE
            // Allow 3P products only if a user has Rovo enabled.
            // Long-term it won't be needed if the 3p-configuration check ensures Rovo eligibility.
            // See https://hello.atlassian.net/wiki/spaces/SEARCH/pages/4469899124.
            const doesUserHaveRovo = (0, $c608e301114d7356$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products,
        supportedProducts
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const parsedConfigFromNewCombinedConfigParser = (0, $cozmU.useMemo)(()=>{
        if (primaryProduct && cloudIdProp && combinedConfigResponse) {
            const parsedCombinedConfig = (0, $c01ed8b87fffede0$export$5a5f668a90736418)({
                configuration: combinedConfigResponse,
                primaryProduct: primaryProduct,
                cloudId: cloudIdProp
            });
            return {
                ...parsedCombinedConfig,
                firstCloudId: '',
                isConfigLoaded: // cloudId must always exist when using the combined endpoint, hence we don't infer one
                isConfigLoaded,
                linkedCloudARIs: linkedCloudARIs,
                unitMetadata: combinedConfigResponse.unitMetadata ?? undefined,
                onOAuthSuccess: undefined
            };
        }
        return null;
    }, [
        primaryProduct,
        cloudIdProp,
        combinedConfigResponse,
        isConfigLoaded,
        linkedCloudARIs
    ]);
    if (parsedConfigFromNewCombinedConfigParser) return parsedConfigFromNewCombinedConfigParser;
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        isRovoEnabled: (0, $c608e301114d7356$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $c608e301114d7356$export$37c9c6a3ae5f363c)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $c608e301114d7356$export$53e066a63a960439)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $c608e301114d7356$export$c635d3296555e2da)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $c608e301114d7356$export$2a1c0662041ee0a3)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs,
        unitMetadata: combinedConfigResponse?.unitMetadata ?? undefined,
        onOAuthSuccess: undefined
    };
};
const $4136576e659ad67d$export$d8e38f995daf9dc5 = ({ cloudId: cloudId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, preloadDataProvider: preloadDataProvider, experience: experience })=>{
    const rovoConfig = (0, $hCtla.useRovoConfig)({
        cloudId: cloudId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        analyticsConsumer: experience,
        // `SearchPreloadDataProvider` (search-page) is a structural
        // superset of `RovoConfigPreloadProvider`
        // (rovo-connectors-config). Both have the same
        // `getPreloadedSearch` / `clearPreloadedSearch` contract; the
        // search-page provider just exposes more fields on
        // `SearchPreloadData` than the narrow `RovoConfigPreloadData`
        // type references.
        preloadDataProvider: preloadDataProvider,
        shouldBypassPreloadProvider: $4136576e659ad67d$var$shouldBypassQuickFindPreload,
        onForgeConnectorTypeMapping: (0, $2gvXK.registerForgeConnectorTypeMapping),
        onConfigCacheState: $4136576e659ad67d$var$reportConfigCacheState
    });
    return (0, $cozmU.useMemo)(()=>{
        // `intercomHmac` is still returned by the shared rovo-connectors-config hook but
        // is no longer consumed by search-page, so it is dropped here.
        const { combinedConfigResponse: _ignored, intercomHmac: _intercomHmac, accessibleProducts: accessibleProducts, ...rest } = rovoConfig;
        const list = accessibleProducts ?? [];
        /**
     * Primary product fallback logic:
     * - If `primaryProduct` is not set or config has not loaded, do nothing (return the list as-is, even if empty).
     * - Otherwise, ensure the primary product is in the list (add it if missing).
     */ if (!primaryProduct || !rest.isConfigLoaded) return {
            ...rest,
            accessibleProducts: accessibleProducts
        };
        if (list.includes(primaryProduct)) return {
            ...rest,
            accessibleProducts: list
        };
        return {
            ...rest,
            accessibleProducts: [
                primaryProduct,
                ...list
            ]
        };
    }, [
        rovoConfig,
        primaryProduct
    ]);
};






var $ktiKH = parcelRequire("ktiKH");





var $4BJ6s = parcelRequire("4BJ6s");











var $9oZuK = parcelRequire("9oZuK");

const $cd8992eb52b9b7f4$export$2f5dbe7f5e5be807 = ({ experience: experience, cloudId: cloudId, fetchedConfig: fetchedConfig })=>{
    const identity = (0, $cozmU.useMemo)(()=>(0, $9oZuK.createQueryBootstrapSnapshotIdentity)({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const [routeTransition] = (0, $cozmU.useState)(()=>{
        if (experience !== (0, $9pcjO.SearchExperience).SEARCH_PAGE || typeof window === 'undefined' || !identity) return null;
        return (0, $9oZuK.readPreparedQueryBootstrapSnapshot)(identity);
    });
    const routeSnapshot = routeTransition?.snapshot ?? null;
    // Expiry controls whether a route may adopt a snapshot. Once adopted, retain that exact
    // snapshot until the route's normal config lifecycle takes ownership. Rechecking Date.now()
    // on every render could otherwise revoke bootstrap state midway through a slow route load.
    const validRouteSnapshot = (0, $cozmU.useMemo)(()=>routeSnapshot && identity && (0, $9oZuK.isQueryBootstrapSnapshotValidForIdentity)(routeSnapshot, identity) ? routeSnapshot : null, [
        identity,
        routeSnapshot
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (routeTransition && validRouteSnapshot) (0, $9oZuK.completeQueryBootstrapSnapshotTransition)(routeTransition);
    }, [
        routeTransition,
        validRouteSnapshot
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (experience !== (0, $9pcjO.SearchExperience).QUICK_FIND || typeof window === 'undefined' || !identity || !fetchedConfig.isConfigLoaded) return;
        (0, $9oZuK.publishQueryBootstrapSnapshot)({
            identity: identity,
            config: fetchedConfig
        });
    }, [
        experience,
        identity,
        fetchedConfig
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (experience === (0, $9pcjO.SearchExperience).SEARCH_PAGE) (0, $7SkLu.addUFOCustomCohortData)('queryBootstrapSnapshotState', validRouteSnapshot === null ? 'miss' : 'hit');
    }, [
        experience,
        validRouteSnapshot
    ]);
    if (validRouteSnapshot && !fetchedConfig.isConfigLoaded) return {
        ...validRouteSnapshot.config,
        onOAuthSuccess: fetchedConfig.onOAuthSuccess
    };
    return fetchedConfig;
};


const $b2f65cdcd3ba2b31$export$8a525a626086c807 = ({ children: children, experience: experience = (0, $9pcjO.SearchExperience).SEARCH_PAGE, ...props })=>{
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, preloadDataProvider: preloadDataProvider, orgId: orgId, analyticsAttributes: analyticsAttributes, products: products, queryParams: queryParams, features: features, searchSessionId: searchSessionId, callbacks: callbacks, experimentLayers: experimentLayers, hasEditOrViewPlanPermission: hasEditOrViewPlanPermission } = props;
    const onError = (0, $2csHQ.useLogException)();
    const bootstrapProviderExp = (0, $4BJ6s.serveBootstrapProviderExp)();
    const smartLinkUsage = (0, $fq2CX.useFetchSmartLinkUsage)(experience, cloudId);
    const normalizedFeatures = (0, $cozmU.useMemo)(()=>(0, $809a409e9024e632$export$a75feafd6c41cba5)(features, primaryProduct), [
        features,
        primaryProduct
    ]);
    // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed in StaticContextProvider
    // via getExperimentConfig. We still call useExperimentConfig unconditionally (rules of hooks) but don't
    // pass the result through initialProps on the FG-on path.
    // Keep in sync with: bootstrap-context-provider/static-context-provider/index.tsx
    const experimentConfig = (0, $3ZYG5.useExperimentConfig)({
        primaryProduct: primaryProduct,
        experimentLayers: experimentLayers ?? [],
        sideBySideExperiment: normalizedFeatures?.sideBySide?.experiments,
        statsigLayer: undefined,
        onError: onError
    });
    // Compute multiSiteSearchInRovo independently for useFetchConfig.
    // Under FG-on, we avoid depending on experimentConfig for this value since experimentConfig
    // will be owned by StaticContextProvider. This direct Statsig call is pure and side-effect-free.
    const multiSiteSearchInRovo = (0, $4BJ6s.serveBootstrapProviderExp)() ? (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    }).cohort === 'test' : (0, $cJff5.getMultiSiteSearchInRovo)(experimentConfig);
    const fetchedConfig = (0, $4136576e659ad67d$export$2b0ac18f7cd43e19)({
        cloudId: cloudId,
        configFetchAbsoluteUrl: configFetchAbsoluteUrl,
        aggregatorHostName: aggregatorHostName,
        preloadDataProvider: preloadDataProvider,
        userId: user?.id,
        primaryProduct: primaryProduct,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        experience: experience,
        activationId: analyticsAttributes?.activationId
    });
    const config = (0, $cd8992eb52b9b7f4$export$2f5dbe7f5e5be807)({
        experience: experience,
        cloudId: cloudId,
        fetchedConfig: fetchedConfig
    });
    const { accessibleProducts: accessibleProducts, accessibleNouns: accessibleNouns, thirdPartyConfigs: thirdPartyConfigs, firstCloudId: firstCloudId, isRovoEnabled: isRovoEnabled, isJiraIssueIndexed: isJiraIssueIndexed, productEdition: productEdition, productDataRegions: productDataRegions, rovoFeatures: rovoFeatures, isConfigLoaded: isConfigLoaded, linkedCloudARIs: linkedCloudARIs, unitMetadata: unitMetadata, onOAuthSuccess: onOAuthSuccess } = config;
    const allFilterExcludedProducts = (0, $cozmU.useMemo)(()=>(0, $4ysB6.getAllFilterExcludedProducts)({
            experience: experience,
            primaryProduct: primaryProduct
        }), [
        experience,
        primaryProduct
    ]);
    const getInitialProps = (0, $cozmU.useCallback)(()=>{
        let storeContainerInitialProps = {
            cloudId: cloudId ?? firstCloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            SAINHostName: SAINHostName,
            aggregatorHostName: aggregatorHostName,
            user: user,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            orgId: orgId,
            analyticsAttributes: analyticsAttributes,
            features: normalizedFeatures,
            // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed
            // in StaticContextProvider via getExperimentConfig instead of being passed through here.
            ...!(0, $4BJ6s.serveBootstrapProviderExp)() && {
                experimentConfig: experimentConfig
            },
            experimentLayers: experimentLayers,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isConfigLoaded: isConfigLoaded,
            // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed
            // in StaticContextProvider instead of here. Pass raw products through.
            products: (0, $4BJ6s.serveBootstrapProviderExp)() ? products : (0, $9NmsO.getAccessibleProducts)({
                supportedProducts: (0, $dvVWp.getAllProductKeys)(),
                products: products,
                accessibleProducts: accessibleProducts
            }),
            nouns: accessibleNouns,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            linkedCloudARIs: linkedCloudARIs,
            unitMetadata: unitMetadata,
            hasEditOrViewPlanPermission: hasEditOrViewPlanPermission,
            smartLinkUsage: smartLinkUsage
        };
        if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
        if (accessibleProducts) storeContainerInitialProps.thirdPartyConfigs = thirdPartyConfigs;
        return storeContainerInitialProps;
    }, [
        cloudId,
        firstCloudId,
        aggAbsoluteUrl,
        SAINHostName,
        aggregatorHostName,
        user,
        primaryProduct,
        primarySubProduct,
        orgId,
        analyticsAttributes,
        normalizedFeatures,
        experimentConfig,
        isRovoEnabled,
        isJiraIssueIndexed,
        isConfigLoaded,
        products,
        accessibleProducts,
        accessibleNouns,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        searchSessionId,
        thirdPartyConfigs,
        rovoFeatures,
        linkedCloudARIs,
        unitMetadata,
        experimentLayers,
        hasEditOrViewPlanPermission,
        smartLinkUsage
    ]);
    if (bootstrapProviderExp) {
        const initialProps = getInitialProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "bootstrap-context"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.BootstrapContextProvider), {
            initialProps: initialProps,
            queryParams: queryParams,
            queryParamsCallback: callbacks?.updateQueryParameters,
            getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
            onSearchCompleted: callbacks?.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess,
            experience: experience,
            accessibleProducts: accessibleProducts
        }, children));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "bootstrap-rss"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32Eau.BootstrapStoreContainer), {
        initialProps: getInitialProps(),
        queryParams: queryParams,
        queryParamsCallback: callbacks?.updateQueryParameters,
        getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
        onSearchCompleted: callbacks?.onSearchCompleted,
        onOAuthSuccess: onOAuthSuccess
    }, children));
};
module.exports["BootstrapStoreProvider"] = $b2f65cdcd3ba2b31$export$8a525a626086c807;

});

parcelRegister("9oZuK", function(module, exports) {
const $403c7608491a3447$var$QUERY_BOOTSTRAP_PREPARED_TRANSITION_LEASE_MS = 10000;
let $403c7608491a3447$var$currentSnapshot = null;
let $403c7608491a3447$var$preparedTransition = null;
const $403c7608491a3447$export$5855a9197a9106f7 = ({ cloudId: cloudId })=>{
    if (!cloudId) return null;
    return Object.freeze({
        cloudId: cloudId
    });
};
const $403c7608491a3447$var$identitiesMatch = (left, right)=>left.cloudId === right.cloudId;
const $403c7608491a3447$export$8a2689d42d2ecd38 = (snapshot, identity)=>$403c7608491a3447$var$identitiesMatch(snapshot.identity, identity);
const $403c7608491a3447$export$9239203db682a4b8 = (args)=>{
    const { identity: identity, config: config } = args;
    if (!config.isConfigLoaded) return null;
    const { onOAuthSuccess: _onOAuthSuccess, ...configWithoutCallbacks } = config;
    const snapshot = Object.freeze({
        identity: identity,
        config: Object.freeze(configWithoutCallbacks)
    });
    $403c7608491a3447$var$currentSnapshot = snapshot;
    return snapshot;
};
const $403c7608491a3447$export$e1ab6a22a448e311 = (identity)=>{
    if ($403c7608491a3447$var$currentSnapshot === null || !$403c7608491a3447$export$8a2689d42d2ecd38($403c7608491a3447$var$currentSnapshot, identity)) return null;
    return $403c7608491a3447$var$currentSnapshot;
};
const $403c7608491a3447$export$7c1fce6e279a25c = (identity, now = Date.now())=>{
    const snapshot = $403c7608491a3447$export$e1ab6a22a448e311(identity);
    $403c7608491a3447$var$preparedTransition = snapshot ? Object.freeze({
        snapshot: snapshot,
        expiresAt: now + $403c7608491a3447$var$QUERY_BOOTSTRAP_PREPARED_TRANSITION_LEASE_MS
    }) : null;
    return snapshot !== null;
};
const $403c7608491a3447$export$5eaee16e78316ae1 = (identity, now = Date.now())=>{
    if (!$403c7608491a3447$var$preparedTransition || $403c7608491a3447$var$preparedTransition.expiresAt <= now || !$403c7608491a3447$export$8a2689d42d2ecd38($403c7608491a3447$var$preparedTransition.snapshot, identity)) return null;
    return $403c7608491a3447$var$preparedTransition;
};
const $403c7608491a3447$export$e607016754089d29 = (transitionToComplete)=>{
    if ($403c7608491a3447$var$preparedTransition === transitionToComplete) $403c7608491a3447$var$preparedTransition = null;
};
const $403c7608491a3447$export$38667558346d64 = ()=>{
    $403c7608491a3447$var$currentSnapshot = null;
    $403c7608491a3447$var$preparedTransition = null;
};
module.exports["createQueryBootstrapSnapshotIdentity"] = $403c7608491a3447$export$5855a9197a9106f7;
module.exports["isQueryBootstrapSnapshotValidForIdentity"] = $403c7608491a3447$export$8a2689d42d2ecd38;
module.exports["publishQueryBootstrapSnapshot"] = $403c7608491a3447$export$9239203db682a4b8;
module.exports["prepareQueryBootstrapSnapshotForTransition"] = $403c7608491a3447$export$7c1fce6e279a25c;
module.exports["readPreparedQueryBootstrapSnapshot"] = $403c7608491a3447$export$5eaee16e78316ae1;
module.exports["completeQueryBootstrapSnapshotTransition"] = $403c7608491a3447$export$e607016754089d29;

});

parcelRegister("c7Prm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1Qme9 = parcelRequire("1Qme9");


var $6Vsfx = parcelRequire("6Vsfx");


var $32Eau = parcelRequire("32Eau");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $4ysB6 = parcelRequire("4ysB6");


var $j4DTV = parcelRequire("j4DTV");


var $hjUvm = parcelRequire("hjUvm");


var $janH5 = parcelRequire("janH5");


var $01yWw = parcelRequire("01yWw");


var $cPezr = parcelRequire("cPezr");


var $cP0Ja = parcelRequire("cP0Ja");


var $2u3Wd = parcelRequire("2u3Wd");


var $bN0jv = parcelRequire("bN0jv");


var $gNxm1 = parcelRequire("gNxm1");


var $8Q2g1 = parcelRequire("8Q2g1");


var $cRSiy = parcelRequire("cRSiy");


var $a4K4k = parcelRequire("a4K4k");


var $dpRDk = parcelRequire("dpRDk");


var $7TxDU = parcelRequire("7TxDU");


var $epN5B = parcelRequire("epN5B");


var $MFQTE = parcelRequire("MFQTE");


var $kIkSt = parcelRequire("kIkSt");


var $i2Y2N = parcelRequire("i2Y2N");


var $EICUN = parcelRequire("EICUN");


var $ikbkS = parcelRequire("ikbkS");


var $5h8lq = parcelRequire("5h8lq");


var $9rMWc = parcelRequire("9rMWc");


var $AmZkX = parcelRequire("AmZkX");


var $2BHso = parcelRequire("2BHso");


var $8NYi4 = parcelRequire("8NYi4");


var $2sAXF = parcelRequire("2sAXF");


var $8BOly = parcelRequire("8BOly");


var $dkj04 = parcelRequire("dkj04");


var $5m4QA = parcelRequire("5m4QA");


var $9XbyR = parcelRequire("9XbyR");


var $1y2K1 = parcelRequire("1y2K1");


var $fV4vp = parcelRequire("fV4vp");


var $j9kbz = parcelRequire("j9kbz");


var $dhhWM = parcelRequire("dhhWM");


var $2iqMh = parcelRequire("2iqMh");


var $5gx32 = parcelRequire("5gx32");


var $fFs6O = parcelRequire("fFs6O");


var $b5q9t = parcelRequire("b5q9t");


var $jQaFd = parcelRequire("jQaFd");


var $6uMwK = parcelRequire("6uMwK");


var $4LpMn = parcelRequire("4LpMn");


var $8bTbn = parcelRequire("8bTbn");


var $hw9HX = parcelRequire("hw9HX");


var $hewHt = parcelRequire("hewHt");


var $lgtmw = parcelRequire("lgtmw");


var $9AliR = parcelRequire("9AliR");


var $5QRIQ = parcelRequire("5QRIQ");


var $bI3lU = parcelRequire("bI3lU");


var $clTf7 = parcelRequire("clTf7");

const $1fb49ee34de0aa72$export$d8428ac7d93fb69a = Object.freeze({
    [(0, $ikbkS.filter).id]: (0, $ikbkS.filter),
    [(0, $a4K4k.filter).id]: (0, $a4K4k.filter),
    [(0, $6uMwK.filter).id]: (0, $6uMwK.filter),
    [(0, $fFs6O.filter).id]: (0, $fFs6O.filter),
    [(0, $bI3lU.filter).id]: (0, $bI3lU.filter),
    [(0, $5QRIQ.filter).id]: (0, $5QRIQ.filter),
    [(0, $cPezr.filter).id]: (0, $cPezr.filter),
    [(0, $j9kbz.filter).id]: (0, $j9kbz.filter),
    [(0, $8Q2g1.filter).id]: (0, $8Q2g1.filter),
    [(0, $1y2K1.filter).id]: (0, $1y2K1.filter),
    [(0, $4ysB6.universalTypeFilterId)]: (0, $9AliR.filter),
    [(0, $cRSiy.filter).id]: (0, $cRSiy.filter),
    [(0, $lgtmw.filter).id]: (0, $lgtmw.filter),
    [(0, $2BHso.filter).id]: (0, $2BHso.filter),
    [(0, $dpRDk.filter).id]: (0, $dpRDk.filter),
    [(0, $EICUN.filter).id]: (0, $EICUN.filter),
    [(0, $8bTbn.filter).id]: (0, $8bTbn.filter),
    [(0, $epN5B.filter).id]: (0, $epN5B.filter),
    [(0, $MFQTE.filter).id]: (0, $MFQTE.filter),
    [(0, $8NYi4.filter).id]: (0, $8NYi4.filter),
    [(0, $j4DTV.filter).id]: (0, $j4DTV.filter),
    [(0, $5h8lq.filter).id]: (0, $5h8lq.filter),
    [(0, $4LpMn.filter).id]: (0, $4LpMn.filter),
    [(0, $hjUvm.filter).id]: (0, $hjUvm.filter),
    [(0, $janH5.filter).id]: (0, $janH5.filter),
    [(0, $01yWw.filter).id]: (0, $01yWw.filter),
    [(0, $5m4QA.filter).id]: (0, $5m4QA.filter),
    [(0, $2sAXF.filter).id]: (0, $2sAXF.filter),
    [(0, $dkj04.filter).id]: (0, $dkj04.filter),
    [(0, $9XbyR.filter).id]: (0, $9XbyR.filter),
    [(0, $8BOly.filter).id]: (0, $8BOly.filter),
    [(0, $AmZkX.filter).id]: (0, $AmZkX.filter),
    [(0, $2u3Wd.filter).id]: (0, $2u3Wd.filter),
    [(0, $bN0jv.filter).id]: (0, $bN0jv.filter),
    [(0, $7TxDU.filter).id]: (0, $7TxDU.filter),
    [(0, $cP0Ja.filter).id]: (0, $cP0Ja.filter),
    [(0, $9rMWc.filter).id]: (0, $9rMWc.filter),
    [(0, $hw9HX.filter).id]: (0, $hw9HX.filter),
    [(0, $hewHt.filter).id]: (0, $hewHt.filter),
    [(0, $jQaFd.filter).id]: (0, $jQaFd.filter),
    [(0, $5gx32.filter).id]: (0, $5gx32.filter),
    [(0, $dhhWM.filter).id]: (0, $dhhWM.filter),
    [(0, $2iqMh.filter).id]: (0, $2iqMh.filter),
    [(0, $gNxm1.filter).id]: (0, $gNxm1.filter),
    [(0, $fV4vp.filter).id]: (0, $fV4vp.filter),
    [(0, $b5q9t.filter).id]: (0, $b5q9t.filter),
    [(0, $kIkSt.filter).id]: (0, $kIkSt.filter),
    [(0, $clTf7.filter).id]: (0, $clTf7.filter),
    [(0, $i2Y2N.filter).id]: (0, $i2Y2N.filter)
});



var $1i979 = parcelRequire("1i979");


var $3t6NJ = parcelRequire("3t6NJ");

const $691d9b258a9d3e65$export$3776ece9f99ed2df = ({ children: children, experience: experience = 'search-page', useCaseId: useCaseId })=>{
    const [shouldAutoSelectPrimaryProduct, setShouldAutoSelectPrimaryProduct] = (0, $cozmU.useState)(true);
    const intl = (0, $kSwu1.useIntl)();
    const [queryParams] = (0, $32Eau.useQueryParams)();
    const [cloudId] = (0, $32Eau.useCloudId)();
    const [aggAbsoluteUrl] = (0, $32Eau.useAggAbsoluteUrl)();
    const [initialSpaceARIs] = (0, $32Eau.useInitialSpaceARIs)();
    const [user] = (0, $32Eau.useUser)();
    const products = (0, $32Eau.useAvailableProducts)();
    const [allFilterExcludedProducts] = (0, $32Eau.useAllFilterExcludedProducts)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [experimentConfig] = (0, $32Eau.useExperimentConfig)();
    const [productEdition] = (0, $32Eau.useProductEdition)();
    const [productDataRegions] = (0, $32Eau.useProductDataRegions)();
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const [orgId] = (0, $32Eau.useOrgId)();
    const unitMetadata = (0, $32Eau.useUnitMetadata)();
    const [analyticsAttributes] = (0, $32Eau.useAnalyticsAttributes)();
    const setQueryParams = (0, $32Eau.useSetQueryParams)(queryParams);
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const primaryProductToAutoSelect = (0, $32Eau.useAutoSelectPrimaryProduct)();
    // Derive a complete, gated site scope for downstream filter lookups.
    const selectedCloudIds = (0, $cozmU.useMemo)(()=>(0, $6Vsfx.getSelectedSiteCloudIds)((0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: primaryProduct
        }) ? queryParams?.sites : undefined, cloudId, unitMetadata), [
        primaryProduct,
        queryParams?.sites,
        unitMetadata,
        cloudId
    ]);
    const config = (0, $cozmU.useMemo)(()=>({
            useCaseId: useCaseId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            ari: '',
            cloudId: cloudId,
            selectedCloudIds: selectedCloudIds,
            experimentConfig: experimentConfig,
            initialSpaceARIs: initialSpaceARIs,
            // Default to an empty array so downstream `Array.isArray(config.contributorAccountIds)`
            // checks (in 3p Space / Content Under typeahead queries) succeed before any
            // contributor selection has been merged into the config by
            // loadInitialSelectFilterOptions / setSelectFilterLookupInput. The actions
            // downstream replace this with the live `allFiltersState.contributor.value` when a
            // contributor is selected.
            contributorAccountIds: [],
            intl: intl,
            productDataRegions: productDataRegions,
            productEdition: productEdition,
            userId: user?.id || '',
            product: queryParams?.product,
            experience: experience,
            primaryProduct: primaryProduct,
            orgId: orgId,
            thirdPartyConfigs: thirdPartyConfigs,
            unitMetadata: unitMetadata,
            activationId: analyticsAttributes?.activationId
        }), [
        useCaseId,
        aggAbsoluteUrl,
        cloudId,
        selectedCloudIds,
        experimentConfig,
        initialSpaceARIs,
        intl,
        productDataRegions,
        productEdition,
        user?.id,
        queryParams?.product,
        experience,
        primaryProduct,
        orgId,
        thirdPartyConfigs,
        unitMetadata,
        analyticsAttributes?.activationId
    ]);
    const queryParamsInUse = (0, $cozmU.useMemo)(()=>{
        const { lastModified_lt: _lastModified_lt, lastModified_gt: _lastModified_gt, ...queryParamsInUse } = queryParams;
        return queryParamsInUse;
    }, [
        queryParams
    ]);
    // primaryProductToAutoSelect will be set to the primary product if the user is in unified search
    // and no product is selected
    // This is to ensure that the primary product is selected by default for unified search
    (0, $cozmU.useEffect)(()=>{
        if (products && products.length > 0) {
            if (shouldAutoSelectPrimaryProduct && primaryProductToAutoSelect) setQueryParams({
                ...queryParams,
                product: primaryProductToAutoSelect
            });
            setShouldAutoSelectPrimaryProduct(false);
        }
    }, [
        applicationMode,
        primaryProduct,
        primaryProductToAutoSelect,
        products,
        queryParams,
        setQueryParams,
        shouldAutoSelectPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3t6NJ.SearchUseCaseIdProvider), {
        value: useCaseId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1i979.SearchStoreContainer), {
        queryParams: queryParamsInUse,
        allFilters: (0, $1fb49ee34de0aa72$export$d8428ac7d93fb69a),
        config: config,
        setQueryParams: setQueryParams,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts,
        applicationMode: applicationMode,
        primaryProduct: primaryProduct,
        thirdPartyConfigs: thirdPartyConfigs,
        experience: experience
    }, children));
};
module.exports["SearchStoreProvider"] = $691d9b258a9d3e65$export$3776ece9f99ed2df;

});

parcelRegister("j4DTV", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $e93dec2575cca0b8$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $e93dec2575cca0b8$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('archived');
const $e93dec2575cca0b8$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'archived',
    queryParams: {
        key: 'archived'
    },
    products: [
        ...$e93dec2575cca0b8$var$productKeys1P,
        ...$e93dec2575cca0b8$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $e93dec2575cca0b8$export$3dea766d36a8935f;

});

parcelRegister("hjUvm", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $6uNXh = parcelRequire("6uNXh");

const $b5d9860a7c877929$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Compass
];
const $b5d9860a7c877929$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'compassArchived',
    queryParams: {
        key: 'compassArchived'
    },
    products: $b5d9860a7c877929$var$productKeys1P,
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $b5d9860a7c877929$export$3dea766d36a8935f;

});

parcelRegister("janH5", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $cYapu = parcelRequire("cYapu");


var $AgYeH = parcelRequire("AgYeH");


var $eoapi = parcelRequire("eoapi");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $27ab78745da1423f$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Assets
];
const $27ab78745da1423f$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'assetsSchema',
    products: $27ab78745da1423f$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsSchema',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allSchemas = await (0, $eoapi.assetsSchemasQuery)(queryParams, headers);
            const hydratedSchemaOptions = allSchemas.data?.assets_schemasByIds?.map((schema)=>{
                return {
                    trackingKey: schema.id,
                    value: schema.id,
                    queryParamValue: schema.id,
                    label: (0, $iDrrr.fg)('cdm_ga') ? schema.displayName || '' : schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    metadata: {
                        internalName: schema.name
                    }
                };
            });
            return hydratedSchemaOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedSchemas = await (0, $cYapu.searchAssetsSchemas)();
            const recommendedSchemaOptions = suggestedSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? schema.displayName || '' : schema.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false,
                    metadata: {
                        internalName: schema.name
                    }
                };
            });
            return recommendedSchemaOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultSchemas = await (0, $cYapu.searchAssetsSchemas)(query);
            const searchSchemaOptions = resultSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? schema.displayName || '' : schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    metadata: {
                        internalName: schema.name
                    }
                };
            });
            return searchSchemaOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Assets
});
module.exports["filter"] = $27ab78745da1423f$export$3dea766d36a8935f;

});

parcelRegister("cYapu", function(module, exports) {

var $fExfj = parcelRequire("fExfj");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");

const $1f1da1a2d0d7fbde$export$3317731fce42efc4 = 'assets-workspace-id';
const { refreshOnAccessDecorator: $1f1da1a2d0d7fbde$var$refreshOnAccessDecoratorAssets } = (0, $fyjce.promiseCache)({
    name: $1f1da1a2d0d7fbde$export$3317731fce42efc4,
    expiration: 86400000 // 24 hours
});
async function $1f1da1a2d0d7fbde$export$7397855f2e1b36a6() {
    const url = '/rest/servicedesk/cmdb/latest/workspace';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)($1f1da1a2d0d7fbde$export$3317731fce42efc4);
    const supplier = ()=>(0, $fExfj.utils).requestService({
            url: url
        }, options);
    const response = await $1f1da1a2d0d7fbde$var$refreshOnAccessDecoratorAssets({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false,
        onlyRefreshIfExpired: true
    });
    const ids = response.results ?? [];
    return ids.length ? ids[0].id : null;
}
async function $1f1da1a2d0d7fbde$export$54126e20e262ab6a(query = '', maxResults = 3) {
    const workspaceId = await $1f1da1a2d0d7fbde$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema/list?maxResults=${maxResults}&includeCounts=false${query ? `&query=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const schemas = responseData.values ?? [];
        const transformedSchemas = schemas.map((schema)=>({
                ...schema,
                schemaLabel: schema.name,
                ari: `ari:cloud:cmdb::schema/${workspaceId}/${schema.id}`
            }));
        return transformedSchemas;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
async function $1f1da1a2d0d7fbde$export$ba9ddace9845bd14(query = '', maxResults = 3) {
    const workspaceId = await $1f1da1a2d0d7fbde$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttype/all/list?pageSize=${maxResults}${query ? `&filterBy=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const types = responseData.data ?? [];
        const transformedTypes = types.map((type)=>({
                ...type,
                ari: `ari:cloud:cmdb::type/${workspaceId}/${type.id}`
            }));
        return transformedTypes;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
module.exports["searchAssetsSchemas"] = $1f1da1a2d0d7fbde$export$54126e20e262ab6a;
module.exports["searchAssetsTypes"] = $1f1da1a2d0d7fbde$export$ba9ddace9845bd14;

});

parcelRegister("eoapi", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $1d9e251b755db171$var$GQL_ASSETS_SCHEMAS_NAME = 'SearchPageAssetsSchemasQuery';
const $1d9e251b755db171$var$getAssetsSchemasQueryString = ()=>`query ${$1d9e251b755db171$var$GQL_ASSETS_SCHEMAS_NAME}(
	$schemaARIs: [ID!]!) {
		assets_schemasByIds(ids: $schemaARIs) {
    		id
    		key
    		name
    		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
    		sequentialId @optIn(to: "AssetsApFields")
  		}
	}`;
const $1d9e251b755db171$export$2ab52cbd1429b72b = (0, $bHHWv.inMemoryCache)();
const $1d9e251b755db171$export$3c3ad61134eb56ad = async (schemaARIs, headers)=>{
    return $1d9e251b755db171$export$2ab52cbd1429b72b.inMemoryDecorator(`${schemaARIs}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $1d9e251b755db171$var$getAssetsSchemasQueryString(),
            variables: {
                schemaARIs: schemaARIs
            },
            headers: {
                'X-ExperimentalApi': 'AssetsSchemas',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsSchemasQuery"] = $1d9e251b755db171$export$3c3ad61134eb56ad;

});

parcelRegister("01yWw", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $cYapu = parcelRequire("cYapu");


var $AgYeH = parcelRequire("AgYeH");


var $92z1S = parcelRequire("92z1S");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $5035981be15551ae$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Assets
];
const $5035981be15551ae$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'assetsType',
    products: $5035981be15551ae$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsType',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allTypes = await (0, $92z1S.assetsObjectTypesQuery)(queryParams, headers);
            const hydratedTypeOptions = allTypes.data?.assets_objectTypesByIds?.map((type)=>{
                return {
                    trackingKey: type.id,
                    value: type.id,
                    queryParamValue: type.id,
                    label: (0, $iDrrr.fg)('cdm_ga') ? type.displayName || '' : type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: (0, $iDrrr.fg)('cdm_ga') ? type.schema.displayName || '' : type.schema.name,
                        internalName: type.name,
                        schemaInternalName: type.schema.name
                    }
                };
            });
            return hydratedTypeOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedTypes = await (0, $cYapu.searchAssetsTypes)();
            const recommendedTypeOptions = suggestedTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? type.displayName || '' : type.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: (0, $iDrrr.fg)('cdm_ga') ? type.schemaDisplayLabel || '' : type.schemaLabel,
                        internalName: type.name,
                        schemaInternalName: type.schemaLabel
                    }
                };
            });
            return recommendedTypeOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultTypes = await (0, $cYapu.searchAssetsTypes)(query);
            const searchTypeOptions = resultTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? type.displayName || '' : type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: (0, $iDrrr.fg)('cdm_ga') ? type.schemaDisplayLabel || '' : type.schemaLabel,
                        internalName: type.name,
                        schemaInternalName: type.schemaLabel
                    }
                };
            });
            return searchTypeOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Assets
});
module.exports["filter"] = $5035981be15551ae$export$3dea766d36a8935f;

});

parcelRegister("92z1S", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $1aee25a5ef1bf06f$var$GQL_ASSETS_OBJECT_TYPES_NAME = 'SearchPageAssetsObjectTypesQuery';
const $1aee25a5ef1bf06f$var$getAssetsObjectTypesQueryString = ()=>`query ${$1aee25a5ef1bf06f$var$GQL_ASSETS_OBJECT_TYPES_NAME}(
	$objectTypeARIs: [ID!]!) {
		assets_objectTypesByIds(ids: $objectTypeARIs) {
    		id
    		name
    		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
    		sequentialId @optIn(to: "AssetsApFields")
    		icon {
      			url16
    		}
    		schema {
      			name
      			${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
    		}
  		}
	}`;
const $1aee25a5ef1bf06f$export$4b370fc8e83d008b = (0, $bHHWv.inMemoryCache)();
const $1aee25a5ef1bf06f$export$b573ef4e7e3425c7 = async (objectTypeARIs, headers)=>{
    return $1aee25a5ef1bf06f$export$4b370fc8e83d008b.inMemoryDecorator(`${objectTypeARIs}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $1aee25a5ef1bf06f$var$getAssetsObjectTypesQueryString(),
            variables: {
                objectTypeARIs: objectTypeARIs
            },
            operationName: $1aee25a5ef1bf06f$var$GQL_ASSETS_OBJECT_TYPES_NAME,
            headers: {
                'X-ExperimentalApi': 'AssetsObjectTypes',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsObjectTypesQuery"] = $1aee25a5ef1bf06f$export$b573ef4e7e3425c7;

});

parcelRegister("cPezr", function(module, exports) {

var $99hPJ = parcelRequire("99hPJ");


var $AgYeH = parcelRequire("AgYeH");


var $fCd3b = parcelRequire("fCd3b");


var $6Zvcd = parcelRequire("6Zvcd");


var $j5Usq = parcelRequire("j5Usq");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $50410043a9055ce6$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $50410043a9055ce6$var$loadInitialOptions = async (config)=>{
    if (config.product === (0, $dvVWp.ProductKeys).JiraDC || config.product === (0, $dvVWp.ProductKeys).JsmDC) return (0, $3e0Ll.loadRecommendedUsers)(config);
    return $50410043a9055ce6$var$searchJiraCloudAssignee('', config, {
        initialOptions: true
    });
};
const $50410043a9055ce6$var$searchAssignee = async (query, config)=>{
    if (config.product === (0, $dvVWp.ProductKeys).JiraDC || config.product === (0, $dvVWp.ProductKeys).JsmDC) return $50410043a9055ce6$var$searchAssignees3P(query, config);
    return $50410043a9055ce6$var$searchJiraCloudAssignee(query, config);
};
const $50410043a9055ce6$var$searchAssignees3P = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $99hPJ.getAssignees)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $50410043a9055ce6$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((assignee)=>({
            trackingKey: assignee.id,
            value: assignee.id,
            label: assignee.name,
            avatarUrl: assignee.avatarUrl,
            queryParamValue: assignee.id,
            product: config.product
        }));
};
const $50410043a9055ce6$var$searchJiraCloudAssignee = async (query, config, options)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $j5Usq.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $fCd3b.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchAssigneeQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $6Zvcd.Scope).People
        ],
        // Keep the primary-only request unchanged; send every explicit non-primary scope.
        ...(config.selectedCloudIds?.length ?? 0) > 1 || config.selectedCloudIds?.some((id)=>id !== config.cloudId) ? {
            sites: config.selectedCloudIds
        } : {},
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchAssigneeReponse] = await Promise.all([
        initialUsersQuery,
        searchAssigneeQuery
    ]);
    const searchAssigneeResults = searchAssigneeReponse.response.rawData.scopes[0]?.results ?? [];
    const allAssignees = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchAssigneeResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return assigneeOptions;
};
const $50410043a9055ce6$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement,
    (0, $dvVWp.ProductKeys).CustomerServiceManagement
];
const $50410043a9055ce6$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('assignee');
const $50410043a9055ce6$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'assignee',
    products: [
        ...$50410043a9055ce6$var$productKeys1P,
        ...$50410043a9055ce6$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jAssignee',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allAssignees = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return assigneeOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $50410043a9055ce6$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $50410043a9055ce6$var$searchAssignee(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Jira || primaryProduct === (0, $dvVWp.ProductKeys).JiraDC || primaryProduct === (0, $dvVWp.ProductKeys).JsmDC || primaryProduct === (0, $dvVWp.ProductKeys).JiraServiceManagement || primaryProduct === (0, $dvVWp.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $50410043a9055ce6$export$3dea766d36a8935f;

});

parcelRegister("99hPJ", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $b15045c6e382f404$export$83f72e15d115a0e7 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'assignee',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getAssignees"] = $b15045c6e382f404$export$83f72e15d115a0e7;

});

parcelRegister("82ADO", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");

const $0b0d92b98afd7ee4$export$6dbf555668213f9e = (primaryProduct)=>{
    // URS (User Recommendation Service) rejects product keys it does not recognise, so anything
    // else falls back to 'confluence' rather than failing deserialization.
    return primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira || primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence || primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Loom ? primaryProduct : (0, $3Ydx7.PrimaryProductKeys).Confluence;
};
module.exports["getUrsProductKey"] = $0b0d92b98afd7ee4$export$6dbf555668213f9e;

});

parcelRegister("cP0Ja", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $2205c26033fd60d7$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $2205c26033fd60d7$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('calendarType');
const $2205c26033fd60d7$var$calendarTypeProducts = Array.from(new Set([
    ...$2205c26033fd60d7$var$salesforceProducts,
    ...$2205c26033fd60d7$var$products3PFromConfig
]));
const $2205c26033fd60d7$var$fetchDynamicCalendarTypeOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const eventTypes = result.filters.find((f)=>f.name === 'eventTypes');
        if (!eventTypes || eventTypes.values.length === 0) return [];
        return eventTypes.values.map((eventType)=>({
                value: eventType.name,
                trackingKey: eventType.name,
                queryParamValue: eventType.name,
                isDefault: false,
                label: eventType.label ?? eventType.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $2205c26033fd60d7$var$fetchCalendarTypeOptions = async (config)=>{
    return $2205c26033fd60d7$var$fetchDynamicCalendarTypeOptions(config);
};
const $2205c26033fd60d7$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $2205c26033fd60d7$var$fetchCalendarTypeOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $2205c26033fd60d7$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'calendarType',
    requiresTopLevel3PDatasource: true,
    products: $2205c26033fd60d7$var$calendarTypeProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'eventTypes',
        fetcher: async (queryParams, config)=>{
            return $2205c26033fd60d7$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $2205c26033fd60d7$var$fetchCalendarTypeOptions(config);
        }
    }
});
module.exports["filter"] = $2205c26033fd60d7$export$3dea766d36a8935f;

});

parcelRegister("2u3Wd", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $691ecec8618d84b5$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $691ecec8618d84b5$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('campaignStatus');
const $691ecec8618d84b5$var$campaignStatusProducts = Array.from(new Set([
    ...$691ecec8618d84b5$var$salesforceProducts,
    ...$691ecec8618d84b5$var$products3PFromConfig
]));
const $691ecec8618d84b5$var$fetchDynamicCampaignStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const campaignStatuses = result.filters.find((f)=>f.name === 'campaignStatuses');
        if (!campaignStatuses || campaignStatuses.values.length === 0) return [];
        return campaignStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
const $691ecec8618d84b5$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $691ecec8618d84b5$var$fetchDynamicCampaignStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $691ecec8618d84b5$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'campaignStatus',
    requiresTopLevel3PDatasource: true,
    products: $691ecec8618d84b5$var$campaignStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'campaignStatuses',
        fetcher: async (queryParams, config)=>{
            return $691ecec8618d84b5$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $691ecec8618d84b5$var$fetchDynamicCampaignStatusOptions(config);
        }
    }
});
module.exports["filter"] = $691ecec8618d84b5$export$3dea766d36a8935f;

});

parcelRegister("bN0jv", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $3296e6ecef6e4ed3$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $3296e6ecef6e4ed3$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('caseStatus');
const $3296e6ecef6e4ed3$var$caseStatusProducts = Array.from(new Set([
    ...$3296e6ecef6e4ed3$var$salesforceProducts,
    ...$3296e6ecef6e4ed3$var$products3PFromConfig
]));
const $3296e6ecef6e4ed3$var$fetchDynamicCaseStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const caseStatuses = result.filters.find((f)=>f.name === 'caseStatuses');
        if (!caseStatuses || caseStatuses.values.length === 0) return [];
        return caseStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
const $3296e6ecef6e4ed3$var$fetchCaseStatusOptions = async (config)=>{
    return $3296e6ecef6e4ed3$var$fetchDynamicCaseStatusOptions(config);
};
const $3296e6ecef6e4ed3$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $3296e6ecef6e4ed3$var$fetchCaseStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $3296e6ecef6e4ed3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'caseStatus',
    requiresTopLevel3PDatasource: true,
    products: $3296e6ecef6e4ed3$var$caseStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'caseStatuses',
        fetcher: async (queryParams, config)=>{
            return $3296e6ecef6e4ed3$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $3296e6ecef6e4ed3$var$fetchCaseStatusOptions(config);
        }
    }
});
module.exports["filter"] = $3296e6ecef6e4ed3$export$3dea766d36a8935f;

});

parcelRegister("gNxm1", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $m6ow8 = parcelRequire("m6ow8");


var $kSwu1 = parcelRequire("kSwu1");

const $e1d34701a254563e$export$95ac8a541f7029bb = (0, $kSwu1.defineMessages)({
    anytime: {
        id: "search-page.filter.close.date.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.close.date.today",
        defaultMessage: "Today"
    },
    last7days: {
        id: "search-page.filter.close.date.last7days",
        defaultMessage: "Last 7 days"
    },
    last30days: {
        id: "search-page.filter.close.date.last30days",
        defaultMessage: "Last 30 days"
    },
    last90days: {
        id: "search-page.filter.close.date.last90days",
        defaultMessage: "Last 90 days"
    },
    last365days: {
        id: "search-page.filter.close.date.last365days",
        defaultMessage: "Last 365 days"
    },
    next7days: {
        id: "search-page.filter.close.date.next7days",
        defaultMessage: "Next 7 days"
    },
    next30days: {
        id: "search-page.filter.close.date.next30days",
        defaultMessage: "Next 30 days"
    },
    next90days: {
        id: "search-page.filter.close.date.next90days",
        defaultMessage: "Next 90 days"
    },
    next365days: {
        id: "search-page.filter.close.date.next365days",
        defaultMessage: "Next 365 days"
    },
    custom: {
        id: "search-page.filter.close.date.custom",
        defaultMessage: "Specific date"
    }
});


const $22e8bbe85fc9ffba$var$CLOSE_DATE_VALUES = [
    'anytime',
    'today',
    'last7days',
    'last30days',
    'last90days',
    'last365days',
    'next7days',
    'next30days',
    'next90days',
    'next365days',
    'custom'
];
const $22e8bbe85fc9ffba$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $22e8bbe85fc9ffba$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $22e8bbe85fc9ffba$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('closeDate');
const $22e8bbe85fc9ffba$var$closeDateProducts = Array.from(new Set([
    ...$22e8bbe85fc9ffba$var$salesforceProducts,
    ...$22e8bbe85fc9ffba$var$products3PFromConfig
]));
const $22e8bbe85fc9ffba$export$3dea766d36a8935f = (0, $m6ow8.createSingleWithCustomOptionSelectFilter)({
    id: 'closeDate',
    products: $22e8bbe85fc9ffba$var$closeDateProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'closeDate',
        fetcher: async (values, config)=>{
            return $22e8bbe85fc9ffba$var$CLOSE_DATE_VALUES.filter((value)=>values.includes(value)).map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $e1d34701a254563e$export$95ac8a541f7029bb)[value]) || (0, $e1d34701a254563e$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: (queryParams)=>{
            const { closeDateVal: closeDateVal } = queryParams;
            const isDateValid = $22e8bbe85fc9ffba$var$isIsoDate(closeDateVal?.[0]);
            const dateVal = isDateValid && closeDateVal?.[0] ? closeDateVal[0] : '';
            if (dateVal) return {
                closeDateVal: dateVal
            };
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $22e8bbe85fc9ffba$var$CLOSE_DATE_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $e1d34701a254563e$export$95ac8a541f7029bb)[value]) || (0, $e1d34701a254563e$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    customValueFields: [
        'closeDateVal'
    ]
});
module.exports["filter"] = $22e8bbe85fc9ffba$export$3dea766d36a8935f;

});

parcelRegister("8Q2g1", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $600b0700f5709c84$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement,
    (0, $dvVWp.ProductKeys).CustomerServiceManagement
];
const $600b0700f5709c84$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('commentedByMe');
const $600b0700f5709c84$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'commentedByMe',
    queryParams: {
        key: 'jCommentedByMe'
    },
    products: [
        ...$600b0700f5709c84$var$productKeys1P,
        ...$600b0700f5709c84$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $600b0700f5709c84$export$3dea766d36a8935f;

});

parcelRegister("cRSiy", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $e6Tv8 = parcelRequire("e6Tv8");


var $evHnc = parcelRequire("evHnc");


var $dv1ov = parcelRequire("dv1ov");


var $S6W9B = parcelRequire("S6W9B");


var $gByuu = parcelRequire("gByuu");


var $7Ag9o = parcelRequire("7Ag9o");


var $fOh5X = parcelRequire("fOh5X");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $kZdMI = parcelRequire("kZdMI");

const $421fbacd3d5c29a7$var$getContentId = (ari)=>{
    const EXTRACT_ID = /ari:.*?:.*?:.*?:.*?\/(.*)?.*/;
    const matches = ari.match(EXTRACT_ID);
    // content id of the ari
    return matches && matches.length > 1 ? matches[1] : '';
};
const $421fbacd3d5c29a7$var$searchContent = async (query, config)=>{
    const location = `ari:cloud:confluence::site/${config.cloudId}`;
    const { useCaseId: useCaseId } = config;
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const product = config.product;
    const selectedSpaceAris = $421fbacd3d5c29a7$var$getSelectedSpaceAris(config);
    if ($421fbacd3d5c29a7$var$isThirdPartyProductWithContentUnder(product)) {
        const selectedSpaceAri = selectedSpaceAris[0];
        const datasource = config.selectedDatasource ?? config.thirdPartyConfigs?.[product];
        if (!datasource?.integrationAri) return [];
        const spaceFilter = selectedSpaceAri ? {
            ancestorAris: [
                selectedSpaceAri
            ]
        } : {};
        const contributorAccountIds = $421fbacd3d5c29a7$var$getSelectedContributorAccountIds(config);
        const commonFilters = contributorAccountIds.length > 0 ? {
            contributorsFilter: contributorAccountIds
        } : undefined;
        const response = await (0, $evHnc.searchEntitiesQuery)({
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            variables: {
                query: query,
                useCaseId: useCaseId,
                first: 10,
                experience: 'search-page',
                filters: {
                    entities: (0, $fOh5X.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    locations: [
                        location
                    ],
                    ...commonFilters && {
                        commonFilters: commonFilters
                    },
                    thirdPartyFilters: {
                        titleMatchOnly: true,
                        ...spaceFilter,
                        thirdPartyProducts: [
                            {
                                product: product,
                                integrationId: datasource.integrationAri,
                                subtypes: $421fbacd3d5c29a7$var$getThirdPartyContentUnderSubtypes(product)
                            }
                        ]
                    }
                }
            },
            headers: headers,
            includeContainerId: true
        });
        const results = response.data?.search?.results.edges.map((content)=>{
            // Access entity.containerId for cross-filter validation (folder belongs to which drive/space)
            const containerId = content.node.entity?.containerId;
            const option = {
                trackingKey: content.node.id,
                value: content.node.id,
                label: content.node.title,
                queryParamValue: content.node.id,
                product: config.product,
                ...containerId && {
                    metadata: {
                        containerARI: containerId
                    }
                }
            };
            return option;
        }) || [];
        return results;
    }
    let contentPagesResponse;
    if (product === (0, $dvVWp.ProductKeys).ConfluenceDC) {
        contentPagesResponse = await (0, $dv1ov.confluenceDcContentFilterOptionsQuery)({
            variables: {
                query: query,
                useCaseId: useCaseId,
                cloudIdARI: location,
                limit: 10,
                entities: [
                    'ati:cloud:graph:document'
                ],
                product: product
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return contentPagesResponse.data?.search?.search?.edges.map((content)=>({
                trackingKey: content.node.id,
                value: content.node.id,
                label: (0, $7Ag9o.cleanExcerpt)(content.node.title),
                queryParamValue: content.node.id,
                product: config.product
            })) || [];
    }
    // `locations` is already an array on the backend, so every selected site is read in one query
    // instead of fanning out per site.
    const [currentCloudId = '', ...additionalCloudIds] = config.selectedCloudIds ?? [];
    const locations = (0, $S6W9B.getCloudIdARIs)(currentCloudId, config.primaryProduct, additionalCloudIds);
    contentPagesResponse = await (0, $evHnc.searchEntitiesQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            query: query,
            useCaseId: useCaseId,
            first: 10,
            filters: {
                entities: [
                    'ati:cloud:confluence:page'
                ],
                locations: locations
            }
        },
        headers: headers
    });
    const allContentPages = contentPagesResponse.data?.search?.results.edges.map((content)=>({
            title: content.node.title,
            id: content.node.id
        })) || [];
    const contentOptions = allContentPages.map((content)=>{
        const contentId = $421fbacd3d5c29a7$var$getContentId(content.id);
        return {
            trackingKey: contentId,
            value: contentId,
            label: content.title,
            queryParamValue: contentId,
            product: config.product
        };
    });
    // Page ids are only unique within a site, and the selection is sent downstream as a plain
    // `ancestorIdsFilter` id, so the same id coming back from two sites is one option.
    return (0, $gByuu.mergeAndDedupeOptions)([
        contentOptions
    ]);
};
const $421fbacd3d5c29a7$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $421fbacd3d5c29a7$var$getProducts3PFromConfig = ()=>(0, $hea5O.getProducts3PFromConfigForFilter)('content');
const $421fbacd3d5c29a7$var$getFilterProducts = ()=>[
        ...$421fbacd3d5c29a7$var$productKeys1P,
        ...$421fbacd3d5c29a7$var$getProducts3PFromConfig()
    ];
const $421fbacd3d5c29a7$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES = {
    [(0, $dvVWp.ProductKeys).GoogleDrive]: [
        (0, $7ydfN.NounSubtypeKey).Folder
    ],
    [(0, $dvVWp.ProductKeys).Sharepoint]: [
        (0, $7ydfN.NounSubtypeKey).Drive,
        (0, $7ydfN.NounSubtypeKey).Folder
    ]
};
const $421fbacd3d5c29a7$var$isThirdPartyProductWithContentUnder = (product)=>!!product && product in $421fbacd3d5c29a7$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES && $421fbacd3d5c29a7$var$getProducts3PFromConfig().includes(product);
const $421fbacd3d5c29a7$var$getThirdPartyContentUnderSubtypes = (product)=>$421fbacd3d5c29a7$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES[product] ?? [];
const $421fbacd3d5c29a7$var$getSelectedSpaceAris = (config)=>Array.isArray(config.initialSpaceARIs) ? config.initialSpaceARIs.filter(Boolean) : [];
const $421fbacd3d5c29a7$var$getSelectedContributorAccountIds = (config)=>Array.isArray(config.contributorAccountIds) ? config.contributorAccountIds.filter(Boolean) : [];
const $421fbacd3d5c29a7$var$withCurrentProducts = (state)=>({
        ...state,
        products: $421fbacd3d5c29a7$var$getFilterProducts()
    });
const $421fbacd3d5c29a7$var$withCurrentProductsFilter = (filter)=>({
        ...filter,
        getState: ()=>$421fbacd3d5c29a7$var$withCurrentProducts(filter.getState()),
        queryParams: {
            ...filter.queryParams,
            set: async (queryParams, onStateChange)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(await filter.queryParams.set(queryParams, onStateChange && ((state)=>onStateChange($421fbacd3d5c29a7$var$withCurrentProducts(state)))))
        },
        loadInitialOptions: async (onStateChange)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(await filter.loadInitialOptions(onStateChange && ((state)=>onStateChange($421fbacd3d5c29a7$var$withCurrentProducts(state))))),
        setOption: (option, customValue)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(filter.setOption(option, customValue)),
        clearOptions: ()=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(filter.clearOptions()),
        setLookupInput: async (query, onStateChange)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(await filter.setLookupInput(query, onStateChange && ((state)=>onStateChange($421fbacd3d5c29a7$var$withCurrentProducts(state))))),
        clear: ()=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(filter.clear())
    });
const $421fbacd3d5c29a7$var$baseFilter = (0, $kZdMI.createSingleSelectFilter)({
    id: 'content',
    products: $421fbacd3d5c29a7$var$getFilterProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'ancestor',
        fetcher: async (queryParams, config)=>{
            const product = config.product;
            const location = `ari:cloud:confluence::site/${config.cloudId}`;
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            if ($421fbacd3d5c29a7$var$isThirdPartyProductWithContentUnder(product)) {
                const contentResponse = await (0, $dv1ov.documentARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product,
                        ...content.container?.id && {
                            metadata: {
                                containerARI: content.container.id
                            }
                        }
                    })) || [];
            }
            if (product === (0, $dvVWp.ProductKeys).ConfluenceDC) {
                const contentPagesResponse = await (0, $dv1ov.confluenceDcPagesQuery)({
                    variables: {
                        query: '',
                        cloudIdARI: location,
                        limit: 10,
                        entities: [
                            'ati:cloud:graph:document'
                        ],
                        product: product,
                        ancestorIds: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentPagesResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product
                    })) || [];
            }
            const initialContentARIs = queryParams.map((contentId)=>`ari:cloud:confluence:${config.cloudId}:page/${contentId}`);
            const initialContentResponse = await (0, $e6Tv8.confluencePagesQuery)(initialContentARIs, headers);
            const allContentPages = initialContentResponse.data?.confluence.pages.map((page)=>({
                    title: page.title,
                    id: page.id
                })) || [];
            const contentOptions = allContentPages.map((content)=>{
                const contentId = $421fbacd3d5c29a7$var$getContentId(content.id);
                return {
                    trackingKey: contentId,
                    value: contentId,
                    label: content.title,
                    queryParamValue: contentId,
                    product: config.product
                };
            });
            return contentOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $421fbacd3d5c29a7$var$searchContent('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $421fbacd3d5c29a7$var$searchContent(query, config);
        }
    }
});
const $421fbacd3d5c29a7$export$3dea766d36a8935f = {
    ...$421fbacd3d5c29a7$var$baseFilter,
    queryParams: {
        ...$421fbacd3d5c29a7$var$baseFilter.queryParams,
        getState: (queryParams, cloudId)=>$421fbacd3d5c29a7$var$withCurrentProducts($421fbacd3d5c29a7$var$baseFilter.queryParams.getState(queryParams, cloudId))
    },
    get products () {
        return $421fbacd3d5c29a7$var$getFilterProducts();
    },
    withState: (state, config)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter($421fbacd3d5c29a7$var$baseFilter.withState({
            ...state,
            products: $421fbacd3d5c29a7$var$getFilterProducts()
        }, config)),
    getInitialState: (config)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter($421fbacd3d5c29a7$var$baseFilter.getInitialState(config))
};
module.exports["filter"] = $421fbacd3d5c29a7$export$3dea766d36a8935f;

});

parcelRegister("a4K4k", function(module, exports) {

var $fR63l = parcelRequire("fR63l");


var $AgYeH = parcelRequire("AgYeH");


var $YTPUb = parcelRequire("YTPUb");


var $j5Usq = parcelRequire("j5Usq");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $7d2151fd53dc4ada$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
// Each site still returns MAX_SEARCHED_OPTIONS_RESULTS, so five sites could otherwise surface 25.
const $7d2151fd53dc4ada$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS = 10;
const $7d2151fd53dc4ada$export$a4d01c087c4a6f1c = [
    '@',
    'contributor:'
];
// Filter out Trello for milestone 1 (QS-4733)
// Focus does not have contributor field
const $7d2151fd53dc4ada$var$productKeys1P = (0, $dvVWp.all1pProductKeys).filter((key)=>key !== (0, $dvVWp.ProductKeys).Trello && key !== (0, $dvVWp.ProductKeys).Focus && key !== (0, $dvVWp.ProductKeys).Talent);
const $7d2151fd53dc4ada$var$fetchContributorOptionsForSite = async (query, config, cloudId)=>{
    if (!config.intl) return [];
    const response = await (0, $YTPUb.getContributors)({
        query: query,
        cloudId: cloudId,
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $7d2151fd53dc4ada$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) // TODO: log not found somewhere
    return [];
    return response.map((contributor)=>({
            trackingKey: contributor.id,
            value: contributor.id,
            label: contributor.name,
            avatarUrl: contributor.avatarUrl,
            queryParamValue: contributor.id,
            product: config.product
        }));
};
// Figma doesn't support contributor
// https://atlassian.slack.com/archives/C07P3MD2U9Z/p1733868616441159?thread_ts=1733866616.102409&cid=C07P3MD2U9Z
const $7d2151fd53dc4ada$var$all3pProductKeysExceptFigma = (0, $dvVWp.all3pProductKeys).filter((key)=>key !== (0, $fR63l.ProductKeys3P).Figma);
const $7d2151fd53dc4ada$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'contributor',
    // 1P only for now (excluding Trello)
    products: [
        ...$7d2151fd53dc4ada$var$productKeys1P,
        ...$7d2151fd53dc4ada$var$all3pProductKeysExceptFigma
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'contributors',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $j5Usq.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (0, $3e0Ll.loadRecommendedUsers)(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            const options = await (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$7d2151fd53dc4ada$var$fetchContributorOptionsForSite(query, config, cloudId));
            return options.slice(0, $7d2151fd53dc4ada$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS);
        }
    }
});
module.exports["filter"] = $7d2151fd53dc4ada$export$3dea766d36a8935f;

});

parcelRegister("dpRDk", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $5yReE = parcelRequire("5yReE");


var $j5Usq = parcelRequire("j5Usq");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $b9457923c85e0a77$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $b9457923c85e0a77$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('createdBy');
const $b9457923c85e0a77$var$loadInitialOptions = async (config)=>{
    return (0, $3e0Ll.loadRecommendedUsers)(config);
};
const $b9457923c85e0a77$var$searchCreatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $5yReE.getCreatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $b9457923c85e0a77$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $b9457923c85e0a77$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'createdBy',
    products: [
        ...$b9457923c85e0a77$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'createdBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allCreatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const createdByOptions = allCreatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return createdByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $b9457923c85e0a77$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $b9457923c85e0a77$var$searchCreatedBy(query, config);
        }
    }
});
module.exports["filter"] = $b9457923c85e0a77$export$3dea766d36a8935f;

});

parcelRegister("7TxDU", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $a7280eb61b4b3796$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $a7280eb61b4b3796$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('documentStatus');
const $a7280eb61b4b3796$var$documentStatusProducts = Array.from(new Set([
    ...$a7280eb61b4b3796$var$salesforceProducts,
    ...$a7280eb61b4b3796$var$products3PFromConfig
]));
const $a7280eb61b4b3796$var$fetchDynamicDocumentStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const knowledgeArticlePublishStatuses = result.filters.find((f)=>f.name === 'knowledgeArticlePublishStatuses');
        if (!knowledgeArticlePublishStatuses || knowledgeArticlePublishStatuses.values.length === 0) return [];
        return knowledgeArticlePublishStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $a7280eb61b4b3796$var$fetchDocumentStatusOptions = async (config)=>{
    return $a7280eb61b4b3796$var$fetchDynamicDocumentStatusOptions(config);
};
const $a7280eb61b4b3796$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $a7280eb61b4b3796$var$fetchDocumentStatusOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $a7280eb61b4b3796$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'documentStatus',
    requiresTopLevel3PDatasource: true,
    products: $a7280eb61b4b3796$var$documentStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'knowledgeArticleStatuses',
        fetcher: async (queryParams, config)=>{
            return $a7280eb61b4b3796$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $a7280eb61b4b3796$var$fetchDocumentStatusOptions(config);
        }
    }
});
module.exports["filter"] = $a7280eb61b4b3796$export$3dea766d36a8935f;

});

parcelRegister("epN5B", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $kfEW5 = parcelRequire("kfEW5");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

/**
 * Queries all focus area types from graphQL and returns all options as suggested but unselected
 * @param config
 * @returns
 */ const $b625ac9cc3d1cd87$var$getFocusAreaTypeOptionsForSite = async (config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreaTypesResponse = await (0, $kfEW5.mercuryFocusAreaTypesQuery)(cloudId, headers);
    const focusAreaTypes = focusAreaTypesResponse.data?.mercury.focusAreaTypes ?? [];
    return focusAreaTypes.map((focusAreaType)=>({
            trackingKey: focusAreaType.id,
            label: focusAreaType.name,
            value: focusAreaType.id,
            queryParamValue: focusAreaType.id,
            product: config.product
        }));
};
const $b625ac9cc3d1cd87$var$getInitialOptions = async (config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$b625ac9cc3d1cd87$var$getFocusAreaTypeOptionsForSite(config, cloudId));
};
/**
 * Queries all focus area types from graphQL and returns all options as suggested and query params are suggested
 * @param queryParams
 * @param config
 * @returns
 */ const $b625ac9cc3d1cd87$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const focusAreaTypeOptions = await $b625ac9cc3d1cd87$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>queryParams.includes(option.value));
};
/**
 * Queries all focus area types from graphQL and filters out options that do not match the text query
 * @param query
 * @param config
 * @returns
 */ const $b625ac9cc3d1cd87$var$getOptionsFilteredByTextQuery = async (query, config)=>{
    const focusAreaTypeOptions = await $b625ac9cc3d1cd87$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>option.label.toLowerCase().includes(query.toLowerCase()));
};
const $b625ac9cc3d1cd87$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Focus
];
const $b625ac9cc3d1cd87$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'focusAreaType',
    products: $b625ac9cc3d1cd87$var$productKeys1P,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'focusAreaTypes',
        fetcher: $b625ac9cc3d1cd87$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: $b625ac9cc3d1cd87$var$getInitialOptions
    },
    lookup: {
        fetcher: $b625ac9cc3d1cd87$var$getOptionsFilteredByTextQuery
    }
});
module.exports["filter"] = $b625ac9cc3d1cd87$export$3dea766d36a8935f;

});

parcelRegister("kfEW5", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $52cd1dbde71c9335$export$fb16ff36c6030271 = (0, $bHHWv.inMemoryCache)();
const $52cd1dbde71c9335$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME = 'FocusAreaTypes';
const $52cd1dbde71c9335$var$mercuryFocusAreaTypesQueryString = `query ${$52cd1dbde71c9335$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME}($cloudId: ID!) {
  mercury {
    focusAreaTypes(cloudId: $cloudId) @optIn(to: "Mercury") {
      id
      name
      hierarchyLevel
    }
  }
}`;
const $52cd1dbde71c9335$export$780cc3f06f467bfe = (cloudId, headers)=>{
    return $52cd1dbde71c9335$export$fb16ff36c6030271.inMemoryDecorator(cloudId, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreaTypes: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $52cd1dbde71c9335$var$mercuryFocusAreaTypesQueryString,
            variables: {
                cloudId: cloudId
            },
            operationName: $52cd1dbde71c9335$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreaTypesQuery"] = $52cd1dbde71c9335$export$780cc3f06f467bfe;

});

parcelRegister("MFQTE", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $imRpm = parcelRequire("imRpm");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $7b0395d16d6ecff3$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $7b0395d16d6ecff3$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $7b0395d16d6ecff3$var$searchFocusAreasForSite = async (query, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $imRpm.mercuryFocusAreasQuery)(cloudId, query, $7b0395d16d6ecff3$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$7b0395d16d6ecff3$var$mapFocusAreaResult(focusArea, config.product));
};
const $7b0395d16d6ecff3$var$searchFocusAreas = async (query, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$7b0395d16d6ecff3$var$searchFocusAreasForSite(query, config, cloudId));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $7b0395d16d6ecff3$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    return $7b0395d16d6ecff3$var$searchFocusAreas(mqlQuery, config);
};
const $7b0395d16d6ecff3$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Focus
];
const $7b0395d16d6ecff3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'focusAreaUnder',
    products: $7b0395d16d6ecff3$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'focusAreaUnder',
        fetcher: $7b0395d16d6ecff3$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $7b0395d16d6ecff3$var$searchFocusAreas(`(search LIKE '')`, config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>$7b0395d16d6ecff3$var$searchFocusAreas(`(search LIKE '${query}')`, config)
    }
});
module.exports["filter"] = $7b0395d16d6ecff3$export$3dea766d36a8935f;

});

parcelRegister("imRpm", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $7280c1ea62400160$export$7e54d23e8f945514 = (0, $bHHWv.inMemoryCache)();
const $7280c1ea62400160$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME = 'FocusAreas';
const $7280c1ea62400160$var$mercuryFocusAreasQueryString = `query ${$7280c1ea62400160$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME}($cloudId: ID!, $q: String, $first: Int, $sort: [MercuryFocusAreaSort]) {
  mercury {
    focusAreas(cloudId: $cloudId, q: $q, first: $first, sort: $sort) @optIn(to: "Mercury") {
      edges {
        node {
          id
          uuid
          name
          status {
		    key            
          }
          health {
            key
          }
          focusAreaType {
		  	name
            hierarchyLevel
          }
		  owner {
            name
          }
        }
      }
    }
  }
}`;
const $7280c1ea62400160$var$MercuryFocusAreaSortField = {
    Budget: 'BUDGET',
    FocusAreaType: 'FOCUS_AREA_TYPE',
    HasParent: 'HAS_PARENT',
    HierarchyLevel: 'HIERARCHY_LEVEL',
    LastUpdated: 'LAST_UPDATED',
    Name: 'NAME',
    Spend: 'SPEND',
    Status: 'STATUS',
    TargetDate: 'TARGET_DATE',
    Watching: 'WATCHING'
};
const $7280c1ea62400160$var$MercuryFocusAreaSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $7280c1ea62400160$export$f9d9785ff9cc54a6 = (cloudId, q, first = 20, sort = [
    {
        field: $7280c1ea62400160$var$MercuryFocusAreaSortField.FocusAreaType,
        order: $7280c1ea62400160$var$MercuryFocusAreaSortOrder['ASC']
    },
    {
        field: $7280c1ea62400160$var$MercuryFocusAreaSortField.Name,
        order: $7280c1ea62400160$var$MercuryFocusAreaSortOrder['ASC']
    }
], headers)=>{
    return $7280c1ea62400160$export$7e54d23e8f945514.inMemoryDecorator(`${cloudId}-${q}-${first}-${JSON.stringify(sort)}`, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreas: {
                        edges: []
                    }
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $7280c1ea62400160$var$mercuryFocusAreasQueryString,
            variables: {
                cloudId: cloudId,
                q: q,
                first: first,
                sort: sort
            },
            operationName: $7280c1ea62400160$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreasQuery"] = $7280c1ea62400160$export$f9d9785ff9cc54a6;

});

parcelRegister("kIkSt", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $AgYeH = parcelRequire("AgYeH");


var $b0Mpu = parcelRequire("b0Mpu");

const $9f68bb72c5fdc3bb$var$LOOM_FOLDER_BY_ID_OPERATION_NAME = 'LoomRovoFolderByIdQuery';
const $9f68bb72c5fdc3bb$var$folderByIdQuery = `
	query ${$9f68bb72c5fdc3bb$var$LOOM_FOLDER_BY_ID_OPERATION_NAME}($id: ID!) {
		loom_folder(id: $id) {
			id
			name
			parentSpaceId
		}
	}
`;
const $9f68bb72c5fdc3bb$export$b7085708bfeef637 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>(0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers,
        graphQuery: $9f68bb72c5fdc3bb$var$folderByIdQuery,
        operationName: $9f68bb72c5fdc3bb$var$LOOM_FOLDER_BY_ID_OPERATION_NAME
    });





const $cd384567b55f9b2c$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME = 'LoomRovoFoldersSearchQuery';
const $cd384567b55f9b2c$var$loomFoldersSearchGraphQuery = `
	query ${$cd384567b55f9b2c$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME}(
		$siteId: ID!
		$query: String
		$spaceId: ID
		$includeDefaultFolders: Boolean
	) {
		loom_foldersSearch(
			siteId: $siteId
			query: $query
			spaceId: $spaceId
			includeDefaultFolders: $includeDefaultFolders
		) {
			id
			name
			parentSpaceId
		}
	}
`;
const $cd384567b55f9b2c$var$trimToLimit = (result, limit)=>typeof limit === 'number' ? {
        ...result,
        data: result.data ? {
            ...result.data,
            loom_foldersSearch: result.data.loom_foldersSearch.slice(0, limit)
        } : result.data
    } : result;
const $cd384567b55f9b2c$export$4be1bdb8e3aa7332 = async ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    // `limit` is not sent to AGG: `loom_foldersSearch` has no limit variable in the GraphQL schema,
    // so we request the full result set and cap length client-side in `trimToLimit` below.
    const { siteId: siteId, query: query, spaceId: spaceId, includeDefaultFolders: includeDefaultFolders, limit: limit } = variables;
    const response = await (0, $b0Mpu.fetchAgg)({
        variables: {
            siteId: siteId,
            query: query,
            spaceId: spaceId,
            includeDefaultFolders: includeDefaultFolders
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $cd384567b55f9b2c$var$loomFoldersSearchGraphQuery,
        operationName: $cd384567b55f9b2c$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME,
        headers: headers
    });
    return $cd384567b55f9b2c$var$trimToLimit(response, limit);
};



var $7Ag9o = parcelRequire("7Ag9o");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT = 15;
const $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_LOOKUP_LIMIT = 15;
/** Max concurrent AGG calls for space suggestions or folder ID hydration. */ const $2679b162acbc1f52$var$LOOM_FOLDER_AGG_CONCURRENCY = 5;
async function $2679b162acbc1f52$var$runWithConcurrencyLimit(tasks, concurrency) {
    if (tasks.length === 0) return [];
    const safeConcurrency = Math.max(1, Math.floor(concurrency));
    const results = new Array(tasks.length);
    let nextIndex = 0;
    const worker = async ()=>{
        for(;;){
            const index = nextIndex++;
            if (index >= tasks.length) return;
            const [outcome] = await Promise.allSettled([
                tasks[index]()
            ]);
            results[index] = outcome.status === 'fulfilled' ? outcome.value : undefined;
        }
    };
    const workerCount = Math.min(safeConcurrency, tasks.length);
    await Promise.allSettled(Array.from({
        length: workerCount
    }, ()=>worker()));
    return results;
}
const $2679b162acbc1f52$var$getSelectedSpaceAris = (config)=>Array.isArray(config.initialSpaceARIs) ? config.initialSpaceARIs.filter(Boolean) : [];
const $2679b162acbc1f52$var$mapFolderNodeToOption = (folder)=>({
        trackingKey: folder.id,
        value: folder.id,
        label: (0, $7Ag9o.cleanExcerpt)(folder.name),
        queryParamValue: folder.id,
        product: (0, $dvVWp.ProductKeys).Loom,
        isDefault: false,
        isSelected: false,
        isSuggested: true,
        ...folder.parentSpaceId ? {
            metadata: {
                parentSpaceId: folder.parentSpaceId
            }
        } : {}
    });
async function $2679b162acbc1f52$var$fetchLoomFolderOptions(config, { query: query = '', limit: limit } = {}) {
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const spaceAris = $2679b162acbc1f52$var$getSelectedSpaceAris(config);
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const queryVariables = {
        siteId: cloudId,
        query: query || undefined,
        limit: limit
    };
    // With no selected space, request workspace / personal default folders (Personal Library,
    // Archived, …). Once spaces are selected, only request folders within those spaces so the
    // suggestions are compatible with the active space filter.
    const folderFetchTasks = spaceAris.length === 0 ? [
        ()=>(0, $cd384567b55f9b2c$export$4be1bdb8e3aa7332)({
                variables: {
                    ...queryVariables,
                    includeDefaultFolders: true
                },
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                headers: headers
            })
    ] : spaceAris.map((spaceId)=>()=>(0, $cd384567b55f9b2c$export$4be1bdb8e3aa7332)({
                variables: {
                    ...queryVariables,
                    spaceId: spaceId,
                    includeDefaultFolders: false
                },
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                headers: headers
            }));
    const responses = await $2679b162acbc1f52$var$runWithConcurrencyLimit(folderFetchTasks, $2679b162acbc1f52$var$LOOM_FOLDER_AGG_CONCURRENCY);
    const seenFolderIds = new Set();
    const folderOptions = [];
    for (const response of responses){
        if (response === undefined) continue;
        for (const folder of response.data?.loom_foldersSearch ?? []){
            if (seenFolderIds.has(folder.id)) continue;
            seenFolderIds.add(folder.id);
            folderOptions.push($2679b162acbc1f52$var$mapFolderNodeToOption(folder));
        }
    }
    return folderOptions;
}
const $2679b162acbc1f52$var$getInitialOptions = async (config)=>$2679b162acbc1f52$var$fetchLoomFolderOptions(config, {
        query: '',
        limit: $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT
    });
const $2679b162acbc1f52$var$fetchLookupOptions = async (input, config)=>{
    return $2679b162acbc1f52$var$fetchLoomFolderOptions(config, {
        query: input,
        limit: $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_LOOKUP_LIMIT
    });
};
const $2679b162acbc1f52$var$fetchQueryParamOptions = async (folderIds, config)=>{
    if (!(0, $iDrrr.fg)('loom-rovo-search')) {
        const requestedFolderIds = new Set(folderIds);
        const options = await $2679b162acbc1f52$var$fetchLoomFolderOptions(config);
        return options.filter((option)=>requestedFolderIds.has(option.value));
    }
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const responses = await $2679b162acbc1f52$var$runWithConcurrencyLimit(Array.from(new Set(folderIds), (id)=>()=>(0, $9f68bb72c5fdc3bb$export$b7085708bfeef637)({
                variables: {
                    id: id
                },
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                headers: headers
            })), $2679b162acbc1f52$var$LOOM_FOLDER_AGG_CONCURRENCY);
    return responses.flatMap((response)=>{
        const folder = response?.data?.loom_folder;
        return folder ? [
            $2679b162acbc1f52$var$mapFolderNodeToOption(folder)
        ] : [];
    });
};
const $2679b162acbc1f52$var$getFilterProducts = ()=>(0, $iDrrr.fg)('loom-rovo-search') ? [
        (0, $dvVWp.ProductKeys).Loom
    ] : [];
const $2679b162acbc1f52$var$createFolderFilter = (products = $2679b162acbc1f52$var$getFilterProducts())=>(0, $7MX1N.createMultiSelectFilter)({
        id: 'folder',
        products: products,
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'folders',
            fetcher: $2679b162acbc1f52$var$fetchQueryParamOptions
        },
        initialOptions: {
            fetcher: $2679b162acbc1f52$var$getInitialOptions
        },
        lookup: {
            fetcher: $2679b162acbc1f52$var$fetchLookupOptions
        }
    });
// Keep module evaluation side-effect free. Runtime entry points below resolve the gated products.
const $2679b162acbc1f52$var$baseFilter = $2679b162acbc1f52$var$createFolderFilter([]);
const $2679b162acbc1f52$export$3dea766d36a8935f = {
    ...$2679b162acbc1f52$var$baseFilter,
    queryParams: {
        ...$2679b162acbc1f52$var$baseFilter.queryParams,
        getState: (queryParams, cloudId)=>{
            const products = $2679b162acbc1f52$var$getFilterProducts();
            const state = $2679b162acbc1f52$var$createFolderFilter(products).queryParams.getState(queryParams, cloudId);
            return {
                ...state,
                value: products.length > 0 ? state.value : [],
                products: products
            };
        }
    },
    withState: (state, config)=>$2679b162acbc1f52$var$createFolderFilter().withState({
            ...state,
            products: $2679b162acbc1f52$var$getFilterProducts()
        }, config),
    getInitialState: (config)=>$2679b162acbc1f52$var$createFolderFilter().getInitialState(config),
    get products () {
        return $2679b162acbc1f52$var$getFilterProducts();
    }
};
module.exports["filter"] = $2679b162acbc1f52$export$3dea766d36a8935f;

});

parcelRegister("i2Y2N", function(module, exports) {

var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $ff0afb98e1d1ef83$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('hasAttachment');
const $ff0afb98e1d1ef83$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'hasAttachment',
    queryParams: {
        key: 'hasAttachment'
    },
    products: [
        ...$ff0afb98e1d1ef83$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $ff0afb98e1d1ef83$export$3dea766d36a8935f;

});

parcelRegister("EICUN", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $6qPRO = parcelRequire("6qPRO");


var $7MX1N = parcelRequire("7MX1N");


var $AgYeH = parcelRequire("AgYeH");


var $gMpbY = parcelRequire("gMpbY");


var $iviWm = parcelRequire("iviWm");




const $7d52788c8ba69304$var$fetchLabelsForSite = async (config, cloudId, query)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const response = await (0, $gMpbY.confluenceLabelsQuery)(cloudId, query, 10, headers);
    const suggestedLabels = response.data?.confluence.searchLabels.suggestedLabels || [];
    const otherLabels = response.data?.confluence.searchLabels.otherLabels || [];
    return [
        ...suggestedLabels,
        ...otherLabels
    ].map((label)=>({
            trackingKey: label.label || '',
            value: label.label || '',
            queryParamValue: label.label || '',
            label: label.label || '',
            product: config.product
        }));
};
const $7d52788c8ba69304$export$1825bdcb0c5952b8 = async (query, config)=>{
    if (!config.intl || config.cloudId === undefined) // base on existing interface, can only query contributors with intl
    return [];
    const product = config.product;
    if (product === (0, $dvVWp.ProductKeys).ConfluenceDC) return [
        {
            trackingKey: query,
            value: query,
            label: query,
            queryParamValue: query,
            product: config.product
        }
    ];
    // Labels are plain strings, so the same label on two sites is one option that filters both.
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$7d52788c8ba69304$var$fetchLabelsForSite(config, cloudId, query));
};
const $7d52788c8ba69304$export$ae59602b611675bf = async (queryParams)=>{
    return queryParams.map((label)=>({
            trackingKey: label,
            value: label,
            queryParamValue: label,
            label: label
        }));
};



var $li5ty = parcelRequire("li5ty");

const $5609f10a8a4040cb$export$218f28c8d8799e97 = async (config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $li5ty.getSuggestedJiraLabels)({
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: true,
            product: config.product
        }));
};
const $5609f10a8a4040cb$export$9a3d32e397d14cdf = async (query, config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $li5ty.getSuggestedJiraLabels)({
        query: query,
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: false,
            product: config.product
        }));
};
const $5609f10a8a4040cb$export$eea6e8b7edaba18f = async (queryParams, config)=>{
    const options = queryParams.map((queryParam)=>({
            trackingKey: queryParam,
            value: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return options;
};


const $c073a91cfc096268$var$getProducts1P = ()=>{
    return [
        (0, $dvVWp.ProductKeys).Confluence,
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement,
        (0, $dvVWp.ProductKeys).CustomerServiceManagement
    ];
};
const $c073a91cfc096268$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'label',
    products: [
        ...$c073a91cfc096268$var$getProducts1P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'labels',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $dvVWp.ProductKeys).Confluence || config.product === (0, $dvVWp.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $dvVWp.ProductKeys).Confluence) return (0, $7d52788c8ba69304$export$ae59602b611675bf)(queryParams, config);
            const safePrimaryProduct = (0, $dvVWp.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $6qPRO.isJiraProduct)(config.product) || (0, $6qPRO.isJiraProduct)(safePrimaryProduct)) return (0, $5609f10a8a4040cb$export$eea6e8b7edaba18f)(queryParams, config);
            // Not supported in other products
            return [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const safePrimaryProduct = (0, $dvVWp.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $6qPRO.isJiraProduct)(config.product) || (0, $6qPRO.isJiraProduct)(safePrimaryProduct)) return (0, $5609f10a8a4040cb$export$218f28c8d8799e97)(config);
            return [];
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (config.product === (0, $dvVWp.ProductKeys).Confluence || config.product === (0, $dvVWp.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $dvVWp.ProductKeys).Confluence) return (0, $7d52788c8ba69304$export$1825bdcb0c5952b8)(query, config);
            const safePrimaryProduct = (0, $dvVWp.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $6qPRO.isJiraProduct)(config.product) || (0, $6qPRO.isJiraProduct)(safePrimaryProduct)) return (0, $5609f10a8a4040cb$export$9a3d32e397d14cdf)(query, config);
            return [];
        }
    }
});
module.exports["filter"] = $c073a91cfc096268$export$3dea766d36a8935f;

});

parcelRegister("6qPRO", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");

const $246f35dff0a837bd$export$ecb101fddedffa32 = (product, includeDC = false)=>{
    const jiraProducts = includeDC ? [
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraDC,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement,
        (0, $dvVWp.ProductKeys).CustomerServiceManagement
    ] : [
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement,
        (0, $dvVWp.ProductKeys).CustomerServiceManagement
    ];
    return Boolean(jiraProducts.find((jiraProduct)=>jiraProduct === product));
};
module.exports["isJiraProduct"] = $246f35dff0a837bd$export$ecb101fddedffa32;

});

parcelRegister("li5ty", function(module, exports) {

var $fExfj = parcelRequire("fExfj");

const $006a7e2c64c5f888$export$eddac1daa475a197 = async ({ query: query = '', absoluteUrl: absoluteUrl })=>{
    const options = {
        path: 'rest/api/1.0/labels/suggest',
        queryParams: {
            query: query
        },
        requestInit: {
            method: 'GET',
            headers: {
                accept: 'application/json',
                'x-atlassian-capability': 'ROVO_FULL_PAGE_SEARCH'
            }
        }
    };
    return (0, $fExfj.utils).requestService({
        url: absoluteUrl
    }, options);
};
module.exports["getSuggestedJiraLabels"] = $006a7e2c64c5f888$export$eddac1daa475a197;

});

parcelRegister("ikbkS", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");


var $hea5O = parcelRequire("hea5O");


var $m6ow8 = parcelRequire("m6ow8");


var $kSwu1 = parcelRequire("kSwu1");

const $4734bd722a21269b$export$3f164da8f895a853 = (0, $kSwu1.defineMessages)({
    anytime: {
        id: "search-page.filter.last.updated.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.last.updated.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "search-page.filter.last.updated.yesterday",
        defaultMessage: "Yesterday"
    },
    past7Days: {
        id: "search-page.filter.last.updated.past7Days",
        defaultMessage: "Past 7 days"
    },
    past30Days: {
        id: "search-page.filter.last.updated.past30Days",
        defaultMessage: "Past 30 days"
    },
    pastYear: {
        id: "search-page.filter.last.updated.pastYear",
        defaultMessage: "Past year"
    },
    custom: {
        id: "search-page.filter.last.updated.custom",
        defaultMessage: "Custom"
    }
});



var $iaii4 = parcelRequire("iaii4");

const $5d3e7fabbed11965$var$LAST_UPDATED_VALUES = [
    'today',
    'yesterday',
    'past7Days',
    'past30Days',
    'pastYear',
    'custom'
];
const $5d3e7fabbed11965$var$sortCompareFn = (a, b)=>{
    return $5d3e7fabbed11965$var$LAST_UPDATED_VALUES.indexOf(a.value) - $5d3e7fabbed11965$var$LAST_UPDATED_VALUES.indexOf(b.value);
};
const $5d3e7fabbed11965$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Atlas,
    (0, $dvVWp.ProductKeys).Confluence,
    (0, $dvVWp.ProductKeys).Focus,
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement,
    (0, $dvVWp.ProductKeys).CustomerServiceManagement,
    (0, $dvVWp.ProductKeys).Compass,
    (0, $dvVWp.ProductKeys).Trello,
    (0, $dvVWp.ProductKeys).Bitbucket
];
const $5d3e7fabbed11965$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('lastUpdated');
const $5d3e7fabbed11965$export$3dea766d36a8935f = (0, $m6ow8.createSingleWithCustomOptionSelectFilter)({
    id: 'lastUpdated',
    products: [
        ...$5d3e7fabbed11965$var$productKeys1P,
        ...$5d3e7fabbed11965$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'lastModified',
        fetcher: async (_, config)=>{
            return $5d3e7fabbed11965$var$LAST_UPDATED_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $4734bd722a21269b$export$3f164da8f895a853)[value]) || (0, $4734bd722a21269b$export$3f164da8f895a853)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: $iaii4.customValueParser,
        generateQueryParamsGetState: $iaii4.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: 'anytime',
                    label: config.intl?.formatMessage((0, $4734bd722a21269b$export$3f164da8f895a853)['anytime']) || (0, $4734bd722a21269b$export$3f164da8f895a853)['anytime'].defaultMessage,
                    value: 'anytime',
                    isDefault: true,
                    queryParamValue: (0, $cZKQq.LastModified).Anytime,
                    product: config.product
                },
                ...$5d3e7fabbed11965$var$LAST_UPDATED_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $4734bd722a21269b$export$3f164da8f895a853)[value]) || (0, $4734bd722a21269b$export$3f164da8f895a853)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $5d3e7fabbed11965$var$sortCompareFn,
    customValueFields: [
        'to',
        'from'
    ]
});
module.exports["filter"] = $5d3e7fabbed11965$export$3dea766d36a8935f;

});

parcelRegister("5h8lq", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $8pAq5 = parcelRequire("8pAq5");


var $j5Usq = parcelRequire("j5Usq");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $5717633a044a584d$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $5717633a044a584d$var$loadInitialOptions = async (config)=>{
    return (0, $3e0Ll.loadRecommendedUsers)(config);
};
const $5717633a044a584d$var$searchlastUpdatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const productKey = (0, $82ADO.getUrsProductKey)(config.primaryProduct);
    const response = await (0, $8pAq5.getLastUpdatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: productKey,
        maxNumberOfResults: $5717633a044a584d$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $5717633a044a584d$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'lastUpdatedBy',
    products: [
        (0, $dvVWp.ProductKeys).Salesforce,
        (0, $dvVWp.ProductKeys).Hubspot
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'lastUpdatedBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allLastUpdatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const lastUpdatedByOptions = allLastUpdatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return lastUpdatedByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $5717633a044a584d$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $5717633a044a584d$var$searchlastUpdatedBy(query, config);
        }
    }
});
module.exports["filter"] = $5717633a044a584d$export$3dea766d36a8935f;

});

parcelRegister("9rMWc", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $25a6065339ecd514$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $25a6065339ecd514$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('leadStatus');
const $25a6065339ecd514$var$leadStatusProducts = Array.from(new Set([
    ...$25a6065339ecd514$var$salesforceProducts,
    ...$25a6065339ecd514$var$products3PFromConfig
]));
const $25a6065339ecd514$var$fetchDynamicLeadStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const leadStatuses = result.filters.find((f)=>f.name === 'leadStatuses');
        if (!leadStatuses || leadStatuses.values.length === 0) return [];
        return leadStatuses.values.map((leadStatus)=>({
                value: leadStatus.name,
                trackingKey: leadStatus.name,
                queryParamValue: leadStatus.name,
                isDefault: false,
                label: leadStatus.label ?? leadStatus.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $25a6065339ecd514$var$fetchLeadStatusOptions = async (config)=>{
    return $25a6065339ecd514$var$fetchDynamicLeadStatusOptions(config);
};
const $25a6065339ecd514$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $25a6065339ecd514$var$fetchLeadStatusOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $25a6065339ecd514$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'leadStatus',
    requiresTopLevel3PDatasource: true,
    products: $25a6065339ecd514$var$leadStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'leadStatuses',
        fetcher: async (queryParams, config)=>{
            return $25a6065339ecd514$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $25a6065339ecd514$var$fetchLeadStatusOptions(config);
        }
    }
});
module.exports["filter"] = $25a6065339ecd514$export$3dea766d36a8935f;

});

parcelRegister("AmZkX", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $kZdMI = parcelRequire("kZdMI");


var $XRj3F = parcelRequire("XRj3F");


var $kSwu1 = parcelRequire("kSwu1");

const $89688ada5362bb20$export$815fbd192b2af8a4 = (0, $kSwu1.defineMessages)({
    all: {
        id: "search-page.filter.opportunityStatus.all",
        defaultMessage: "Any"
    },
    open: {
        id: "search-page.filter.opportunityStatus.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.filter.opportunityStatus.closed",
        defaultMessage: "Closed"
    }
});


const $2b4edcc5a5aed134$export$2fbe3998cc101414 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $89688ada5362bb20$export$815fbd192b2af8a4)['all']) ?? '',
        product: config.product
    };
    const opportunityStatusOptions = (0, $XRj3F.allOpportunityStatusFilterValueKeys).map((key)=>({
            value: key,
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $89688ada5362bb20$export$815fbd192b2af8a4)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...opportunityStatusOptions
    ];
};


const $81b199ef174fc1a5$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $81b199ef174fc1a5$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('opportunityStatus');
const $81b199ef174fc1a5$var$opportunityStatusProducts = Array.from(new Set([
    ...$81b199ef174fc1a5$var$salesforceProducts,
    ...$81b199ef174fc1a5$var$products3PFromConfig
]));
const $81b199ef174fc1a5$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $2b4edcc5a5aed134$export$2fbe3998cc101414)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $81b199ef174fc1a5$var$getInitialOptions = (config)=>{
    const allOptions = (0, $2b4edcc5a5aed134$export$2fbe3998cc101414)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $81b199ef174fc1a5$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: 'opportunityStatus',
    products: $81b199ef174fc1a5$var$opportunityStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'opportunityStatus',
        fetcher: async (queryParams, config)=>{
            return $81b199ef174fc1a5$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $81b199ef174fc1a5$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $81b199ef174fc1a5$export$3dea766d36a8935f;

});

parcelRegister("2BHso", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $f530N = parcelRequire("f530N");


var $6yWnN = parcelRequire("6yWnN");


var $j5Usq = parcelRequire("j5Usq");


var $iviWm = parcelRequire("iviWm");


var $gByuu = parcelRequire("gByuu");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");

const $1d0369792cfc05e0$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $1d0369792cfc05e0$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
// Each site still returns MAX_SEARCHED_OPTIONS_RESULTS, so five sites could otherwise surface 25.
const $1d0369792cfc05e0$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS = 10;
// Same reasoning for the zero-query recommendations, which return MAX_SMART_DEFAULT_OPTIONS a site.
const $1d0369792cfc05e0$var$MAX_MULTI_SITE_SMART_DEFAULT_OPTIONS = 10;
const $1d0369792cfc05e0$var$toRecommendedUserOption = (config, user)=>({
        trackingKey: user.accountId,
        value: user.accountId,
        label: user.name,
        avatarUrl: user.picture,
        queryParamValue: user.accountId,
        product: config.product
    });
// URS only accepts a scalar `siteId`, so multi-site search fans out one request per site.
const $1d0369792cfc05e0$var$fetchOwnerOptionsForSite = async (query, config, cloudId)=>{
    if (!config.intl) return [];
    const response = await (0, $f530N.getOwners)({
        query: query,
        cloudId: cloudId,
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $1d0369792cfc05e0$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) // TODO: log not found somewhere
    return [];
    return response.map((owner)=>({
            trackingKey: owner.id,
            value: owner.id,
            label: owner.name,
            avatarUrl: owner.avatarUrl,
            queryParamValue: owner.id,
            product: config.product
        }));
};
// `smarts.recommendedUser` takes a scalar `tenantId`, so recommendations fan out one query a site.
const $1d0369792cfc05e0$var$fetchRecommendedOwnerOptionsForSite = async (config, cloudId)=>{
    const response = await (0, $6yWnN.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: cloudId,
            maxNumberOfResults: $1d0369792cfc05e0$var$MAX_SMART_DEFAULT_OPTIONS
        },
        // Attribution is per-site, so these headers cannot be hoisted out of the fan-out.
        headers: (0, $AgYeH.buildAtlAttributionHeaders)({
            cloudId: cloudId,
            activationId: config.activationId,
            product: config.primaryProduct
        })
    });
    const recommendedUsers = (response.data?.smarts.results ?? []).flatMap((recommendedUser)=>!!recommendedUser && !!recommendedUser.user ? {
            id: recommendedUser.id,
            ...recommendedUser.user
        } : []);
    return recommendedUsers.map((user)=>$1d0369792cfc05e0$var$toRecommendedUserOption(config, user));
};
const $1d0369792cfc05e0$var$loadRecommendedOwner = async (config)=>{
    // The current user leads the list and is not site-specific, so this stays a single query —
    // fanning it out would just return the same person once per site.
    const initialUsersQuery = (0, $j5Usq.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : [] // The current user should always be the first recommended user
    ], (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    }));
    const cloudIds = config.selectedCloudIds?.length ? config.selectedCloudIds : [
        config.cloudId || ''
    ];
    const [initialUsersResponse, recommendedOwnerOptions] = await Promise.all([
        initialUsersQuery,
        (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$1d0369792cfc05e0$var$fetchRecommendedOwnerOptionsForSite(config, cloudId))
    ]);
    const currentUserOptions = (initialUsersResponse.data?.users ?? []).map((user)=>$1d0369792cfc05e0$var$toRecommendedUserOption(config, user));
    if (cloudIds.length === 1) return [
        ...currentUserOptions,
        ...recommendedOwnerOptions
    ];
    // The current user leads the round-robin, so they stay first and are not duplicated by a site
    // that also recommends them.
    return (0, $gByuu.mergeAndDedupeOptions)([
        currentUserOptions,
        recommendedOwnerOptions
    ]).slice(0, $1d0369792cfc05e0$var$MAX_MULTI_SITE_SMART_DEFAULT_OPTIONS);
};
const $1d0369792cfc05e0$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence,
    (0, $dvVWp.ProductKeys).Focus
];
const $1d0369792cfc05e0$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('owner');
const $1d0369792cfc05e0$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'owner',
    products: [
        ...$1d0369792cfc05e0$var$productKeys1P,
        ...$1d0369792cfc05e0$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'owners',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $j5Usq.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $1d0369792cfc05e0$var$loadRecommendedOwner(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return [];
            const options = await (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$1d0369792cfc05e0$var$fetchOwnerOptionsForSite(query, config, cloudId));
            return options.slice(0, $1d0369792cfc05e0$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS);
        }
    }
});
module.exports["filter"] = $1d0369792cfc05e0$export$3dea766d36a8935f;

});

parcelRegister("8NYi4", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $kZdMI = parcelRequire("kZdMI");


var $2bNdD = parcelRequire("2bNdD");


var $1Fy3P = parcelRequire("1Fy3P");


var $kSwu1 = parcelRequire("kSwu1");

const $7b4cda44e30068e9$export$29ee4a15a943675b = (0, $kSwu1.defineMessages)({
    all: {
        id: "search-page.filter.pageStatus.all",
        defaultMessage: "All"
    },
    roughDraft: {
        id: "search-page.filter.pageStatus.roughDraft",
        defaultMessage: "Rough draft"
    },
    inProgress: {
        id: "search-page.filter.pageStatus.inProgress",
        defaultMessage: "In progress"
    },
    readyForReview: {
        id: "search-page.filter.pageStatus.readyForReview",
        defaultMessage: "Ready for review"
    },
    verified: {
        id: "search-page.filter.pageStatus.verified",
        defaultMessage: "Verified"
    }
});


const $ad6e803698b1e20f$export$3195c4e56ca4af29 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $7b4cda44e30068e9$export$29ee4a15a943675b)['all']) ?? '',
        product: config.product
    };
    const pageStatusOptions = (0, $1Fy3P.allPageStatusFilterValueKeys).map((key)=>({
            value: (0, $1Fy3P.PageStatusFilterValue)[key],
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $7b4cda44e30068e9$export$29ee4a15a943675b)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...pageStatusOptions
    ];
};


const $632362e36b9f63c9$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $632362e36b9f63c9$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('pageStatus');
const $632362e36b9f63c9$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $ad6e803698b1e20f$export$3195c4e56ca4af29)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $632362e36b9f63c9$var$getInitialOptions = (config)=>{
    const allOptions = (0, $ad6e803698b1e20f$export$3195c4e56ca4af29)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $632362e36b9f63c9$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: 'pageStatus',
    products: [
        ...$632362e36b9f63c9$var$productKeys1P,
        ...$632362e36b9f63c9$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pageStatus',
        fetcher: async (queryParams, config)=>{
            return $632362e36b9f63c9$var$loadQueryParams(queryParams, config);
        },
        generateQueryParamsGetState: $2bNdD.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $632362e36b9f63c9$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $632362e36b9f63c9$export$3dea766d36a8935f;

});

parcelRegister("2sAXF", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $bxIiJ = parcelRequire("bxIiJ");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $8489f1d5f3a8c9c3$var$LIMIT = 20;
const $8489f1d5f3a8c9c3$var$EmploymentTypeMapping = {
    Contingent: 'contingent',
    Employee: 'employee',
    Contractor: 'contractor'
};
const $8489f1d5f3a8c9c3$var$ReverseEmploymentTypeMapping = Object.fromEntries(Object.entries($8489f1d5f3a8c9c3$var$EmploymentTypeMapping).map(([key, value])=>[
        value,
        key
    ]));
const $8489f1d5f3a8c9c3$export$3362d5a8d7ac6a7b = (positionEmploymentType, product)=>{
    const value = $8489f1d5f3a8c9c3$var$EmploymentTypeMapping[positionEmploymentType.node.stringValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionEmploymentType.node.stringValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position employment types by search term
 * @param query
 * @param config
 * @returns
 */ const $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypesForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionEmploymentTypesResponse = await (0, $bxIiJ.positionEmploymentTypesQuery)(cloudId, rqlQuery, $8489f1d5f3a8c9c3$var$LIMIT, undefined, headers);
    const positionEmploymentTypes = positionEmploymentTypesResponse.data?.radar_fieldValues.edges ?? [];
    return positionEmploymentTypes.map((positionEmploymentType)=>$8489f1d5f3a8c9c3$export$3362d5a8d7ac6a7b(positionEmploymentType, config.product));
};
const $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypes = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypesForSite(rqlQuery, config, cloudId));
};
const $8489f1d5f3a8c9c3$var$searchPositionEmploymentTypes = async (query, config)=>{
    const rqlQuery = `employmentType ~ '${query}'`;
    return $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypes(rqlQuery, config);
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $8489f1d5f3a8c9c3$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `employmentType in ('${queryParams.map((param)=>$8489f1d5f3a8c9c3$var$ReverseEmploymentTypeMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    return $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypes(rqlQuery, config);
};
const $8489f1d5f3a8c9c3$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $8489f1d5f3a8c9c3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionEmploymentType',
    products: $8489f1d5f3a8c9c3$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionEmploymentTypes',
        fetcher: $8489f1d5f3a8c9c3$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8489f1d5f3a8c9c3$var$searchPositionEmploymentTypes('', config);
        }
    },
    lookup: {
        fetcher: $8489f1d5f3a8c9c3$var$searchPositionEmploymentTypes
    }
});
module.exports["filter"] = $8489f1d5f3a8c9c3$export$3dea766d36a8935f;

});

parcelRegister("bxIiJ", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $d142e9aafa48423e$export$77f684104cbf1994 = (0, $bHHWv.inMemoryCache)();
const $d142e9aafa48423e$var$QUERY_NAME = 'PositionEmploymentTypes';
const $d142e9aafa48423e$var$positionEmploymentTypesQueryString = `query ${$d142e9aafa48423e$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $d142e9aafa48423e$export$66f27dc417575281 = (cloudId, rql, first = 20, after, headers)=>{
    const fieldId = 'positionEmploymentType';
    return $d142e9aafa48423e$export$77f684104cbf1994.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $d142e9aafa48423e$var$positionEmploymentTypesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $d142e9aafa48423e$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionEmploymentTypesQuery"] = $d142e9aafa48423e$export$66f27dc417575281;

});

parcelRegister("8BOly", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $imRpm = parcelRequire("imRpm");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $8c726a43af8bc8ca$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $8c726a43af8bc8ca$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
const $8c726a43af8bc8ca$var$fetchPositionFocusAreasForSite = async (mqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $imRpm.mercuryFocusAreasQuery)(cloudId, mqlQuery, $8c726a43af8bc8ca$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$8c726a43af8bc8ca$var$mapFocusAreaResult(focusArea, config.product));
};
const $8c726a43af8bc8ca$var$fetchPositionFocusAreas = async (mqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$8c726a43af8bc8ca$var$fetchPositionFocusAreasForSite(mqlQuery, config, cloudId));
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $8c726a43af8bc8ca$var$searchPositionFocusAreas = async (query, config)=>{
    return $8c726a43af8bc8ca$var$fetchPositionFocusAreas(`(search LIKE '${query}')`, config);
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $8c726a43af8bc8ca$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    return $8c726a43af8bc8ca$var$fetchPositionFocusAreas(mqlQuery, config);
};
const $8c726a43af8bc8ca$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $8c726a43af8bc8ca$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionFocusArea',
    products: $8c726a43af8bc8ca$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionFocusAreas',
        fetcher: $8c726a43af8bc8ca$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8c726a43af8bc8ca$var$searchPositionFocusAreas('', config);
        }
    },
    lookup: {
        fetcher: $8c726a43af8bc8ca$var$searchPositionFocusAreas
    }
});
module.exports["filter"] = $8c726a43af8bc8ca$export$3dea766d36a8935f;

});

parcelRegister("dkj04", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $jZtm2 = parcelRequire("jZtm2");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $209dbf838e771ca9$var$LIMIT = 20;
const $209dbf838e771ca9$var$mapPositionJobFamilyResult = (positionJobFamily, product)=>{
    const encodedValue = encodeURIComponent(positionJobFamily.node.stringValue);
    return {
        trackingKey: encodedValue || '',
        label: positionJobFamily.node.stringValue || '',
        value: encodedValue || '',
        queryParamValue: encodedValue || '',
        product: product
    };
};
/**
 * Queries position job families by search term
 * @param query
 * @param config
 * @returns
 */ const $209dbf838e771ca9$var$fetchPositionJobFamiliesForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionJobFamiliesResponse = await (0, $jZtm2.positionJobFamiliesQuery)(cloudId, $209dbf838e771ca9$var$LIMIT, rqlQuery, undefined, headers);
    const positionJobFamilies = positionJobFamiliesResponse.data?.radar_fieldValues.edges ?? [];
    return positionJobFamilies.map((positionJobFamily)=>$209dbf838e771ca9$var$mapPositionJobFamilyResult(positionJobFamily, config.product));
};
const $209dbf838e771ca9$var$fetchPositionJobFamilies = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$209dbf838e771ca9$var$fetchPositionJobFamiliesForSite(rqlQuery, config, cloudId));
};
const $209dbf838e771ca9$var$searchPositionJobFamilies = async (query, config)=>{
    const rqlQuery = `jobFamily ~ '${query}'`;
    return $209dbf838e771ca9$var$fetchPositionJobFamilies(rqlQuery, config);
};
/**
 * Queries all selected job families by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $209dbf838e771ca9$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `jobFamily in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    return $209dbf838e771ca9$var$fetchPositionJobFamilies(rqlQuery, config);
};
const $209dbf838e771ca9$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $209dbf838e771ca9$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionJobFamily',
    products: $209dbf838e771ca9$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionJobFamilies',
        fetcher: $209dbf838e771ca9$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $209dbf838e771ca9$var$searchPositionJobFamilies('', config);
        }
    },
    lookup: {
        fetcher: $209dbf838e771ca9$var$searchPositionJobFamilies
    }
});
module.exports["filter"] = $209dbf838e771ca9$export$3dea766d36a8935f;

});

parcelRegister("jZtm2", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $a11a0d42712a0ff2$export$5918017b3202b827 = (0, $bHHWv.inMemoryCache)();
const $a11a0d42712a0ff2$var$QUERY_NAME = 'PositionJobFamilies';
const $a11a0d42712a0ff2$var$positionJobFamiliesQueryString = `query ${$a11a0d42712a0ff2$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $a11a0d42712a0ff2$export$9573cb9936eb57f3 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionJobFamily';
    return $a11a0d42712a0ff2$export$5918017b3202b827.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $a11a0d42712a0ff2$var$positionJobFamiliesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $a11a0d42712a0ff2$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionJobFamiliesQuery"] = $a11a0d42712a0ff2$export$9573cb9936eb57f3;

});

parcelRegister("5m4QA", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $50e7e = parcelRequire("50e7e");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $b256ce03128dfe3b$var$LIMIT = 20;
const $b256ce03128dfe3b$var$StatusMapping = {
    Filled: 'filled',
    'Not filled': 'unfilled'
};
const $b256ce03128dfe3b$var$ReverseStatusMapping = Object.fromEntries(Object.entries($b256ce03128dfe3b$var$StatusMapping).map(([key, value])=>[
        value,
        key
    ]));
const $b256ce03128dfe3b$export$aa60679002fe2884 = (positionStatus, product)=>{
    const value = $b256ce03128dfe3b$var$StatusMapping[positionStatus.node.statusValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionStatus.node.statusDisplayValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position statuses by search term
 * @param query
 * @param config
 * @returns
 */ const $b256ce03128dfe3b$var$fetchPositionStatusesForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionStatusesResponse = await (0, $50e7e.positionStatusesQuery)(cloudId, $b256ce03128dfe3b$var$LIMIT, rqlQuery, undefined, headers);
    const positionStatuses = positionStatusesResponse.data?.radar_fieldValues.edges ?? [];
    return positionStatuses.map((positionStatus)=>$b256ce03128dfe3b$export$aa60679002fe2884(positionStatus, config.product));
};
const $b256ce03128dfe3b$var$fetchPositionStatuses = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$b256ce03128dfe3b$var$fetchPositionStatusesForSite(rqlQuery, config, cloudId));
};
const $b256ce03128dfe3b$var$searchPositionStatuses = async (query, config)=>{
    const rqlQuery = `status ~ '${query}'`;
    return $b256ce03128dfe3b$var$fetchPositionStatuses(rqlQuery, config);
};
/**
 * Queries all selected position statuses by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $b256ce03128dfe3b$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `status in ('${queryParams.map((param)=>$b256ce03128dfe3b$var$ReverseStatusMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    return $b256ce03128dfe3b$var$fetchPositionStatuses(rqlQuery, config);
};
const $b256ce03128dfe3b$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $b256ce03128dfe3b$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionStatus',
    products: $b256ce03128dfe3b$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionStatuses',
        fetcher: $b256ce03128dfe3b$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $b256ce03128dfe3b$var$searchPositionStatuses('', config);
        }
    },
    lookup: {
        fetcher: $b256ce03128dfe3b$var$searchPositionStatuses
    }
});
module.exports["filter"] = $b256ce03128dfe3b$export$3dea766d36a8935f;

});

parcelRegister("50e7e", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $1c9dfd67ee1bf436$export$9030a66c314dd4f9 = (0, $bHHWv.inMemoryCache)();
const $1c9dfd67ee1bf436$var$QUERY_NAME = 'PositionStatuses';
const $1c9dfd67ee1bf436$var$positionStatusesQueryString = `query ${$1c9dfd67ee1bf436$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStatusFieldValue {
          __typename
          isRestricted
          statusValue: value
          statusDisplayValue: displayValue
          appearance
        }
      }
    }
  }
}`;
const $1c9dfd67ee1bf436$export$edd0381f12f6ff4d = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionStatus';
    return $1c9dfd67ee1bf436$export$9030a66c314dd4f9.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $1c9dfd67ee1bf436$var$positionStatusesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $1c9dfd67ee1bf436$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionStatusesQuery"] = $1c9dfd67ee1bf436$export$edd0381f12f6ff4d;

});

parcelRegister("9XbyR", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $6UNGx = parcelRequire("6UNGx");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");


var $26LZ9 = parcelRequire("26LZ9");

// Number of results returned in dropdown
const $0d2452782e4fdfb3$var$LIMIT = 20;
const $0d2452782e4fdfb3$var$mapPositionTeamResult = (positionTeam, product)=>{
    return {
        trackingKey: positionTeam.node.ari || '',
        label: positionTeam.node.value?.displayName || '',
        value: positionTeam.node.ari || '',
        queryParamValue: encodeURIComponent(positionTeam.node.ari) || '',
        product: product,
        avatarUrl: positionTeam.node.value?.smallAvatarImageUrl || ''
    };
};
/**
 * Queries position teams by search term
 * @param query
 * @param config
 * @returns
 */ const $0d2452782e4fdfb3$var$fetchPositionTeamsForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionTeamsResponse = await (0, $6UNGx.positionTeamsQuery)(cloudId, $0d2452782e4fdfb3$var$LIMIT, rqlQuery, undefined, headers);
    const positionTeams = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];
    return positionTeams.map((positionTeam)=>$0d2452782e4fdfb3$var$mapPositionTeamResult(positionTeam, config.product));
};
const $0d2452782e4fdfb3$var$fetchPositionTeams = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$0d2452782e4fdfb3$var$fetchPositionTeamsForSite(rqlQuery, config, cloudId));
};
const $0d2452782e4fdfb3$var$searchPositionTeams = async (query, config)=>{
    const rqlQuery = `team ~ '${query}'`;
    return $0d2452782e4fdfb3$var$fetchPositionTeams(rqlQuery, config);
};
/**
 * Queries all selected position teams by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $0d2452782e4fdfb3$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `team in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    return $0d2452782e4fdfb3$var$fetchPositionTeams(rqlQuery, config);
};
const $0d2452782e4fdfb3$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $0d2452782e4fdfb3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionTeam',
    products: $0d2452782e4fdfb3$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionTeams',
        fetcher: $0d2452782e4fdfb3$var$getOptionsWithSelectionsFromQueryParams,
        generateQueryParamsGetState: $26LZ9.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $0d2452782e4fdfb3$var$searchPositionTeams('', config);
        }
    },
    lookup: {
        fetcher: $0d2452782e4fdfb3$var$searchPositionTeams
    }
});
module.exports["filter"] = $0d2452782e4fdfb3$export$3dea766d36a8935f;

});

parcelRegister("6UNGx", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $864bd9bcea253ed9$export$7e7f4c6c4a157b2d = (0, $bHHWv.inMemoryCache)();
const $864bd9bcea253ed9$var$QUERY_NAME = 'PositionTeams';
const $864bd9bcea253ed9$var$positionTeamsQueryString = `query ${$864bd9bcea253ed9$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        __typename
        __isRadarFieldValue: __typename
        ... on RadarAriFieldValue {
          __typename
          isRestricted
          ari
          value {
            __typename
            ... on TeamV2 {
              __typename
              displayName
              id
              organizationId
              smallAvatarImageUrl
            }
          }
        }
      }
    }
  }
}`;
const $864bd9bcea253ed9$export$ed23ff9c143a4269 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'team';
    return $864bd9bcea253ed9$export$7e7f4c6c4a157b2d.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $864bd9bcea253ed9$var$positionTeamsQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $864bd9bcea253ed9$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionTeamsQuery"] = $864bd9bcea253ed9$export$ed23ff9c143a4269;

});

parcelRegister("1y2K1", function(module, exports) {

var $99V2N = parcelRequire("99V2N");


var $fd0l2 = parcelRequire("fd0l2");


var $AgYeH = parcelRequire("AgYeH");


var $fCd3b = parcelRequire("fCd3b");


var $6Zvcd = parcelRequire("6Zvcd");


var $7uPDr = parcelRequire("7uPDr");


var $dv1ov = parcelRequire("dv1ov");


var $iviWm = parcelRequire("iviWm");


var $gFWyZ = parcelRequire("gFWyZ");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $2UU5O = parcelRequire("2UU5O");

const $e5eefd7608991b9e$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $e5eefd7608991b9e$export$c4acd5097f11a5c9 = ({ projectKey: projectKey, name: name })=>{
    if (!projectKey) return name;
    const key = `(${projectKey})`;
    if (name.toLowerCase().includes(key.toLowerCase())) return name;
    return `${name} ${key}`;
};
const $e5eefd7608991b9e$var$searchProjectsForSite = async (query, config, cloudId)=>{
    const searchClient = (0, $fCd3b.createClient)({
        cloudId: cloudId
    });
    const searchProjectsResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $6Zvcd.Scope).JiraProject
        ],
        sites: [
            cloudId
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const scopes = searchProjectsResponse.response.rawData.scopes;
    const searchedProjects = scopes.length > 0 ? scopes[0].results.map((projectResult)=>({
            projectId: projectResult.id,
            name: projectResult.name,
            projectKey: projectResult.attributes.projectKey,
            avatar: {
                small: 'url' in projectResult.attributes.avatar ? projectResult.attributes.avatar.url : undefined
            }
        })) : [];
    // Results carry no cloudId, so attribute them to the site this call was made against.
    return searchedProjects.map((project)=>{
        const projectARI = $e5eefd7608991b9e$var$projectIdToARI(cloudId, project.projectId);
        return {
            trackingKey: projectARI,
            value: projectARI,
            label: $e5eefd7608991b9e$export$c4acd5097f11a5c9(project),
            avatarUrl: project.avatar?.small,
            // The ARI names the site, so hydration can query it directly instead of asking every site.
            queryParamValue: projectARI,
            product: config.product
        };
    });
};
const $e5eefd7608991b9e$var$searchProject = async (query, config)=>{
    const product = config.product;
    if (product === (0, $dvVWp.ProductKeys).JiraDC || product === (0, $dvVWp.ProductKeys).JsmDC) {
        const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
            cloudId: config.cloudId,
            activationId: config.activationId,
            product: config.primaryProduct
        });
        const { useCaseId: useCaseId } = config;
        const searchProjectsResponse = await (0, $dv1ov.jiraDcProjectFilterOptionsQuery)({
            variables: {
                query: query,
                useCaseId: useCaseId,
                cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
                limit: 5,
                entities: (0, $gFWyZ.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                product: (0, $dvVWp.ProductKeys).JiraDC,
                integration: config.selectedDatasource?.integrationAri,
                containerTypes: (0, $fd0l2.ThirdPartyConfigsSync).get(product)?.containerTypes
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return searchProjectsResponse?.data?.search?.search?.edges?.map((edge)=>({
                trackingKey: edge.node.entity.id,
                value: edge.node.entity.id,
                label: $e5eefd7608991b9e$export$c4acd5097f11a5c9({
                    projectKey: edge.node.entity.key,
                    name: edge.node.entity.displayName
                }),
                avatarUrl: edge?.node?.entity?.icon?.url,
                queryParamValue: edge.node.entity.id,
                product: config.product
            })) || [];
    }
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$e5eefd7608991b9e$var$searchProjectsForSite(query, config, cloudId));
};
const $e5eefd7608991b9e$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement,
    (0, $dvVWp.ProductKeys).CustomerServiceManagement
];
const $e5eefd7608991b9e$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('project');
const $e5eefd7608991b9e$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'project',
    products: [
        ...$e5eefd7608991b9e$var$productKeys1P,
        ...$e5eefd7608991b9e$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'jProject',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $dvVWp.ProductKeys).JiraDC || config.product === (0, $dvVWp.ProductKeys).JsmDC) {
                const initialProjectsResponse = await (0, $dv1ov.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    }
                });
                const projectOptions = initialProjectsResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return projectOptions || [];
            } else {
                // Query params hold ARIs, which name their own site. Links predating that hold bare
                // project ids and still have to be looked up on every selected site.
                // TODO QS-10359: drop the bare id branch, and the fan-out it forces, once pre-ARI
                // links have aged out. This outlives the multi-site rollout.
                const cloudIds = config.selectedCloudIds ?? [];
                const initialProjectARIs = queryParams.flatMap((queryParamValue)=>(0, $99V2N.AnyAri).check(queryParamValue) ? [
                        queryParamValue
                    ] : cloudIds.map((cloudId)=>$e5eefd7608991b9e$var$projectIdToARI(cloudId, queryParamValue)));
                const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const initialProjectsResponse = await (0, $7uPDr.jiraProjectsQuery)(initialProjectARIs, headers);
                const initialProjects = initialProjectsResponse.data?.jira.jiraProjects ?? [];
                // The returned ARI names the site the project actually lives on. Without it a project
                // cannot be attributed, and guessing the current site would select the wrong project.
                const requested = new Set(queryParams);
                return initialProjects.flatMap((project)=>project.id && (0, $99V2N.AnyAri).check(project.id) ? [
                        {
                            trackingKey: project.id,
                            value: project.id,
                            label: project.name,
                            avatarUrl: project.avatar?.small,
                            // Echo back whichever form the URL used so the option stays selected.
                            queryParamValue: requested.has(project.id) ? project.id : project.projectId,
                            product: config.product
                        }
                    ] : []);
            }
        },
        generateQueryParamsGetState: $2UU5O.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $e5eefd7608991b9e$var$searchProject('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $e5eefd7608991b9e$var$searchProject(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Jira || primaryProduct === (0, $dvVWp.ProductKeys).JiraDC || primaryProduct === (0, $dvVWp.ProductKeys).JsmDC || primaryProduct === (0, $dvVWp.ProductKeys).JiraServiceManagement || primaryProduct === (0, $dvVWp.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $e5eefd7608991b9e$export$3dea766d36a8935f;

});

parcelRegister("7uPDr", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $849aa335edd3427b$export$56d694fb8fe349ab = (0, $bHHWv.inMemoryCache)();
const $849aa335edd3427b$var$GQL_JIRA_PROJECTS_OPERATION_NAME = 'SearchPageJiraProjectQuery';
const $849aa335edd3427b$var$jiraProjectsQueryString = `query ${$849aa335edd3427b$var$GQL_JIRA_PROJECTS_OPERATION_NAME}($projectIds: [ID!]!) {
  jira {
    jiraProjects(ids: $projectIds) {
			id
			projectId
      name
      avatar {
        small
      }
    }
  }
}`;
const $849aa335edd3427b$export$fd1d4a933080bfe2 = (projectIds, headers)=>{
    return $849aa335edd3427b$export$56d694fb8fe349ab.inMemoryDecorator(projectIds.join(','), async ()=>{
        if (projectIds.length === 0) return {
            data: {
                jira: {
                    jiraProjects: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $849aa335edd3427b$var$jiraProjectsQueryString,
            variables: {
                projectIds: projectIds
            },
            operationName: $849aa335edd3427b$var$GQL_JIRA_PROJECTS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return $849aa335edd3427b$var$filterProjectsWithoutId(response);
    });
};
const $849aa335edd3427b$var$filterProjectsWithoutId = (response)=>{
    const filteredProjects = response.data?.jira.jiraProjects?.filter((project)=>project.projectId);
    return {
        ...response,
        data: {
            jira: {
                jiraProjects: filteredProjects
            }
        }
    };
};
module.exports["jiraProjectsQuery"] = $849aa335edd3427b$export$fd1d4a933080bfe2;

});

parcelRegister("gFWyZ", function(module, exports) {
const $ed1006d28bdc8f5b$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $ed1006d28bdc8f5b$export$1e3b02869b42f77a;

});

parcelRegister("fV4vp", function(module, exports) {

var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $kSwu1 = parcelRequire("kSwu1");

const $da1834def4ab0830$export$9baa81d83dcf973 = [
    'open',
    'merged',
    'declined',
    'draft',
    'unknown'
];
const $da1834def4ab0830$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    open: {
        id: "search-page.filter.pull-request-status.open",
        defaultMessage: "Open"
    },
    merged: {
        id: "search-page.filter.pull-request-status.merged",
        defaultMessage: "Merged"
    },
    declined: {
        id: "search-page.filter.pull-request-status.declined",
        defaultMessage: "Declined"
    },
    draft: {
        id: "search-page.filter.pull-request-status.draft",
        defaultMessage: "Draft"
    },
    unknown: {
        id: "search-page.filter.pull-request-status.unknown",
        defaultMessage: "Unknown"
    }
});


const $30268aa033c8cbc3$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('pullRequestStatus');
const $30268aa033c8cbc3$var$getAllPullRequestStatusOptions = (config)=>{
    const options = (0, $da1834def4ab0830$export$9baa81d83dcf973).map((status)=>({
            value: status,
            trackingKey: status,
            queryParamValue: status,
            isDefault: false,
            label: config.intl?.formatMessage((0, $da1834def4ab0830$export$a7357cdd1f0b0168)[status]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $30268aa033c8cbc3$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $30268aa033c8cbc3$var$getAllPullRequestStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $30268aa033c8cbc3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'pullRequestStatus',
    products: [
        'bitbucket',
        ...$30268aa033c8cbc3$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pullRequestStatus',
        fetcher: async (queryParams, config)=>{
            return $30268aa033c8cbc3$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $30268aa033c8cbc3$var$getAllPullRequestStatusOptions(config);
        }
    }
});
module.exports["filter"] = $30268aa033c8cbc3$export$3dea766d36a8935f;

});

parcelRegister("j9kbz", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $fCd3b = parcelRequire("fCd3b");


var $6Zvcd = parcelRequire("6Zvcd");


var $j5Usq = parcelRequire("j5Usq");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");

const $0652ecb4ad9b4f5a$var$searchJiraCloudReporter = async (query, config, options)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $j5Usq.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $fCd3b.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchReporterQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $6Zvcd.Scope).People
        ],
        // Keep the primary-only request unchanged; send every explicit non-primary scope.
        ...(config.selectedCloudIds?.length ?? 0) > 1 || config.selectedCloudIds?.some((id)=>id !== config.cloudId) ? {
            sites: config.selectedCloudIds
        } : {},
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchReporterReponse] = await Promise.all([
        initialUsersQuery,
        searchReporterQuery
    ]);
    const searchReporterResults = searchReporterReponse.response.rawData.scopes[0]?.results ?? [];
    const allReporters = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchReporterResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
};
const $0652ecb4ad9b4f5a$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement,
    (0, $dvVWp.ProductKeys).CustomerServiceManagement
];
const $0652ecb4ad9b4f5a$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('reporter');
const $0652ecb4ad9b4f5a$var$getProducts = ()=>[
        ...$0652ecb4ad9b4f5a$var$productKeys1P,
        ...$0652ecb4ad9b4f5a$var$products3PFromConfig
    ];
const $0652ecb4ad9b4f5a$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'reporter',
    products: $0652ecb4ad9b4f5a$var$getProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jReporter',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allReporters = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $0652ecb4ad9b4f5a$var$searchJiraCloudReporter('', config, {
                initialOptions: true
            });
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $0652ecb4ad9b4f5a$var$searchJiraCloudReporter(query, config);
        }
    }
});
module.exports["filter"] = $0652ecb4ad9b4f5a$export$3dea766d36a8935f;

});

parcelRegister("dhhWM", function(module, exports) {

var $fd0l2 = parcelRequire("fd0l2");


var $AgYeH = parcelRequire("AgYeH");


var $dv1ov = parcelRequire("dv1ov");


var $S6W9B = parcelRequire("S6W9B");


var $7ohhA = parcelRequire("7ohhA");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");

const $bcdb0eaa6cf70577$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('repository');
const $bcdb0eaa6cf70577$var$FETCH_LIMIT = 30;
/**
 * Calls AGG to fetch the user's accessible repositories for the currently-selected 3P datasource.
 */ const $bcdb0eaa6cf70577$var$fetchRepositoryOptions = async (config, query = '')=>{
    const { cloudId: cloudId, product: product, primaryProduct: primaryProduct, activationId: activationId } = config;
    const integrationAri = config.selectedDatasource?.integrationAri ?? (product && (0, $dvVWp.is3pProductKey)(product) ? (0, $fd0l2.ThirdPartyConfigsSync).get(product)?.integrationAri : undefined);
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const { useCaseId: useCaseId } = config;
    const response = await (0, $dv1ov.thirdPartyRepositoryFilterOptionsQuery)({
        variables: {
            query: query,
            useCaseId: useCaseId,
            cloudIdARI: (0, $S6W9B.getCloudIdARIs)(cloudId, primaryProduct),
            limit: $bcdb0eaa6cf70577$var$FETCH_LIMIT,
            entities: (0, $7ohhA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: [
                (0, $7ydfN.NounSubtypeKey).Repository
            ]
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return response?.data?.search?.search?.edges?.map(({ node: node })=>{
        const name = node.entity?.name;
        if (!name) return undefined;
        return {
            value: name,
            trackingKey: name,
            queryParamValue: name,
            label: name,
            product: config.product,
            isDefault: false,
            isSelected: false,
            isSuggested: false
        };
    }).filter((option)=>option !== undefined) ?? [];
};
/**
 * Initial / pre-query options shown when the filter dropdown is first opened.
 */ const $bcdb0eaa6cf70577$var$getInitialOptions = async (config)=>$bcdb0eaa6cf70577$var$fetchRepositoryOptions(config);
/**
 * URL-hydration fetch. Resolves `?repository=...` values into
 * `SelectFilterOption`.
 */ const $bcdb0eaa6cf70577$var$fetchQueryParams = async (queryParams, config)=>{
    if (queryParams.length === 0) return [];
    const allOptions = await $bcdb0eaa6cf70577$var$fetchRepositoryOptions(config, queryParams.join(' '));
    const matched = allOptions.filter((option)=>queryParams.some((queryParam)=>option.value === queryParam)).map((option)=>({
            ...option,
            isSelected: true
        }));
    if (matched.length === queryParams.length) return matched;
    const matchedValues = new Set(matched.map((option)=>option.value));
    const fallback = queryParams.filter((queryParam)=>!matchedValues.has(queryParam)).map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            product: config.product,
            isSelected: true,
            isSuggested: false
        }));
    return [
        ...matched,
        ...fallback
    ];
};
/**
 * Lookup (typeahead) fetcher.
 */ const $bcdb0eaa6cf70577$var$fetchLookupOptions = async (input, config)=>{
    if (!input) return [];
    return $bcdb0eaa6cf70577$var$fetchRepositoryOptions(config, input);
};
const $bcdb0eaa6cf70577$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'repository',
    products: $bcdb0eaa6cf70577$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'repository',
        fetcher: $bcdb0eaa6cf70577$var$fetchQueryParams
    },
    initialOptions: {
        fetcher: $bcdb0eaa6cf70577$var$getInitialOptions
    },
    lookup: {
        fetcher: $bcdb0eaa6cf70577$var$fetchLookupOptions
    }
});
module.exports["filter"] = $bcdb0eaa6cf70577$export$3dea766d36a8935f;

});

parcelRegister("2iqMh", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $YTPUb = parcelRequire("YTPUb");


var $j5Usq = parcelRequire("j5Usq");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $53db1c4a24decd00$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
// GitHub-only filter — the AGG `gitFilters.reviewer` field accepts an array of reviewer AAIDs.
// Internal naming uses `reviewer` (URL key, folder, i18n) while the wire-level key remains
// `reviewer` per the AGG `SearchGitFilters` schema contract. Options are URS-backed (same
// resolver as the Confluence `contributor` people-picker).
const $53db1c4a24decd00$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('reviewer');
const $53db1c4a24decd00$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'reviewer',
    products: $53db1c4a24decd00$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'reviewer',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersResponse.data?.users ?? [];
            return allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (0, $3e0Ll.loadRecommendedUsers)(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query reviewers with intl
            const response = await (0, $YTPUb.getContributors)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
                maxNumberOfResults: $53db1c4a24decd00$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) return [];
            return response.map((reviewer)=>({
                    trackingKey: reviewer.id,
                    value: reviewer.id,
                    label: reviewer.name,
                    avatarUrl: reviewer.avatarUrl,
                    queryParamValue: reviewer.id,
                    product: config.product
                }));
        }
    }
});
module.exports["filter"] = $53db1c4a24decd00$export$3dea766d36a8935f;

});

parcelRegister("5gx32", function(module, exports) {

var $jy53k = parcelRequire("jy53k");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $1b66d940a8c8a7d5$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $1b66d940a8c8a7d5$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('salesforceStage');
const $1b66d940a8c8a7d5$var$fetchDynamicStageOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const opportunityStages = result.filters.find((f)=>f.name === 'opportunityStages');
        if (!opportunityStages || opportunityStages.values.length === 0) return [];
        return opportunityStages.values.map((stage)=>({
                value: stage.name,
                trackingKey: stage.name,
                queryParamValue: stage.name,
                isDefault: false,
                label: stage.label ?? stage.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
/**
 * Returns dynamic stage options for supported apps.
 */ const $1b66d940a8c8a7d5$var$getStageOptions = async (config)=>{
    if ((0, $jy53k.isSalesforceStageFilterSupportedInCurrentApp)()) return $1b66d940a8c8a7d5$var$fetchDynamicStageOptions(config);
    return [];
};
const $1b66d940a8c8a7d5$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $1b66d940a8c8a7d5$var$getStageOptions(config);
    const matched = allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
    // If the API fetch returned no options (e.g. datasource not yet initialised on
    // initial URL load), fall back to synthetic options built from the raw query param
    // values so the store reflects hasSelection=true and shows the selected label in
    // the UI before the async fetch resolves.
    // Only apply this fallback when the flag is on — when off, the filter is disabled
    // and should not hydrate any state from query params.
    if (matched.length === 0 && queryParams.length > 0 && (0, $jy53k.isSalesforceStageFilterSupportedInCurrentApp)()) return queryParams.map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return matched;
};
const $1b66d940a8c8a7d5$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'salesforceStage',
    requiresTopLevel3PDatasource: true,
    products: [
        ...$1b66d940a8c8a7d5$var$salesforceProducts,
        ...$1b66d940a8c8a7d5$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'salesforceStages',
        fetcher: async (queryParams, config)=>{
            return $1b66d940a8c8a7d5$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $1b66d940a8c8a7d5$var$getStageOptions(config);
        }
    }
});
module.exports["filter"] = $1b66d940a8c8a7d5$export$3dea766d36a8935f;

});

parcelRegister("fFs6O", function(module, exports) {

var $j2nXD = parcelRequire("j2nXD");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $905d93f73911b710$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'site',
    products: [
        ...(0, $dvVWp.all1pProductKeys),
        ...(0, $dvVWp.all3pProductKeys)
    ],
    alwaysVisible: false,
    universal: true,
    queryParams: {
        key: 'sites',
        fetcher: async (queryParams, config)=>{
            return (config.unitMetadata ?? []).map((site)=>({
                    cloudId: (0, $j2nXD.getSiteCloudId)(site.id),
                    siteName: site.siteName
                })).filter(({ cloudId: cloudId })=>queryParams.includes(cloudId)).map(({ cloudId: cloudId, siteName: siteName })=>({
                    trackingKey: cloudId,
                    value: cloudId,
                    label: siteName,
                    queryParamValue: cloudId,
                    isSelected: true
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (config.unitMetadata ?? []).map((site)=>({
                    cloudId: (0, $j2nXD.getSiteCloudId)(site.id),
                    siteName: site.siteName
                })).map(({ cloudId: cloudId, siteName: siteName })=>({
                    trackingKey: cloudId,
                    value: cloudId,
                    label: siteName,
                    queryParamValue: cloudId
                }));
        }
    }
});
module.exports["filter"] = $905d93f73911b710$export$3dea766d36a8935f;

});

parcelRegister("b5q9t", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $iPZ04 = parcelRequire("iPZ04");


var $hea5O = parcelRequire("hea5O");


var $aCR6W = parcelRequire("aCR6W");


var $7MX1N = parcelRequire("7MX1N");

const $97eff50800a111ac$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('slackChannel');
// 200 recommended by Slack as the max per request
// Select Filter does not support pagination, but the backend API does via cursor
// This filter can be enhanced in the future to support pagination on scroll/search if needed
const $97eff50800a111ac$var$MAX_CHANNELS_TO_FETCH = 200;
/**
 * Session-level cache: maps cloudId → in-flight or resolved promise of channel options.
 * This deduplicates concurrent and repeated calls (e.g. queryParams.fetcher + initialOptions.fetcher
 * both fire on page load when a channel is pre-selected via URL param).
 * The cache is module-level so it persists for the browser session but resets on page navigation.
 */ const $97eff50800a111ac$var$channelOptionsCache = new Map();
const $97eff50800a111ac$export$687cc7f9972f010f = ()=>$97eff50800a111ac$var$channelOptionsCache.clear();
async function $97eff50800a111ac$var$doFetchSlackChannels(config) {
    const { cloudId: cloudId } = config;
    if (!cloudId) throw new Error('Cloud ID is required to fetch Slack channels');
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    try {
        const payload = await (0, $iPZ04.getSlackChannels)({
            cloudId: cloudId,
            limit: $97eff50800a111ac$var$MAX_CHANNELS_TO_FETCH,
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return (payload?.channels ?? []).map((channel)=>({
                value: channel.name,
                trackingKey: channel.id,
                queryParamValue: channel.name,
                label: channel.name,
                isDefault: false,
                isSelected: false,
                isSuggested: false,
                product: config.product
            }));
    } catch  {
        return [];
    }
}
const $97eff50800a111ac$var$fetchSlackChannelOptions = (config)=>{
    const { cloudId: cloudId } = config;
    if (!cloudId) return Promise.resolve([]);
    // Return cached promise (handles both in-flight dedup and session-level caching).
    // If the fetch returns an empty result (e.g. network blip, auth error — doFetchSlackChannels
    // catches internally and returns []) or rejects unexpectedly, remove the cache entry so a
    // subsequent open/retry can attempt a fresh fetch rather than returning stale empty results.
    if (!$97eff50800a111ac$var$channelOptionsCache.has(cloudId)) {
        const promise = $97eff50800a111ac$var$doFetchSlackChannels(config);
        $97eff50800a111ac$var$channelOptionsCache.set(cloudId, promise);
        promise.then((channels)=>{
            if (channels.length === 0) $97eff50800a111ac$var$channelOptionsCache.delete(cloudId);
        }).catch(()=>{
            $97eff50800a111ac$var$channelOptionsCache.delete(cloudId);
        });
    }
    return $97eff50800a111ac$var$channelOptionsCache.get(cloudId);
};
const $97eff50800a111ac$var$fetchQueryParams = async (queryParams, config)=>{
    // Hydrate selected channel names from URL params by client-side filtering
    // the full fetched list — no extra API call needed.
    const allOptions = await $97eff50800a111ac$var$fetchSlackChannelOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $97eff50800a111ac$var$lookupChannels = async (query, config)=>{
    const allOptions = await $97eff50800a111ac$var$fetchSlackChannelOptions(config);
    if (!query) return allOptions;
    return (0, $aCR6W.fuzzyFilter)(query, allOptions, (option)=>option.label);
};
const $97eff50800a111ac$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'slackChannel',
    products: $97eff50800a111ac$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'slackChannels',
        fetcher: async (queryParams, config)=>{
            return $97eff50800a111ac$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $97eff50800a111ac$var$fetchSlackChannelOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $97eff50800a111ac$var$lookupChannels(query, config);
        }
    }
});
module.exports["filter"] = $97eff50800a111ac$export$3dea766d36a8935f;

});

parcelRegister("jQaFd", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");


var $kZdMI = parcelRequire("kZdMI");


var $kSwu1 = parcelRequire("kSwu1");

const $85abfd322db30634$export$b351dad7e43554a2 = (0, $kSwu1.defineMessages)({
    relevance: {
        id: "relevance",
        defaultMessage: "Relevance"
    },
    updatedNewest: {
        id: "updatedNewest",
        defaultMessage: "Updated (newest)"
    },
    updatedOldest: {
        id: "updatedOldest",
        defaultMessage: "Updated (oldest)"
    },
    createdNewest: {
        id: "createdNewest",
        defaultMessage: "Created (newest)"
    },
    createdOldest: {
        id: "createdOldest",
        defaultMessage: "Created (oldest)"
    }
});


const $e4011984b6740259$var$SORT_VALUES = [
    'updatedNewest',
    'updatedOldest',
    'createdNewest',
    'createdOldest'
];
const $e4011984b6740259$var$sortCompareFn = (a, b)=>{
    return $e4011984b6740259$var$SORT_VALUES.indexOf(a.queryParamValue) - $e4011984b6740259$var$SORT_VALUES.indexOf(b.queryParamValue);
};
const $e4011984b6740259$var$products = [
    (0, $dvVWp.ProductKeys).Confluence,
    (0, $dvVWp.ProductKeys).Jira
];
const $e4011984b6740259$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: 'sort',
    products: $e4011984b6740259$var$products,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'sort',
        fetcher: async (_, config)=>{
            return $e4011984b6740259$var$SORT_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $85abfd322db30634$export$b351dad7e43554a2)[value]) || (0, $85abfd322db30634$export$b351dad7e43554a2)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: (0, $cZKQq.Sort).Relevance,
                    label: config.intl?.formatMessage((0, $85abfd322db30634$export$b351dad7e43554a2)[(0, $cZKQq.Sort).Relevance]) || (0, $85abfd322db30634$export$b351dad7e43554a2)[(0, $cZKQq.Sort).Relevance].defaultMessage,
                    value: (0, $cZKQq.Sort).Relevance,
                    isDefault: true,
                    queryParamValue: (0, $cZKQq.Sort).Relevance,
                    product: config.product
                },
                ...$e4011984b6740259$var$SORT_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $85abfd322db30634$export$b351dad7e43554a2)[value]) || (0, $85abfd322db30634$export$b351dad7e43554a2)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $e4011984b6740259$var$sortCompareFn,
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Jira || primaryProduct === (0, $dvVWp.ProductKeys).Confluence
});
module.exports["filter"] = $e4011984b6740259$export$3dea766d36a8935f;

});

parcelRegister("6uMwK", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");


var $AgYeH = parcelRequire("AgYeH");


var $gfZaP = parcelRequire("gfZaP");


var $evHnc = parcelRequire("evHnc");


var $b0Mpu = parcelRequire("b0Mpu");

const $dbe7ebdea6f4550c$var$LOOM_SPACES_BY_IDS_OPERATION_NAME = 'LoomRovoSpacesByIdsQuery';
const $dbe7ebdea6f4550c$var$loomSpacesByIdsQuery = `
	query ${$dbe7ebdea6f4550c$var$LOOM_SPACES_BY_IDS_OPERATION_NAME}($ids: [ID!]!) {
		loom_spaces(ids: $ids) {
			id
			name
			url
		}
	}
`;
const $dbe7ebdea6f4550c$export$d3c2717269e16428 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>(0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $dbe7ebdea6f4550c$var$loomSpacesByIdsQuery,
        operationName: $dbe7ebdea6f4550c$var$LOOM_SPACES_BY_IDS_OPERATION_NAME,
        headers: headers
    });





const $cd2b541f50707893$var$LOOM_SPACES_SEARCH_OPERATION_NAME = 'LoomRovoSpacesSearchQuery';
const $cd2b541f50707893$var$loomSpacesSearchQuery = `
	query ${$cd2b541f50707893$var$LOOM_SPACES_SEARCH_OPERATION_NAME}($siteId: ID!, $query: String) {
		loom_spacesSearch(siteId: $siteId, query: $query) {
			id
			name
			url
		}
	}
`;
const $cd2b541f50707893$var$trimToLimit = (result, limit)=>typeof limit === 'number' ? {
        ...result,
        data: result.data ? {
            ...result.data,
            loom_spacesSearch: result.data.loom_spacesSearch.slice(0, limit)
        } : result.data
    } : result;
const $cd2b541f50707893$export$79bd8211418f2310 = async ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const { siteId: siteId, query: query, limit: limit } = variables;
    const response = await (0, $b0Mpu.fetchAgg)({
        variables: {
            siteId: siteId,
            query: query
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $cd2b541f50707893$var$loomSpacesSearchQuery,
        operationName: $cd2b541f50707893$var$LOOM_SPACES_SEARCH_OPERATION_NAME,
        headers: headers
    });
    return $cd2b541f50707893$var$trimToLimit(response, limit);
};



var $dv1ov = parcelRequire("dv1ov");


var $kGvYo = parcelRequire("kGvYo");


var $hZCfd = parcelRequire("hZCfd");


var $iviWm = parcelRequire("iviWm");


var $S6W9B = parcelRequire("S6W9B");


var $gByuu = parcelRequire("gByuu");


var $7Ag9o = parcelRequire("7Ag9o");


var $5msm2 = parcelRequire("5msm2");


var $gFWyZ = parcelRequire("gFWyZ");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $hea5O = parcelRequire("hea5O");


var $03qcI = parcelRequire("03qcI");


var $7MX1N = parcelRequire("7MX1N");


var $kZdMI = parcelRequire("kZdMI");

// TODO: Add Loom in 1P product when backend is ready
const $fd1dea4454c91600$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $fd1dea4454c91600$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('space');
const $fd1dea4454c91600$var$getProducts3PFromConfig = ()=>$fd1dea4454c91600$var$products3PFromConfig;
const $fd1dea4454c91600$var$getFilterProducts = ()=>[
        ...new Set([
            ...$fd1dea4454c91600$var$productKeys1P,
            ...$fd1dea4454c91600$var$getProducts3PFromConfig(),
            ...(0, $iDrrr.fg)('loom-rovo-search') ? [
                (0, $dvVWp.ProductKeys).Loom
            ] : []
        ])
    ];
const $fd1dea4454c91600$var$LOOKUP_ENTITIES = [
    'ati:cloud:confluence:space'
];
const $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT = 15;
const $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT = 15;
const $fd1dea4454c91600$var$isLoomSpaceProduct = (product)=>product === (0, $dvVWp.ProductKeys).Loom && (0, $iDrrr.fg)('loom-rovo-search');
const $fd1dea4454c91600$var$resolveSpaceFilterConfig = (config)=>{
    if (config.product || config.experience !== (0, $9pcjO.SearchExperience).QUICK_FIND || !$fd1dea4454c91600$var$isLoomSpaceProduct(config.primaryProduct)) return config;
    return {
        ...config,
        product: (0, $dvVWp.ProductKeys).Loom
    };
};
const $fd1dea4454c91600$var$fetchRecommendedSpaceOptionsForSite = async (config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const recommendedSpacesResponse = await (0, $gfZaP.smartsRecommendedContainerQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: cloudId
        },
        headers: headers
    });
    const allRecommendedSpaces = recommendedSpacesResponse.data?.smarts.results?.flatMap(({ container: container })=>{
        if (!(container && container.key)) return [];
        return [
            {
                key: container.key,
                name: container.name,
                ari: container.id,
                avatarUrl: container.links?.base && container.icon?.path ? `${container.links.base}${container.icon.path}` : ''
            }
        ];
    }) || [];
    return allRecommendedSpaces.map((space)=>({
            trackingKey: space.ari,
            value: space.key,
            queryParamValue: space.key,
            avatarUrl: space.avatarUrl,
            label: space.name || '',
            product: config.product
        }));
};
const $fd1dea4454c91600$var$isSingleSelectSpaceProduct = (product)=>(0, $dvVWp.is3pProductKey)(product ?? '') && !$fd1dea4454c91600$var$isLoomSpaceProduct(product);
async function $fd1dea4454c91600$var$searchDcSpaces(query, config) {
    const { useCaseId: useCaseId } = config;
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    let spacesResponse = await (0, $dv1ov.confluenceDcSpaceFilterOptionsQuery)({
        variables: {
            query: query,
            useCaseId: useCaseId,
            cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
            limit: 5,
            entities: (0, $gFWyZ.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: (0, $dvVWp.ProductKeys).ConfluenceDC
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            trackingKey: node.entity.id,
            value: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $7Ag9o.cleanExcerpt)(node.entity.displayName),
            product: config.product
        })) ?? [];
}
async function $fd1dea4454c91600$var$searchThirdPartySpaceOptions(config, query = '') {
    const cloudId = config.cloudId;
    const product = config.product;
    const { useCaseId: useCaseId } = config;
    // Get integrationAri from the static ThirdPartyConfigs using the product key.
    // This avoids the dependency on selectedDatasource being populated in the store,
    // which was causing lookup/search to fail when selectedDatasource was undefined.
    const integrationAri = config.selectedDatasource?.integrationAri ?? (0, $fd0l2.ThirdPartyConfigsSync).get(product)?.integrationAri;
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const subtypes = product === (0, $dvVWp.ProductKeys).Sharepoint ? [
        (0, $7ydfN.NounSubtypeKey).Site,
        (0, $7ydfN.NounSubtypeKey).Subsite
    ] : [
        (0, $7ydfN.NounSubtypeKey).Space
    ];
    let spacesResponse = await (0, $dv1ov.thirdPartySpaceFilterOptionsQuery)({
        variables: {
            query: query,
            useCaseId: useCaseId,
            cloudIdARI: [
                `ari:cloud:confluence::site/${cloudId}`
            ],
            limit: 15,
            entities: (0, $gFWyZ.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: subtypes
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            value: node.entity.id,
            trackingKey: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $7Ag9o.cleanExcerpt)(node.entity.displayName),
            product: product
        })) ?? [];
}
async function $fd1dea4454c91600$var$fetchLoomSpaceOptions(config, { query: query = '', limit: limit = $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT } = {}) {
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const spacesResponse = await (0, $cd2b541f50707893$export$79bd8211418f2310)({
        variables: {
            query: query || undefined,
            siteId: cloudId,
            limit: limit
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.loom_spacesSearch?.map((space)=>({
            value: space.id,
            trackingKey: space.id,
            queryParamValue: space.id,
            avatarUrl: undefined,
            label: (0, $7Ag9o.cleanExcerpt)(space.name),
            product: (0, $dvVWp.ProductKeys).Loom
        })) ?? [];
}
const $fd1dea4454c91600$var$spaceFilterInitial = {
    id: 'space',
    products: $fd1dea4454c91600$var$getFilterProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'spaces',
        fetcher: async (queryParams, config)=>{
            if ($fd1dea4454c91600$var$isLoomSpaceProduct(config.product)) {
                const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $dbe7ebdea6f4550c$export$d3c2717269e16428)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse?.data?.loom_spaces?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.name,
                        avatarUrl: undefined,
                        queryParamValue: space.id,
                        product: (0, $dvVWp.ProductKeys).Loom
                    }));
                return spacesOptions || [];
            }
            if (config.product === (0, $dvVWp.ProductKeys).ConfluenceDC || config.product === (0, $dvVWp.ProductKeys).GoogleDrive || config.product === (0, $dvVWp.ProductKeys).Sharepoint) {
                const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $dv1ov.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return spacesOptions || [];
            }
            const cloudId = config.cloudId;
            // Practically cloudId should always be present, but we need to satisfy the type checker
            if (!cloudId) return [];
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const response = await (0, $hZCfd.confluenceSpaceKeysToIdsQuery)({
                spaceKeys: queryParams,
                cloudId: cloudId,
                headers: headers
            });
            const spaceIds = response.data?.spaces?.nodes?.map((node)=>node?.id).filter((0, $hea5O.notEmpty)) ?? [];
            const spaceARIs = spaceIds.map((id)=>`ari:cloud:confluence:${cloudId}:space/${id}`);
            const initialSpacesResponse = await (0, $kGvYo.confluenceSpacesQuery)(spaceARIs, headers);
            const allRecommendedSpaces = initialSpacesResponse.data?.confluence.spaces.map((space)=>({
                    key: space.key,
                    name: space.name,
                    ari: space.id,
                    avatarUrl: space.links?.base && space.icon?.path ? `${space.links.base}${space.icon.path}` : ''
                })) || [];
            return allRecommendedSpaces.map((space)=>({
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || '',
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            if ($fd1dea4454c91600$var$isLoomSpaceProduct(config.product)) return $fd1dea4454c91600$var$fetchLoomSpaceOptions(config, {
                limit: $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT
            });
            if (config.product === (0, $dvVWp.ProductKeys).ConfluenceDC) {
                const spaces = await $fd1dea4454c91600$var$searchDcSpaces('', config);
                return spaces;
            }
            if (config.product === (0, $dvVWp.ProductKeys).GoogleDrive || config.product === (0, $dvVWp.ProductKeys).Sharepoint) return $fd1dea4454c91600$var$searchThirdPartySpaceOptions(config);
            return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$fd1dea4454c91600$var$fetchRecommendedSpaceOptionsForSite(config, cloudId));
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if ($fd1dea4454c91600$var$isLoomSpaceProduct(config.product)) return $fd1dea4454c91600$var$fetchLoomSpaceOptions(config, {
                query: query,
                limit: $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT
            });
            if (config.product === (0, $dvVWp.ProductKeys).ConfluenceDC) return $fd1dea4454c91600$var$searchDcSpaces(query, config);
            if (config.product === (0, $dvVWp.ProductKeys).GoogleDrive || config.product === (0, $dvVWp.ProductKeys).Sharepoint) return $fd1dea4454c91600$var$searchThirdPartySpaceOptions(config, query);
            const backendExperiment = config.experimentConfig && (0, $5msm2.getBackendExperiment)({
                experimentConfig: config.experimentConfig,
                entities: $fd1dea4454c91600$var$LOOKUP_ENTITIES,
                productEdition: config.productEdition,
                isHello: (0, $03qcI.isHello)(config.cloudId),
                productDataRegions: config.productDataRegions,
                experience: 'search-page-space-filter',
                tenantId: config.cloudId
            });
            const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const [currentCloudId = '', ...additionalCloudIds] = config.selectedCloudIds ?? [];
            const { useCaseId: useCaseId } = config;
            const response = await (0, $evHnc.searchEntitiesQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    query: query,
                    useCaseId: useCaseId,
                    first: 15,
                    filters: {
                        entities: [
                            'ati:cloud:confluence:space'
                        ],
                        // get ARIs for each cloud id
                        locations: (0, $S6W9B.getCloudIdARIs)(currentCloudId, config.primaryProduct, additionalCloudIds)
                    },
                    experience: 'full-page-search-space-filter',
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        }))
                },
                includeSpaceKey: true,
                headers: headers
            });
            const { data: data } = response;
            if (!data) return [];
            const lookupOptions = data.search?.results.edges.map(({ node: node })=>({
                    trackingKey: node.id || '',
                    value: node.key || '',
                    queryParamValue: node.key ?? '',
                    avatarUrl: node.iconUrl || undefined,
                    label: node.title,
                    product: config.product
                })) ?? [];
            // A space key can repeat across sites (personal spaces share `~<aaid>`), so collapse them
            // into a single option.
            return (0, $gByuu.mergeAndDedupeOptions)([
                lookupOptions
            ]);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Confluence
};
const $fd1dea4454c91600$var$getSpaceFilterInitial = ()=>({
        ...$fd1dea4454c91600$var$spaceFilterInitial,
        products: $fd1dea4454c91600$var$getFilterProducts()
    });
/**
 * Builds the raw (unwrapped) monad for the given state and config, choosing
 * SingleSelectFilter for 3P products and MultiSelectFilter for 1P. Used internally
 * so that withSelectTypeFilter can wrap exactly once — calling filter.withState would
 * double-wrap because filter.withState itself calls withSelectTypeFilter for 3P.
 */ const $fd1dea4454c91600$var$buildSelectFilter = (state, config)=>{
    if ($fd1dea4454c91600$var$isSingleSelectSpaceProduct(config.product)) return (0, $kZdMI.SingleSelectFilter)({
        initial: $fd1dea4454c91600$var$getSpaceFilterInitial(),
        state: {
            ...state,
            type: 'single-select'
        },
        config: config
    });
    return (0, $7MX1N.MultiSelectFilter)({
        initial: $fd1dea4454c91600$var$getSpaceFilterInitial(),
        state: {
            ...state,
            type: 'multi-select'
        },
        config: config
    });
};
/**
 * Ensures every chained monad operation re-dispatches through buildSelectFilter so the
 * correct select type (SingleSelectFilter for 3P, MultiSelectFilter for 1P) is preserved
 * throughout the chain. Without this, base-select-filter operations (loadInitialOptions,
 * setQueryParams, etc.) return a plain SelectFilter monad that always uses multi-select
 * setOption. buildSelectFilter is used instead of filter.withState to avoid double-wrapping:
 * filter.withState for 3P already calls withSelectTypeFilter internally.
 */ const $fd1dea4454c91600$var$withSelectTypeFilter = (spaceFilter, config)=>({
        ...spaceFilter,
        loadInitialOptions: async (onStateChange)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter((await spaceFilter.loadInitialOptions(onStateChange)).getState(), config), config),
        setOption: (option, customValue)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter(spaceFilter.setOption(option, customValue).getState(), config), config),
        clearOptions: ()=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter(spaceFilter.clearOptions().getState(), config), config),
        setLookupInput: async (query, onStateChange)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter((await spaceFilter.setLookupInput(query, onStateChange)).getState(), config), config),
        clear: ()=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter(spaceFilter.clear().getState(), config), config),
        queryParams: {
            ...spaceFilter.queryParams,
            set: async (queryParams, onStateChange)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter((await spaceFilter.queryParams.set(queryParams, onStateChange)).getState(), config), config)
        }
    });
// Used only for its static shape (id, type, products, queryParams.key, etc.) via the
// spread below. withState and getInitialState are overridden to dispatch per product.
const $fd1dea4454c91600$var$baseFilter = (0, $7MX1N.createMultiSelectFilter)($fd1dea4454c91600$var$spaceFilterInitial);
const $fd1dea4454c91600$export$3dea766d36a8935f = {
    ...$fd1dea4454c91600$var$baseFilter,
    queryParams: {
        ...$fd1dea4454c91600$var$baseFilter.queryParams,
        getState: (queryParams, cloudId)=>({
                ...$fd1dea4454c91600$var$baseFilter.queryParams.getState(queryParams, cloudId),
                products: $fd1dea4454c91600$var$getFilterProducts()
            })
    },
    withState: (state, config)=>{
        const resolvedConfig = $fd1dea4454c91600$var$resolveSpaceFilterConfig(config);
        // buildSelectFilter is the single source of truth for monad construction.
        // For 3P, wrap with withSelectTypeFilter to preserve single-select dispatch
        // through every chained operation; 1P uses MultiSelectFilter directly.
        const monad = $fd1dea4454c91600$var$buildSelectFilter({
            ...state,
            products: $fd1dea4454c91600$var$getFilterProducts()
        }, resolvedConfig);
        return $fd1dea4454c91600$var$isSingleSelectSpaceProduct(resolvedConfig.product) ? $fd1dea4454c91600$var$withSelectTypeFilter(monad, resolvedConfig) : monad;
    },
    getInitialState: (config)=>{
        const resolvedConfig = $fd1dea4454c91600$var$resolveSpaceFilterConfig(config);
        const currentBaseFilter = (0, $7MX1N.createMultiSelectFilter)($fd1dea4454c91600$var$getSpaceFilterInitial());
        return $fd1dea4454c91600$export$3dea766d36a8935f.withState(currentBaseFilter.getInitialState(resolvedConfig).getState(), resolvedConfig);
    },
    get products () {
        return $fd1dea4454c91600$var$getFilterProducts();
    }
};
module.exports["filter"] = $fd1dea4454c91600$export$3dea766d36a8935f;

});

parcelRegister("4LpMn", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $hggbF = parcelRequire("hggbF");


var $7MX1N = parcelRequire("7MX1N");


var $kSwu1 = parcelRequire("kSwu1");

const $88db50376767ed86$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    OPEN: {
        id: "search-page.filter.status.open",
        defaultMessage: "Open"
    },
    DONE: {
        id: "search-page.filter.status.done",
        defaultMessage: "Done"
    },
    INDETERMINATE: {
        id: "search-page.filter.status.indeterminate",
        defaultMessage: "In Progress (Open)"
    },
    UNDEFINED: {
        id: "search-page.filter.status.undefined",
        defaultMessage: "Other"
    },
    NEW: {
        id: "search-page.filter.status.new",
        defaultMessage: "To Do (Open)"
    }
});


const $ced47b91345aac9d$var$getProductKeys1P = ()=>{
    return [
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement,
        (0, $dvVWp.ProductKeys).CustomerServiceManagement
    ];
};
const $ced47b91345aac9d$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('statusFilter');
const $ced47b91345aac9d$var$getAllIssueStatusOptions = (config)=>{
    // Only use allowedJiraIssueStatuses values for Jira issue statuses or else it will be ignored in
    // the GraphQL query request. See the getJiraIssueStatusFilterOptions function.
    const options = (0, $hggbF.allowedJiraIssueStatuses).filter((status)=>status !== 'OPEN').map((issueStatus)=>({
            value: issueStatus,
            trackingKey: issueStatus,
            queryParamValue: issueStatus,
            isDefault: false,
            label: config.intl?.formatMessage((0, $88db50376767ed86$export$a7357cdd1f0b0168)[issueStatus]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $ced47b91345aac9d$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $ced47b91345aac9d$var$getAllIssueStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $ced47b91345aac9d$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'statusFilter',
    // This also sets the `id=statusFilter` attribute and unfortunately `id=status` contains a global CSS target
    products: [
        ...$ced47b91345aac9d$var$getProductKeys1P(),
        ...$ced47b91345aac9d$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'status',
        fetcher: async (queryParams, config)=>{
            return $ced47b91345aac9d$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $ced47b91345aac9d$var$getAllIssueStatusOptions(config);
        }
    }
});
module.exports["filter"] = $ced47b91345aac9d$export$3dea766d36a8935f;

});

parcelRegister("8bTbn", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $AgYeH = parcelRequire("AgYeH");


var $b0Mpu = parcelRequire("b0Mpu");

const $4860ec9064de773e$var$LOOM_TAGS_SEARCH_OPERATION_NAME = 'LoomRovoTagsSearchQuery';
const $4860ec9064de773e$var$loomTagsSearchGraphQuery = `
	query ${$4860ec9064de773e$var$LOOM_TAGS_SEARCH_OPERATION_NAME}($siteId: ID!, $query: String!, $limit: Int) {
		loom_tagsSearch(siteId: $siteId, query: $query, limit: $limit) {
			tag
			url
			videoCount
		}
	}
`;
const $4860ec9064de773e$export$ec756e977e6e5d8c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>(0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $4860ec9064de773e$var$loomTagsSearchGraphQuery,
        operationName: $4860ec9064de773e$var$LOOM_TAGS_SEARCH_OPERATION_NAME,
        headers: headers
    });



var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $082eb23e09c9fa95$var$DEFAULT_LOOM_TAG_INITIAL_LIMIT = 15;
const $082eb23e09c9fa95$var$DEFAULT_LOOM_TAG_LOOKUP_LIMIT = 15;
const $082eb23e09c9fa95$var$getFilterProducts = ()=>(0, $iDrrr.fg)('loom-rovo-search') ? [
        (0, $dvVWp.ProductKeys).Loom
    ] : [];
const $082eb23e09c9fa95$var$fetchLoomTagOptions = async (query, limit, config)=>{
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const response = await (0, $4860ec9064de773e$export$ec756e977e6e5d8c)({
        variables: {
            siteId: cloudId,
            query: query,
            limit: limit
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return response.data?.loom_tagsSearch?.map(({ tag: tag })=>({
            trackingKey: tag,
            value: tag,
            queryParamValue: tag,
            label: tag,
            product: (0, $dvVWp.ProductKeys).Loom
        })) ?? [];
};
const $082eb23e09c9fa95$var$createTagFilter = (products = $082eb23e09c9fa95$var$getFilterProducts())=>(0, $7MX1N.createMultiSelectFilter)({
        id: 'tag',
        products: products,
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'tags',
            // Loom tag names are persisted directly, so hydration does not need another network request.
            fetcher: async (queryParams)=>queryParams.map((tag)=>({
                        trackingKey: tag,
                        value: tag,
                        queryParamValue: tag,
                        label: tag,
                        product: (0, $dvVWp.ProductKeys).Loom
                    }))
        },
        initialOptions: {
            fetcher: async (config)=>$082eb23e09c9fa95$var$fetchLoomTagOptions('', $082eb23e09c9fa95$var$DEFAULT_LOOM_TAG_INITIAL_LIMIT, config)
        },
        lookup: {
            fetcher: async (query, config)=>$082eb23e09c9fa95$var$fetchLoomTagOptions(query, $082eb23e09c9fa95$var$DEFAULT_LOOM_TAG_LOOKUP_LIMIT, config)
        }
    });
// Keep module evaluation side-effect free. Runtime entry points below resolve the gated products.
const $082eb23e09c9fa95$var$baseFilter = $082eb23e09c9fa95$var$createTagFilter([]);
const $082eb23e09c9fa95$export$3dea766d36a8935f = {
    ...$082eb23e09c9fa95$var$baseFilter,
    queryParams: {
        ...$082eb23e09c9fa95$var$baseFilter.queryParams,
        getState: (queryParams, cloudId)=>{
            const products = $082eb23e09c9fa95$var$getFilterProducts();
            const state = $082eb23e09c9fa95$var$createTagFilter(products).queryParams.getState(queryParams, cloudId);
            return {
                ...state,
                value: products.length > 0 ? state.value : [],
                products: products
            };
        }
    },
    withState: (state, config)=>$082eb23e09c9fa95$var$createTagFilter().withState({
            ...state,
            products: $082eb23e09c9fa95$var$getFilterProducts()
        }, config),
    getInitialState: (config)=>$082eb23e09c9fa95$var$createTagFilter().getInitialState(config),
    get products () {
        return $082eb23e09c9fa95$var$getFilterProducts();
    }
};
module.exports["filter"] = $082eb23e09c9fa95$export$3dea766d36a8935f;

});

parcelRegister("hw9HX", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $618e602ad32f1056$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $618e602ad32f1056$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('taskStatus');
const $618e602ad32f1056$var$taskStatusProducts = Array.from(new Set([
    ...$618e602ad32f1056$var$salesforceProducts,
    ...$618e602ad32f1056$var$products3PFromConfig
]));
const $618e602ad32f1056$var$fetchDynamicTaskStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const taskStatuses = result.filters.find((f)=>f.name === 'taskStatuses');
        if (!taskStatuses || taskStatuses.values.length === 0) return [];
        return taskStatuses.values.map((taskStatus)=>({
                value: taskStatus.name,
                trackingKey: taskStatus.name,
                queryParamValue: taskStatus.name,
                isDefault: false,
                label: taskStatus.label ?? taskStatus.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $618e602ad32f1056$var$fetchTaskStatusOptions = async (config)=>{
    return $618e602ad32f1056$var$fetchDynamicTaskStatusOptions(config);
};
const $618e602ad32f1056$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $618e602ad32f1056$var$fetchTaskStatusOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $618e602ad32f1056$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'taskStatus',
    requiresTopLevel3PDatasource: true,
    products: $618e602ad32f1056$var$taskStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'taskStatuses',
        fetcher: async (queryParams, config)=>{
            return $618e602ad32f1056$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $618e602ad32f1056$var$fetchTaskStatusOptions(config);
        }
    }
});
module.exports["filter"] = $618e602ad32f1056$export$3dea766d36a8935f;

});

parcelRegister("hewHt", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $52505079f37c2302$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $52505079f37c2302$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('taskType');
const $52505079f37c2302$var$taskTypeProducts = Array.from(new Set([
    ...$52505079f37c2302$var$salesforceProducts,
    ...$52505079f37c2302$var$products3PFromConfig
]));
const $52505079f37c2302$var$fetchDynamicTaskTypeOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const taskTypes = result.filters.find((f)=>f.name === 'taskTypes');
        if (!taskTypes || taskTypes.values.length === 0) return [];
        return taskTypes.values.map((taskType)=>({
                value: taskType.name,
                trackingKey: taskType.name,
                queryParamValue: taskType.name,
                isDefault: false,
                label: taskType.label ?? taskType.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $52505079f37c2302$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $52505079f37c2302$var$fetchDynamicTaskTypeOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $52505079f37c2302$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'taskType',
    requiresTopLevel3PDatasource: true,
    products: $52505079f37c2302$var$taskTypeProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'taskTypes',
        fetcher: async (queryParams, config)=>{
            return $52505079f37c2302$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $52505079f37c2302$var$fetchDynamicTaskTypeOptions(config);
        }
    }
});
module.exports["filter"] = $52505079f37c2302$export$3dea766d36a8935f;

});

parcelRegister("lgtmw", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $ef172d69004c3216$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $ef172d69004c3216$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('onlyTitleMatch');
const $ef172d69004c3216$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'onlyTitleMatch',
    queryParams: {
        key: 'titleMatch'
    },
    products: [
        ...$ef172d69004c3216$var$productKeys1P,
        ...$ef172d69004c3216$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $ef172d69004c3216$export$3dea766d36a8935f;

});

parcelRegister("5QRIQ", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $200179514a8b8d5f$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $200179514a8b8d5f$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('verified');
const $200179514a8b8d5f$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'verified',
    queryParams: {
        key: 'verified'
    },
    products: [
        ...$200179514a8b8d5f$var$productKeys1P,
        ...$200179514a8b8d5f$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $200179514a8b8d5f$export$3dea766d36a8935f;

});

parcelRegister("bI3lU", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $6uNXh = parcelRequire("6uNXh");

const $547f24803e7bddf5$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement,
    (0, $dvVWp.ProductKeys).CustomerServiceManagement
];
const $547f24803e7bddf5$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'watchedByMe',
    queryParams: {
        key: 'jWatchedByMe'
    },
    products: [
        ...$547f24803e7bddf5$var$productKeys1P
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $547f24803e7bddf5$export$3dea766d36a8935f;

});

parcelRegister("clTf7", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $2UnMH = parcelRequire("2UnMH");


var $aCR6W = parcelRequire("aCR6W");


var $bHPvH = parcelRequire("bHPvH");


var $7MX1N = parcelRequire("7MX1N");

/**
 * `workspaceName` filter — maps to `teamsFilters.workspaceName` in the AGG GraphQL schema.
 * Filters Microsoft Teams search results by workspace (team) name.
 *
 * The internal filter id, URL key, folder, and AGG wire field are all `workspaceName`
 * (per the naming convention agreed with the backend — PR 7086 in alexander/xpsearch-aggregator).
 *
 * Team name options are fetched through Aggregator Search.
 * Gated behind `rovo_fps_show_workspace_name_filter` (frontend) and
 * `xpsearch-aggregator_teams_team_name_filter` (backend).
 */ const $6e3687d31b29b791$var$products3PFromConfig = (0, $bHPvH.getProducts3PFromConfigForFilter)('workspaceName');
/**
 * Session-level cache: maps cloudId → in-flight or resolved promise of workspace options.
 * This deduplicates concurrent and repeated calls (e.g. queryParams.fetcher + initialOptions.fetcher
 * both fire on page load when a team is pre-selected via URL param).
 * The cache is module-level so it persists for the browser session but resets on page navigation.
 */ const $6e3687d31b29b791$var$workspaceOptionsCache = new Map();
const $6e3687d31b29b791$export$c6346c315d8aa4eb = ()=>$6e3687d31b29b791$var$workspaceOptionsCache.clear();
async function $6e3687d31b29b791$var$doFetchMSTeamsWorkspaces(config, cloudId) {
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        product: config.primaryProduct,
        cloudId: cloudId,
        activationId: config.activationId
    });
    const { useCaseId: useCaseId } = config;
    const workspaces = await (0, $2UnMH.getMSTeamsWorkspaces)({
        cloudId: cloudId,
        useCaseId: useCaseId,
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return workspaces.map((workspace)=>({
            value: workspace.name,
            trackingKey: workspace.id ?? workspace.name,
            queryParamValue: workspace.name,
            label: workspace.name,
            isDefault: false,
            isSelected: false,
            isSuggested: false,
            product: config.product
        }));
}
const $6e3687d31b29b791$var$fetchWorkspaceOptions = (config)=>{
    const { cloudId: cloudId } = config;
    if (!cloudId) return Promise.resolve([]);
    // Return cached promise (handles both in-flight dedup and session-level caching).
    // If the fetch returns an empty result or rejects, remove the cache entry so a
    // subsequent open/retry can attempt a fresh fetch rather than returning stale empty results.
    if (!$6e3687d31b29b791$var$workspaceOptionsCache.has(cloudId)) {
        const promise = $6e3687d31b29b791$var$doFetchMSTeamsWorkspaces(config, cloudId);
        $6e3687d31b29b791$var$workspaceOptionsCache.set(cloudId, promise);
        promise.then((workspaces)=>{
            if (workspaces.length === 0) $6e3687d31b29b791$var$workspaceOptionsCache.delete(cloudId);
        }).catch(()=>{
            $6e3687d31b29b791$var$workspaceOptionsCache.delete(cloudId);
        });
    }
    return $6e3687d31b29b791$var$workspaceOptionsCache.get(cloudId);
};
const $6e3687d31b29b791$var$fetchQueryParams = async (queryParams, config)=>{
    // Hydrate selected team names from URL params by client-side filtering
    // the full fetched list — no extra API call needed.
    const allOptions = await $6e3687d31b29b791$var$fetchWorkspaceOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $6e3687d31b29b791$var$lookupWorkspaces = async (query, config)=>{
    const allOptions = await $6e3687d31b29b791$var$fetchWorkspaceOptions(config);
    if (!query) return allOptions;
    return (0, $aCR6W.fuzzyFilter)(query, allOptions, (option)=>option.label);
};
const $6e3687d31b29b791$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'workspaceName',
    products: $6e3687d31b29b791$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'workspaceName',
        fetcher: async (queryParams, config)=>{
            return $6e3687d31b29b791$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $6e3687d31b29b791$var$fetchWorkspaceOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $6e3687d31b29b791$var$lookupWorkspaces(query, config);
        }
    }
});
module.exports["filter"] = $6e3687d31b29b791$export$3dea766d36a8935f;

});

parcelRegister("5sEiG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $8EgKx = parcelRequire("8EgKx");


var $fR63l = parcelRequire("fR63l");


var $3Ydx7 = parcelRequire("3Ydx7");


var $dvVWp = parcelRequire("dvVWp");


var $73Hia = parcelRequire("73Hia");


var $cJff5 = parcelRequire("cJff5");


var $32Eau = parcelRequire("32Eau");




const $bdf54d62951b67b2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    appStackLabel: {
        id: "search-page.controllers.all-apps-icon.appStackLabel",
        defaultMessage: "Apps not shown"
    }
});


const $35b383f41d621682$var$styles = {
    container: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    iconBox: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC"
};
const $35b383f41d621682$export$a9ec35d044cf4cf = ({ showGitHubIcon: showGitHubIcon = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const productConfigs = (0, $73Hia.useProductConfigs)();
    const showAppStack = (0, $cozmU.useMemo)(()=>!showGitHubIcon && (0, $cJff5.shouldShowSearchAppRefresh)(primaryProduct) || (0, $cJff5.shouldShowRefreshedFilterRow)(primaryProduct), [
        primaryProduct,
        showGitHubIcon
    ]);
    const FirstPartyIcon = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira ? productConfigs[(0, $dvVWp.ProductKeys).Confluence]?.Icon : productConfigs[(0, $dvVWp.ProductKeys).Jira]?.Icon;
    const icons = [
        FirstPartyIcon,
        showGitHubIcon ? productConfigs[(0, $dvVWp.ProductKeys).Github]?.Icon : productConfigs[(0, $fR63l.ProductKeys3P).GoogleDrive]?.Icon,
        productConfigs[(0, $fR63l.ProductKeys3P).Slack]?.Icon
    ].filter(Boolean);
    if (showAppStack) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "presentation",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8EgKx.default), {
        data: icons.map((Icon)=>({
                component: Icon
            })),
        label: formatMessage((0, $bdf54d62951b67b2$export$defe85febe8b728c).appStackLabel),
        maxCount: 3,
        size: "xxsmall"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        role: "presentation",
        "aria-hidden": "true",
        xcss: $35b383f41d621682$var$styles.container
    }, icons.map((Icon, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: index,
            xcss: $35b383f41d621682$var$styles.iconBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "xxsmall"
        }))));
};
module.exports["AllAppsIcon"] = $35b383f41d621682$export$a9ec35d044cf4cf;

});

parcelRegister("18jLb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7akNQ = parcelRequire("7akNQ");


var $fodiz = parcelRequire("fodiz");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $lDUCP = parcelRequire("lDUCP");


var $32Eau = parcelRequire("32Eau");


var $73Hia = parcelRequire("73Hia");


var $gPOtu = parcelRequire("gPOtu");


var $cJff5 = parcelRequire("cJff5");


var $4d3Vs = parcelRequire("4d3Vs");


var $3NbcK = parcelRequire("3NbcK");

const $b5e85212d9d69ad9$var$infoIconStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.050',
    cursor: 'pointer'
});
const $b5e85212d9d69ad9$var$popupTriggerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $b5e85212d9d69ad9$var$connectButtonStyles = (0, $buxP3.xcss)({
    marginLeft: 'auto',
    right: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $b5e85212d9d69ad9$var$sidebarStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $b5e85212d9d69ad9$var$connectTextStyles = (0, $buxP3.xcss)({
    color: 'color.link',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $b5e85212d9d69ad9$var$singleSelectConnectTextStyles = (0, $buxP3.xcss)({
    color: 'color.link',
    font: 'font.body.small',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $b5e85212d9d69ad9$export$14011507d36518b5 = ({ product: product, isInline: isInline, trigger: trigger, isOnSearchDialog: isOnSearchDialog, searchQuery: searchQuery, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, option: option, postAuthAction: postAuthAction, oAuthSource: oAuthSource, datasourceId: datasourceId, thirdPartyConfigs: thirdPartyConfigs, onAppFilterClick: onAppFilterClick })=>{
    const products = (0, $73Hia.useProductConfigs)();
    const [{ cloudId: cloudId }] = (0, $32Eau.useBootstrap)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { userNeedsOAuth: userNeedsOAuth, outboundAuthUrl: outboundAuthUrl } = useIsUserOAuthed(product, datasourceId);
    const fireOAuthHovered = (0, $lDUCP.useFireOAuthHovered)({
        cloudId: cloudId || '',
        product: product || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs || {}
    });
    // For Forge connectors, use workspaceName from thirdPartyConfigs
    const workspaceName = thirdPartyConfigs ? (0, $4d3Vs.getWorkspaceNameFromProduct)(product, thirdPartyConfigs) : undefined;
    const productString = product && workspaceName || product && products[product]?.displayName || '';
    const { onAuthorize: onAuthorize } = useOAuthHandlers({
        product: product,
        successFlagTitle: formatMessage((0, $3NbcK.messages).authorizationSuccess, {
            product: productString
        }),
        failFlagTitle: formatMessage((0, $3NbcK.messages).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl || '',
        onCompletedAction: ()=>{
            option?.showFilter();
            option?.onSelect();
            postAuthAction?.();
        },
        isOnSearchDialog: isOnSearchDialog,
        query: searchQuery,
        datasourceId: datasourceId
    });
    // This component is a functional wrapper that turns the trigger prop into a connect trigger.
    // if no warning is needed, we just render the trigger
    const isAdminImported = (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs ?? {});
    if (!product || !userNeedsOAuth || !outboundAuthUrl || isAdminImported) return trigger({
        isDisabled: false
    });
    // One-click 3P connect: authorize immediately when the user clicks the trigger.
    const handleClickConnect = ()=>{
        onAppFilterClick?.();
        onAuthorize(oAuthSource);
    };
    const handleConnectHover = ()=>{
        setTimeout(()=>{
            fireOAuthHovered(oAuthSource);
        }, 1000);
    };
    const connectButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $b5e85212d9d69ad9$var$connectButtonStyles,
            onMouseEnter: handleConnectHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $b5e85212d9d69ad9$var$singleSelectConnectTextStyles : $b5e85212d9d69ad9$var$connectTextStyles
        }, formatMessage((0, $3NbcK.messages).connect)));
    };
    const oAuthWarning = isInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $b5e85212d9d69ad9$var$infoIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "oauth warning",
        color: "var(--ds-icon-brand, #1868DB)",
        size: "small"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, connectButton());
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        onClick: handleClickConnect,
        onMouseEnter: handleConnectHover,
        xcss: [
            $b5e85212d9d69ad9$var$popupTriggerStyles,
            !isInline && !isOnSearchDialog && $b5e85212d9d69ad9$var$sidebarStyles
        ]
    }, trigger({
        oAuthWarning: oAuthWarning,
        isDisabled: true
    })));
};
const $b5e85212d9d69ad9$export$3415e5401c1f1ae1 = (props)=>{
    return props.isOnSearchDialog || props.skipFlagsProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5e85212d9d69ad9$export$14011507d36518b5, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5e85212d9d69ad9$export$14011507d36518b5, props));
};
module.exports["OAuthWarningWrapper"] = $b5e85212d9d69ad9$export$3415e5401c1f1ae1;

});

parcelRegister("4d3Vs", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $2b5540a240ad455b$export$ee0bd2121a6df2d5 = (product, thirdPartyConfigs)=>{
    let workspaceName;
    if (product && thirdPartyConfigs) {
        // Check if it's a 3P product or Forge connector
        const is3POrForge = (0, $dvVWp.is3pProductKey)(product) || (0, $8fNUp.isForgeConnectorProductKey)(product);
        if (is3POrForge) {
            const config = thirdPartyConfigs[product];
            const shouldDisplayWorkspaceName = config?.displayWorkspaceNameAsProductName;
            const shouldUseFanOutConnector = config?.fanOutConnectorSources;
            if (shouldDisplayWorkspaceName || shouldUseFanOutConnector) workspaceName = config?.workspaceName;
        }
    }
    return workspaceName;
};
module.exports["getWorkspaceNameFromProduct"] = $2b5540a240ad455b$export$ee0bd2121a6df2d5;

});

parcelRegister("3NbcK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dd0e54d48a3704f9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "sidebar-oauth-warning-dismiss",
        defaultMessage: "Dismiss"
    },
    authorize: {
        id: "sidebar-oauth-warning-authorize",
        defaultMessage: "Authorize"
    },
    authorizationFail: {
        id: "sidebar-oauth-warning.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "sidebar-oauth-warning.authorization-success",
        defaultMessage: "Successfully connected to {product}."
    },
    connect: {
        id: "sidebar-oauth-warning.connect",
        defaultMessage: "Connect"
    },
    appFilterTooltipContent: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content",
        defaultMessage: "Connect your account to see missing results, including documents only you have access to."
    },
    appFilterTooltipContentAlternate: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content-alternate",
        defaultMessage: "Connect your account to see missing results, including content only you have access to."
    }
});
module.exports["messages"] = $dd0e54d48a3704f9$export$defe85febe8b728c;

});

parcelRegister("2MNU9", function(module, exports) {
const $d83e8fbab81fac23$export$abf7f7ce81b5b4bb = ({ action: action, actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: action,
        actionSubject: 'appSelector',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
module.exports["onAppFilterSelect"] = $d83e8fbab81fac23$export$abf7f7ce81b5b4bb;

});

parcelRegister("iUD7b", function(module, exports) {
const $516ef5a78afb181c$export$ba5ea5559df2d439 = {
    DROPDOWN: 'dropdown',
    INLINE: 'inline',
    DROPDOWN_FPS: 'dropdown-search-page',
    INLINE_FPS: 'inline-search-page',
    INLINE_FPS_SUGGESTION: 'inline-search-page-suggestion'
};
const $516ef5a78afb181c$export$ef6638e4a0319a7a = ({ attributes: attributes, action: action, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $516ef5a78afb181c$export$37ec8c521d184f25 = ({ attributes: attributes, action: action, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filterDropdown',
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
const $516ef5a78afb181c$export$9c0c40377c27961c = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $516ef5a78afb181c$export$5e2091b35b0526ca = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
module.exports["FILTER_CHANGE_LOCATION"] = $516ef5a78afb181c$export$ba5ea5559df2d439;
module.exports["onFilterSelection"] = $516ef5a78afb181c$export$ef6638e4a0319a7a;
module.exports["onFilterDropdown"] = $516ef5a78afb181c$export$37ec8c521d184f25;
module.exports["onFilterClear"] = $516ef5a78afb181c$export$9c0c40377c27961c;
module.exports["onSingleFilterClear"] = $516ef5a78afb181c$export$5e2091b35b0526ca;

});

parcelRegister("59z6f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $l9ukq = parcelRequire("l9ukq");

const $db9abd3eac45bf16$var$boxStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    boxSizing: 'border-box'
});
const $db9abd3eac45bf16$export$7a7fa4424cb20976 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.selectProps.isSearchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        paddingInline: "space.100",
        paddingBlockStart: "space.100",
        xcss: $db9abd3eac45bf16$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, props)));
module.exports["Control"] = $db9abd3eac45bf16$export$7a7fa4424cb20976;

});

parcelRegister("hJSVF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $l9ukq = parcelRequire("l9ukq");


var $h97BQ = parcelRequire("h97BQ");

const $3d1cb7e3c0b71576$var$menuFooterStyles = (0, $buxP3.xcss)({
    borderTop: `${"var(--ds-border, #0B120E24)"} solid ${"var(--ds-border-width, 1px)"}`
});
const $3d1cb7e3c0b71576$export$d1b6a8b216735e8c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3d1cb7e3c0b71576$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h97BQ.default), {
        onClick: ()=>props.selectProps.onClearOptions()
    })));
};
module.exports["MenuListWithoutClearFilterOptionLabel"] = $3d1cb7e3c0b71576$export$d1b6a8b216735e8c;

});

parcelRegister("h97BQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kh0hi = parcelRequire("kh0hi");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");




const $d4f2f1e3dea3bfde$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    clearFilterButtonLabel: {
        id: "search-page.common.ui.clear-filter-button.label",
        defaultMessage: "Clear filter"
    }
});


const $4adc7ddcca943e4e$var$ClearFilterButton = ({ text: text = (0, $d4f2f1e3dea3bfde$export$defe85febe8b728c).clearFilterButtonLabel, xcss: xcss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        ...props,
        xcss: [
            $4adc7ddcca943e4e$var$clearFilterOptionsButtonStyles,
            xcss
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, formatMessage(text)));
};
var $4adc7ddcca943e4e$export$2e2bcd8739ae039 = $4adc7ddcca943e4e$var$ClearFilterButton;
const $4adc7ddcca943e4e$var$clearFilterOptionsButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    ':disabled': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
module.exports["default"] = $4adc7ddcca943e4e$export$2e2bcd8739ae039;

});

parcelRegister("dr3fs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $aHeLI = parcelRequire("aHeLI");

const $2998698cd9cb315b$var$optionTextWrapperStyles = (0, $buxP3.xcss)({
    font: 'font.body',
    marginLeft: 'space.100',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $2998698cd9cb315b$var$renderOptionLabelText = (label)=>typeof label === 'string' ? (0, $aHeLI.enrichExcerpt)(label) : label;
const $2998698cd9cb315b$export$2cf7ef1e2dd6c6b1 = ({ option: option, state: state, children: children })=>{
    const renderedLabel = $2998698cd9cb315b$var$renderOptionLabelText(option.label);
    if (state.context === 'menu' || state.context === 'value') {
        const spaces = {
            menu: 'space.050',
            value: undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: spaces[state.context]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            alignItems: "center"
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2998698cd9cb315b$var$optionTextWrapperStyles
        }, renderedLabel)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2998698cd9cb315b$var$optionTextWrapperStyles
    }, renderedLabel);
};
const $2998698cd9cb315b$export$100d0de045bdee7c = (Component)=>(option, state)=>{
        const props = {
            option: option,
            state: state
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2998698cd9cb315b$export$2cf7ef1e2dd6c6b1, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
const $2998698cd9cb315b$var$AvatarOptionLabel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: props.option.avatarUrl,
        appearance: "circle",
        size: "small",
        borderColor: "none"
    });
const $2998698cd9cb315b$export$aaa1dc33930567f9 = $2998698cd9cb315b$export$100d0de045bdee7c($2998698cd9cb315b$var$AvatarOptionLabel);
module.exports["createOptionLabelFormatter"] = $2998698cd9cb315b$export$100d0de045bdee7c;
module.exports["formatAvatarOptionLabel"] = $2998698cd9cb315b$export$aaa1dc33930567f9;

});

parcelRegister("aHeLI", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $glA79 = parcelRequire("glA79");


var $fR63l = parcelRequire("fR63l");

const $2eef0b6b95583939$export$aba8a20643d1b275 = [
    'email'
];



var $4eSGu = parcelRequire("4eSGu");


var $3Z7rz = parcelRequire("3Z7rz");


var $fZV6T = parcelRequire("fZV6T");


var $dTqCf = parcelRequire("dTqCf");


var $480dC = parcelRequire("480dC");


var $7Rtv4 = parcelRequire("7Rtv4");










const $47aad1046588c982$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $47aad1046588c982$var$MAX_EXCERPT_LENGTH = 80;
const $47aad1046588c982$export$16c2ab98757b54d6 = (excerpt, noLeadingEllipsis, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $fZV6T.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($47aad1046588c982$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipsis prefix if beginning of excerpt isn't a URL and excerpt length is greater than 80
    if (!noLeadingEllipsis && !beginsWithUrl && excerpt.length > $47aad1046588c982$var$MAX_EXCERPT_LENGTH) excerpt = '...'.concat(excerpt);
    // Add ellipsis suffix if excerpt doesn't end with ending punctuation and if length is greater than 80
    if (excerpt.length > $47aad1046588c982$var$MAX_EXCERPT_LENGTH && !excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with separators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $47aad1046588c982$export$b847312d69858d61(excerpt, prefix);
};
// Utility function to insert zero-width space every N characters
const $47aad1046588c982$var$insertZeroWidthSpace = (str, interval)=>{
    let result = '';
    for(let i = 0; i < str.length; i++){
        result += str[i];
        if ((i + 1) % interval === 0) result += '\u200B';
    }
    return result;
};
const $47aad1046588c982$export$ca7c2d622a259944 = (segment)=>{
    return segment.split(' ').map((word)=>{
        if (word.length > 20) return $47aad1046588c982$var$insertZeroWidthSpace(word, 5);
        return word;
    }).join(' ');
};
const $47aad1046588c982$export$b847312d69858d61 = (excerpt, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $fZV6T.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: excerpt
            }, $47aad1046588c982$export$ca7c2d622a259944(excerpt)));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            key: `pre-${i}`
        }, $47aad1046588c982$export$ca7c2d622a259944(pre)));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "strong",
            key: `textMatch-${i}`
        }, $47aad1046588c982$export$ca7c2d622a259944(textMatch)));
        i++;
    }
    return(// NOTE: wrapping these in <div> previously broke focus rings
    // in search results
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, prefix, res));
};
const $47aad1046588c982$export$fdcae512e9fdc5ad = (timestamp)=>{
    return $47aad1046588c982$export$96e2a37e068d7fac($47aad1046588c982$export$7e0fd00186ff29c6(timestamp));
};
const $47aad1046588c982$export$7e0fd00186ff29c6 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const secondsPast = (0, $dTqCf.secondsSinceDate)(timestamp);
    const timeUnits = {
        seconds: secondsPast,
        minutes: secondsPast / 60,
        hours: secondsPast / 3600,
        days: secondsPast / 86400,
        months: secondsPast / 2592000,
        years: secondsPast / 31536000
    };
    return {
        seconds: Math.floor(timeUnits.seconds),
        minutes: Math.floor(timeUnits.minutes),
        hours: Math.floor(timeUnits.hours),
        days: Math.floor(timeUnits.days),
        months: Math.floor(timeUnits.months),
        years: Math.floor(timeUnits.years)
    };
};
const $47aad1046588c982$export$96e2a37e068d7fac = ({ seconds: seconds, minutes: minutes, hours: hours, days: days, months: months, years: years })=>{
    return $47aad1046588c982$export$3e6e07f5a5b9cd48(seconds, minutes, hours, days, months, years);
};
const $47aad1046588c982$export$3e6e07f5a5b9cd48 = (seconds, minutes, hours, days, months, years)=>{
    if (years > 0) return {
        unit: 'year',
        value: years
    };
    else if (months > 0) return {
        unit: 'month',
        value: months
    };
    else if (days > 0) return {
        unit: 'day',
        value: days
    };
    else if (hours > 0) return {
        unit: 'hour',
        value: hours
    };
    else if (minutes > 0) return {
        unit: 'minute',
        value: minutes
    };
    else return {
        unit: 'second',
        value: seconds
    };
};
const $47aad1046588c982$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'ari:cloud:platform::integration/slack';
    const isMsTeams = integrationId === 'ari:cloud:platform::integration/microsoft';
    if (isSlack) {
        const openDmUrl = $47aad1046588c982$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $47aad1046588c982$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'ms-teams',
            openDmUrl: openDmUrl
        };
    }
};
const $47aad1046588c982$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $47aad1046588c982$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
const $47aad1046588c982$export$3856aba7736e125f = 'microsoft';
const $47aad1046588c982$export$c60276faecd0e082 = (integrationKey, resourceType)=>{
    if (integrationKey !== $47aad1046588c982$export$3856aba7736e125f || !resourceType) return undefined;
    if ((0, $480dC.SHAREPOINT_RESOURCE_TYPES).includes(resourceType)) return 'sharepoint';
    if ((0, $7Rtv4.TEAMS_RESOURCE_TYPES).includes(resourceType)) return 'teams';
    if ((0, $iDrrr.fg)('ai_3p_email_graph_document_variant_enabled') && (0, $2eef0b6b95583939$export$aba8a20643d1b275).includes(resourceType)) return (0, $fR63l.ProductKeys3P).OutlookMail;
    return undefined;
};
const $47aad1046588c982$export$fe9263de7294a8e0 = 'google';
const $47aad1046588c982$export$cfd5f31372b22684 = (integrationKey, resourceType)=>{
    if (integrationKey !== $47aad1046588c982$export$fe9263de7294a8e0 || !resourceType) return undefined;
    if ((0, $iDrrr.fg)('ai_3p_email_graph_document_variant_enabled') && (0, $2eef0b6b95583939$export$aba8a20643d1b275).includes(resourceType)) return (0, $fR63l.ProductKeys3P).Gmail;
    return undefined;
};
const $47aad1046588c982$export$42f00afbb84516be = ({ thirdPartyConfigs: thirdPartyConfigs, providerId: providerId, integrationId: integrationId, resourceType: resourceType })=>{
    const integrationKey = (0, $4eSGu.getIntegrationKey)(integrationId);
    return(// Last-resort fallback: returns the raw integration key (e.g. 'slack', 'github').
    // For Microsoft products without a matching resourceType (e.g. OneDrive), this returns
    // 'microsoft' which has no displayName — intentional, as we can't disambiguate further.
    (0, $3Z7rz.getProductFromProviderId)(thirdPartyConfigs, providerId) || $47aad1046588c982$export$c60276faecd0e082(integrationKey, resourceType) || integrationKey);
};
const $47aad1046588c982$export$ab95c7c231b79a76 = (originalEntityType)=>{
    if (!originalEntityType) return undefined;
    try {
        return (0, $glA79.Ati).parse(originalEntityType).resourceType;
    } catch  {
        return undefined;
    }
};
module.exports["processExcerpt"] = $47aad1046588c982$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $47aad1046588c982$export$b847312d69858d61;
module.exports["getRelativeTimeSince"] = $47aad1046588c982$export$fdcae512e9fdc5ad;
module.exports["getExternalMessageDmIntegrationInfo"] = $47aad1046588c982$export$596e547f4ce626bc;
module.exports["MICROSOFT_INTEGRATION_KEY"] = $47aad1046588c982$export$3856aba7736e125f;
module.exports["getProductFromMicrosoftResourceType"] = $47aad1046588c982$export$c60276faecd0e082;
module.exports["GOOGLE_INTEGRATION_KEY"] = $47aad1046588c982$export$fe9263de7294a8e0;
module.exports["getProductFromGoogleResourceType"] = $47aad1046588c982$export$cfd5f31372b22684;
module.exports["get3PProductFromProviderIdOrIntegrationId"] = $47aad1046588c982$export$42f00afbb84516be;
module.exports["getGraphAnalyticsEntityType"] = $47aad1046588c982$export$ab95c7c231b79a76;

});

parcelRegister("4eSGu", function(module, exports) {

var $8bWTU = parcelRequire("8bWTU");

const $be776f71a1b59fdb$export$fb63ba58603395b8 = (integrationId)=>{
    try {
        const integrationKey = integrationId ? (0, $8bWTU.PlatformIntegrationAri).parse(integrationId).integrationKey : undefined;
        if (integrationKey === 'jira-dc-secondary' || integrationKey === 'jira-dc-tertiary') return 'jira-dc';
        return integrationKey;
    } catch  {
        // TODO QS-7368 log exception for invalid integration IDs
        return undefined;
    }
};
module.exports["getIntegrationKey"] = $be776f71a1b59fdb$export$fb63ba58603395b8;

});

parcelRegister("4PFuU", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $1i979 = parcelRequire("1i979");


var $6zZLZ = parcelRequire("6zZLZ");


var $bL3N3 = parcelRequire("bL3N3");







const $898f39b25c1cf4af$export$6d20082d2748aae3 = (params)=>{
    if (params.selectedProducts.length > 0) return params.selectedProducts;
    const primaryProduct = params.primaryProduct ?? '';
    const safePrimaryProduct = (0, $dvVWp.isProductKey)(primaryProduct) ? [
        primaryProduct
    ] : undefined;
    if (params.experience === (0, $9pcjO.SearchExperience).QUICK_FIND) return safePrimaryProduct ?? params.availableProducts;
    return params.availableProducts;
};


const $2df3b5a7051df39d$export$ac822ab68badd883 = ({ filterId: filterId, optionValuesToExclude: optionValuesToExclude })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [state, storeActions] = (0, $1i979.useSelectFilterStore)({
        filterId: filterId
    });
    const isContributor = filterId === 'contributor';
    const viewActions = {
        setOption: (option, customValue, setSelectedProduct, validateDependentFilterId)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected,
                    // Preserve display fields for client-only options (see SelectFilterOptionChange)
                    // so a mined deactivated contributor keeps its label/avatar/metadata once the
                    // store persists it.
                    ...isContributor ? {
                        label: option.label,
                        avatarUrl: option.avatarUrl,
                        trackingKey: option.trackingKey,
                        queryParamValue: option.queryParamValue,
                        metadata: option.metadata
                    } : {}
                }));
            const productToSelect = (0, $bL3N3.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                productToSet: setSelectedProduct,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            });
            const customOptions = {
                customValue: customValue,
                setSelectedProduct: productToSelect,
                validateDependentFilterId: validateDependentFilterId
            };
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                ...Object.values(customOptions).some((customOption)=>customOption !== undefined) ? {
                    options: customOptions
                } : {}
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                intl: intl,
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: (dependentFilterId)=>storeActions.clearSelectFilterOptions({
                filterId: filterId,
                dependentFilterId: dependentFilterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const filteredOptions = state.options.filter((option)=>{
        if (optionValuesToExclude) return !optionValuesToExclude.includes(option.value);
        return true;
    });
    const selectedOptionsCount = state.selectedOptions.length;
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: state.selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible,
        customValue: state.customValue,
        badgeLabel: selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined,
        firstSelectedOptionLabel: state.selectedOptions[0]?.label
    };
    return [
        viewState,
        viewActions
    ];
};
const $2df3b5a7051df39d$export$eb312ee1d3a7a748 = ({ filterId: filterId, filterOptionsByPrimaryProduct: filterOptionsByPrimaryProduct = true, optionsToProducts: optionsToProducts, selectPrimaryProductOnChange: selectPrimaryProductOnChange = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [state, storeActions] = (0, $1i979.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            const productToSelect = selectPrimaryProductOnChange ? (0, $bL3N3.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            }) : undefined;
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                options: {
                    setSelectedProduct: productToSelect
                }
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId,
                intl: intl
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const productsNew = (0, $898f39b25c1cf4af$export$6d20082d2748aae3)({
        selectedProducts: state.selectedProducts,
        primaryProduct: filterOptionsByPrimaryProduct ? state.primaryProduct ?? undefined : undefined,
        experience: state.experience,
        availableProducts: state.availableProducts
    });
    const products = productsNew;
    const isAtlasSelected = state.selectedProducts[0] === (0, $dvVWp.ProductKeys).Atlas;
    const isLoomContext = state.selectedProducts[0] === (0, $dvVWp.ProductKeys).Loom || state.selectedProducts.length === 0 && state.experience === (0, $9pcjO.SearchExperience).QUICK_FIND && state.primaryProduct === (0, $dvVWp.ProductKeys).Loom;
    const filteredOptions = state.options.filter((option)=>option.isDefault || option.isSelected || optionsToProducts[option.value]?.some((product)=>products.includes(product))).filter((option)=>{
        // TODO: Product-specific filtering in this shared controller is a code smell.
        // Atlas introduced this workaround to only show Goal and Tag types when Atlas is selected.
        // Loom had to alter this because we need to see Tag type when Loom is selected.
        if (option.value === 'goal') return isAtlasSelected;
        if (option.value === 'tag') return isAtlasSelected || isLoomContext;
        return true;
    })// Filtering out all options that are tied exclusively to allFilterExcludedProducts for universal types
    .filter((option)=>!selectedProductsAvailable && optionsToProducts[option.value]?.length ? optionsToProducts[option.value].some((product)=>!state.allFilterExcludedProducts.includes(product)) : true);
    const selectedOptions = state.selectedOptions.map((option)=>({
            ...option
        }));
    if (products.length === 1 && products[0] === (0, $dvVWp.ProductKeys).ConfluenceDC) {
        const isPageOption = (option)=>option.value === (0, $7ydfN.TypeFilterValueKey).Page;
        // Update both filtered and selected options that match Page type
        [
            filteredOptions,
            selectedOptions
        ].flatMap((options)=>options.filter(isPageOption)).forEach((option)=>{
            option.label = intl.formatMessage((0, $6zZLZ.typeLabels).page);
        });
    }
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible
    };
    return [
        viewState,
        viewActions
    ];
};
module.exports["useSelectFilter"] = $2df3b5a7051df39d$export$ac822ab68badd883;
module.exports["useUniversalSelectFilter"] = $2df3b5a7051df39d$export$eb312ee1d3a7a748;

});

parcelRegister("bL3N3", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");

const $98123a8b5da55e9b$export$a415be24ece1d149 = (params)=>{
    if (params.productToSet || params.isUniversal && // Universal Filters on Quick Find selects the primaryProduct until we do cross product search
    //https://atlassian.slack.com/archives/C050EC6FM28/p1763330594902229?thread_ts=1763092320.695409&cid=C050EC6FM28
    params.experience !== (0, $9pcjO.SearchExperience).QUICK_FIND) return params.productToSet;
    const productToSelect = params.selectedProduct ?? params.primaryProduct ?? '';
    const safeProductKey = (0, $dvVWp.isProductKey)(productToSelect) ? productToSelect : undefined;
    return safeProductKey;
};
module.exports["getProductToSelect"] = $98123a8b5da55e9b$export$a415be24ece1d149;

});

parcelRegister("2xMvQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6vPLm = parcelRequire("6vPLm");


var $5lkNm = parcelRequire("5lkNm");


var $ldJ1U = parcelRequire("ldJ1U");


var $hupj2 = parcelRequire("hupj2");


var $3Ydx7 = parcelRequire("3Ydx7");




const $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    confluenceIconLabel: {
        id: "rovo-search.confluence.filter.icon.label",
        defaultMessage: "Confluence filter"
    },
    jiraIconLabel: {
        id: "rovo-search.jira.filter.icon.label",
        defaultMessage: "Jira filter"
    },
    assetsIconLabel: {
        id: "rovo-search.assets.filter.icon.label",
        defaultMessage: "Assets filter"
    },
    talentIconLabel: {
        id: "rovo-search.talent.filter.icon.label",
        defaultMessage: "Talent filter"
    }
});


const $a35b0c9ab8dfd460$export$5d27b8605be74adf = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showPrimaryProductIcon: showPrimaryProductIcon, primaryProduct: primaryProduct } = props;
    if (!showPrimaryProductIcon || !primaryProduct) return null;
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5lkNm.ConfluenceIcon), {
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).confluenceIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).jiraIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Assets) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6vPLm.AssetsIcon), {
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).assetsIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Talent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hupj2.TalentIcon), {
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).talentIconLabel),
        size: "xxsmall"
    });
    // Add more primary product icons here
    return null;
};
module.exports["FilterProductIcon"] = $a35b0c9ab8dfd460$export$5d27b8605be74adf;

});

parcelRegister("5cu3N", function(module, exports) {

var $2khPJ = parcelRequire("2khPJ");


var $8zVc5 = parcelRequire("8zVc5");


var $jZ9Hw = parcelRequire("jZ9Hw");

const $10250bb52907579a$export$4e07a927e22bed0a = ({ query: query, projectARIs: projectARIs, accountARIs: accountARIs })=>{
    let text;
    if (query) {
        // If the query looks like an issue key, use issueKey instead of textfields
        if ((0, $jZ9Hw.isQueryLikeWorkItemKey)(query)) text = `issuekey ~ "${encodeURIComponent(query)}*"`;
        else text = `textfields ~ "${encodeURIComponent(query)}*"`;
    }
    const projectIds = projectARIs.map($10250bb52907579a$var$getProjectIdFromProjectAri).filter(Boolean);
    const projectJQL = projectARIs.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : undefined;
    const accountIds = accountARIs.map($10250bb52907579a$var$getAccountIdFromUserAri).filter(Boolean);
    const assigneeClause = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : undefined;
    return [
        text,
        projectJQL,
        assigneeClause
    ].filter(Boolean).join(' AND ');
};
function $10250bb52907579a$var$getProjectIdFromProjectAri(projectAri) {
    try {
        return projectAri ? (0, $8zVc5.JiraProjectAri).parse(projectAri).projectId : undefined;
    } catch  {
        return undefined;
    }
}
function $10250bb52907579a$var$getAccountIdFromUserAri(userAri) {
    try {
        return userAri ? (0, $2khPJ.IdentityUserAri).parse(userAri).userId : undefined;
    } catch  {
        return undefined;
    }
}
const $10250bb52907579a$export$23c957892b92c4a0 = ({ query: query, jiraFilters: jiraFilters, generateSearchUrl: generateSearchUrl, queryParams: queryParams = {}, issueKeyLookup: issueKeyLookup, isQueryJql: isQueryJql = false })=>{
    const trimmedQuery = query.trim();
    let jql;
    if (isQueryJql) jql = trimmedQuery;
    else if (trimmedQuery !== '' && (jiraFilters.issueFilter.projectARIs.length !== 0 || jiraFilters.issueFilter.assigneeARIs.length !== 0)) /* If query is empty we don't need to build jql as it will be ignored by generateSearchUrl
		 ** Otherwise, we pass the JQL to be redirected to work items page */ jql = $10250bb52907579a$export$4e07a927e22bed0a({
        query: trimmedQuery,
        accountARIs: jiraFilters.issueFilter.assigneeARIs,
        projectARIs: jiraFilters.issueFilter.projectARIs
    });
    /* generateSearchUrl takes care of navigating to a signle work item page in case the query is a work item key
	 * Otherwise, it'll take the user to work items page.
	 * */ return generateSearchUrl({
        ...queryParams,
        text: query,
        ...jql && {
            jql: jql
        }
    }, true, undefined, undefined, issueKeyLookup);
};
const $10250bb52907579a$export$ddc03b5bf54ec4ae = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $10250bb52907579a$export$fffb7b540a9a6468 = (params)=>{
    const trimmedQuery = params.query.trim();
    if (trimmedQuery === '') return [];
    const jqlUrl = $10250bb52907579a$export$23c957892b92c4a0({
        ...params,
        query: trimmedQuery,
        issueKeyLookup: false
    });
    return [
        jqlUrl,
        $10250bb52907579a$export$ddc03b5bf54ec4ae(trimmedQuery)
    ];
};
const $10250bb52907579a$export$9b8240b7fc8c64cd = (params)=>{
    const trimmedQuery = params.query.trim();
    if (trimmedQuery === '') return [];
    // Complete issue keys resolve to the issue view, so skip the general search candidates.
    if ((0, $jZ9Hw.isQueryLikeWorkItemKey)(trimmedQuery)) return [];
    return $10250bb52907579a$export$fffb7b540a9a6468(params);
};
module.exports["buildJql"] = $10250bb52907579a$export$4e07a927e22bed0a;
module.exports["getWorkItemPageUrl"] = $10250bb52907579a$export$23c957892b92c4a0;
module.exports["getWorkItemPrefetchUrls"] = $10250bb52907579a$export$9b8240b7fc8c64cd;

});

parcelRegister("jZ9Hw", function(module, exports) {
const $ceb46d9b15e1a17c$export$e43472a3ada71740 = (query)=>/^[A-Z0-9]{2,}-\d+$/i.test(query.trim());
const $ceb46d9b15e1a17c$var$ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
const $ceb46d9b15e1a17c$var$buildJiraJqlUrl = (jql, query)=>`/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(query)}`;
const $ceb46d9b15e1a17c$var$buildJiraSearchUrl = (searchString, issueKeyLookup)=>{
    if (!issueKeyLookup) {
        const clauseField = $ceb46d9b15e1a17c$export$e43472a3ada71740(searchString) ? 'issuekey' : 'textfields';
        return `/issues/?jql=${clauseField} ~ "${encodeURIComponent(searchString)}*"`;
    }
    return `/jira/search?${new URLSearchParams({
        searchString: searchString
    }).toString()}`;
};
const $ceb46d9b15e1a17c$export$772e48b507423c7c = (query, jql, issueKeyLookup)=>{
    const trimmedQuery = query.trim();
    if (jql) return $ceb46d9b15e1a17c$var$buildJiraJqlUrl(jql, query);
    if (trimmedQuery) return $ceb46d9b15e1a17c$var$buildJiraSearchUrl(trimmedQuery, issueKeyLookup);
    return $ceb46d9b15e1a17c$var$ISSUE_NAVIGATOR_URL;
};
const $ceb46d9b15e1a17c$var$buildRovoSearchUrl = (siteUrl)=>{
    const path = '/jira/rovo-search';
    if (!siteUrl) return path;
    return new URL(path, siteUrl || '').href;
};
const $ceb46d9b15e1a17c$export$48bdb02c221fe04 = (urlQueryParams, isSecondaryLink, customParams, issueKeyLookup = true)=>{
    const searchParams = new URLSearchParams(customParams || {});
    // This function assumes the text is in sync with JQL text field
    let queryString = searchParams.get('text') || urlQueryParams.text?.toString() || '';
    const jql = searchParams.get('jql') || !isSecondaryLink && urlQueryParams.jql?.toString() || '';
    // remove jql from params as it's already picked up
    searchParams.delete('jql');
    if (!isSecondaryLink) Object.entries(urlQueryParams).forEach(([key, value])=>{
        // add current params if they are not in custom search params
        if (value !== undefined && value !== null && !searchParams.has(key)) searchParams.set(key, String(value));
    });
    let url = isSecondaryLink ? $ceb46d9b15e1a17c$export$772e48b507423c7c(queryString, jql, issueKeyLookup) : $ceb46d9b15e1a17c$var$buildRovoSearchUrl();
    const params = searchParams.toString();
    if (params) url = url.concat(url.includes('?') ? '&' : '?').concat(params);
    return url;
};
module.exports["isQueryLikeWorkItemKey"] = $ceb46d9b15e1a17c$export$e43472a3ada71740;
module.exports["generateJiraSearchUrl"] = $ceb46d9b15e1a17c$export$48bdb02c221fe04;

});

parcelRegister("8nTVT", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $3wZF4 = parcelRequire("3wZF4");


var $coUcA = parcelRequire("coUcA");


var $1Qme9 = parcelRequire("1Qme9");


var $S6W9B = parcelRequire("S6W9B");


var $fnx12 = parcelRequire("fnx12");


var $2ePuQ = parcelRequire("2ePuQ");


var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");


var $cJff5 = parcelRequire("cJff5");


var $c3cgJ = parcelRequire("c3cgJ");


var $9AIBu = parcelRequire("9AIBu");


var $03qcI = parcelRequire("03qcI");


var $6qPRO = parcelRequire("6qPRO");


var $6Vsfx = parcelRequire("6Vsfx");


var $hggbF = parcelRequire("hggbF");

const $21d1cc4e299beef1$export$62c31c0f13603e08 = (jiraFilters, availableProducts)=>{
    const allAvailableJiraProductTypes = Object.keys((0, $hggbF.JiraProductProjectFilterKey)).reduce((acc, productKey)=>{
        const jiraProductKey = productKey;
        if (!availableProducts || availableProducts.includes(jiraProductKey)) acc.push(...(0, $hggbF.JiraProductProjectFilterKey)[jiraProductKey]);
        return acc;
    }, []);
    return {
        ...jiraFilters,
        projectFilter: {
            ...jiraFilters.projectFilter,
            projectTypes: allAvailableJiraProductTypes
        }
    };
};



var $dXat9 = parcelRequire("dXat9");

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $518WI = parcelRequire("518WI");


// DJB2 hash function for JSON objects
function $b5a3e357e30a85ab$var$hashJsonObjectDJB2(jsonObject) {
    // Convert the JSON object to a string
    const jsonString = JSON.stringify(jsonObject);
    // Initialize hash value
    let hash = 5381;
    // Iterate over each character in the string
    for(let i = 0; i < jsonString.length; i++){
        const char = jsonString.charCodeAt(i);
        hash = hash * 33 ^ char; // XOR and multiply by 33
    }
    // Ensure the hash is a positive 32-bit integer
    return (hash >>> 0).toString(16);
}
const $b5a3e357e30a85ab$var$sessionIdsMap = new Map();
function $b5a3e357e30a85ab$export$8b9832780ea0337b(variables) {
    if ($b5a3e357e30a85ab$var$sessionIdsMap.size > 1000) $b5a3e357e30a85ab$var$sessionIdsMap.clear();
    const { sessionId: sessionId, searchSessionId: searchSessionId, ...vars } = variables;
    const queryKey = $b5a3e357e30a85ab$var$hashJsonObjectDJB2(vars);
    const existingSession = $b5a3e357e30a85ab$var$sessionIdsMap.get(queryKey);
    if (existingSession) return existingSession;
    $b5a3e357e30a85ab$var$sessionIdsMap.set(queryKey, [
        sessionId,
        searchSessionId
    ]);
    return [
        sessionId,
        searchSessionId
    ];
}
function $b5a3e357e30a85ab$export$77a5fc99991cbb57() {
    $b5a3e357e30a85ab$var$sessionIdsMap.clear();
}
const $b5a3e357e30a85ab$export$966bb5e577b5d521 = (forceUpdate = false)=>{
    const sessionId = (0, $518WI.SEARCH_SESSION_ID).value();
    if (!sessionId || forceUpdate) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    (0, $518WI.SEARCH_SESSION_ID).update((0, $03RpJ.default)());
};






var $5msm2 = parcelRequire("5msm2");


var $3ZYG5 = parcelRequire("3ZYG5");

const $5311b2f8ca23af19$export$8c6fefe9b6b2ccd8 = (props)=>{
    const experimentConfig = (0, $3ZYG5.getExperimentConfig)({
        experimentLayers: props.experimentLayers,
        sideBySideExperiment: undefined,
        statsigLayer: undefined,
        onError: props.onError,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: props.entities,
        productEdition: props.productEdition,
        isHello: props.isHello,
        productDataRegions: props.productDataRegions,
        experience: props.experienceLayer,
        tenantId: props.cloudId,
        isJiraIssueIndexed: props.isJiraIssueIndexed,
        thirdPartyFilters: props.thirdPartyFilters,
        backendExperimentOverrides: props.backendExperimentOverrides,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata } = backendExperiment || {};
    return {
        experimentId: experimentId,
        experimentLayers: experimentLayers,
        matchingLayerExperimentsMetadata: (0, $iDrrr.fg)('search_experiment_layer_metadata') ? matchingLayerExperimentsMetadata : undefined,
        shadowExperimentId: shadowExperimentId,
        fanoutExperimentCohort: 'enable-v2',
        backendExperiment: backendExperiment
    };
};









var $gDBUP = parcelRequire("gDBUP");


var $epRE1 = parcelRequire("epRE1");

const $e3a18b26227074f0$export$8a04e6ddedd0bb29 = ({ queryParams: queryParams, cloudId: cloudId, availableProducts: availableProducts, unitMetadata: unitMetadata, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds, primaryProduct: primaryProduct })=>{
    const { filters: filters, selectedProducts: requestedProducts, selectedDatasource: selectedDatasource, sites: sites } = (0, $epRE1.getSearchConfig)({
        cloudId: cloudId,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct,
        unitMetadata: unitMetadata
    });
    // Resolve app availability and explicit app selection against the same site scope.
    const productsForQuery = (0, $6Vsfx.getAvailableProductsForSelectedCloudIds)({
        currentCloudId: cloudId,
        availableProducts: availableProducts,
        selectedCloudIds: sites,
        unitMetadata: unitMetadata
    });
    const primaryIsExcluded = sites.length > 0 && !sites.includes(cloudId);
    const selectedProducts = primaryIsExcluded ? requestedProducts.filter((0, $dvVWp.is1pProductKey)) : requestedProducts;
    const selectedFilters = (0, $gDBUP.getSelectedFilters)({
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource,
        availableProducts: productsForQuery,
        allFilterExcludedProducts: allFilterExcludedProducts,
        thirdPartyConfigs: thirdPartyConfigs,
        currentUserId: currentUserId,
        jsmIncidentFilterIds: jsmIncidentFilterIds
    });
    return {
        availableProducts: productsForQuery,
        selectedProducts: selectedProducts,
        sites: sites,
        ...selectedFilters
    };
};


const $c1b18402330cc36d$export$cd3c83311f418ff4 = ({ queryParams: queryParams })=>{
    if (!queryParams) return {
        searchQuery: '',
        originalQuery: undefined
    };
    const searchQuery = queryParams?.text ?? '';
    const originalQuery = queryParams?.originalQuery;
    return {
        searchQuery: searchQuery,
        originalQuery: originalQuery
    };
};


/**
 * Utility for resolving the `__relay_internal__pv__*` provided variables
 * required by the search-results persisted query.
 *
 * Non-Relay callers (e.g. SSR preload helpers that POST persisted queries
 * directly to AGG) must include these variables in their request body to
 * satisfy the gateway's `Boolean!` NonNull declarations. Historically those
 * callers duplicated the keys as a static map, which silently drifts from
 * the live `.relayprovider` evaluations performed inside the Relay
 * environment.
 *
 * This module is the single source of truth for that resolution. It calls
 * each provider's `get()` at invocation time so feature-gate / experiment
 * results are picked up at runtime (including during SSR, on the
 * assumption that the underlying feature gates are SSR-evaluable). The
 * shape of the returned map is pinned to the generated query artifact by
 * `index.relay-provided-variables.test.ts`.
 *
 * SSR Safety: This function is synchronous, contains no React hooks, and
 * does not touch browser-only globals directly. Each provider's `get()`
 * implementation must uphold the same contract.
 */ 
var $hd5Dy = parcelRequire("hd5Dy");


var $8NMWF = parcelRequire("8NMWF");


var $hFjUk = parcelRequire("hFjUk");


var $iK48f = parcelRequire("iK48f");


var $8dp6J = parcelRequire("8dp6J");


var $4Pgy4 = parcelRequire("4Pgy4");


var $b9kI4 = parcelRequire("b9kI4");


var $jfrG1 = parcelRequire("jfrG1");

const $fb8d04ee47c1bab9$export$722bffef5ff5d4b4 = ()=>({
        __relay_internal__pv__skiplinkeduserhydrationrelayprovider: (0, $8NMWF.default).get(),
        __relay_internal__pv__isassetsenabledrelayprovider: (0, $hd5Dy.default).get(),
        __relay_internal__pv__isleadnounenabledrelayprovider: (0, $iK48f.default).get(),
        __relay_internal__pv__isleaduserastitleenabledrelayprovider: (0, $8dp6J.default).get(),
        __relay_internal__pv__isprojectrendererenabledrelayprovider: (0, $b9kI4.default).get(),
        __relay_internal__pv__isslacktopreactionenabledrelayprovider: (0, $4Pgy4.default).get(),
        __relay_internal__pv__isslackworkspacemetadataenabledrelayprovider: (0, $hFjUk.default).get(),
        __relay_internal__pv__ismetadatacontentenabledrelayprovider: (0, $jfrG1.default).get()
    });


const $41b899904a7901a9$export$b83d7680b0db727d = ({ backendExperimentOverrides: backendExperimentOverrides, cloudId: cloudId, experimentLayers: rawExperimentLayers, experience: experience, useCaseId: useCaseId, isJiraIssueIndexed: isJiraIssueIndexed, jsmIncidentFilterIds: jsmIncidentFilterIds, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, analyticsAttributes: analyticsAttributes, productDataRegions: productDataRegions, productEdition: productEdition, products: bootstrapProducts, unitMetadata: unitMetadata, queryParams: queryParams, sessionId: rawSessionId, searchSessionId: rawSearchSessionId, thirdPartyConfigs: thirdPartyConfigs, user: user, onError: onError, getLayerValuesFn: getLayerValuesFn, expectResult: expectResult = true, isLiteMode: isLiteMode = false })=>{
    const { originalQuery: originalQuery, searchQuery: searchQuery } = (0, $c1b18402330cc36d$export$cd3c83311f418ff4)({
        queryParams: queryParams
    });
    const { availableProducts: products, entities: entities, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedEntities: selectedEntities, selectedFilters: selectedFilters, selectedProducts: selectedProducts, sites: sites, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters } = (0, $e3a18b26227074f0$export$8a04e6ddedd0bb29)({
        allFilterExcludedProducts: (0, $4ysB6.getAllFilterExcludedProducts)({
            experience: experience,
            primaryProduct: primaryProduct
        }),
        availableProducts: bootstrapProducts,
        cloudId: cloudId,
        currentUserId: user?.id,
        jsmIncidentFilterIds: jsmIncidentFilterIds,
        primaryProduct: primaryProduct,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs,
        ...experience === 'search-page' && unitMetadata ? {
            unitMetadata: unitMetadata
        } : {}
    });
    const searchableProducts = $41b899904a7901a9$var$getSearchableProducts(searchQuery, products);
    const { assetsFilters: assetsFilters, commonFilters: commonFilters, compassFilters: compassFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, loomFilters: loomFilters, mercuryFilters: mercuryFilters, sortFilters: sortFilters, talentFilters: talentFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const { experimentId: experimentId, experimentLayers: experimentLayers, matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata, shadowExperimentId: shadowExperimentId, fanoutExperimentCohort: fanoutExperimentCohort, backendExperiment: backendExperiment } = (0, $5311b2f8ca23af19$export$8c6fefe9b6b2ccd8)({
        backendExperimentOverrides: backendExperimentOverrides,
        cloudId: cloudId,
        entities: entities,
        experimentLayers: rawExperimentLayers,
        experienceLayer: experience,
        isHello: (0, $03qcI.isHello)(cloudId),
        isJiraIssueIndexed: isJiraIssueIndexed,
        onError: onError,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        thirdPartyFilters: selectedFilters.thirdPartyFilters,
        getLayerValuesFn: getLayerValuesFn
    });
    const requestHeaders = {
        [(0, $fnx12.EDGE_REGION_HINT_HEADER)]: primaryProduct && productDataRegions ? (0, $fnx12.getEdgeRegionHint)(primaryProduct, productDataRegions) : undefined
    };
    const additionalSites = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
        primaryProduct: primaryProduct
    }) ? sites : [];
    const [firstSite = cloudId, ...remainingSites] = (0, $6Vsfx.getSelectedSiteCloudIds)(additionalSites, cloudId);
    const cloudIdARIs = (0, $S6W9B.getCloudIdARIs)(firstSite, primaryProduct, remainingSites);
    const requestUseCaseId = (0, $3wZF4.getSearchUseCaseIdForRequest)(useCaseId);
    // Fast Jira value-field hydration experiment. Evaluate the experiment ONCE so we only fire a
    // single exposure event.
    const hasJiraProduct = products.some((product)=>(0, $6qPRO.isJiraProduct)(product, true));
    const fastJiraHydrationEnabled = hasJiraProduct && (0, $cJff5.serveFastJiraHydrationExperiment)();
    const sourceSubProduct = analyticsAttributes?.referredSubProduct ?? primarySubProduct;
    const sharedQueryVariables = {
        commonFilters: commonFilters,
        compassFilters: compassFilters,
        confluenceFilters: confluenceFilters,
        disableQueryReplacement: !!originalQuery,
        entities: entities,
        experience: experience,
        ...requestUseCaseId ? {
            useCaseId: requestUseCaseId
        } : {},
        jiraFilters: jiraFilters,
        limit: $41b899904a7901a9$var$getLimit(entities),
        mercuryFilters: mercuryFilters,
        query: searchQuery,
        queryVersion: 1,
        searchSessionId: rawSearchSessionId,
        sessionId: rawSessionId,
        sort: sortFilters,
        sourceProduct: primaryProduct,
        ...(0, $iDrrr.fg)('jira_search_referred_sub_product') && sourceSubProduct ? {
            sourceSubProduct: sourceSubProduct
        } : {},
        tenantId: cloudId,
        thirdPartyFilters: thirdPartyFilters,
        ...(0, $iDrrr.fg)('assets_rovo_search_all') ? {
            assetsFilters: assetsFilters
        } : {},
        ...(0, $iDrrr.fg)('talent_global_search') ? {
            talentFilters: talentFilters
        } : {}
    };
    const shouldIncludeLoomFilters = entities.some((entity)=>entity.startsWith('ati:cloud:loom:')) && Object.values(loomFilters).some((value)=>value && value.length > 0);
    const searchResultsQueryVariables = {
        ...sharedQueryVariables,
        ...shouldIncludeLoomFilters ? {
            loomFilters: loomFilters
        } : {},
        cloudIdARIs: cloudIdARIs,
        expectResult: expectResult,
        /**
		 * Highlighting is only useful for results
		 */ enableHighlighting: true,
        experimentId: /**
		 * Experimentation is only valid in results section. Note that experiments
		 * can differ based on selected entites/products, so if we include experiments
		 * in counts, the counts will change as filters change
		 */ experimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId,
                definitions: definitions
            })),
        ...matchingLayerExperimentsMetadata ? {
            matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata
        } : {},
        fanoutExperimentCohort: fanoutExperimentCohort,
        includeCodeSearch: (0, $coUcA.getCodeSearchScope)({
            products: selectedProducts,
            selectedTypes: selectedEntities,
            isAllProductSearch: (0, $c3cgJ.isAllProductSearch)(selectedProducts),
            codeHostProductKeys: (0, $dvVWp.CODE_HOST_PRODUCT_KEYS),
            githubProductKeys: (0, $dvVWp.GITHUB_PRODUCT_KEYS)
        }) !== 'none',
        includeJiraLiteModeFields: isLiteMode && selectedProducts.some((product)=>(0, $6qPRO.isJiraProduct)(product, true)),
        // Fast Jira value-field hydration experiment. Enrolled whenever a Jira product is among
        // the products being searched (`products` includes selected-site products and drives the
        // entities). We do NOT use
        // the filter-selection `selectedProducts` here: that is empty on the default "All apps"
        // search, which would wrongly skip enrolment even though Jira results are shown (e.g. when
        // searching Jira from Confluence). When on, the query selects the lighter
        // issueType/assignee/project/priority/labels value fields instead of the higher-cost
        // *Field variants (see searchJiraIssue_AtlassianSearchPage).
        includeFastJiraHydration: fastJiraHydrationEnabled,
        includeNavBoostScore: (0, $iDrrr.fg)('kd_enable_nav_boost_score'),
        includePassionfruitAsk: (0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled') && !(0, $iDrrr.fg)('platform_mercury_ask_search_ui_enabled'),
        includeRisk: (0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled'),
        includeMercuryAsk: (0, $iDrrr.fg)('platform_mercury_ask_search_ui_enabled'),
        includePositions: (0, $iDrrr.fg)('talent_global_search'),
        includeThirdPartyId: (0, $9AIBu.isEligibleFor3PClickIngestion)(thirdPartyConfigs),
        includeDatasourceId: true,
        includeOriginalEntityType: (0, $iDrrr.fg)('rovo_fps_original_entity_type_analytics'),
        includeCaseEmbeddedComments: (0, $iDrrr.fg)('rovo_fps_case_embedded_comments'),
        // Federated results are deferred only for the unfiltered all-products search. A product
        // pill must keep federated connector results in `edges`, which is the path the existing
        // product-specific result renderer consumes.
        deferFederatedResults: (0, $c3cgJ.isAllProductSearch)(selectedProducts) && (0, $dXat9.isFederatedResultsEnabled)(),
        includeJiraEmbeddedComments: (0, $iDrrr.fg)('rovo_fps_jira_issue_embedded_comments'),
        shadowExperimentId: shadowExperimentId,
        thirdPartyFilters: thirdPartyFilters
    };
    const rightPanelQueryVariables = {
        ...sharedQueryVariables,
        cloudIdARIs: cloudIdARIs,
        expectResult: expectResult,
        /**
		 * Counts searches for approx all entities (see getSelectedFilters for edge cases)
		 */ entities: entitiesForResultsCountQuery,
        /**
		 * We need to search for all Jira product types to support counts in Jira/JSM/JPD correctly
		 */ jiraFilters: (0, $21d1cc4e299beef1$export$62c31c0f13603e08)(jiraFilters, searchableProducts),
        limit: 0,
        sort: [],
        thirdPartyFilters: unselectedProductsThirdPartyFilters
    };
    /**
	 * Relay uses the entire variables objects as a cache key. For this reason,
	 * when making the same search request, we need to ensure we retrieve the
	 * same sessionId and searchSessionId. We do this by caching these ids
	 * and retrieving them using the variables object excluding the ids as a cache key.
	 */ const [searchResultsQuerySessionId, searchResultsQuerySearchSessionId] = (0, $b5a3e357e30a85ab$export$8b9832780ea0337b)(searchResultsQueryVariables);
    searchResultsQueryVariables.sessionId = searchResultsQuerySessionId;
    searchResultsQueryVariables.searchSessionId = searchResultsQuerySearchSessionId;
    const [rightPanelQuerySessionId, rightPanelQuerySearchSessionId] = (0, $b5a3e357e30a85ab$export$8b9832780ea0337b)(rightPanelQueryVariables);
    rightPanelQueryVariables.sessionId = rightPanelQuerySessionId;
    rightPanelQueryVariables.searchSessionId = rightPanelQuerySearchSessionId;
    const searchResultsQueryRelayProvidedVariables = (0, $fb8d04ee47c1bab9$export$722bffef5ff5d4b4)();
    return {
        backendExperiment: backendExperiment,
        requestHeaders: requestHeaders,
        rightPanelQueryVariables: rightPanelQueryVariables,
        searchResultsQueryRelayProvidedVariables: searchResultsQueryRelayProvidedVariables,
        searchResultsQueryVariables: searchResultsQueryVariables
    };
};
const $41b899904a7901a9$var$getLimit = (entities)=>{
    return entities.length === (0, $2ePuQ.getDefaultEntityAti)().length ? (0, $2ePuQ.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $2ePuQ.RESULT_LIMIT_FOR_SINGLE_PRODUCT);
};
const $41b899904a7901a9$var$getSearchableProducts = (searchQuery, products)=>{
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    return products.filter((product)=>!isEmptyQuery || (0, $dvVWp.productsSupportingEmptyQuery).includes(product));
};
module.exports["generateSearchInputs"] = $41b899904a7901a9$export$b83d7680b0db727d;

});

parcelRegister("dXat9", function(module, exports) {

var $cha5E = parcelRequire("cha5E");


var $2pQiO = parcelRequire("2pQiO");

const $339a29aca7a6802d$export$b0448c33e62a2376 = ()=>(0, $cha5E.expVal)('fed_search_results_in_conf_fps', 'isEnabled', false);
const $339a29aca7a6802d$export$3a60d7d1a7259b31 = ()=>(0, $2pQiO.UNSAFE_expValNoExposure)('fed_search_results_in_conf_fps', 'isEnabled', false);
module.exports["isFederatedResultsEnabled"] = $339a29aca7a6802d$export$b0448c33e62a2376;
module.exports["getFederatedResultsExperimentValueWithoutExposure"] = $339a29aca7a6802d$export$3a60d7d1a7259b31;

});

parcelRegister("518WI", function(module, exports) {

var $6onJ6 = parcelRequire("6onJ6");

const $e416c75d0c35adf1$export$e9ddc0ee913bbcbd = (0, $6onJ6.disposableValue)();
module.exports["SEARCH_SESSION_ID"] = $e416c75d0c35adf1$export$e9ddc0ee913bbcbd;

});

parcelRegister("epRE1", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $1Qme9 = parcelRequire("1Qme9");


var $dvVWp = parcelRequire("dvVWp");


var $biQM6 = parcelRequire("biQM6");


var $6Vsfx = parcelRequire("6Vsfx");

/**
 * Lightweight filter data for query generation.
 * Constructs minimal filter objects without importing filter definition files,
 * avoiding transitive deps on smart-user-picker, @atlaskit/select, react-dom etc.
 *
 *
 */ 
var $fR63l = parcelRequire("fR63l");





var $bHPvH = parcelRequire("bHPvH");


var $6uNXh = parcelRequire("6uNXh");


var $7MX1N = parcelRequire("7MX1N");


var $kZdMI = parcelRequire("kZdMI");


var $iaii4 = parcelRequire("iaii4");


var $2bNdD = parcelRequire("2bNdD");


var $26LZ9 = parcelRequire("26LZ9");


var $2UU5O = parcelRequire("2UU5O");

// Helper product arrays
const $2f888f9fa31c2db5$var$confluenceProducts = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $2f888f9fa31c2db5$var$baseJiraProducts = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement
];
const $2f888f9fa31c2db5$var$assetsProducts = [
    (0, $dvVWp.ProductKeys).Assets
];
const $2f888f9fa31c2db5$var$mercuryProducts = [
    (0, $dvVWp.ProductKeys).Focus
];
const $2f888f9fa31c2db5$var$talentProducts = [
    (0, $dvVWp.ProductKeys).Talent
];
const $2f888f9fa31c2db5$var$contributorProducts = (0, $dvVWp.all1pProductKeys).filter((key)=>key !== (0, $dvVWp.ProductKeys).Trello && key !== (0, $dvVWp.ProductKeys).Focus && key !== (0, $dvVWp.ProductKeys).Talent);
const $2f888f9fa31c2db5$var$contributor3P = (0, $dvVWp.all3pProductKeys).filter((key)=>key !== (0, $fR63l.ProductKeys3P).Figma);
const $2f888f9fa31c2db5$var$createFilterData = (jiraProducts)=>({
        lastUpdated: (0, $7MX1N.createMultiSelectFilter)({
            id: 'lastUpdated',
            products: [
                (0, $dvVWp.ProductKeys).Atlas,
                (0, $dvVWp.ProductKeys).Confluence,
                (0, $dvVWp.ProductKeys).Focus,
                ...jiraProducts,
                (0, $dvVWp.ProductKeys).Compass,
                (0, $dvVWp.ProductKeys).Trello,
                (0, $dvVWp.ProductKeys).Bitbucket,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('lastUpdated')
            ],
            alwaysVisible: true,
            universal: true,
            queryParams: {
                key: 'lastModified',
                generateQueryParamsGetState: (0, $iaii4.generateQueryParamsGetState)
            }
        }),
        contributor: (0, $7MX1N.createMultiSelectFilter)({
            id: 'contributor',
            products: [
                ...$2f888f9fa31c2db5$var$contributorProducts,
                ...$2f888f9fa31c2db5$var$contributor3P
            ],
            alwaysVisible: true,
            universal: true,
            queryParams: {
                key: 'contributors'
            }
        }),
        space: (0, $7MX1N.createMultiSelectFilter)({
            id: 'space',
            products: [
                ...$2f888f9fa31c2db5$var$confluenceProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('space'),
                (0, $dvVWp.ProductKeys).Loom
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'spaces'
            }
        }),
        site: (0, $7MX1N.createMultiSelectFilter)({
            id: 'site',
            products: [
                ...(0, $dvVWp.all1pProductKeys),
                ...(0, $dvVWp.all3pProductKeys)
            ],
            alwaysVisible: false,
            universal: true,
            queryParams: {
                key: 'sites'
            }
        }),
        watchedByMe: (0, $6uNXh.createBooleanFilter)({
            id: 'watchedByMe',
            products: jiraProducts,
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'jWatchedByMe'
            }
        }),
        verified: (0, $6uNXh.createBooleanFilter)({
            id: 'verified',
            products: [
                ...$2f888f9fa31c2db5$var$confluenceProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('verified')
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'verified'
            }
        }),
        assignee: (0, $7MX1N.createMultiSelectFilter)({
            id: 'assignee',
            products: [
                ...jiraProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('assignee')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'jAssignee'
            }
        }),
        reporter: (0, $7MX1N.createMultiSelectFilter)({
            id: 'reporter',
            products: [
                ...jiraProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('reporter')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'jReporter'
            }
        }),
        commentedByMe: (0, $6uNXh.createBooleanFilter)({
            id: 'commentedByMe',
            products: [
                ...jiraProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('commentedByMe')
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'jCommentedByMe'
            }
        }),
        project: (0, $7MX1N.createMultiSelectFilter)({
            id: 'project',
            products: [
                ...jiraProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('project')
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'jProject',
                generateQueryParamsGetState: (0, $2UU5O.generateQueryParamsGetState)
            }
        }),
        universalTypeFilter: (0, $kZdMI.createSingleSelectFilter)({
            id: 'universalTypeFilter',
            products: [
                ...(0, $dvVWp.all1pProductKeys),
                ...(0, $dvVWp.all3pProductKeys)
            ],
            alwaysVisible: true,
            universal: true,
            queryParams: {
                key: 'type'
            }
        }),
        content: (0, $7MX1N.createMultiSelectFilter)({
            id: 'content',
            products: [
                ...$2f888f9fa31c2db5$var$confluenceProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('content')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'ancestor'
            }
        }),
        onlyTitleMatch: (0, $6uNXh.createBooleanFilter)({
            id: 'onlyTitleMatch',
            products: [
                ...$2f888f9fa31c2db5$var$confluenceProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('onlyTitleMatch')
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'titleMatch'
            }
        }),
        owner: (0, $7MX1N.createMultiSelectFilter)({
            id: 'owner',
            products: [
                (0, $dvVWp.ProductKeys).Confluence,
                (0, $dvVWp.ProductKeys).Focus,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('owner')
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'owners'
            }
        }),
        createdBy: (0, $7MX1N.createMultiSelectFilter)({
            id: 'createdBy',
            products: [
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('createdBy')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'createdBy'
            }
        }),
        label: (0, $7MX1N.createMultiSelectFilter)({
            id: 'label',
            products: [
                (0, $dvVWp.ProductKeys).Confluence,
                ...jiraProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'labels'
            }
        }),
        tag: (0, $7MX1N.createMultiSelectFilter)({
            id: 'tag',
            products: [
                (0, $dvVWp.ProductKeys).Loom
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'tags'
            }
        }),
        focusAreaType: (0, $7MX1N.createMultiSelectFilter)({
            id: 'focusAreaType',
            products: [
                ...$2f888f9fa31c2db5$var$mercuryProducts
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'focusAreaTypes'
            }
        }),
        focusAreaUnder: (0, $7MX1N.createMultiSelectFilter)({
            id: 'focusAreaUnder',
            products: [
                ...$2f888f9fa31c2db5$var$mercuryProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'focusAreaUnder'
            }
        }),
        pageStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'pageStatus',
            products: [
                ...$2f888f9fa31c2db5$var$confluenceProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'pageStatus',
                generateQueryParamsGetState: (0, $2bNdD.generateQueryParamsGetState)
            }
        }),
        archived: (0, $6uNXh.createBooleanFilter)({
            id: 'archived',
            products: [
                ...$2f888f9fa31c2db5$var$confluenceProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('archived')
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'archived'
            }
        }),
        lastUpdatedBy: (0, $7MX1N.createMultiSelectFilter)({
            id: 'lastUpdatedBy',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce,
                (0, $dvVWp.ProductKeys).Hubspot
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'lastUpdatedBy'
            }
        }),
        statusFilter: (0, $7MX1N.createMultiSelectFilter)({
            id: 'statusFilter',
            products: [
                ...jiraProducts,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('statusFilter')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'status'
            }
        }),
        compassArchived: (0, $6uNXh.createBooleanFilter)({
            id: 'compassArchived',
            products: [
                (0, $dvVWp.ProductKeys).Compass
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'compassArchived'
            }
        }),
        assetsSchema: (0, $7MX1N.createMultiSelectFilter)({
            id: 'assetsSchema',
            products: [
                ...$2f888f9fa31c2db5$var$assetsProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'assetsSchema'
            }
        }),
        assetsType: (0, $7MX1N.createMultiSelectFilter)({
            id: 'assetsType',
            products: [
                ...$2f888f9fa31c2db5$var$assetsProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'assetsType'
            }
        }),
        positionStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'positionStatus',
            products: [
                ...$2f888f9fa31c2db5$var$talentProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'positionStatuses'
            }
        }),
        positionEmploymentType: (0, $7MX1N.createMultiSelectFilter)({
            id: 'positionEmploymentType',
            products: [
                ...$2f888f9fa31c2db5$var$talentProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'positionEmploymentTypes'
            }
        }),
        positionJobFamily: (0, $7MX1N.createMultiSelectFilter)({
            id: 'positionJobFamily',
            products: [
                ...$2f888f9fa31c2db5$var$talentProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'positionJobFamilies'
            }
        }),
        positionTeam: (0, $7MX1N.createMultiSelectFilter)({
            id: 'positionTeam',
            products: [
                ...$2f888f9fa31c2db5$var$talentProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'positionTeams',
                generateQueryParamsGetState: (0, $26LZ9.generateQueryParamsGetState)
            }
        }),
        positionFocusArea: (0, $7MX1N.createMultiSelectFilter)({
            id: 'positionFocusArea',
            products: [
                ...$2f888f9fa31c2db5$var$talentProducts
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'positionFocusAreas'
            }
        }),
        opportunityStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'opportunityStatus',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'opportunityStatus'
            }
        }),
        campaignStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'campaignStatus',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'campaignStatuses'
            }
        }),
        caseStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'caseStatus',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'caseStatuses'
            }
        }),
        documentStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'documentStatus',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'knowledgeArticleStatuses'
            }
        }),
        calendarType: (0, $7MX1N.createMultiSelectFilter)({
            id: 'calendarType',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'eventTypes'
            }
        }),
        leadStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'leadStatus',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'leadStatuses'
            }
        }),
        taskStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'taskStatus',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'taskStatuses'
            }
        }),
        taskType: (0, $7MX1N.createMultiSelectFilter)({
            id: 'taskType',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'taskTypes'
            }
        }),
        sort: (0, $kZdMI.createSingleSelectFilter)({
            id: 'sort',
            products: [
                (0, $dvVWp.ProductKeys).Confluence,
                (0, $dvVWp.ProductKeys).Jira
            ],
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'sort'
            }
        }),
        salesforceStage: (0, $7MX1N.createMultiSelectFilter)({
            id: 'salesforceStage',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'salesforceStages'
            }
        }),
        closeDate: (0, $kZdMI.createSingleSelectFilter)({
            id: 'closeDate',
            products: [
                (0, $dvVWp.ProductKeys).Salesforce
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'closeDate'
            }
        }),
        pullRequestStatus: (0, $7MX1N.createMultiSelectFilter)({
            id: 'pullRequestStatus',
            products: [
                (0, $dvVWp.ProductKeys).Bitbucket,
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('pullRequestStatus')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'pullRequestStatus'
            }
        }),
        repository: (0, $7MX1N.createMultiSelectFilter)({
            id: 'repository',
            products: [
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('repository')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'repository'
            }
        }),
        reviewer: (0, $7MX1N.createMultiSelectFilter)({
            id: 'reviewer',
            products: [
                ...(0, $bHPvH.getProducts3PFromConfigForFilter)('reviewer')
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'reviewer'
            }
        }),
        slackChannel: (0, $7MX1N.createMultiSelectFilter)({
            id: 'slackChannel',
            products: (0, $bHPvH.getProducts3PFromConfigForFilter)('slackChannel'),
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'slackChannels'
            }
        }),
        folder: (0, $7MX1N.createMultiSelectFilter)({
            id: 'folder',
            products: [
                (0, $dvVWp.ProductKeys).Loom
            ],
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'folders'
            }
        }),
        workspaceName: (0, $7MX1N.createMultiSelectFilter)({
            id: 'workspaceName',
            products: (0, $bHPvH.getProducts3PFromConfigForFilter)('workspaceName'),
            alwaysVisible: false,
            universal: false,
            queryParams: {
                key: 'workspaceName'
            }
        }),
        hasAttachment: (0, $6uNXh.createBooleanFilter)({
            id: 'hasAttachment',
            products: (0, $bHPvH.getProducts3PFromConfigForFilter)('hasAttachment'),
            alwaysVisible: true,
            universal: false,
            queryParams: {
                key: 'hasAttachment'
            }
        })
    });
const $2f888f9fa31c2db5$export$e2027e051ab4adfa = ({ includeCustomerServiceManagement: includeCustomerServiceManagement = false } = {})=>$2f888f9fa31c2db5$var$createFilterData([
        ...$2f888f9fa31c2db5$var$baseJiraProducts,
        ...includeCustomerServiceManagement ? [
            (0, $dvVWp.ProductKeys).CustomerServiceManagement
        ] : []
    ]);
const $2f888f9fa31c2db5$export$e8343e733de21ab3 = $2f888f9fa31c2db5$export$e2027e051ab4adfa();



var $ieiUX = parcelRequire("ieiUX");

const $8f45aa0a73d663f1$export$2e9655e8b4177582 = ({ cloudId: cloudId, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct, unitMetadata: unitMetadata })=>{
    // Parse query params so they're typed more strongly
    const parsedQueryParams = (0, $biQM6.parseQueryParams)(queryParams);
    const { lastModified_lt: _, lastModified_gt: __, ...parsedQueryParamsInUse } = parsedQueryParams;
    const queryParamsWithValuesAsStringArray = (0, $biQM6.convertQueryParamsToStringArray)(parsedQueryParamsInUse, Object.keys(parsedQueryParams));
    const includeCustomerServiceManagement = (0, $iDrrr.fg)('csm_product_filter_in_search');
    const allFilterData = (0, $2f888f9fa31c2db5$export$e2027e051ab4adfa)({
        includeCustomerServiceManagement: includeCustomerServiceManagement
    });
    const enabledCustomerServiceManagementProduct = includeCustomerServiceManagement ? (0, $dvVWp.ProductKeys).CustomerServiceManagement : undefined;
    const productSelectionQueryParams = {
        ...queryParams,
        product: parsedQueryParams.product === (0, $dvVWp.ProductKeys).CustomerServiceManagement ? enabledCustomerServiceManagementProduct : queryParams.product
    };
    // Get utilities for processing query params into filters
    const { getSelectedProducts: getSelectedProducts } = (0, $ieiUX.FilterUtils)(allFilterData, {});
    // Get selected products from query params
    const selectedProducts = getSelectedProducts(productSelectionQueryParams);
    // Get minimal filters object containing selected values based on query params
    const filters = Object.fromEntries(Object.entries(allFilterData).map(([filterId, filter])=>{
        return [
            filterId,
            filter.queryParams.getState(queryParamsWithValuesAsStringArray, cloudId)
        ];
    }));
    // Get selected datasource
    const selectedDatasource = (0, $biQM6.getDatasourceFromId)(parsedQueryParams.datasource, selectedProducts[0], thirdPartyConfigs);
    const isMultiSiteEnabled = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
        primaryProduct: primaryProduct
    });
    return {
        cql: parsedQueryParams.cql,
        searchQuery: parsedQueryParams.text || '',
        originalQuery: parsedQueryParams.originalQuery,
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource,
        // Keep site selection behind the rollout gate and product eligibility check.
        sites: isMultiSiteEnabled ? unitMetadata === undefined ? parsedQueryParams.sites ?? [] : (0, $6Vsfx.getSelectedSiteCloudIds)(parsedQueryParams.sites, cloudId, unitMetadata) : []
    };
};
module.exports["getSearchConfig"] = $8f45aa0a73d663f1$export$2e9655e8b4177582;

});

parcelRegister("23j2F", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");

const $a6b891e4fc5c2845$export$f09e972bbd9c2e = ({ cloudId: cloudId, primaryProduct: primaryProduct, activationId: activationId, locale: locale, orgId: orgId, query: query })=>{
    const product = primaryProduct || '';
    const siteId = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira ? `ari:cloud:jira-software::site/${cloudId}` : `ari:cloud:${product}::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : '';
    return {
        query: query,
        siteId: siteId,
        locale: locale,
        orgId: orgId ?? '',
        workspaceId: workspaceId,
        cloudId: cloudId,
        product: product
    };
};
module.exports["buildIntentDetectionVariables"] = $a6b891e4fc5c2845$export$f09e972bbd9c2e;

});

parcelRegister("7KnRQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $cuvLu = parcelRequire("cuvLu");


var $zzZbq = parcelRequire("zzZbq");







function $f4c8592a99c48782$export$7542d9981bb876f9(query) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $iDrrr.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $zzZbq.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $iDrrr.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $zzZbq.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return {
        queryIntent: (0, $zzZbq.QueryIntent).AGENT,
        transformedQuery: query.replace(' agent', '').replace(' Agent', '')
    };
}






var $7DMz5 = parcelRequire("7DMz5");

const $b0caf69c721de740$export$6c52de753cb858f8 = 'KnowledgeDiscoveryIntentDetectionQuery';
const $b0caf69c721de740$export$12788ba4bf4fbd92 = `
    ... on KnowledgeDiscoveryBookmarkIntent {
        __typename
        bookmark {
            id
            url
            title
            description
            keyPhrase
            bookmarkState
            lastModifierAccountId
            lastModifiedTimestamp
            parentAdminhubBookmarkId
        }
    }
`;
const $b0caf69c721de740$export$6f87cad788b6beba = `
	... on KnowledgeDiscoveryPersonIntent {
		__typename
		persons {
			accountId
			name
			email
			picture
			jobTitle
			department
			organization
			location
			zoneInfo
		}
	}
`;
const $b0caf69c721de740$export$fbbcc7a6fd1b5b3 = `
	originalIntent
	elsTraceId
	prefilterEntities {
		entityType
		id
		name
		mention
		confidenceScore
		clarificationLevel
	}
`;
const $b0caf69c721de740$export$5cc310960e46a388 = `
	... on KnowledgeDiscoveryNavContentIntent {
		__typename
		url
		title
		createdAt
	}
`;
const $b0caf69c721de740$export$8145deeb4e892b30 = ()=>`
	query KnowledgeDiscoveryIntentDetectionQuery(
		$siteId: String!
		$query: String!
		$locale: String!
		$orgId: String!
	) {
		knowledgeDiscovery {
			intentDetection(locale: $locale, orgId: $orgId, query: $query, siteId: $siteId) {
				... on KnowledgeDiscoveryIntentDetectionSuccess {
					__typename
					errors {
						errorType
						statusCode
					}
					detectionMetadata {
						cacheHit
						latencyMs
						method
						model
						timestamp
						entityMetadata {
							entityCount
							entityType
						}
						${(0, $7DMz5.SAINFeatureControl).isFEPersonsELSEnabled() ? $b0caf69c721de740$export$fbbcc7a6fd1b5b3 : ''}
					}
					intent {
						classification
						detectionType
						subTypes
						transformedQuery
						... on KnowledgeDiscoveryJiraIntent {
							__typename
						}
						... on KnowledgeDiscoveryKeywordOrAcronymIntent {
							__typename
						}
						... on KnowledgeDiscoveryNaturalLanguageIntent {
							__typename
						}
						... on KnowledgeDiscoveryNoneIntent {
							__typename
						}
						... on KnowledgeDiscoveryPersonIntent {
							__typename
						}
						... on KnowledgeDiscoveryTeamIntent {
							__typename
						}
						... on KnowledgeDiscoveryTopicIntent {
							__typename
						}
						... on KnowledgeDiscoveryNavigationalIntent {
							__typename
						}
						... on KnowledgeDiscoveryOrgChartIntent {
							__typename
						}
						${(0, $iDrrr.fg)('kd_enable_sain_hero_nav') ? $b0caf69c721de740$export$5cc310960e46a388 : ''}
						${(0, $iDrrr.fg)('kd_bookmark_query_intent') ? $b0caf69c721de740$export$12788ba4bf4fbd92 : ''}
						${(0, $7DMz5.SAINFeatureControl).isFEPersonsELSEnabled() ? $b0caf69c721de740$export$6f87cad788b6beba : ''}
					}
				}
			}
		}
	}
`;


// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $87641ab558a8c326$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
const $87641ab558a8c326$export$c16051a8e758ff55 = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, setIntentData: setIntentData, setRequestId: setRequestId, setTraceId: setTraceId, setIntentDetectionMetadata: setIntentDetectionMetadata, onError: onError, onComplete: onComplete })=>{
    // Records the resolved intent with its provenance; emitted via `onComplete` in `finally`.
    let resolved;
    const resolveQueryIntent = (result)=>{
        resolved = result;
        setQueryIntent(result.queryIntent);
    };
    const handleError = (error, responseFailure = false, tracing)=>{
        resolveQueryIntent({
            queryIntent: (0, $zzZbq.QueryIntent).NONE,
            source: 'backend_v2'
        });
        setTransformedQuery('');
        onError?.(error);
        (0, $cuvLu.logger).error({
            feature: 'query-intent',
            element: 'container',
            operation: 'fetch',
            category: responseFailure ? 'graphql' : 'unknown',
            error: responseFailure ? undefined : error,
            legacyError: error,
            message: 'Query intent request failed',
            traceId: tracing?.['x-trace-id'],
            requestId: tracing?.['atl-request-id'],
            functionName: 'getQueryIntent: handleError'
        });
    };
    try {
        const frontendQueryIntent = (0, $f4c8592a99c48782$export$7542d9981bb876f9)(query);
        // Intent from the frontend has a higher priority than the BE
        // Add any experiment and gate exclusion logic in `getFrontendQueryIntent` to prevent messy conditionals in this function
        if (!!frontendQueryIntent) {
            resolveQueryIntent({
                queryIntent: frontendQueryIntent.queryIntent,
                source: 'frontend'
            });
            setTransformedQuery(frontendQueryIntent.transformedQuery);
            return;
        }
        const aggResponse = await (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $b0caf69c721de740$export$8145deeb4e892b30)(),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $b0caf69c721de740$export$6c52de753cb858f8),
            // we're using the cache to make sure the number of calls remain the same
            // make sure the cache key format is different from the actual intent detection call
            cache: {
                ttl: 300000,
                key: `shadow-intent-detection-${query}`
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        // Trace / request IDs from the gateway HTTP response (for analytics and debugging).
        const gatewayTracingHeaders = aggResponse.gatewayTracingHeaders ?? {};
        const response = aggResponse?.data?.knowledgeDiscovery.intentDetection;
        if (!response || !aggResponse?.data || aggResponse?.errors && aggResponse?.errors.length > 0 || response?.errors && response?.errors.length > 0) {
            // errors show up at the top level or in the response
            let errorMessage = aggResponse?.errors?.[0]?.message;
            if (response?.errors && response?.errors.length > 0) errorMessage = response?.errors?.[0]?.message;
            const error = errorMessage ? new Error(errorMessage) : new Error('getQueryIntent error');
            handleError(error, Boolean(aggResponse?.errors?.length || response?.errors?.length), gatewayTracingHeaders);
            return;
        }
        // Intent from the BE
        let queryIntent = response.intent?.classification;
        if (queryIntent === (0, $zzZbq.QueryIntent).VISUAL && !(0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search')) queryIntent = (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
        if ((queryIntent === (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY || queryIntent === (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD) && selectedProduct && !$87641ab558a8c326$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $iDrrr.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) queryIntent = (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
        resolveQueryIntent({
            queryIntent: queryIntent,
            source: 'backend_v2',
            detectionMetadata: response.detectionMetadata
        });
        setTransformedQuery(response.intent?.transformedQuery);
        setIntentData?.(response.intent);
        if (response.detectionMetadata) setIntentDetectionMetadata?.(response.detectionMetadata);
        setRequestId(gatewayTracingHeaders['atl-request-id'] ?? '');
        setTraceId?.(gatewayTracingHeaders['x-trace-id'] ?? '');
    } catch (error) {
        handleError(error);
    } finally{
        if (resolved) onComplete?.(resolved);
    }
};
module.exports["getQueryIntent"] = $87641ab558a8c326$export$c16051a8e758ff55;

});

parcelRegister("3LDzU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e1bacc011ec444be$export$b6ea13c37acfe578 = ()=>{
    return (0, $cozmU.useMemo)(()=>({
            getPreloadedSearch: ({ cloudId: cloudId })=>{
                // The payload is returned regardless of route transition state, and remains
                // readable until it is explicitly cleared. Both matter for the Quick Find async
                // preload: a Quick Find→search-page navigation is a client-side transition, so
                // bailing out during transitions would discard the payload Quick Find just
                // warmed. The consumer (search-page) owns clearing it at the right time.
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                if (!preloadedSearch || preloadedSearch.cloudId !== cloudId) return null;
                return preloadedSearch;
            },
            clearPreloadedSearch: ({ cloudId: cloudId })=>{
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                // Destructive by design: freeing the global stops any consumer that bypasses
                // this provider from reading stale data, and lets Quick Find re-warm it on the
                // next search-page transition.
                if (preloadedSearch?.cloudId === cloudId) window.__PRELOADED_SEARCH__ = undefined;
            }
        }), []);
};
module.exports["usePreloadDataProvider"] = $e1bacc011ec444be$export$b6ea13c37acfe578;

});

parcelRegister("95n8y", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");

const $90cef935646eff28$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        // add third party types for dual connectors
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    // GitHub SmartLinks. Mirrors the canonical entry in rovo-connectors-config's
    // `getThirdPartyTypes`: maps the SmartLinks `resource.type` onto the existing
    // `github` product key so a SmartLinks GitHub connection contributes the
    // `smartlinks` connector source to the same merged config as the full
    // `github-connector`. Gated because an unmapped type is silently dropped,
    // which is exactly the pre-gate behaviour we fall back to.
    if ((0, $iDrrr.fg)('is_github_smartlink_search_enabled')) thirdPartyTypes['smartlinks-connector-github'] = `github`;
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
module.exports["getThirdPartyTypes"] = $90cef935646eff28$export$6750011b01164bda;

});

parcelRegister("b3qPd", function(module, exports) {
const $22b8243cc01c6b6d$export$3f8022b7bd277557 = (siteId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}`;
module.exports["getSmartlinkSiteTraitsUrl"] = $22b8243cc01c6b6d$export$3f8022b7bd277557;

});

parcelRegister("6onJ6", function(module, exports) {
/**
 * Interface representing a disposable resource.
 */ function $91e2827df3c23738$export$e29d65b7eabdc6dd(value) {
    return typeof value === 'object' && value !== null && typeof value.dispose === 'function';
}
function $91e2827df3c23738$export$79eba17614bd018c(initialValue, optionsOrDisposeFn) {
    let currentValue = initialValue ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValue = ()=>{
        if (disposeFn) disposeFn(currentValue);
        else if ($91e2827df3c23738$export$e29d65b7eabdc6dd(currentValue)) currentValue.dispose();
    };
    return {
        update: (nextValue)=>{
            if (disposeOnUpdate) disposeCurrentValue();
            currentValue = nextValue;
        },
        value: ()=>currentValue,
        dispose: ()=>{
            disposeCurrentValue();
            currentValue = null;
        }
    };
}
function $91e2827df3c23738$export$bd7305966afe1e62(disposeFn, initialValue, disposeOnUpdate = true) {
    return $91e2827df3c23738$export$79eba17614bd018c(initialValue, {
        disposeFn: disposeFn,
        disposeOnUpdate: disposeOnUpdate
    });
}
function $91e2827df3c23738$export$c86c752d0542be0d(initialValues, optionsOrDisposeFn) {
    let currentValues = initialValues ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValues = ()=>{
        if (disposeFn) disposeFn(currentValues);
        else currentValues?.forEach((value)=>{
            if ($91e2827df3c23738$export$e29d65b7eabdc6dd(value)) value.dispose();
        });
    };
    return {
        update: (nextValues)=>{
            if (disposeOnUpdate) disposeCurrentValues();
            currentValues = nextValues;
        },
        value: ()=>currentValues,
        dispose: ()=>{
            disposeCurrentValues();
            currentValues = null;
        }
    };
}
module.exports["disposableValue"] = $91e2827df3c23738$export$79eba17614bd018c;

});

parcelRegister("9AliR", function(module, exports) {

var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");


var $kZdMI = parcelRequire("kZdMI");


var $7IS25 = parcelRequire("7IS25");

const $f17bc3a8bd0f04dd$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $7IS25.getAllTypeOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $f17bc3a8bd0f04dd$var$getInitialOptions = (config)=>{
    const allOptions = (0, $7IS25.getAllTypeOptions)(config);
    return allOptions.map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $f17bc3a8bd0f04dd$var$sortCompareFn = (a, b)=>{
    const allOption = (0, $7IS25.getAllTypeOptions)({
        intl: undefined
    });
    return allOption.findIndex((option)=>option.queryParamValue === a.queryParamValue) - allOption.findIndex((option)=>option.queryParamValue === b.queryParamValue);
};
const $f17bc3a8bd0f04dd$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: (0, $4ysB6.universalTypeFilterId),
    products: (0, $dvVWp.allProductKeys),
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'type',
        fetcher: async (queryParams, config)=>{
            return $f17bc3a8bd0f04dd$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $f17bc3a8bd0f04dd$var$getInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            // NOTE: this is the first step of filtering options
            //  the store does product specific filtering
            return (0, $7IS25.lookupOptions)(query, config);
        }
    },
    sortCompareFn: $f17bc3a8bd0f04dd$var$sortCompareFn
});
module.exports["filter"] = $f17bc3a8bd0f04dd$export$3dea766d36a8935f;

});

parcelRegister("gwa0N", function(module, exports) {
const $ea4d5fa2e98920cc$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return {
            ...initialState,
            value: booleanValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $ea4d5fa2e98920cc$export$64e49a0c7bd6f7a0;

});

parcelRegister("6uNXh", function(module, exports) {

var $gwa0N = parcelRequire("gwa0N");

const $c827cef6a94b859d$export$2963583aeb05fcae = (initial)=>{
    const initialState = {
        ...initial,
        type: 'boolean',
        value: false,
        hasSelection: false,
        universal: initial.universal
    };
    return {
        id: initial.id,
        type: initialState.type,
        products: initial.products,
        universal: initial.universal,
        queryParams: {
            key: initialState.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $gwa0N.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$c827cef6a94b859d$export$cd193ee4357dee7f({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$c827cef6a94b859d$export$cd193ee4357dee7f({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter
    };
};
const $c827cef6a94b859d$export$cd193ee4357dee7f = ({ initial: initial, state: state, config: config })=>{
    const filterState = {
        ...state,
        hasSelection: state.value
    };
    return {
        ...filterState,
        setValue: $c827cef6a94b859d$var$setValue({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: ()=>filterState.value,
        getState: ()=>filterState,
        queryParams: {
            key: initial.queryParams.key,
            get: $c827cef6a94b859d$var$getQueryParams({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $c827cef6a94b859d$var$setQueryParams({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        clear: $c827cef6a94b859d$var$clear({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $c827cef6a94b859d$var$setValue = ({ initial: initial, state: state, config: config })=>{
    return (value)=>{
        const newState = {
            ...state,
            value: value,
            hasSelection: value
        };
        return $c827cef6a94b859d$export$cd193ee4357dee7f({
            initial: initial,
            state: newState,
            config: config
        });
    };
};
const $c827cef6a94b859d$var$getQueryParams = ({ initial: initial, state: state })=>{
    return ()=>({
            [initial.queryParams.key]: state.value === true ? [
                'true'
            ] : undefined
        });
};
const $c827cef6a94b859d$var$setQueryParams = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams)=>{
        const queryParamValue = queryParams[initial.queryParams.key];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return $c827cef6a94b859d$export$cd193ee4357dee7f({
            initial: initial,
            state: {
                ...state,
                value: booleanValue,
                hasSelection: booleanValue
            },
            config: config
        });
    };
};
const $c827cef6a94b859d$var$clear = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $c827cef6a94b859d$export$cd193ee4357dee7f({
            initial: initial,
            state: state,
            config: config
        });
        return filter.setValue(false);
    };
};
module.exports["createBooleanFilter"] = $c827cef6a94b859d$export$2963583aeb05fcae;

});

parcelRegister("7Nao2", function(module, exports) {

var $4NJNH = parcelRequire("4NJNH");

const $2293d7b5f5f2f478$export$d2312e68e1f5ad00 = ({ initial: initial, state: state, config: config })=>{
    return (options)=>{
        const isContributor = initial.id === 'contributor';
        const productBasedOptionsFilter = (option)=>option.product === (0, $4NJNH.getProductForFilterOption)({
                config: config,
                isUniversal: initial.universal
            });
        const allSelectedValues = new Set([
            ...state.queryParams.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.initialOptions.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.lookup.options.filter(productBasedOptionsFilter).filter((lookupOption)=>lookupOption.isSelected).map((option)=>option.value)
        ]);
        if (options.isLookupActive) {
            const withPersistedSelectedOptions = ()=>{
                const lookupResultValues = new Set(state.lookup.lookupResultOptions.map((option)=>option.value));
                const persistedSelectedOptions = [
                    ...state.queryParams.options,
                    ...state.initialOptions.options,
                    ...state.lookup.options
                ].filter(productBasedOptionsFilter).filter((option)=>allSelectedValues.has(option.value) && !lookupResultValues.has(option.value));
                const selectedPersistedDuplicates = new Set();
                return [
                    ...persistedSelectedOptions.filter((option)=>!selectedPersistedDuplicates.has(option.value) && selectedPersistedDuplicates.add(option.value)),
                    ...state.lookup.lookupResultOptions
                ];
            };
            const lookupResults = (isContributor ? withPersistedSelectedOptions() : state.lookup.lookupResultOptions).map((option)=>({
                    ...option,
                    isSelected: allSelectedValues.has(option.value)
                })).sort((option1, option2)=>Number(option2.isSelected) - Number(option1.isSelected));
            return lookupResults;
        }
        const duplicateOptions = new Set();
        const newOptions = [
            ...state.queryParams.options,
            // Query Params first
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.options,
            ...state.initialOptions.options
        ].filter(productBasedOptionsFilter).filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value) // remove duplicates
        ).map((option)=>({
                ...option,
                isSelected: allSelectedValues.has(option.value)
            }));
        if (initial.sortCompareFn) return newOptions.sort(initial.sortCompareFn);
        return newOptions;
    };
};
module.exports["getOptions"] = $2293d7b5f5f2f478$export$d2312e68e1f5ad00;

});

parcelRegister("7MX1N", function(module, exports) {

var $7ir7l = parcelRequire("7ir7l");


var $1E0hA = parcelRequire("1E0hA");


var $7Nao2 = parcelRequire("7Nao2");

const $d5b625e2e95a5452$export$9c05e038f495cba8 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'multi-select',
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $1E0hA.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$d5b625e2e95a5452$export$63027158d47e5479({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$d5b625e2e95a5452$export$63027158d47e5479({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $d5b625e2e95a5452$export$63027158d47e5479 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $7ir7l.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $7ir7l.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $7ir7l.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $7ir7l.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: (0, $7ir7l.setOption)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $7ir7l.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $7ir7l.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $7ir7l.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $7ir7l.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
module.exports["createMultiSelectFilter"] = $d5b625e2e95a5452$export$9c05e038f495cba8;
module.exports["MultiSelectFilter"] = $d5b625e2e95a5452$export$63027158d47e5479;

});

parcelRegister("ekeCA", function(module, exports) {

var $dYKlp = parcelRequire("dYKlp");

/**
 * Module-level cache of in-flight (or resolved) promises for
 * `getThirdPartyFilterOptions`, keyed by `${cloudId}::${datasourceId}`.
 *
 * The endpoint returns **all** custom filters for an integration in a single
 * response, so multiple filters that share the same datasource (e.g. campaign
 * status, case status, deal stage) can reuse one promise instead of each
 * issuing an independent network request.
 *
 * Cache lifetime: a typical session has at most O(connected integrations)
 * entries (usually 1–5), so no eviction strategy is needed.  The cache is
 * intentionally kept for the lifetime of the page — filter-option data is
 * static per datasource within a search session.
 *
 * Rejection handling: failed entries are removed so subsequent callers can
 * retry rather than receive a permanently-stuck rejected promise.
 *
 * Cache key: `cloudId::datasourceId::orgId` so different orgs do not share a cached response.
 * `aggAbsoluteUrl` is
 * intentionally excluded — it is constant for a given (cloudId, datasourceId) pair within a
 * session and so cannot disambiguate entries.
 */ const $dfc58da14dd3ac6c$var$cache = new Map();
const $dfc58da14dd3ac6c$export$92d46a4d5ee2716c = (config)=>{
    const { cloudId: cloudId } = config;
    const datasourceId = config.selectedDatasource?.datasourceId;
    // Defensive guard: do not invoke (or cache) without a complete key.
    // Callers in filter index files are expected to short-circuit before this.
    if (!cloudId || !datasourceId) return Promise.resolve(null);
    const orgId = config.orgId;
    const orgSegment = config.orgId ?? '';
    const fetchOptions = {
        cloudId: cloudId,
        datasourceId: datasourceId,
        orgId: orgId,
        aggAbsoluteUrl: config.aggAbsoluteUrl
    };
    const key = `${cloudId}::${datasourceId}::${orgSegment}`;
    let promise = $dfc58da14dd3ac6c$var$cache.get(key);
    if (!promise) {
        promise = (0, $dYKlp.getThirdPartyFilterOptions)(fetchOptions);
        // Evict on failure so the next call can retry.
        promise.catch(()=>$dfc58da14dd3ac6c$var$cache.delete(key));
        $dfc58da14dd3ac6c$var$cache.set(key, promise);
    }
    return promise;
};
const $dfc58da14dd3ac6c$export$a54b0e43665cba85 = ()=>{
    $dfc58da14dd3ac6c$var$cache.clear();
};
module.exports["getCachedThirdPartyFilterOptions"] = $dfc58da14dd3ac6c$export$92d46a4d5ee2716c;

});

parcelRegister("7ir7l", function(module, exports) {

var $7Nao2 = parcelRequire("7Nao2");


var $4NJNH = parcelRequire("4NJNH");


const $e70b761ee131722b$export$639eaf0f64f8fe4 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: $e70b761ee131722b$export$50fdfeece43146fd({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $e70b761ee131722b$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $e70b761ee131722b$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: $e70b761ee131722b$export$ad6c12f692e14555({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $e70b761ee131722b$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: $e70b761ee131722b$export$69017055aa8b346e({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: $e70b761ee131722b$export$92164aa84e23cd67({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: $e70b761ee131722b$export$bf7199a9ebcb84a9({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: $e70b761ee131722b$export$d0f857db6e3e26d7({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $e70b761ee131722b$export$50fdfeece43146fd = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = filter.getOptions({
            isLookupActive: false
        });
        const newOptions = filter.getOptions({
            isLookupActive: state.lookup.isActive
        });
        const selectedOptions = allOptions.filter((option)=>option.isSelected);
        const newState = {
            ...state,
            options: newOptions,
            selectedOptions: selectedOptions,
            hasSelection: selectedOptions.length > 0,
            value: filter.getValue()
        };
        return newState;
    };
};
const $e70b761ee131722b$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const filterWithNewOptions = filter.setOption(newOptions);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $e70b761ee131722b$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamValue = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.queryParamValue);
        return {
            [initial.queryParams.key]: queryParamValue
        };
    };
};
const $e70b761ee131722b$export$ad6c12f692e14555 = ({ initial: initial, state: state, config: config })=>{
    return async (onStateChange)=>{
        const didMountForProduct = state.didMountPerProducts[(0, $4NJNH.getProductForFilterOption)({
            config: config,
            isUniversal: initial.universal
        })];
        if (didMountForProduct) // Already loaded — return the current monad without dispatching a state change.
        // Calling onStateChange here would cause a no-op store write (new object identity
        // for the same data), which makes downstream selectors that return derived references
        // (e.g. useFilters() consumers that compute new arrays/Sets) re-render. When the
        // caller is a useEffect that depends on derived values, this can trigger an
        // infinite render loop. The store should only change when something actually changed.
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const newOptions = [
            ...state.initialOptions.options
        ];
        const fetcher = initial.initialOptions?.fetcher;
        if (fetcher) {
            const fetchingInitialOptionsState = {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    isLoading: true
                }
            };
            onStateChange?.(fetchingInitialOptionsState);
            try {
                const fetchedOptions = await fetcher(config);
                fetchedOptions.forEach((option)=>{
                    const mappedOption = {
                        isSelected: false,
                        trackingKey: option.trackingKey,
                        value: option.value,
                        queryParamValue: option.queryParamValue,
                        isSuggested: true,
                        isDefault: option.isDefault ?? false,
                        avatarUrl: option.avatarUrl,
                        label: option.label,
                        metadata: option.metadata,
                        product: (0, $4NJNH.getProductForFilterOption)({
                            config: config,
                            isUniversal: initial.universal
                        })
                    };
                    newOptions.push(mappedOption);
                });
            } catch  {
                const fetchFailedState = {
                    ...state,
                    initialOptions: {
                        ...state.initialOptions,
                        isLoading: false
                    }
                };
                onStateChange?.(fetchFailedState);
            }
        }
        const newInitialOptionsState = {
            ...state,
            didMountPerProducts: {
                ...state.didMountPerProducts,
                [(0, $4NJNH.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })]: true
            },
            initialOptions: {
                ...state.initialOptions,
                options: newOptions,
                isLoading: false
            }
        };
        onStateChange?.(newInitialOptionsState);
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: newInitialOptionsState,
            config: config
        });
    };
};
const $e70b761ee131722b$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        const isContributor = initial.id === 'contributor';
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const optionsToChangeRecord = Object.fromEntries(optionsToChange.map((option)=>[
                option.value,
                option
            ]));
        const allExistingValues = new Set([
            ...state.queryParams.options.map((o)=>o.value),
            ...state.initialOptions.options.map((o)=>o.value),
            ...state.lookup.options.map((o)=>o.value),
            ...state.lookup.lookupResultOptions.map((o)=>o.value)
        ]);
        // Options being selected that don't exist in any list yet (e.g. dynamic async-loaded options
        // selected before the store has been populated) are added directly to queryParams.options so
        // they participate in URL param generation immediately.
        const newQueryParamOptions = optionsToChange.filter((o)=>o.isSelected && !allExistingValues.has(o.value)).map((o)=>({
                value: o.value,
                ...isContributor ? {
                    queryParamValue: o.queryParamValue ?? o.value,
                    trackingKey: o.trackingKey ?? o.value,
                    label: o.label ?? o.value,
                    avatarUrl: o.avatarUrl,
                    metadata: o.metadata
                } : {
                    queryParamValue: o.value,
                    trackingKey: o.value,
                    label: o.value
                },
                isSelected: true,
                isSuggested: false,
                isDefault: false,
                product: (0, $4NJNH.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })
            }));
        const queryParamOptions = [
            ...state.queryParams.options.map((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value && (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    }) === option.product)) return option;
                return {
                    ...option,
                    isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
                };
            }),
            ...newQueryParamOptions
        ];
        const initialOptions = state.initialOptions.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value && (0, $4NJNH.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                }) === option.product)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const duplicateOptions = new Set();
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value) // remove duplicates
        ).map((option)=>({
                ...option,
                isSuggested: true,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? option.isSelected
            }));
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $e70b761ee131722b$export$69017055aa8b346e = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamOptions = state.queryParams.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const initialOptions = state.initialOptions.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const lookupOptions = state.lookup.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $e70b761ee131722b$export$92164aa84e23cd67 = ({ initial: initial, state: state, config: config })=>{
    return async (query, onStateChange)=>{
        if (!initial.lookup || query.length === 0 || state.lookup.input === query) {
            const noQueryState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: false
                }
            };
            onStateChange?.(noQueryState);
            return $e70b761ee131722b$export$639eaf0f64f8fe4({
                initial: initial,
                state: noQueryState,
                config: config
            });
        }
        const fetchingLookupOptionsState = {
            ...state,
            lookup: {
                ...state.lookup,
                input: query,
                isLoading: true,
                isActive: true
            }
        };
        onStateChange?.(fetchingLookupOptionsState);
        try {
            const fetchedLookupOptions = await initial.lookup.fetcher(query, config);
            const newLookupOptions = fetchedLookupOptions.map((option)=>{
                const mappedOption = {
                    isSelected: false,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                return mappedOption;
            });
            const newLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    lookupResultOptions: newLookupOptions,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(newLookupOptionsState);
            return $e70b761ee131722b$export$639eaf0f64f8fe4({
                initial: initial,
                state: newLookupOptionsState,
                config: config
            });
        } catch  {
            const failedLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(failedLookupOptionsState);
            return $e70b761ee131722b$export$639eaf0f64f8fe4({
                initial: initial,
                state: failedLookupOptionsState,
                config: config
            });
        }
    };
};
const $e70b761ee131722b$export$bf7199a9ebcb84a9 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const value = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.value);
        return value;
    };
};
const $e70b761ee131722b$export$d0f857db6e3e26d7 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = [
            ...filter.getOptions({
                isLookupActive: true
            }),
            ...filter.getOptions({
                isLookupActive: false
            })
        ].map((option)=>({
                value: option.value,
                isSelected: false
            }));
        return filter.setOption(allOptions);
    };
};
module.exports["getState"] = $e70b761ee131722b$export$50fdfeece43146fd;
module.exports["getQueryParams"] = $e70b761ee131722b$export$e2de15bbd9edf9c6;
module.exports["setQueryParams"] = $e70b761ee131722b$export$7755017099c85a0d;
module.exports["loadInitialOptions"] = $e70b761ee131722b$export$ad6c12f692e14555;
module.exports["setOption"] = $e70b761ee131722b$export$b2a7969df3fe0aa3;
module.exports["clearOptions"] = $e70b761ee131722b$export$69017055aa8b346e;
module.exports["setLookupInput"] = $e70b761ee131722b$export$92164aa84e23cd67;
module.exports["getValue"] = $e70b761ee131722b$export$bf7199a9ebcb84a9;
module.exports["deselectOptions"] = $e70b761ee131722b$export$d0f857db6e3e26d7;

});

parcelRegister("1E0hA", function(module, exports) {
const $3494f3f137fe420a$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        return {
            ...initialState,
            value: queryParamValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $3494f3f137fe420a$export$64e49a0c7bd6f7a0;

});

parcelRegister("4NJNH", function(module, exports) {
const $50ea31049167f9c5$export$dc0a6726495eccc1 = (params)=>{
    if (params.isUniversal) return 'all';
    return(// If a product is selected, the filter option will be tied to the selected product
    params.config.product ?? // If no product is selected, such as the 'all' state it will use the primary product. This is the case for suggested space filters.
    // All suggested filters are sets the primary product as the product selected after a filter option selection.
    params.config.primaryProduct ?? 'all' // config.primaryProduct should always be defined but 'all' is used as a catch-all
    );
};
module.exports["getProductForFilterOption"] = $50ea31049167f9c5$export$dc0a6726495eccc1;

});

parcelRegister("3e0Ll", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $6yWnN = parcelRequire("6yWnN");


var $j5Usq = parcelRequire("j5Usq");

const $e64642fc2aa68e63$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $e64642fc2aa68e63$export$8e839a938752e935 = async (config)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = (0, $j5Usq.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ], headers);
    const recommendedUserQuery = (0, $6yWnN.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $e64642fc2aa68e63$var$MAX_SMART_DEFAULT_OPTIONS
        },
        headers: headers
    });
    const [initialUsersReponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersReponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return recommendedUserOptions;
};
module.exports["loadRecommendedUsers"] = $e64642fc2aa68e63$export$8e839a938752e935;

});

parcelRegister("m6ow8", function(module, exports) {

var $c9Etd = parcelRequire("c9Etd");


var $7ir7l = parcelRequire("7ir7l");


var $1E0hA = parcelRequire("1E0hA");


var $7Nao2 = parcelRequire("7Nao2");


var $4NJNH = parcelRequire("4NJNH");

const $498f338ea1866e3a$export$711b0a1d273f9525 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $1E0hA.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$498f338ea1866e3a$export$44d389225cc01eb5({
                initial: initial,
                state: state,
                config: // This has to be cast back to the correct state
                config
            }),
        getInitialState: (config)=>$498f338ea1866e3a$export$44d389225cc01eb5({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: true,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $498f338ea1866e3a$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const options = $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        });
        const selectedOptions = options.filter((option)=>option.isSelected);
        const queryParamValue = selectedOptions.map((option)=>option.queryParamValue);
        const isCustomOptionSelected = selectedOptions.find((option)=>option.value === (0, $c9Etd.CUSTOM_OPTION_VALUE));
        const customValueQueryParam = isCustomOptionSelected && state.customValue ? state.customValue : {};
        return {
            [initial.queryParams.key]: queryParamValue,
            ...customValueQueryParam
        };
    };
};
const $498f338ea1866e3a$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const isCustomOptionSelected = newOptions.find((option)=>option.value === (0, $c9Etd.CUSTOM_OPTION_VALUE))?.isSelected;
            const customValueParser = initial.queryParams.customValueParser;
            let customValue;
            if (isCustomOptionSelected) {
                if (customValueParser) customValue = customValueParser(queryParams);
                else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                        ...acc,
                        [field]: queryParams[field]?.[0] ?? ''
                    }), {}) : {};
            }
            const filterWithNewOptions = filter.setOption(newOptions, customValue);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        let customValue;
        const isCustomOptionSelected = selectedOptionsFromQueryParams.find((option)=>option.value === (0, $c9Etd.CUSTOM_OPTION_VALUE))?.isSelected;
        if (isCustomOptionSelected) {
            const customValueParser = initial.queryParams.customValueParser;
            if (customValueParser) customValue = customValueParser(queryParams);
            else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                    ...acc,
                    [field]: queryParams[field]?.[0] ?? ''
                }), {}) : {};
        }
        const hydratedQueryParams = $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                },
                customValue: customValue
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $498f338ea1866e3a$export$44d389225cc01eb5 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $7ir7l.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $498f338ea1866e3a$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $498f338ea1866e3a$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $7ir7l.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $498f338ea1866e3a$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $7ir7l.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $7ir7l.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $7ir7l.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $7ir7l.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $498f338ea1866e3a$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.selectedOption ? props.selectedOption.value === option.value : option.isSelected
        };
    };
const $498f338ea1866e3a$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option, customValue)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const selectedOption = optionsToChange.filter((o)=>o.isSelected)[0];
        const queryParamOptions = state.queryParams.options.map($498f338ea1866e3a$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const initialOptions = state.initialOptions.options.map($498f338ea1866e3a$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($498f338ea1866e3a$var$updateOptionState({
            selectedOption: selectedOption
        }));
        return $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                },
                customValue: customValue
            },
            config: config
        });
    };
};
module.exports["createSingleWithCustomOptionSelectFilter"] = $498f338ea1866e3a$export$711b0a1d273f9525;

});

parcelRegister("kZdMI", function(module, exports) {

var $7ir7l = parcelRequire("7ir7l");


var $1E0hA = parcelRequire("1E0hA");


var $7Nao2 = parcelRequire("7Nao2");

const $6f4c23c6c3ab5dea$export$b77715d04a87c12b = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $1E0hA.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$6f4c23c6c3ab5dea$export$767f444f15b8d660({
                initial: initial,
                state: state,
                config: // This has to be cast back to the correct state
                config
            }),
        getInitialState: (config)=>$6f4c23c6c3ab5dea$export$767f444f15b8d660({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $6f4c23c6c3ab5dea$export$767f444f15b8d660 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $7ir7l.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $7ir7l.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $7ir7l.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $7ir7l.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $6f4c23c6c3ab5dea$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $7ir7l.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $7ir7l.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $7ir7l.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $7ir7l.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $6f4c23c6c3ab5dea$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.firstSelectedOption?.value === option.value
        };
    };
const $6f4c23c6c3ab5dea$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        // Theoretically this should only ever give you one option to change
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const firstSelectedOption = optionsToChange[0];
        const isOptionAlreadySelected = state.options.filter((x)=>x.isSelected).find((x)=>x.value === firstSelectedOption?.value);
        if (isOptionAlreadySelected) // do nothing
        return $6f4c23c6c3ab5dea$export$767f444f15b8d660({
            initial: initial,
            state: state,
            config: config
        });
        const queryParamOptions = state.queryParams.options.map($6f4c23c6c3ab5dea$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const initialOptions = state.initialOptions.options.map($6f4c23c6c3ab5dea$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($6f4c23c6c3ab5dea$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        return $6f4c23c6c3ab5dea$export$767f444f15b8d660({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
module.exports["createSingleSelectFilter"] = $6f4c23c6c3ab5dea$export$b77715d04a87c12b;
module.exports["SingleSelectFilter"] = $6f4c23c6c3ab5dea$export$767f444f15b8d660;

});

parcelRegister("aCR6W", function(module, exports) {
/**
 * Generic fuzzy matching utility for filtering select filter options client-side.
 *
 * ## Normalization
 * Both the query and candidate text are normalized before comparison by:
 *   - Converting to lowercase
 *   - Stripping all non-alphanumeric characters (hyphens, underscores, spaces, punctuation, etc.)
 *
 * This means "trex" will match "t-rex", "t_rex", "T.Rex", "(T)Rex", etc.
 *
 * ## Matching strategy (applied to normalized strings)
 * 1. **Substring match** — normalized candidate contains normalized query as a contiguous substring.
 *    e.g. "flu" matches "confluence" → "confluence"
 * 2. **Subsequence match** — every character in the normalized query appears in the normalized
 *    candidate in the same relative order (but not necessarily contiguous).
 *    e.g. "cnf" matches "confluence" → "cnflue**n**ce" (c…n…f)
 *
 * An empty query matches everything.
 */ /** Strip all non-alphanumeric characters and lowercase. */ const $ea8a7d6f7faefd94$var$normalize = (text)=>text.toLowerCase().replace(/[^a-z0-9]/g, '');
/**
 * Returns true if every character in `query` appears in `text` in the same
 * relative order (subsequence match).
 */ const $ea8a7d6f7faefd94$var$isSubsequence = (text, query)=>{
    let queryIndex = 0;
    for(let i = 0; i < text.length && queryIndex < query.length; i++)if (text[i] === query[queryIndex]) queryIndex++;
    return queryIndex === query.length;
};
const $ea8a7d6f7faefd94$export$3ace64ce5180d918 = (query, candidate)=>{
    const normalizedQuery = $ea8a7d6f7faefd94$var$normalize(query);
    // Empty query matches everything
    if (!normalizedQuery) return true;
    const normalizedCandidate = $ea8a7d6f7faefd94$var$normalize(candidate);
    // Nothing left after stripping non-alphanumeric — can't match a non-empty query
    if (!normalizedCandidate) return false;
    // 1. Substring match (faster — try first)
    if (normalizedCandidate.includes(normalizedQuery)) return true;
    // 2. Subsequence match
    return $ea8a7d6f7faefd94$var$isSubsequence(normalizedCandidate, normalizedQuery);
};
const $ea8a7d6f7faefd94$export$775f9687cb3a8d8b = (query, items, getText)=>{
    if (!query) return items;
    return items.filter((item)=>$ea8a7d6f7faefd94$export$3ace64ce5180d918(query, getText(item)));
};
module.exports["fuzzyFilter"] = $ea8a7d6f7faefd94$export$775f9687cb3a8d8b;

});

parcelRegister("lDUCP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5pcom = parcelRequire("5pcom");


var $i28CG = parcelRequire("i28CG");


var $fIeaC = parcelRequire("fIeaC");


var $dsOco = parcelRequire("dsOco");

const $b23f12babcafb113$export$694cb0e3f167dbc8 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthStarted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: {
                ...commonAttributes,
                ...(0, $fIeaC.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $b23f12babcafb113$export$cbd7e681ca5b8fd4 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthCompleted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $b23f12babcafb113$export$cff3d5cd941b3b4d = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthFailed)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $b23f12babcafb113$export$3168f7d5a2074317 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthConnectHovered)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
module.exports["useFireOAuthStarted"] = $b23f12babcafb113$export$694cb0e3f167dbc8;
module.exports["useFireOAuthCompleted"] = $b23f12babcafb113$export$cbd7e681ca5b8fd4;
module.exports["useFireOAuthFailed"] = $b23f12babcafb113$export$cff3d5cd941b3b4d;
module.exports["useFireOAuthHovered"] = $b23f12babcafb113$export$3168f7d5a2074317;

});

parcelRegister("fZV6T", function(module, exports) {
const $f464135d5c5977a6$export$2f5ba0d1129fe71 = (inputStr)=>{
    const htmlEntities = {
        '&nbsp;': ' ',
        '&lt;': '<',
        '&amp;': '&',
        '&quot;': '"',
        '&gt;': '>'
    };
    return Object.keys(htmlEntities).reduce((str, entity)=>{
        return str.replace(new RegExp(entity, 'g'), htmlEntities[entity]);
    }, inputStr);
};
module.exports["replaceHtmlEntities"] = $f464135d5c5977a6$export$2f5ba0d1129fe71;

});

parcelRegister("dTqCf", function(module, exports) {
const $cf4a96c4694a466a$export$158516eb8829fc93 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const now = new Date();
    return (now.getTime() - new Date(timestamp).getTime()) / 1000;
};
module.exports["secondsSinceDate"] = $cf4a96c4694a466a$export$158516eb8829fc93;

});

parcelRegister("480dC", function(module, exports) {
const $3d24f627ae2fbe4a$export$c7b83231a41239c7 = [
    'document'
];
module.exports["SHAREPOINT_RESOURCE_TYPES"] = $3d24f627ae2fbe4a$export$c7b83231a41239c7;

});

parcelRegister("7Rtv4", function(module, exports) {
const $cb96b18b3fb0fbd5$export$5c9d109db494cbec = [
    'message',
    'conversation',
    'video'
];
module.exports["TEAMS_RESOURCE_TYPES"] = $cb96b18b3fb0fbd5$export$5c9d109db494cbec;

});

parcelRegister("bHPvH", function(module, exports) {
/**
 * Pure function to get 3P product keys for a given filter ID.
 * Uses pre-computed static mapping instead of ThirdPartyConfigs
 * to avoid importing React icon components.
 */ 
var $cEDkb = parcelRequire("cEDkb");

const $9bd88cee383af9a7$export$ef6dfb919b1d7267 = (filterId)=>{
    return (0, $cEDkb.thirdPartyFilterProducts)[filterId] ?? [];
};
module.exports["getProducts3PFromConfigForFilter"] = $9bd88cee383af9a7$export$ef6dfb919b1d7267;

});

parcelRegister("iaii4", function(module, exports) {

var $hea5O = parcelRequire("hea5O");

const $bf3c9af35b635e5b$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $bf3c9af35b635e5b$export$cb0ede5f191413 = (queryParams)=>{
    const { to: to, from: from } = queryParams;
    const isToDateValid = $bf3c9af35b635e5b$var$isIsoDate(to?.[0]);
    const isFromDateValid = $bf3c9af35b635e5b$var$isIsoDate(from?.[0]);
    const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
    const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
    const invalidDateRange = (0, $hea5O.getInvalidDateRange)(fromDate, toDate);
    if (!invalidDateRange) return {
        to: toDate,
        from: fromDate
    };
};
const $bf3c9af35b635e5b$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        let customValue;
        if (Array.isArray(queryParamValue)) {
            value = queryParamValue;
            if (queryParamValue[0] === 'custom') customValue = $bf3c9af35b635e5b$export$cb0ede5f191413(queryParams);
        }
        return {
            ...initialState,
            value: value || initialState.value,
            customValue: customValue || initialState.customValue
        };
    };
};
module.exports["customValueParser"] = $bf3c9af35b635e5b$export$cb0ede5f191413;
module.exports["generateQueryParamsGetState"] = $bf3c9af35b635e5b$export$64e49a0c7bd6f7a0;

});

parcelRegister("2bNdD", function(module, exports) {

var $1Fy3P = parcelRequire("1Fy3P");

const $fa8fc29bf8514fb8$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) {
            if (queryParamValue[0] === 'all') value = queryParamValue;
            else if ((0, $1Fy3P.isPageStatusFilterValueKey)(queryParamValue[0])) value = [
                (0, $1Fy3P.PageStatusFilterValue)[queryParamValue[0]]
            ];
        }
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $fa8fc29bf8514fb8$export$64e49a0c7bd6f7a0;

});

parcelRegister("26LZ9", function(module, exports) {
const $a7dc4cdc231636e7$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) value = queryParamValue.map((param)=>decodeURIComponent(param));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $a7dc4cdc231636e7$export$64e49a0c7bd6f7a0;

});

parcelRegister("2UU5O", function(module, exports) {

var $99V2N = parcelRequire("99V2N");


var $dvVWp = parcelRequire("dvVWp");

const $ceccebe48d4d7257$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $ceccebe48d4d7257$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams, cloudId)=>{
        const selectedProduct = (queryParams['product'] ?? [])[0];
        const queryParamValue = queryParams[queryParamKey] || [];
        // Query params hold ARIs. Links predating that hold bare project ids, which can only be
        // resolved against the current site here.
        // TODO QS-10359: drop the bare id branch once pre-ARI links have aged out. Note this
        // outlives the multi-site rollout, since the ARI format is ungated.
        const value = selectedProduct === (0, $dvVWp.ProductKeys).JiraDC || selectedProduct === (0, $dvVWp.ProductKeys).JsmDC ? queryParamValue : queryParamValue.map((entry)=>(0, $99V2N.AnyAri).check(entry) ? entry : $ceccebe48d4d7257$var$projectIdToARI(cloudId || '', entry));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $ceccebe48d4d7257$export$64e49a0c7bd6f7a0;

});


//# sourceMappingURL=QuickFind.187fd826.js.map
